var Fp = Object.defineProperty;
var Yp = (e, r, t) => r in e ? Fp(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var re = (e, r, t) => (Yp(e, typeof r != "symbol" ? r + "" : r, t), t);
import * as T from "react";
import S, { forwardRef as qe, useState as $e, useEffect as fe, createElement as R1, Component as j1, useLayoutEffect as ao, createRef as $p, createContext as Kt, useContext as ze, useRef as me, useCallback as Oe, useMemo as it, cloneElement as Oi, Children as zp, isValidElement as Is, useReducer as Zp } from "react";
import * as Wp from "react-dom";
import Bp, { findDOMNode as Up, createPortal as Kp } from "react-dom";
function P1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Va = { exports: {} }, Zn = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xl;
function Qp() {
  if (Xl)
    return Zn;
  Xl = 1;
  var e = S, r = 60103;
  if (Zn.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    r = t("react.element"), Zn.Fragment = t("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l)
      o.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: r, type: s, key: h, ref: p, props: d, _owner: n.current };
  }
  return Zn.jsx = a, Zn.jsxs = a, Zn;
}
var Ji = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jl;
function qp() {
  return Jl || (Jl = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var r = S, t = 60103, n = 60106;
      e.Fragment = 60107;
      var o = 60108, i = 60114, a = 60109, s = 60110, l = 60112, c = 60113, u = 60120, d = 60115, h = 60116, p = 60121, v = 60122, m = 60117, y = 60129, b = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var g = Symbol.for;
        t = g("react.element"), n = g("react.portal"), e.Fragment = g("react.fragment"), o = g("react.strict_mode"), i = g("react.profiler"), a = g("react.provider"), s = g("react.context"), l = g("react.forward_ref"), c = g("react.suspense"), u = g("react.suspense_list"), d = g("react.memo"), h = g("react.lazy"), p = g("react.block"), v = g("react.server.block"), m = g("react.fundamental"), g("react.scope"), g("react.opaque.id"), y = g("react.debug_trace_mode"), g("react.offscreen"), b = g("react.legacy_hidden");
      }
      var w = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
      function C(k) {
        if (k === null || typeof k != "object")
          return null;
        var G = w && k[w] || k[x];
        return typeof G == "function" ? G : null;
      }
      var O = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function E(k) {
        {
          for (var G = arguments.length, ie = new Array(G > 1 ? G - 1 : 0), he = 1; he < G; he++)
            ie[he - 1] = arguments[he];
          _("error", k, ie);
        }
      }
      function _(k, G, ie) {
        {
          var he = O.ReactDebugCurrentFrame, Se = "";
          if (J) {
            var Re = U(J.type), Me = J._owner;
            Se += Y(Re, J._source, Me && U(Me.type));
          }
          Se += he.getStackAddendum(), Se !== "" && (G += "%s", ie = ie.concat([Se]));
          var ve = ie.map(function(nt) {
            return "" + nt;
          });
          ve.unshift("Warning: " + G), Function.prototype.apply.call(console[k], console, ve);
        }
      }
      var R = !1;
      function H(k) {
        return !!(typeof k == "string" || typeof k == "function" || k === e.Fragment || k === i || k === y || k === o || k === c || k === u || k === b || R || typeof k == "object" && k !== null && (k.$$typeof === h || k.$$typeof === d || k.$$typeof === a || k.$$typeof === s || k.$$typeof === l || k.$$typeof === m || k.$$typeof === p || k[0] === v));
      }
      var $ = /^(.*)[\\\/]/;
      function Y(k, G, ie) {
        var he = "";
        if (G) {
          var Se = G.fileName, Re = Se.replace($, "");
          if (/^index\./.test(Re)) {
            var Me = Se.match($);
            if (Me) {
              var ve = Me[1];
              if (ve) {
                var nt = ve.replace($, "");
                Re = nt + "/" + Re;
              }
            }
          }
          he = " (at " + Re + ":" + G.lineNumber + ")";
        } else
          ie && (he = " (created by " + ie + ")");
        return `
    in ` + (k || "Unknown") + he;
      }
      var j = 1;
      function A(k) {
        return k._status === j ? k._result : null;
      }
      function W(k, G, ie) {
        var he = G.displayName || G.name || "";
        return k.displayName || (he !== "" ? ie + "(" + he + ")" : ie);
      }
      function U(k) {
        if (k == null)
          return null;
        if (typeof k.tag == "number" && E("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof k == "function")
          return k.displayName || k.name || null;
        if (typeof k == "string")
          return k;
        switch (k) {
          case e.Fragment:
            return "Fragment";
          case n:
            return "Portal";
          case i:
            return "Profiler";
          case o:
            return "StrictMode";
          case c:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if (typeof k == "object")
          switch (k.$$typeof) {
            case s:
              return "Context.Consumer";
            case a:
              return "Context.Provider";
            case l:
              return W(k, k.render, "ForwardRef");
            case d:
              return U(k.type);
            case p:
              return U(k.render);
            case h: {
              var G = k, ie = A(G);
              if (ie)
                return U(ie);
              break;
            }
          }
        return null;
      }
      var Z = {};
      O.ReactDebugCurrentFrame;
      var J = null;
      function le(k) {
        J = k;
      }
      function z(k, G, ie, he, Se) {
        {
          var Re = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Me in k)
            if (Re(k, Me)) {
              var ve = void 0;
              try {
                if (typeof k[Me] != "function") {
                  var nt = Error((he || "React class") + ": " + ie + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw nt.name = "Invariant Violation", nt;
                }
                ve = k[Me](G, Me, he, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Nt) {
                ve = Nt;
              }
              ve && !(ve instanceof Error) && (le(Se), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", he || "React class", ie, Me, typeof ve), le(null)), ve instanceof Error && !(ve.message in Z) && (Z[ve.message] = !0, le(Se), E("Failed %s type: %s", ie, ve.message), le(null));
            }
        }
      }
      var F = O.ReactCurrentOwner, L = Object.prototype.hasOwnProperty, N = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, I, P, B;
      B = {};
      function ee(k) {
        if (L.call(k, "ref")) {
          var G = Object.getOwnPropertyDescriptor(k, "ref").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return k.ref !== void 0;
      }
      function te(k) {
        if (L.call(k, "key")) {
          var G = Object.getOwnPropertyDescriptor(k, "key").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return k.key !== void 0;
      }
      function ae(k, G) {
        if (typeof k.ref == "string" && F.current && G && F.current.stateNode !== G) {
          var ie = U(F.current.type);
          B[ie] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(F.current.type), k.ref), B[ie] = !0);
        }
      }
      function se(k, G) {
        {
          var ie = function() {
            I || (I = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          ie.isReactWarning = !0, Object.defineProperty(k, "key", {
            get: ie,
            configurable: !0
          });
        }
      }
      function ge(k, G) {
        {
          var ie = function() {
            P || (P = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          ie.isReactWarning = !0, Object.defineProperty(k, "ref", {
            get: ie,
            configurable: !0
          });
        }
      }
      var q = function(k, G, ie, he, Se, Re, Me) {
        var ve = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: t,
          // Built-in properties that belong on the element
          type: k,
          key: G,
          ref: ie,
          props: Me,
          // Record the component responsible for creating this element.
          _owner: Re
        };
        return ve._store = {}, Object.defineProperty(ve._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ve, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: he
        }), Object.defineProperty(ve, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Se
        }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
      };
      function ke(k, G, ie, he, Se) {
        {
          var Re, Me = {}, ve = null, nt = null;
          ie !== void 0 && (ve = "" + ie), te(G) && (ve = "" + G.key), ee(G) && (nt = G.ref, ae(G, Se));
          for (Re in G)
            L.call(G, Re) && !N.hasOwnProperty(Re) && (Me[Re] = G[Re]);
          if (k && k.defaultProps) {
            var Nt = k.defaultProps;
            for (Re in Nt)
              Me[Re] === void 0 && (Me[Re] = Nt[Re]);
          }
          if (ve || nt) {
            var Gt = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
            ve && se(Me, Gt), nt && ge(Me, Gt);
          }
          return q(k, ve, nt, Se, he, F.current, Me);
        }
      }
      var ne = O.ReactCurrentOwner;
      O.ReactDebugCurrentFrame;
      function Ze(k) {
        J = k;
      }
      var Qe;
      Qe = !1;
      function vt(k) {
        return typeof k == "object" && k !== null && k.$$typeof === t;
      }
      function ct() {
        {
          if (ne.current) {
            var k = U(ne.current.type);
            if (k)
              return `

Check the render method of \`` + k + "`.";
          }
          return "";
        }
      }
      function Hn(k) {
        {
          if (k !== void 0) {
            var G = k.fileName.replace(/^.*[\\\/]/, ""), ie = k.lineNumber;
            return `

Check your code at ` + G + ":" + ie + ".";
          }
          return "";
        }
      }
      var Fn = {};
      function mt(k) {
        {
          var G = ct();
          if (!G) {
            var ie = typeof k == "string" ? k : k.displayName || k.name;
            ie && (G = `

Check the top-level render call using <` + ie + ">.");
          }
          return G;
        }
      }
      function qt(k, G) {
        {
          if (!k._store || k._store.validated || k.key != null)
            return;
          k._store.validated = !0;
          var ie = mt(G);
          if (Fn[ie])
            return;
          Fn[ie] = !0;
          var he = "";
          k && k._owner && k._owner !== ne.current && (he = " It was passed a child from " + U(k._owner.type) + "."), Ze(k), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, he), Ze(null);
        }
      }
      function Yn(k, G) {
        {
          if (typeof k != "object")
            return;
          if (Array.isArray(k))
            for (var ie = 0; ie < k.length; ie++) {
              var he = k[ie];
              vt(he) && qt(he, G);
            }
          else if (vt(k))
            k._store && (k._store.validated = !0);
          else if (k) {
            var Se = C(k);
            if (typeof Se == "function" && Se !== k.entries)
              for (var Re = Se.call(k), Me; !(Me = Re.next()).done; )
                vt(Me.value) && qt(Me.value, G);
          }
        }
      }
      function $n(k) {
        {
          var G = k.type;
          if (G == null || typeof G == "string")
            return;
          var ie;
          if (typeof G == "function")
            ie = G.propTypes;
          else if (typeof G == "object" && (G.$$typeof === l || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          G.$$typeof === d))
            ie = G.propTypes;
          else
            return;
          if (ie) {
            var he = U(G);
            z(ie, k.props, "prop", he, k);
          } else if (G.PropTypes !== void 0 && !Qe) {
            Qe = !0;
            var Se = U(G);
            E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Se || "Unknown");
          }
          typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Et(k) {
        {
          for (var G = Object.keys(k.props), ie = 0; ie < G.length; ie++) {
            var he = G[ie];
            if (he !== "children" && he !== "key") {
              Ze(k), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", he), Ze(null);
              break;
            }
          }
          k.ref !== null && (Ze(k), E("Invalid attribute `ref` supplied to `React.Fragment`."), Ze(null));
        }
      }
      function It(k, G, ie, he, Se, Re) {
        {
          var Me = H(k);
          if (!Me) {
            var ve = "";
            (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var nt = Hn(Se);
            nt ? ve += nt : ve += ct();
            var Nt;
            k === null ? Nt = "null" : Array.isArray(k) ? Nt = "array" : k !== void 0 && k.$$typeof === t ? (Nt = "<" + (U(k.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : Nt = typeof k, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Nt, ve);
          }
          var Gt = ke(k, G, ie, Se, Re);
          if (Gt == null)
            return Gt;
          if (Me) {
            var zn = G.children;
            if (zn !== void 0)
              if (he)
                if (Array.isArray(zn)) {
                  for (var Xi = 0; Xi < zn.length; Xi++)
                    Yn(zn[Xi], k);
                  Object.freeze && Object.freeze(zn);
                } else
                  E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Yn(zn, k);
          }
          return k === e.Fragment ? Et(Gt) : $n(Gt), Gt;
        }
      }
      function Ot(k, G, ie) {
        return It(k, G, ie, !0);
      }
      function at(k, G, ie) {
        return It(k, G, ie, !1);
      }
      var Gi = at, Hp = Ot;
      e.jsx = Gi, e.jsxs = Hp;
    }();
  }(Ji)), Ji;
}
process.env.NODE_ENV === "production" ? Va.exports = Qp() : Va.exports = qp();
var f = Va.exports, A1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var r = {}.hasOwnProperty;
    function t() {
      for (var n = [], o = 0; o < arguments.length; o++) {
        var i = arguments[o];
        if (i) {
          var a = typeof i;
          if (a === "string" || a === "number")
            n.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var s = t.apply(null, i);
              s && n.push(s);
            }
          } else if (a === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              n.push(i.toString());
              continue;
            }
            for (var l in i)
              r.call(i, l) && i[l] && n.push(l);
          }
        }
      }
      return n.join(" ");
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(A1);
var Gp = A1.exports;
const X = /* @__PURE__ */ P1(Gp);
const Xp = qe(
  ({
    open: e,
    title: r,
    onClick: t,
    elevated: n = !1,
    icon: o,
    tagIcon: i,
    tagLabel: a,
    children: s,
    size: l = "m",
    tagVariant: c = "neutral",
    ...u
  }, d) => {
    const h = o, [p, v] = $e(e);
    fe(() => {
      v(e);
    }, [e]);
    const m = p ? px : Es;
    let y = "24", b = {
      size: "s",
      variant: "headline-content"
    };
    switch (l) {
      case "s":
        b = {
          variant: "body-content",
          size: "s",
          weight: 600
        }, y = "16";
        break;
      case "m":
        b = {
          variant: "headline-content",
          size: "xs"
        };
        break;
    }
    const g = (w) => {
      w.stopPropagation(), v(!p), t && t(w);
    };
    return /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: d,
        ...u,
        "data-testid": "accordion",
        className: X(
          "sp-accordion",
          `sp-accordion--${l}`,
          { "sp-accordion--elevated": n },
          { "sp-accordion--open": p }
        ),
        children: [
          /* @__PURE__ */ f.jsxs("button", { onClick: g, className: "sp-accordion__header", children: [
            /* @__PURE__ */ f.jsxs("div", { className: "sp-accordion__header--left-content", children: [
              h ? /* @__PURE__ */ f.jsx(h, { size: y, iconColor: "#545454" }) : null,
              r != null && /* @__PURE__ */ f.jsx(
                pe,
                {
                  className: "sp-accordion__header--left-content__title",
                  ...b,
                  children: r
                }
              )
            ] }),
            /* @__PURE__ */ f.jsxs("div", { className: "sp-accordion__header--right-content", children: [
              a && /* @__PURE__ */ f.jsx(
                An.Label,
                {
                  Icon: i,
                  hierarchy: "default",
                  label: a,
                  variant: c
                }
              ),
              /* @__PURE__ */ f.jsx(
                m,
                {
                  className: "sp-actionchip--arrow-icon",
                  iconColor: "#545454",
                  size: "16"
                }
              )
            ] })
          ] }),
          p && /* @__PURE__ */ f.jsx("div", { className: "sp-accordion__content", children: s })
        ]
      }
    );
  }
);
Xp.displayName = "Accordion";
const L1 = qe(
  ({
    onClick: e,
    onDelete: r,
    disabled: t,
    icon: n,
    label: o,
    active: i,
    labelCount: a,
    ...s
  }, l) => {
    const c = n, [u, d] = $e(!!i), [h, p] = $e(!1);
    fe(() => {
      d(!!i);
    }, [i]);
    const v = (g) => {
      !t && e && e(o, g);
    }, m = (g) => {
      g.stopPropagation(), !t && r && (r(o, g), d(!1), p(!1));
    }, y = () => {
      p(!0);
    }, b = () => {
      p(!1);
    };
    return /* @__PURE__ */ f.jsxs(
      "button",
      {
        ...s,
        className: X([
          "sp-actionchip",
          { "sp-actionchip--active": u },
          { "sp-actionchip--disabled": t }
        ]),
        onClick: v,
        ref: l,
        type: "button",
        children: [
          /* @__PURE__ */ f.jsxs("div", { className: X("sp-actionchip__content", { inactive: h }), children: [
            c ? /* @__PURE__ */ f.jsx(c, { size: "16", iconColor: "currentColor" }) : null,
            o != null && /* @__PURE__ */ f.jsx(
              pe,
              {
                className: "sp-actionchip__content-label",
                variant: "body-content",
                size: "caption-m",
                weight: u ? 600 : void 0,
                children: o
              }
            ),
            u && a && a > 1 ? /* @__PURE__ */ f.jsxs(
              pe,
              {
                variant: "body-content",
                size: "caption-m",
                className: "sp-actionchip__content-count",
                children: [
                  "+",
                  a - 1,
                  " other"
                ]
              }
            ) : null
          ] }),
          u && r && /* @__PURE__ */ f.jsx(
            "button",
            {
              className: "sp-actionchip--close",
              onMouseEnter: y,
              onMouseLeave: b,
              "data-testid": "delete-icon",
              "aria-label": "Delete Action",
              onClick: m,
              children: /* @__PURE__ */ f.jsx(
                yr,
                {
                  className: "sp-actionchip--close-icon",
                  iconColor: "currentColor",
                  size: "16"
                }
              )
            }
          )
        ]
      }
    );
  }
);
L1.displayName = "ActionChip";
const qC = ({
  items: e,
  onClick: r,
  defaultActive: t = -1
}) => {
  const [n, o] = $e(t);
  return /* @__PURE__ */ f.jsx("div", { role: "tablist", className: "sp-actionchip-group", children: e.map(({ icon: i, label: a }, s) => {
    const l = n === s;
    let c = i;
    return !c && l && (c = Gl), /* @__PURE__ */ f.jsx(
      L1,
      {
        icon: c,
        active: l,
        onClick: () => {
          o(s), r(a);
        },
        role: "tab",
        label: a
      },
      s
    );
  }) });
};
const GC = ({
  icon: e,
  title: r,
  description: t,
  variant: n,
  onClose: o,
  size: i = "m"
}) => {
  const a = e || Qx;
  return /* @__PURE__ */ f.jsxs(
    "article",
    {
      className: X(
        "sp-banner",
        `sp-banner--${n}`,
        `sp-banner--${i}`
      ),
      children: [
        /* @__PURE__ */ f.jsx(a, { iconColor: "currentColor", size: "16", className: "sp-banner__icon" }),
        /* @__PURE__ */ f.jsxs("div", { className: "sp-banner__content", children: [
          r && /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", weight: 600, tag: "h4", children: r }),
          t && /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", tag: "p", children: t })
        ] }),
        o && /* @__PURE__ */ f.jsx("button", { className: "sp-banner__cross", onClick: o, children: /* @__PURE__ */ f.jsx(yr, { iconColor: "currentColor", size: "16" }) })
      ]
    }
  );
};
const Xe = qe(
  ({
    className: e,
    children: r,
    disabled: t,
    loading: n,
    size: o = "m",
    variant: i,
    icon: a,
    ...s
  }, l) => {
    let c;
    const u = a ?? void 0;
    switch (i) {
      case "danger":
        c = "danger";
        break;
      case "success":
        c = "success";
        break;
      case "primary":
        c = "inverse";
        break;
      default:
        c = "brand";
        break;
    }
    let d = "s", h = "24";
    switch (o) {
      case "xs":
        h = "16", d = "caption-m";
        break;
      case "s":
        h = "16";
        break;
      case "m":
        h = "16", d = "m";
        break;
      case "l":
        d = "m";
        break;
      case "xl":
        d = "l";
        break;
    }
    return /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: X([
          "sp-button",
          e,
          `sp-button--${o}`,
          `sp-button--${i}`,
          { "sp-button--loading": n }
        ]),
        disabled: t,
        ...s,
        ref: l,
        children: [
          u ? /* @__PURE__ */ f.jsx(
            u,
            {
              size: h,
              iconColor: "currentColor",
              className: X({
                ["sp-button__icon--hidden"]: n
              })
            }
          ) : null,
          n ? /* @__PURE__ */ f.jsx(
            Z4.Spinner,
            {
              size: h === "16" ? "s" : "l",
              variant: c,
              className: "sp-button__loader",
              "data-testid": "loader"
            }
          ) : null,
          /* @__PURE__ */ f.jsx(
            pe,
            {
              variant: "body-content",
              size: d,
              weight: 600,
              className: X({
                ["sp-button__text--hidden"]: n
              }),
              children: r
            }
          )
        ]
      }
    );
  }
);
Xe.displayName = "Button";
const vr = qe(
  ({
    className: e,
    elevation: r = "level-1",
    padding: t = "medium",
    radius: n = "m",
    ...o
  }, i) => /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: i,
      className: X(
        "sp-card",
        `sp-card--elevation--${r}`,
        `sp-card--padding--${t}`,
        `sp-card--radius--${n}`,
        e
      ),
      ...o
    }
  )
);
vr.displayName = "Card";
const Jp = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("rect", { x: "1", y: "7", width: "14", height: "2", rx: "1", fill: "white" })
  }
), e6 = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5528 2.18233C15.0209 2.50765 15.1408 3.15682 14.8205 3.63229L8.44832 13.0917C7.75216 14.1251 6.32282 14.3072 5.39692 13.4805L1.34894 9.86593C0.922942 9.48555 0.881198 8.82643 1.2557 8.39375C1.6302 7.96107 2.27913 7.91867 2.70513 8.29905L6.75311 11.9136L13.1253 2.4542C13.4456 1.97873 14.0847 1.85701 14.5528 2.18233Z",
        fill: "white"
      }
    )
  }
), V1 = qe(
  ({
    indeterminate: e,
    checked: r,
    disabled: t,
    size: n = "m",
    id: o,
    children: i,
    required: a,
    className: s,
    ...l
  }, c) => {
    const [u, d] = $e("unchecked");
    fe(() => {
      d(e ? "indeterminate" : r ? "checked" : "unchecked");
    }, [e, r]);
    let h;
    switch (u) {
      case "indeterminate":
        h = Jp;
        break;
      case "checked":
        h = e6;
        break;
    }
    const p = () => {
      if (t)
        return;
      let v;
      u === "checked" ? v = "unchecked" : v = "checked", d(v);
    };
    return /* @__PURE__ */ f.jsxs(
      "label",
      {
        htmlFor: o,
        ref: c,
        className: X("sp-checkbox", `sp-checkbox--${n}`, s),
        onClick: p,
        children: [
          /* @__PURE__ */ f.jsx(
            "input",
            {
              type: "checkbox",
              "data-state": u,
              disabled: t,
              checked: r,
              ...l,
              onChange: t || l == null ? void 0 : l.onChange,
              className: "sp-checkbox__input"
            }
          ),
          /* @__PURE__ */ f.jsx("div", { className: "sp-checkbox__input-visual", children: h && /* @__PURE__ */ f.jsx(h, {}) }),
          i ? /* @__PURE__ */ f.jsxs(
            pe,
            {
              size: n,
              variant: "body-content",
              className: "sp-checkbox__label",
              children: [
                i,
                /* @__PURE__ */ f.jsx("span", { className: "sp-checkbox__label__required", children: a && "*" })
              ]
            }
          ) : null
        ]
      }
    );
  }
);
V1.displayName = "Checkbox";
var Ha = { exports: {} }, xo = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ec;
function t6() {
  if (ec)
    return we;
  ec = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function w(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case r:
          switch (C = C.type, C) {
            case l:
            case c:
            case n:
            case i:
            case o:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case u:
                case v:
                case p:
                case a:
                  return C;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  function x(C) {
    return w(C) === c;
  }
  return we.AsyncMode = l, we.ConcurrentMode = c, we.ContextConsumer = s, we.ContextProvider = a, we.Element = r, we.ForwardRef = u, we.Fragment = n, we.Lazy = v, we.Memo = p, we.Portal = t, we.Profiler = i, we.StrictMode = o, we.Suspense = d, we.isAsyncMode = function(C) {
    return x(C) || w(C) === l;
  }, we.isConcurrentMode = x, we.isContextConsumer = function(C) {
    return w(C) === s;
  }, we.isContextProvider = function(C) {
    return w(C) === a;
  }, we.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === r;
  }, we.isForwardRef = function(C) {
    return w(C) === u;
  }, we.isFragment = function(C) {
    return w(C) === n;
  }, we.isLazy = function(C) {
    return w(C) === v;
  }, we.isMemo = function(C) {
    return w(C) === p;
  }, we.isPortal = function(C) {
    return w(C) === t;
  }, we.isProfiler = function(C) {
    return w(C) === i;
  }, we.isStrictMode = function(C) {
    return w(C) === o;
  }, we.isSuspense = function(C) {
    return w(C) === d;
  }, we.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === c || C === i || C === o || C === d || C === h || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === p || C.$$typeof === a || C.$$typeof === s || C.$$typeof === u || C.$$typeof === y || C.$$typeof === b || C.$$typeof === g || C.$$typeof === m);
  }, we.typeOf = w, we;
}
var xe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tc;
function n6() {
  return tc || (tc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function w(q) {
      return typeof q == "string" || typeof q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      q === n || q === c || q === i || q === o || q === d || q === h || typeof q == "object" && q !== null && (q.$$typeof === v || q.$$typeof === p || q.$$typeof === a || q.$$typeof === s || q.$$typeof === u || q.$$typeof === y || q.$$typeof === b || q.$$typeof === g || q.$$typeof === m);
    }
    function x(q) {
      if (typeof q == "object" && q !== null) {
        var ke = q.$$typeof;
        switch (ke) {
          case r:
            var ne = q.type;
            switch (ne) {
              case l:
              case c:
              case n:
              case i:
              case o:
              case d:
                return ne;
              default:
                var Ze = ne && ne.$$typeof;
                switch (Ze) {
                  case s:
                  case u:
                  case v:
                  case p:
                  case a:
                    return Ze;
                  default:
                    return ke;
                }
            }
          case t:
            return ke;
        }
      }
    }
    var C = l, O = c, E = s, _ = a, R = r, H = u, $ = n, Y = v, j = p, A = t, W = i, U = o, Z = d, J = !1;
    function le(q) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(q) || x(q) === l;
    }
    function z(q) {
      return x(q) === c;
    }
    function F(q) {
      return x(q) === s;
    }
    function L(q) {
      return x(q) === a;
    }
    function N(q) {
      return typeof q == "object" && q !== null && q.$$typeof === r;
    }
    function I(q) {
      return x(q) === u;
    }
    function P(q) {
      return x(q) === n;
    }
    function B(q) {
      return x(q) === v;
    }
    function ee(q) {
      return x(q) === p;
    }
    function te(q) {
      return x(q) === t;
    }
    function ae(q) {
      return x(q) === i;
    }
    function se(q) {
      return x(q) === o;
    }
    function ge(q) {
      return x(q) === d;
    }
    xe.AsyncMode = C, xe.ConcurrentMode = O, xe.ContextConsumer = E, xe.ContextProvider = _, xe.Element = R, xe.ForwardRef = H, xe.Fragment = $, xe.Lazy = Y, xe.Memo = j, xe.Portal = A, xe.Profiler = W, xe.StrictMode = U, xe.Suspense = Z, xe.isAsyncMode = le, xe.isConcurrentMode = z, xe.isContextConsumer = F, xe.isContextProvider = L, xe.isElement = N, xe.isForwardRef = I, xe.isFragment = P, xe.isLazy = B, xe.isMemo = ee, xe.isPortal = te, xe.isProfiler = ae, xe.isStrictMode = se, xe.isSuspense = ge, xe.isValidElementType = w, xe.typeOf = x;
  }()), xe;
}
var nc;
function H1() {
  return nc || (nc = 1, process.env.NODE_ENV === "production" ? xo.exports = t6() : xo.exports = n6()), xo.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ea, rc;
function r6() {
  if (rc)
    return ea;
  rc = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ea = o() ? Object.assign : function(i, a) {
    for (var s, l = n(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        r.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          t.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, ea;
}
var ta, oc;
function Os() {
  if (oc)
    return ta;
  oc = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ta = e, ta;
}
var na, ic;
function F1() {
  return ic || (ic = 1, na = Function.call.bind(Object.prototype.hasOwnProperty)), na;
}
var ra, ac;
function o6() {
  if (ac)
    return ra;
  ac = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Os(), t = {}, n = F1();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = i[u](a, u, l, s, null, r);
          } catch (v) {
            d = v;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, ra = o, ra;
}
var oa, sc;
function i6() {
  if (sc)
    return oa;
  sc = 1;
  var e = H1(), r = r6(), t = Os(), n = F1(), o = o6(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return oa = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(z) {
      var F = z && (c && z[c] || z[u]);
      if (typeof F == "function")
        return F;
    }
    var h = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: g(),
      arrayOf: w,
      element: x(),
      elementType: C(),
      instanceOf: O,
      node: H(),
      objectOf: _,
      oneOf: E,
      oneOfType: R,
      shape: Y,
      exact: j
    };
    function v(z, F) {
      return z === F ? z !== 0 || 1 / z === 1 / F : z !== z && F !== F;
    }
    function m(z, F) {
      this.message = z, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function y(z) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, L = 0;
      function N(P, B, ee, te, ae, se, ge) {
        if (te = te || h, se = se || ee, ge !== t) {
          if (l) {
            var q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw q.name = "Invariant Violation", q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ke = te + ":" + ee;
            !F[ke] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + se + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[ke] = !0, L++);
          }
        }
        return B[ee] == null ? P ? B[ee] === null ? new m("The " + ae + " `" + se + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new m("The " + ae + " `" + se + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : z(B, ee, te, ae, se);
      }
      var I = N.bind(null, !1);
      return I.isRequired = N.bind(null, !0), I;
    }
    function b(z) {
      function F(L, N, I, P, B, ee) {
        var te = L[N], ae = U(te);
        if (ae !== z) {
          var se = Z(te);
          return new m(
            "Invalid " + P + " `" + B + "` of type " + ("`" + se + "` supplied to `" + I + "`, expected ") + ("`" + z + "`."),
            { expectedType: z }
          );
        }
        return null;
      }
      return y(F);
    }
    function g() {
      return y(a);
    }
    function w(z) {
      function F(L, N, I, P, B) {
        if (typeof z != "function")
          return new m("Property `" + B + "` of component `" + I + "` has invalid PropType notation inside arrayOf.");
        var ee = L[N];
        if (!Array.isArray(ee)) {
          var te = U(ee);
          return new m("Invalid " + P + " `" + B + "` of type " + ("`" + te + "` supplied to `" + I + "`, expected an array."));
        }
        for (var ae = 0; ae < ee.length; ae++) {
          var se = z(ee, ae, I, P, B + "[" + ae + "]", t);
          if (se instanceof Error)
            return se;
        }
        return null;
      }
      return y(F);
    }
    function x() {
      function z(F, L, N, I, P) {
        var B = F[L];
        if (!s(B)) {
          var ee = U(B);
          return new m("Invalid " + I + " `" + P + "` of type " + ("`" + ee + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(z);
    }
    function C() {
      function z(F, L, N, I, P) {
        var B = F[L];
        if (!e.isValidElementType(B)) {
          var ee = U(B);
          return new m("Invalid " + I + " `" + P + "` of type " + ("`" + ee + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(z);
    }
    function O(z) {
      function F(L, N, I, P, B) {
        if (!(L[N] instanceof z)) {
          var ee = z.name || h, te = le(L[N]);
          return new m("Invalid " + P + " `" + B + "` of type " + ("`" + te + "` supplied to `" + I + "`, expected ") + ("instance of `" + ee + "`."));
        }
        return null;
      }
      return y(F);
    }
    function E(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(L, N, I, P, B) {
        for (var ee = L[N], te = 0; te < z.length; te++)
          if (v(ee, z[te]))
            return null;
        var ae = JSON.stringify(z, function(ge, q) {
          var ke = Z(q);
          return ke === "symbol" ? String(q) : q;
        });
        return new m("Invalid " + P + " `" + B + "` of value `" + String(ee) + "` " + ("supplied to `" + I + "`, expected one of " + ae + "."));
      }
      return y(F);
    }
    function _(z) {
      function F(L, N, I, P, B) {
        if (typeof z != "function")
          return new m("Property `" + B + "` of component `" + I + "` has invalid PropType notation inside objectOf.");
        var ee = L[N], te = U(ee);
        if (te !== "object")
          return new m("Invalid " + P + " `" + B + "` of type " + ("`" + te + "` supplied to `" + I + "`, expected an object."));
        for (var ae in ee)
          if (n(ee, ae)) {
            var se = z(ee, ae, I, P, B + "." + ae, t);
            if (se instanceof Error)
              return se;
          }
        return null;
      }
      return y(F);
    }
    function R(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < z.length; F++) {
        var L = z[F];
        if (typeof L != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(L) + " at index " + F + "."
          ), a;
      }
      function N(I, P, B, ee, te) {
        for (var ae = [], se = 0; se < z.length; se++) {
          var ge = z[se], q = ge(I, P, B, ee, te, t);
          if (q == null)
            return null;
          q.data && n(q.data, "expectedType") && ae.push(q.data.expectedType);
        }
        var ke = ae.length > 0 ? ", expected one of type [" + ae.join(", ") + "]" : "";
        return new m("Invalid " + ee + " `" + te + "` supplied to " + ("`" + B + "`" + ke + "."));
      }
      return y(N);
    }
    function H() {
      function z(F, L, N, I, P) {
        return A(F[L]) ? null : new m("Invalid " + I + " `" + P + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return y(z);
    }
    function $(z, F, L, N, I) {
      return new m(
        (z || "React class") + ": " + F + " type `" + L + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + I + "`."
      );
    }
    function Y(z) {
      function F(L, N, I, P, B) {
        var ee = L[N], te = U(ee);
        if (te !== "object")
          return new m("Invalid " + P + " `" + B + "` of type `" + te + "` " + ("supplied to `" + I + "`, expected `object`."));
        for (var ae in z) {
          var se = z[ae];
          if (typeof se != "function")
            return $(I, P, B, ae, Z(se));
          var ge = se(ee, ae, I, P, B + "." + ae, t);
          if (ge)
            return ge;
        }
        return null;
      }
      return y(F);
    }
    function j(z) {
      function F(L, N, I, P, B) {
        var ee = L[N], te = U(ee);
        if (te !== "object")
          return new m("Invalid " + P + " `" + B + "` of type `" + te + "` " + ("supplied to `" + I + "`, expected `object`."));
        var ae = r({}, L[N], z);
        for (var se in ae) {
          var ge = z[se];
          if (n(z, se) && typeof ge != "function")
            return $(I, P, B, se, Z(ge));
          if (!ge)
            return new m(
              "Invalid " + P + " `" + B + "` key `" + se + "` supplied to `" + I + "`.\nBad object: " + JSON.stringify(L[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(z), null, "  ")
            );
          var q = ge(ee, se, I, P, B + "." + se, t);
          if (q)
            return q;
        }
        return null;
      }
      return y(F);
    }
    function A(z) {
      switch (typeof z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !z;
        case "object":
          if (Array.isArray(z))
            return z.every(A);
          if (z === null || s(z))
            return !0;
          var F = d(z);
          if (F) {
            var L = F.call(z), N;
            if (F !== z.entries) {
              for (; !(N = L.next()).done; )
                if (!A(N.value))
                  return !1;
            } else
              for (; !(N = L.next()).done; ) {
                var I = N.value;
                if (I && !A(I[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(z, F) {
      return z === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function U(z) {
      var F = typeof z;
      return Array.isArray(z) ? "array" : z instanceof RegExp ? "object" : W(F, z) ? "symbol" : F;
    }
    function Z(z) {
      if (typeof z > "u" || z === null)
        return "" + z;
      var F = U(z);
      if (F === "object") {
        if (z instanceof Date)
          return "date";
        if (z instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function J(z) {
      var F = Z(z);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function le(z) {
      return !z.constructor || !z.constructor.name ? h : z.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, oa;
}
var ia, lc;
function a6() {
  if (lc)
    return ia;
  lc = 1;
  var e = Os();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, ia = function() {
    function n(a, s, l, c, u, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, ia;
}
if (process.env.NODE_ENV !== "production") {
  var s6 = H1(), l6 = !0;
  Ha.exports = i6()(s6.isElement, l6);
} else
  Ha.exports = a6()();
var c6 = Ha.exports;
const K = /* @__PURE__ */ P1(c6);
function kn(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function oe(e) {
  const r = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && r === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || r === "[object Number]" || typeof e == "string" || r === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function zr(e) {
  if (!kn(e) && typeof e != "number")
    return !1;
  const r = oe(e);
  return !isNaN(Number(r));
}
const u6 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, d6 = (e, r, t) => {
  let n;
  const o = u6[e];
  return typeof o == "string" ? n = o : r === 1 ? n = o.one : n = o.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function aa(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const f6 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, p6 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, h6 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, v6 = {
  date: aa({
    formats: f6,
    defaultWidth: "full"
  }),
  time: aa({
    formats: p6,
    defaultWidth: "full"
  }),
  dateTime: aa({
    formats: h6,
    defaultWidth: "full"
  })
}, m6 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, g6 = (e, r, t, n) => m6[e];
function wr(e) {
  return (r, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(r) : r;
    return o[i];
  };
}
const y6 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, w6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, x6 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, C6 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, b6 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, M6 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, D6 = (e, r) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, _6 = {
  ordinalNumber: D6,
  era: wr({
    values: y6,
    defaultWidth: "wide"
  }),
  quarter: wr({
    values: w6,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: wr({
    values: x6,
    defaultWidth: "wide"
  }),
  day: wr({
    values: C6,
    defaultWidth: "wide"
  }),
  dayPeriod: wr({
    values: b6,
    defaultWidth: "wide",
    formattingValues: M6,
    defaultFormattingWidth: "wide"
  })
};
function xr(e) {
  return (r, t = {}) => {
    const n = t.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = r.match(o);
    if (!i)
      return null;
    const a = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? I6(s, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      E6(s, (d) => d.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(c)
    ) : c;
    const u = r.slice(a.length);
    return { value: c, rest: u };
  };
}
function E6(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function I6(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function O6(e) {
  return (r, t = {}) => {
    const n = r.match(e.matchPattern);
    if (!n)
      return null;
    const o = n[0], i = r.match(e.parsePattern);
    if (!i)
      return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const s = r.slice(o.length);
    return { value: a, rest: s };
  };
}
const N6 = /^(\d+)(th|st|nd|rd)?/i, T6 = /\d+/i, k6 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, S6 = {
  any: [/^b/i, /^(a|c)/i]
}, R6 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, j6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, P6 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, A6 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, L6 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, V6 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, H6 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, F6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Y6 = {
  ordinalNumber: O6({
    matchPattern: N6,
    parsePattern: T6,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: xr({
    matchPatterns: k6,
    defaultMatchWidth: "wide",
    parsePatterns: S6,
    defaultParseWidth: "any"
  }),
  quarter: xr({
    matchPatterns: R6,
    defaultMatchWidth: "wide",
    parsePatterns: j6,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: xr({
    matchPatterns: P6,
    defaultMatchWidth: "wide",
    parsePatterns: A6,
    defaultParseWidth: "any"
  }),
  day: xr({
    matchPatterns: L6,
    defaultMatchWidth: "wide",
    parsePatterns: V6,
    defaultParseWidth: "any"
  }),
  dayPeriod: xr({
    matchPatterns: H6,
    defaultMatchWidth: "any",
    parsePatterns: F6,
    defaultParseWidth: "any"
  })
}, Y1 = {
  code: "en-US",
  formatDistance: d6,
  formatLong: v6,
  formatRelative: g6,
  localize: _6,
  match: Y6,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let $6 = {};
function Ln() {
  return $6;
}
const $1 = 6048e5, z6 = 864e5, Ni = 6e4, Ti = 36e5, Z6 = 1e3;
function jt(e) {
  const r = oe(e);
  return r.setHours(0, 0, 0, 0), r;
}
function Xo(e) {
  const r = oe(e), t = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return t.setUTCFullYear(r.getFullYear()), +e - +t;
}
function Zr(e, r) {
  const t = jt(e), n = jt(r), o = +t - Xo(t), i = +n - Xo(n);
  return Math.round((o - i) / z6);
}
function Ie(e, r) {
  return e instanceof Date ? new e.constructor(r) : new Date(r);
}
function Ns(e) {
  const r = oe(e), t = Ie(e, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function W6(e) {
  const r = oe(e);
  return Zr(r, Ns(r)) + 1;
}
function zt(e, r) {
  var s, l, c, u;
  const t = Ln(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = oe(e), i = o.getDay(), a = (i < n ? 7 : 0) + i - n;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function ir(e) {
  return zt(e, { weekStartsOn: 1 });
}
function z1(e) {
  const r = oe(e), t = r.getFullYear(), n = Ie(e, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = ir(n), i = Ie(e, 0);
  i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0);
  const a = ir(i);
  return r.getTime() >= o.getTime() ? t + 1 : r.getTime() >= a.getTime() ? t : t - 1;
}
function B6(e) {
  const r = z1(e), t = Ie(e, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), ir(t);
}
function Ts(e) {
  const r = oe(e), t = +ir(r) - +B6(r);
  return Math.round(t / $1) + 1;
}
function ks(e, r) {
  var u, d, h, p;
  const t = oe(e), n = t.getFullYear(), o = Ln(), i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = Ie(e, 0);
  a.setFullYear(n + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = zt(a, r), l = Ie(e, 0);
  l.setFullYear(n, 0, i), l.setHours(0, 0, 0, 0);
  const c = zt(l, r);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= c.getTime() ? n : n - 1;
}
function U6(e, r) {
  var s, l, c, u;
  const t = Ln(), n = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = ks(e, r), i = Ie(e, 0);
  return i.setFullYear(o, 0, n), i.setHours(0, 0, 0, 0), zt(i, r);
}
function Z1(e, r) {
  const t = oe(e), n = +zt(t, r) - +U6(t, r);
  return Math.round(n / $1) + 1;
}
function De(e, r) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(r, "0");
  return t + n;
}
const Xt = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return De(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : De(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return De(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return De(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return De(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return De(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return De(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, n = e.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return De(o, r.length);
  }
}, Wn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, cc = {
  // Era
  G: function(e, r, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return Xt.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, n) {
    const o = ks(e, n), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      const a = i % 100;
      return De(a, 2);
    }
    return r === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : De(i, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = z1(e);
    return De(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return De(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return De(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return De(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return Xt.M(e, r);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return De(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, n) {
    const o = Z1(e, n);
    return r === "wo" ? t.ordinalNumber(o, { unit: "week" }) : De(o, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const n = Ts(e);
    return r === "Io" ? t.ordinalNumber(n, { unit: "week" }) : De(n, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Xt.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const n = W6(e);
    return r === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : De(n, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const n = e.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return De(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return De(i, r.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return De(o, r.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = Wn.noon : n === 0 ? o = Wn.midnight : o = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = Wn.evening : n >= 12 ? o = Wn.afternoon : n >= 4 ? o = Wn.morning : o = Wn.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return Xt.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Xt.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const n = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : De(n, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), r === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : De(n, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Xt.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Xt.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return Xt.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (r) {
      case "X":
        return dc(n);
      case "XXXX":
      case "XX":
        return bn(n);
      case "XXXXX":
      case "XXX":
      default:
        return bn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "x":
        return dc(n);
      case "xxxx":
      case "xx":
        return bn(n);
      case "xxxxx":
      case "xxx":
      default:
        return bn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + uc(n, ":");
      case "OOOO":
      default:
        return "GMT" + bn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + uc(n, ":");
      case "zzzz":
      default:
        return "GMT" + bn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t) {
    const n = Math.trunc(e.getTime() / 1e3);
    return De(n, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t) {
    const n = e.getTime();
    return De(n, r.length);
  }
};
function uc(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? t + String(o) : t + String(o) + r + De(i, 2);
}
function dc(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + De(Math.abs(e) / 60, 2) : bn(e, r);
}
function bn(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = De(Math.trunc(n / 60), 2), i = De(n % 60, 2);
  return t + o + r + i;
}
const fc = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, W1 = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, K6 = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], o = t[2];
  if (!o)
    return fc(e, r);
  let i;
  switch (n) {
    case "P":
      i = r.dateTime({ width: "short" });
      break;
    case "PP":
      i = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = r.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", fc(n, r)).replace("{{time}}", W1(o, r));
}, Jo = {
  p: W1,
  P: K6
}, Q6 = /^D+$/, q6 = /^Y+$/, G6 = ["D", "DD", "YY", "YYYY"];
function B1(e) {
  return Q6.test(e);
}
function U1(e) {
  return q6.test(e);
}
function Fa(e, r, t) {
  const n = X6(e, r, t);
  if (console.warn(n), G6.includes(e))
    throw new RangeError(n);
}
function X6(e, r, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const J6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, eh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, th = /^'([^]*?)'?$/, nh = /''/g, rh = /[a-zA-Z]/;
function pc(e, r, t) {
  var u, d, h, p, v, m, y, b;
  const n = Ln(), o = (t == null ? void 0 : t.locale) ?? n.locale ?? Y1, i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = oe(e);
  if (!zr(s))
    throw new RangeError("Invalid time value");
  let l = r.match(eh).map((g) => {
    const w = g[0];
    if (w === "p" || w === "P") {
      const x = Jo[w];
      return x(g, o.formatLong);
    }
    return g;
  }).join("").match(J6).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const w = g[0];
    if (w === "'")
      return { isToken: !1, value: oh(g) };
    if (cc[w])
      return { isToken: !0, value: g };
    if (w.match(rh))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: g };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((g) => {
    if (!g.isToken)
      return g.value;
    const w = g.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && U1(w) || !(t != null && t.useAdditionalDayOfYearTokens) && B1(w)) && Fa(w, r, String(e));
    const x = cc[w[0]];
    return x(s, w, o.localize, c);
  }).join("");
}
function oh(e) {
  const r = e.match(th);
  return r ? r[1].replace(nh, "'") : e;
}
function K1(e, r) {
  const t = +oe(e);
  return Ie(e, t + r);
}
function Ya(e, r) {
  return K1(e, r * Ni);
}
function ih(e, r) {
  return K1(e, r * Ti);
}
function yn(e, r) {
  const t = oe(e);
  return isNaN(r) ? Ie(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
function ei(e, r) {
  const t = r * 7;
  return yn(e, t);
}
function Dt(e, r) {
  const t = oe(e);
  if (isNaN(r))
    return Ie(e, NaN);
  if (!r)
    return t;
  const n = t.getDate(), o = Ie(e, t.getTime());
  o.setMonth(t.getMonth() + r + 1, 0);
  const i = o.getDate();
  return n >= i ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), t);
}
function Q1(e, r) {
  const t = r * 3;
  return Dt(e, t);
}
function on(e, r) {
  return Dt(e, r * 12);
}
function ah(e, r) {
  return yn(e, -r);
}
function hc(e, r) {
  return ei(e, -r);
}
function ar(e, r) {
  return Dt(e, -r);
}
function sh(e, r) {
  return Q1(e, -r);
}
function Wr(e, r) {
  return on(e, -r);
}
function vc(e) {
  return oe(e).getSeconds();
}
function Pt(e) {
  return oe(e).getMinutes();
}
function At(e) {
  return oe(e).getHours();
}
function lh(e) {
  return oe(e).getDay();
}
function mc(e) {
  return oe(e).getDate();
}
function tt(e) {
  return oe(e).getMonth();
}
function Nr(e) {
  const r = oe(e);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function de(e) {
  return oe(e).getFullYear();
}
function $a(e) {
  return oe(e).getTime();
}
function ch(e, r) {
  const t = oe(e);
  return t.setSeconds(r), t;
}
function Vo(e, r) {
  const t = oe(e);
  return t.setMinutes(r), t;
}
function Ho(e, r) {
  const t = oe(e);
  return t.setHours(r), t;
}
function uh(e) {
  const r = oe(e), t = r.getFullYear(), n = r.getMonth(), o = Ie(e, 0);
  return o.setFullYear(t, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function et(e, r) {
  const t = oe(e), n = t.getFullYear(), o = t.getDate(), i = Ie(e, 0);
  i.setFullYear(n, r, 15), i.setHours(0, 0, 0, 0);
  const a = uh(i);
  return t.setMonth(r, Math.min(o, a)), t;
}
function Bn(e, r) {
  const t = oe(e), n = Math.trunc(t.getMonth() / 3) + 1, o = r - n;
  return et(t, t.getMonth() + o * 3);
}
function Yt(e, r) {
  const t = oe(e);
  return isNaN(+t) ? Ie(e, NaN) : (t.setFullYear(r), t);
}
function gc(e) {
  let r;
  return e.forEach((t) => {
    const n = oe(t);
    (!r || r > n || isNaN(+n)) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function yc(e) {
  let r;
  return e.forEach(function(t) {
    const n = oe(t);
    (r === void 0 || r < n || isNaN(Number(n))) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function ti(e, r) {
  const t = oe(e), n = oe(r), o = t.getFullYear() - n.getFullYear(), i = t.getMonth() - n.getMonth();
  return o * 12 + i;
}
function ni(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() - n.getFullYear();
}
function q1(e) {
  const r = oe(e);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function za(e) {
  const r = oe(e), t = r.getMonth(), n = t - t % 3;
  return r.setMonth(n, 1), r.setHours(0, 0, 0, 0), r;
}
function Za(e) {
  const r = oe(e);
  return r.setHours(23, 59, 59, 999), r;
}
function dh(e, r) {
  var s, l, c, u;
  const t = Ln(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = oe(e), i = o.getDay(), a = (i < n ? -7 : 0) + 6 - (i - n);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function fh(e) {
  const r = oe(e), t = r.getMonth();
  return r.setFullYear(r.getFullYear(), t + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function ph(e) {
  const r = oe(e), t = r.getFullYear();
  return r.setFullYear(t + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function hh(e, r) {
  const t = oe(e), n = oe(r);
  return +t == +n;
}
function vh(e, r) {
  const t = jt(e), n = jt(r);
  return +t == +n;
}
function mh(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function gh(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() === n.getFullYear();
}
function yh(e, r) {
  const t = za(e), n = za(r);
  return +t == +n;
}
function hn(e, r) {
  const t = oe(e), n = oe(r);
  return t.getTime() > n.getTime();
}
function Sn(e, r) {
  const t = oe(e), n = oe(r);
  return +t < +n;
}
function Br(e, r) {
  const t = +oe(e), [n, o] = [
    +oe(r.start),
    +oe(r.end)
  ].sort((i, a) => i - a);
  return t >= n && t <= o;
}
function wh() {
  return Object.assign({}, Ln());
}
function xh(e, r) {
  const t = r instanceof Date ? Ie(r, 0) : new r(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const Ch = 10;
class G1 {
  constructor() {
    re(this, "subPriority", 0);
  }
  validate(r, t) {
    return !0;
  }
}
class bh extends G1 {
  constructor(r, t, n, o, i) {
    super(), this.value = r, this.validateValue = t, this.setValue = n, this.priority = o, i && (this.subPriority = i);
  }
  validate(r, t) {
    return this.validateValue(r, this.value, t);
  }
  set(r, t, n) {
    return this.setValue(r, t, this.value, n);
  }
}
class Mh extends G1 {
  constructor() {
    super(...arguments);
    re(this, "priority", Ch);
    re(this, "subPriority", -1);
  }
  set(t, n) {
    return n.timestampIsSet ? t : Ie(t, xh(t, Date));
  }
}
class ye {
  run(r, t, n, o) {
    const i = this.parse(r, t, n, o);
    return i ? {
      setter: new bh(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(r, t, n) {
    return !0;
  }
}
class Dh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 140);
    re(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, n, o) {
    return n.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const Fe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, St = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ye(e, r) {
  return e && {
    value: r(e.value),
    rest: e.rest
  };
}
function Ae(e, r) {
  const t = r.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function Rt(e, r) {
  const t = r.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, a = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (o * Ti + i * Ni + a * Z6),
    rest: r.slice(t[0].length)
  };
}
function X1(e) {
  return Ae(Fe.anyDigitsSigned, e);
}
function He(e, r) {
  switch (e) {
    case 1:
      return Ae(Fe.singleDigit, r);
    case 2:
      return Ae(Fe.twoDigits, r);
    case 3:
      return Ae(Fe.threeDigits, r);
    case 4:
      return Ae(Fe.fourDigits, r);
    default:
      return Ae(new RegExp("^\\d{1," + e + "}"), r);
  }
}
function ri(e, r) {
  switch (e) {
    case 1:
      return Ae(Fe.singleDigitSigned, r);
    case 2:
      return Ae(Fe.twoDigitsSigned, r);
    case 3:
      return Ae(Fe.threeDigitsSigned, r);
    case 4:
      return Ae(Fe.fourDigitsSigned, r);
    default:
      return Ae(new RegExp("^-?\\d{1," + e + "}"), r);
  }
}
function Ss(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function J1(e, r) {
  const t = r > 0, n = t ? r : 1 - r;
  let o;
  if (n <= 50)
    o = e || 100;
  else {
    const i = n + 50, a = Math.trunc(i / 100) * 100, s = e >= i % 100;
    o = e + a - (s ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function ed(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class _h extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Ye(He(4, t), i);
      case "yo":
        return Ye(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return Ye(He(n.length, t), i);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o) {
    const i = t.getFullYear();
    if (o.isTwoDigitYear) {
      const s = J1(
        o.year,
        i
      );
      return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Eh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Ye(He(4, t), i);
      case "Yo":
        return Ye(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return Ye(He(n.length, t), i);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o, i) {
    const a = ks(t, i);
    if (o.isTwoDigitYear) {
      const l = J1(
        o.year,
        a
      );
      return t.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), zt(t, i);
    }
    const s = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(s, 0, i.firstWeekContainsDate), t.setHours(0, 0, 0, 0), zt(t, i);
  }
}
class Ih extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n) {
    return ri(n === "R" ? 4 : n.length, t);
  }
  set(t, n, o) {
    const i = Ie(t, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), ir(i);
  }
}
class Oh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 130);
    re(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n) {
    return ri(n === "u" ? 4 : n.length, t);
  }
  set(t, n, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Nh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 120);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "Q":
      case "QQ":
        return He(n.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Th extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 120);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "q":
      case "qq":
        return He(n.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class kh extends ye {
  constructor() {
    super(...arguments);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    re(this, "priority", 110);
  }
  parse(t, n, o) {
    const i = (a) => a - 1;
    switch (n) {
      case "M":
        return Ye(
          Ae(Fe.month, t),
          i
        );
      case "MM":
        return Ye(He(2, t), i);
      case "Mo":
        return Ye(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Sh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 110);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => a - 1;
    switch (n) {
      case "L":
        return Ye(
          Ae(Fe.month, t),
          i
        );
      case "LL":
        return Ye(He(2, t), i);
      case "Lo":
        return Ye(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Rh(e, r, t) {
  const n = oe(e), o = Z1(n, t) - r;
  return n.setDate(n.getDate() - o * 7), n;
}
class jh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 100);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "w":
        return Ae(Fe.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o, i) {
    return zt(Rh(t, o, i), i);
  }
}
function Ph(e, r) {
  const t = oe(e), n = Ts(t) - r;
  return t.setDate(t.getDate() - n * 7), t;
}
class Ah extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 100);
    re(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "I":
        return Ae(Fe.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o) {
    return ir(Ph(t, o));
  }
}
const Lh = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Vh = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Hh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "subPriority", 1);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "d":
        return Ae(Fe.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear(), i = ed(o), a = t.getMonth();
    return i ? n >= 1 && n <= Vh[a] : n >= 1 && n <= Lh[a];
  }
  set(t, n, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class Fh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "subpriority", 1);
    re(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "D":
      case "DD":
        return Ae(Fe.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear();
    return ed(o) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Rs(e, r, t) {
  var d, h, p, v;
  const n = Ln(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? n.weekStartsOn ?? ((v = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = oe(e), a = i.getDay(), l = (r % 7 + 7) % 7, c = 7 - o, u = r < 0 || r > 6 ? r - (a + c) % 7 : (l + c) % 7 - (a + c) % 7;
  return yn(i, u);
}
class Yh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = Rs(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
class $h extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, i) {
    const a = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return Ye(He(n.length, t), a);
      case "eo":
        return Ye(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = Rs(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
class zh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, i) {
    const a = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return Ye(He(n.length, t), a);
      case "co":
        return Ye(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = Rs(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
function Zh(e) {
  let t = oe(e).getDay();
  return t === 0 && (t = 7), t;
}
function Wh(e, r) {
  const t = oe(e), n = Zh(t), o = r - n;
  return yn(t, o);
}
class Bh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 90);
    re(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => a === 0 ? 7 : a;
    switch (n) {
      case "i":
      case "ii":
        return He(n.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return Ye(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return Ye(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return Ye(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return Ye(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, o) {
    return t = Wh(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Uh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Ss(o), 0, 0, 0), t;
  }
}
class Kh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Ss(o), 0, 0, 0), t;
  }
}
class Qh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 80);
    re(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Ss(o), 0, 0, 0), t;
  }
}
class qh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "h":
        return Ae(Fe.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, o) {
    const i = t.getHours() >= 12;
    return i && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class Gh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "H":
        return Ae(Fe.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class Xh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "K":
        return Ae(Fe.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class Jh extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 70);
    re(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "k":
        return Ae(Fe.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, o) {
    const i = o <= 24 ? o % 24 : o;
    return t.setHours(i, 0, 0, 0), t;
  }
}
class e2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 60);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "m":
        return Ae(Fe.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class t2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 50);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "s":
        return Ae(Fe.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return He(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setSeconds(o, 0), t;
  }
}
class n2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 30);
    re(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n) {
    const o = (i) => Math.trunc(i * Math.pow(10, -n.length + 3));
    return Ye(He(n.length, t), o);
  }
  set(t, n, o) {
    return t.setMilliseconds(o), t;
  }
}
class r2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 10);
    re(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, n) {
    switch (n) {
      case "X":
        return Rt(
          St.basicOptionalMinutes,
          t
        );
      case "XX":
        return Rt(St.basic, t);
      case "XXXX":
        return Rt(
          St.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Rt(
          St.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Rt(St.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : Ie(
      t,
      t.getTime() - Xo(t) - o
    );
  }
}
class o2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 10);
    re(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, n) {
    switch (n) {
      case "x":
        return Rt(
          St.basicOptionalMinutes,
          t
        );
      case "xx":
        return Rt(St.basic, t);
      case "xxxx":
        return Rt(
          St.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Rt(
          St.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Rt(St.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : Ie(
      t,
      t.getTime() - Xo(t) - o
    );
  }
}
class i2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 40);
    re(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return X1(t);
  }
  set(t, n, o) {
    return [Ie(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class a2 extends ye {
  constructor() {
    super(...arguments);
    re(this, "priority", 20);
    re(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return X1(t);
  }
  set(t, n, o) {
    return [Ie(t, o), { timestampIsSet: !0 }];
  }
}
const s2 = {
  G: new Dh(),
  y: new _h(),
  Y: new Eh(),
  R: new Ih(),
  u: new Oh(),
  Q: new Nh(),
  q: new Th(),
  M: new kh(),
  L: new Sh(),
  w: new jh(),
  I: new Ah(),
  d: new Hh(),
  D: new Fh(),
  E: new Yh(),
  e: new $h(),
  c: new zh(),
  i: new Bh(),
  a: new Uh(),
  b: new Kh(),
  B: new Qh(),
  h: new qh(),
  H: new Gh(),
  K: new Xh(),
  k: new Jh(),
  m: new e2(),
  s: new t2(),
  S: new n2(),
  X: new r2(),
  x: new o2(),
  t: new i2(),
  T: new a2()
}, l2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, c2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, u2 = /^'([^]*?)'?$/, d2 = /''/g, f2 = /\S/, p2 = /[a-zA-Z]/;
function sa(e, r, t, n) {
  var m, y, b, g, w, x, C, O;
  const o = wh(), i = (n == null ? void 0 : n.locale) ?? o.locale ?? Y1, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((y = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : y.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((g = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((x = (w = n == null ? void 0 : n.locale) == null ? void 0 : w.options) == null ? void 0 : x.weekStartsOn) ?? o.weekStartsOn ?? ((O = (C = o.locale) == null ? void 0 : C.options) == null ? void 0 : O.weekStartsOn) ?? 0;
  if (r === "")
    return e === "" ? oe(t) : Ie(t, NaN);
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: i
  }, c = [new Mh()], u = r.match(c2).map((E) => {
    const _ = E[0];
    if (_ in Jo) {
      const R = Jo[_];
      return R(E, i.formatLong);
    }
    return E;
  }).join("").match(l2), d = [];
  for (let E of u) {
    !(n != null && n.useAdditionalWeekYearTokens) && U1(E) && Fa(E, r, e), !(n != null && n.useAdditionalDayOfYearTokens) && B1(E) && Fa(E, r, e);
    const _ = E[0], R = s2[_];
    if (R) {
      const { incompatibleTokens: H } = R;
      if (Array.isArray(H)) {
        const Y = d.find(
          (j) => H.includes(j.token) || j.token === _
        );
        if (Y)
          throw new RangeError(
            `The format string mustn't contain \`${Y.fullToken}\` and \`${E}\` at the same time`
          );
      } else if (R.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${E}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: E });
      const $ = R.run(
        e,
        E,
        i.match,
        l
      );
      if (!$)
        return Ie(t, NaN);
      c.push($.setter), e = $.rest;
    } else {
      if (_.match(p2))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (E === "''" ? E = "'" : _ === "'" && (E = h2(E)), e.indexOf(E) === 0)
        e = e.slice(E.length);
      else
        return Ie(t, NaN);
    }
  }
  if (e.length > 0 && f2.test(e))
    return Ie(t, NaN);
  const h = c.map((E) => E.priority).sort((E, _) => _ - E).filter((E, _, R) => R.indexOf(E) === _).map(
    (E) => c.filter((_) => _.priority === E).sort((_, R) => R.subPriority - _.subPriority)
  ).map((E) => E[0]);
  let p = oe(t);
  if (isNaN(p.getTime()))
    return Ie(t, NaN);
  const v = {};
  for (const E of h) {
    if (!E.validate(p, l))
      return Ie(t, NaN);
    const _ = E.set(p, v, l);
    Array.isArray(_) ? (p = _[0], Object.assign(v, _[1])) : p = _;
  }
  return Ie(t, p);
}
function h2(e) {
  return e.match(u2)[1].replace(d2, "'");
}
function v2(e, r) {
  const t = (r == null ? void 0 : r.additionalDigits) ?? 2, n = w2(e);
  let o;
  if (n.date) {
    const l = x2(n.date, t);
    o = C2(l.restDateString, l.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = o.getTime();
  let a = 0, s;
  if (n.time && (a = b2(n.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (s = M2(n.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(i + a), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(i + a + s);
}
const Co = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, m2 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, g2 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, y2 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function w2(e) {
  const r = {}, t = e.split(Co.dateTimeDelimiter);
  let n;
  if (t.length > 2)
    return r;
  if (/:/.test(t[0]) ? n = t[0] : (r.date = t[0], n = t[1], Co.timeZoneDelimiter.test(r.date) && (r.date = e.split(Co.timeZoneDelimiter)[0], n = e.substr(
    r.date.length,
    e.length
  ))), n) {
    const o = Co.timezone.exec(n);
    o ? (r.time = n.replace(o[1], ""), r.timezone = o[1]) : r.time = n;
  }
  return r;
}
function x2(e, r) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), n = e.match(t);
  if (!n)
    return { year: NaN, restDateString: "" };
  const o = n[1] ? parseInt(n[1]) : null, i = n[2] ? parseInt(n[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function C2(e, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = e.match(m2);
  if (!t)
    return /* @__PURE__ */ new Date(NaN);
  const n = !!t[4], o = Cr(t[1]), i = Cr(t[2]) - 1, a = Cr(t[3]), s = Cr(t[4]), l = Cr(t[5]) - 1;
  if (n)
    return O2(r, s, l) ? D2(r, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !E2(r, i, a) || !I2(r, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(r, i, Math.max(o, a)), c);
  }
}
function Cr(e) {
  return e ? parseInt(e) : 1;
}
function b2(e) {
  const r = e.match(g2);
  if (!r)
    return NaN;
  const t = la(r[1]), n = la(r[2]), o = la(r[3]);
  return N2(t, n, o) ? t * Ti + n * Ni + o * 1e3 : NaN;
}
function la(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function M2(e) {
  if (e === "Z")
    return 0;
  const r = e.match(y2);
  if (!r)
    return 0;
  const t = r[1] === "+" ? -1 : 1, n = parseInt(r[2]), o = r[3] && parseInt(r[3]) || 0;
  return T2(n, o) ? t * (n * Ti + o * Ni) : NaN;
}
function D2(e, r, t) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const o = n.getUTCDay() || 7, i = (r - 1) * 7 + t + 1 - o;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const _2 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function td(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function E2(e, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (_2[r] || (td(e) ? 29 : 28));
}
function I2(e, r) {
  return r >= 1 && r <= (td(e) ? 366 : 365);
}
function O2(e, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function N2(e, r, t) {
  return e === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && e >= 0 && e < 25;
}
function T2(e, r) {
  return r >= 0 && r <= 59;
}
function k2(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, Wa(e, r);
}
function Wa(e, r) {
  return Wa = Object.setPrototypeOf || function(n, o) {
    return n.__proto__ = o, n;
  }, Wa(e, r);
}
function S2(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function wc(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function R2(e, r, t) {
  return e === r ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(t) : e.classList.contains(t);
}
function j2(e, r, t) {
  if (e === r)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && R2(e, r, t))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function P2(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var A2 = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var r = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), n = function() {
    };
    return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), r;
  }
};
function L2(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var V2 = L2(), Ba, bo = {}, ca = {}, H2 = ["touchstart", "touchmove"], F2 = "ignore-react-onclickoutside";
function xc(e, r) {
  var t = {}, n = H2.indexOf(r) !== -1;
  return n && Ba && (t.passive = !e.props.preventDefault), t;
}
function ki(e, r) {
  var t, n, o = e.displayName || e.name || "Component";
  return n = t = /* @__PURE__ */ function(i) {
    k2(a, i);
    function a(l) {
      var c;
      return c = i.call(this, l) || this, c.__outsideClickHandler = function(u) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(u);
          return;
        }
        var d = c.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + o + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var u = c.getInstance();
        return r && typeof r.setClickOutsideRef == "function" ? r.setClickOutsideRef()(u) : typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : Up(u);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document > "u" || ca[c._uid])) {
          typeof Ba > "u" && (Ba = A2()), ca[c._uid] = !0;
          var u = c.props.eventTypes;
          u.forEach || (u = [u]), bo[c._uid] = function(d) {
            if (c.componentNode !== null && (c.props.preventDefault && d.preventDefault(), c.props.stopPropagation && d.stopPropagation(), !(c.props.excludeScrollbar && P2(d)))) {
              var h = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              j2(h, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, bo[c._uid], xc(wc(c), d));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete ca[c._uid];
        var u = bo[c._uid];
        if (u && typeof document < "u") {
          var d = c.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(h) {
            return document.removeEventListener(h, u, xc(wc(c), h));
          }), delete bo[c._uid];
        }
      }, c.getRef = function(u) {
        return c.instanceRef = u;
      }, c._uid = V2(), c;
    }
    var s = a.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var c = this.instanceRef;
      return c.getInstance ? c.getInstance() : c;
    }, s.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var c = this.getInstance();
        if (r && typeof r.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = r.handleClickOutside(c), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + o + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var c = this.props;
      c.excludeScrollbar;
      var u = S2(c, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? u.ref = this.getRef : u.wrappedRef = this.getRef, u.disableOnClickOutside = this.disableOnClickOutside, u.enableOnClickOutside = this.enableOnClickOutside, R1(e, u);
    }, a;
  }(j1), t.displayName = "OnClickOutside(" + o + ")", t.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: r && r.excludeScrollbar || !1,
    outsideClickIgnoreClass: F2,
    preventDefault: !1,
    stopPropagation: !1
  }, t.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, n;
}
function Y2(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function br(e) {
  return e instanceof Element || e instanceof Y2(e).Element;
}
const Ua = Math.min, $2 = Math.max, z2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Z2 = {
  start: "end",
  end: "start"
};
function Ka(e, r, t) {
  return $2(e, Ua(r, t));
}
function so(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Rn(e) {
  return e.split("-")[0];
}
function lo(e) {
  return e.split("-")[1];
}
function nd(e) {
  return e === "x" ? "y" : "x";
}
function js(e) {
  return e === "y" ? "height" : "width";
}
function Si(e) {
  return ["top", "bottom"].includes(Rn(e)) ? "y" : "x";
}
function Ps(e) {
  return nd(Si(e));
}
function W2(e, r, t) {
  t === void 0 && (t = !1);
  const n = lo(e), o = Ps(e), i = js(o);
  let a = o === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return r.reference[i] > r.floating[i] && (a = oi(a)), [a, oi(a)];
}
function B2(e) {
  const r = oi(e);
  return [Qa(e), r, Qa(r)];
}
function Qa(e) {
  return e.replace(/start|end/g, (r) => Z2[r]);
}
function U2(e, r, t) {
  const n = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? r ? o : n : r ? n : o;
    case "left":
    case "right":
      return r ? i : a;
    default:
      return [];
  }
}
function K2(e, r, t, n) {
  const o = lo(e);
  let i = U2(Rn(e), t === "start", n);
  return o && (i = i.map((a) => a + "-" + o), r && (i = i.concat(i.map(Qa)))), i;
}
function oi(e) {
  return e.replace(/left|right|bottom|top/g, (r) => z2[r]);
}
function Q2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function rd(e) {
  return typeof e != "number" ? Q2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ii(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Cc(e, r, t) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = Si(r), a = Ps(r), s = js(a), l = Rn(r), c = i === "y", u = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, h = n[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (lo(r)) {
    case "start":
      p[a] -= h * (t && c ? -1 : 1);
      break;
    case "end":
      p[a] += h * (t && c ? -1 : 1);
      break;
  }
  return p;
}
const q2 = async (e, r, t) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = t, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(r));
  let c = await a.getElementRects({
    reference: e,
    floating: r,
    strategy: o
  }), {
    x: u,
    y: d
  } = Cc(c, n, l), h = n, p = {}, v = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: y,
      fn: b
    } = s[m], {
      x: g,
      y: w,
      data: x,
      reset: C
    } = await b({
      x: u,
      y: d,
      initialPlacement: n,
      placement: h,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: r
      }
    });
    u = g ?? u, d = w ?? d, p = {
      ...p,
      [y]: {
        ...p[y],
        ...x
      }
    }, C && v <= 50 && (v++, typeof C == "object" && (C.placement && (h = C.placement), C.rects && (c = C.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: r,
      strategy: o
    }) : C.rects), {
      x: u,
      y: d
    } = Cc(c, h, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: o,
    middlewareData: p
  };
};
async function od(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = so(r, e), v = rd(p), y = s[h ? d === "floating" ? "reference" : "floating" : d], b = ii(await i.getClippingRect({
    element: (t = await (i.isElement == null ? void 0 : i.isElement(y))) == null || t ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), g = d === "floating" ? {
    ...a.floating,
    x: n,
    y: o
  } : a.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), x = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = ii(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: g,
    offsetParent: w,
    strategy: l
  }) : g);
  return {
    top: (b.top - C.top + v.top) / x.y,
    bottom: (C.bottom - b.bottom + v.bottom) / x.y,
    left: (b.left - C.left + v.left) / x.x,
    right: (C.right - b.right + v.right) / x.x
  };
}
const G2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(r) {
    const {
      x: t,
      y: n,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = r, {
      element: c,
      padding: u = 0
    } = so(e, r) || {};
    if (c == null)
      return {};
    const d = rd(u), h = {
      x: t,
      y: n
    }, p = Ps(o), v = js(p), m = await a.getDimensions(c), y = p === "y", b = y ? "top" : "left", g = y ? "bottom" : "right", w = y ? "clientHeight" : "clientWidth", x = i.reference[v] + i.reference[p] - h[p] - i.floating[v], C = h[p] - i.reference[p], O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let E = O ? O[w] : 0;
    (!E || !await (a.isElement == null ? void 0 : a.isElement(O))) && (E = s.floating[w] || i.floating[v]);
    const _ = x / 2 - C / 2, R = E / 2 - m[v] / 2 - 1, H = Ua(d[b], R), $ = Ua(d[g], R), Y = H, j = E - m[v] - $, A = E / 2 - m[v] / 2 + _, W = Ka(Y, A, j), U = !l.arrow && lo(o) != null && A !== W && i.reference[v] / 2 - (A < Y ? H : $) - m[v] / 2 < 0, Z = U ? A < Y ? A - Y : A - j : 0;
    return {
      [p]: h[p] + Z,
      data: {
        [p]: W,
        centerOffset: A - W - Z,
        ...U && {
          alignmentOffset: Z
        }
      },
      reset: U
    };
  }
}), X2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(r) {
      var t, n;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = r, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: m = !0,
        ...y
      } = so(e, r);
      if ((t = i.arrow) != null && t.alignmentOffset)
        return {};
      const b = Rn(o), g = Rn(s) === s, w = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = h || (g || !m ? [oi(s)] : B2(s));
      !h && v !== "none" && x.push(...K2(s, m, v, w));
      const C = [s, ...x], O = await od(r, y), E = [];
      let _ = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && E.push(O[b]), d) {
        const Y = W2(o, a, w);
        E.push(O[Y[0]], O[Y[1]]);
      }
      if (_ = [..._, {
        placement: o,
        overflows: E
      }], !E.every((Y) => Y <= 0)) {
        var R, H;
        const Y = (((R = i.flip) == null ? void 0 : R.index) || 0) + 1, j = C[Y];
        if (j)
          return {
            data: {
              index: Y,
              overflows: _
            },
            reset: {
              placement: j
            }
          };
        let A = (H = _.filter((W) => W.overflows[0] <= 0).sort((W, U) => W.overflows[1] - U.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!A)
          switch (p) {
            case "bestFit": {
              var $;
              const W = ($ = _.map((U) => [U.placement, U.overflows.filter((Z) => Z > 0).reduce((Z, J) => Z + J, 0)]).sort((U, Z) => U[1] - Z[1])[0]) == null ? void 0 : $[0];
              W && (A = W);
              break;
            }
            case "initialPlacement":
              A = s;
              break;
          }
        if (o !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
async function J2(e, r) {
  const {
    placement: t,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), a = Rn(t), s = lo(t), l = Si(t) === "y", c = ["left", "top"].includes(a) ? -1 : 1, u = i && l ? -1 : 1, d = so(r, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof v == "number" && (p = s === "end" ? v * -1 : v), l ? {
    x: p * u,
    y: h * c
  } : {
    x: h * c,
    y: p * u
  };
}
const As = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(r) {
      var t, n;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = r, l = await J2(r, e);
      return a === ((t = s.offset) == null ? void 0 : t.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, e3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(r) {
      const {
        x: t,
        y: n,
        placement: o
      } = r, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: g
            } = y;
            return {
              x: b,
              y: g
            };
          }
        },
        ...l
      } = so(e, r), c = {
        x: t,
        y: n
      }, u = await od(r, l), d = Si(Rn(o)), h = nd(d);
      let p = c[h], v = c[d];
      if (i) {
        const y = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", g = p + u[y], w = p - u[b];
        p = Ka(g, p, w);
      }
      if (a) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", g = v + u[y], w = v - u[b];
        v = Ka(g, v, w);
      }
      const m = s.fn({
        ...r,
        [h]: p,
        [d]: v
      });
      return {
        ...m,
        data: {
          x: m.x - t,
          y: m.y - n
        }
      };
    }
  };
}, qa = Math.min, tr = Math.max, ai = Math.round, Mo = Math.floor, vn = (e) => ({
  x: e,
  y: e
});
function mn(e) {
  return id(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function lt(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Qt(e) {
  var r;
  return (r = (id(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : r.documentElement;
}
function id(e) {
  return e instanceof Node || e instanceof lt(e).Node;
}
function Zt(e) {
  return e instanceof Element || e instanceof lt(e).Element;
}
function Vt(e) {
  return e instanceof HTMLElement || e instanceof lt(e).HTMLElement;
}
function bc(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof lt(e).ShadowRoot;
}
function co(e) {
  const {
    overflow: r,
    overflowX: t,
    overflowY: n,
    display: o
  } = pt(e);
  return /auto|scroll|overlay|hidden|clip/.test(r + n + t) && !["inline", "contents"].includes(o);
}
function t3(e) {
  return ["table", "td", "th"].includes(mn(e));
}
function Ls(e) {
  const r = Vs(), t = pt(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (t.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (t.contain || "").includes(n));
}
function n3(e) {
  let r = sr(e);
  for (; Vt(r) && !Ri(r); ) {
    if (Ls(r))
      return r;
    r = sr(r);
  }
  return null;
}
function Vs() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ri(e) {
  return ["html", "body", "#document"].includes(mn(e));
}
function pt(e) {
  return lt(e).getComputedStyle(e);
}
function ji(e) {
  return Zt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function sr(e) {
  if (mn(e) === "html")
    return e;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    bc(e) && e.host || // Fallback.
    Qt(e)
  );
  return bc(r) ? r.host : r;
}
function ad(e) {
  const r = sr(e);
  return Ri(r) ? e.ownerDocument ? e.ownerDocument.body : e.body : Vt(r) && co(r) ? r : ad(r);
}
function un(e, r, t) {
  var n;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  const o = ad(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = lt(o);
  return i ? r.concat(a, a.visualViewport || [], co(o) ? o : [], a.frameElement && t ? un(a.frameElement) : []) : r.concat(o, un(o, [], t));
}
function sd(e) {
  const r = pt(e);
  let t = parseFloat(r.width) || 0, n = parseFloat(r.height) || 0;
  const o = Vt(e), i = o ? e.offsetWidth : t, a = o ? e.offsetHeight : n, s = ai(t) !== i || ai(n) !== a;
  return s && (t = i, n = a), {
    width: t,
    height: n,
    $: s
  };
}
function Hs(e) {
  return Zt(e) ? e : e.contextElement;
}
function nr(e) {
  const r = Hs(e);
  if (!Vt(r))
    return vn(1);
  const t = r.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = sd(r);
  let a = (i ? ai(t.width) : t.width) / n, s = (i ? ai(t.height) : t.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const r3 = /* @__PURE__ */ vn(0);
function ld(e) {
  const r = lt(e);
  return !Vs() || !r.visualViewport ? r3 : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function o3(e, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== lt(e) ? !1 : r;
}
function jn(e, r, t, n) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), i = Hs(e);
  let a = vn(1);
  r && (n ? Zt(n) && (a = nr(n)) : a = nr(e));
  const s = o3(i, t, n) ? ld(i) : vn(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (i) {
    const h = lt(i), p = n && Zt(n) ? lt(n) : n;
    let v = h, m = v.frameElement;
    for (; m && n && p !== v; ) {
      const y = nr(m), b = m.getBoundingClientRect(), g = pt(m), w = b.left + (m.clientLeft + parseFloat(g.paddingLeft)) * y.x, x = b.top + (m.clientTop + parseFloat(g.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += w, c += x, v = lt(m), m = v.frameElement;
    }
  }
  return ii({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
const i3 = [":popover-open", ":modal"];
function cd(e) {
  return i3.some((r) => {
    try {
      return e.matches(r);
    } catch {
      return !1;
    }
  });
}
function a3(e) {
  let {
    elements: r,
    rect: t,
    offsetParent: n,
    strategy: o
  } = e;
  const i = o === "fixed", a = Qt(n), s = r ? cd(r.floating) : !1;
  if (n === a || s && i)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = vn(1);
  const u = vn(0), d = Vt(n);
  if ((d || !d && !i) && ((mn(n) !== "body" || co(a)) && (l = ji(n)), Vt(n))) {
    const h = jn(n);
    c = nr(n), u.x = h.x + n.clientLeft, u.y = h.y + n.clientTop;
  }
  return {
    width: t.width * c.x,
    height: t.height * c.y,
    x: t.x * c.x - l.scrollLeft * c.x + u.x,
    y: t.y * c.y - l.scrollTop * c.y + u.y
  };
}
function s3(e) {
  return Array.from(e.getClientRects());
}
function ud(e) {
  return jn(Qt(e)).left + ji(e).scrollLeft;
}
function l3(e) {
  const r = Qt(e), t = ji(e), n = e.ownerDocument.body, o = tr(r.scrollWidth, r.clientWidth, n.scrollWidth, n.clientWidth), i = tr(r.scrollHeight, r.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -t.scrollLeft + ud(e);
  const s = -t.scrollTop;
  return pt(n).direction === "rtl" && (a += tr(r.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function c3(e, r) {
  const t = lt(e), n = Qt(e), o = t.visualViewport;
  let i = n.clientWidth, a = n.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = Vs();
    (!c || c && r === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function u3(e, r) {
  const t = jn(e, !0, r === "fixed"), n = t.top + e.clientTop, o = t.left + e.clientLeft, i = Vt(e) ? nr(e) : vn(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = n * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function Mc(e, r, t) {
  let n;
  if (r === "viewport")
    n = c3(e, t);
  else if (r === "document")
    n = l3(Qt(e));
  else if (Zt(r))
    n = u3(r, t);
  else {
    const o = ld(e);
    n = {
      ...r,
      x: r.x - o.x,
      y: r.y - o.y
    };
  }
  return ii(n);
}
function dd(e, r) {
  const t = sr(e);
  return t === r || !Zt(t) || Ri(t) ? !1 : pt(t).position === "fixed" || dd(t, r);
}
function d3(e, r) {
  const t = r.get(e);
  if (t)
    return t;
  let n = un(e, [], !1).filter((s) => Zt(s) && mn(s) !== "body"), o = null;
  const i = pt(e).position === "fixed";
  let a = i ? sr(e) : e;
  for (; Zt(a) && !Ri(a); ) {
    const s = pt(a), l = Ls(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || co(a) && !l && dd(e, a)) ? n = n.filter((u) => u !== a) : o = s, a = sr(a);
  }
  return r.set(e, n), n;
}
function f3(e) {
  let {
    element: r,
    boundary: t,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...t === "clippingAncestors" ? d3(r, this._c) : [].concat(t), n], s = a[0], l = a.reduce((c, u) => {
    const d = Mc(r, u, o);
    return c.top = tr(d.top, c.top), c.right = qa(d.right, c.right), c.bottom = qa(d.bottom, c.bottom), c.left = tr(d.left, c.left), c;
  }, Mc(r, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function p3(e) {
  const {
    width: r,
    height: t
  } = sd(e);
  return {
    width: r,
    height: t
  };
}
function h3(e, r, t) {
  const n = Vt(r), o = Qt(r), i = t === "fixed", a = jn(e, !0, i, r);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = vn(0);
  if (n || !n && !i)
    if ((mn(r) !== "body" || co(o)) && (s = ji(r)), n) {
      const d = jn(r, !0, i, r);
      l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
    } else
      o && (l.x = ud(o));
  const c = a.left + s.scrollLeft - l.x, u = a.top + s.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Dc(e, r) {
  return !Vt(e) || pt(e).position === "fixed" ? null : r ? r(e) : e.offsetParent;
}
function fd(e, r) {
  const t = lt(e);
  if (!Vt(e) || cd(e))
    return t;
  let n = Dc(e, r);
  for (; n && t3(n) && pt(n).position === "static"; )
    n = Dc(n, r);
  return n && (mn(n) === "html" || mn(n) === "body" && pt(n).position === "static" && !Ls(n)) ? t : n || n3(e) || t;
}
const v3 = async function(e) {
  const r = this.getOffsetParent || fd, t = this.getDimensions;
  return {
    reference: h3(e.reference, await r(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await t(e.floating)
    }
  };
};
function m3(e) {
  return pt(e).direction === "rtl";
}
const Fs = {
  convertOffsetParentRelativeRectToViewportRelativeRect: a3,
  getDocumentElement: Qt,
  getClippingRect: f3,
  getOffsetParent: fd,
  getElementRects: v3,
  getClientRects: s3,
  getDimensions: p3,
  getScale: nr,
  isElement: Zt,
  isRTL: m3
};
function g3(e, r) {
  let t = null, n;
  const o = Qt(e);
  function i() {
    var s;
    clearTimeout(n), (s = t) == null || s.disconnect(), t = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (s || r(), !d || !h)
      return;
    const p = Mo(u), v = Mo(o.clientWidth - (c + d)), m = Mo(o.clientHeight - (u + h)), y = Mo(c), g = {
      rootMargin: -p + "px " + -v + "px " + -m + "px " + -y + "px",
      threshold: tr(0, qa(1, l)) || 1
    };
    let w = !0;
    function x(C) {
      const O = C[0].intersectionRatio;
      if (O !== l) {
        if (!w)
          return a();
        O ? a(!1, O) : n = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...g,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, g);
    }
    t.observe(e);
  }
  return a(!0), i;
}
function Ys(e, r, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = Hs(e), u = o || i ? [...c ? un(c) : [], ...un(r)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", t, {
      passive: !0
    }), i && b.addEventListener("resize", t);
  });
  const d = c && s ? g3(c, t) : null;
  let h = -1, p = null;
  a && (p = new ResizeObserver((b) => {
    let [g] = b;
    g && g.target === c && p && (p.unobserve(r), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(r);
    })), t();
  }), c && !l && p.observe(c), p.observe(r));
  let v, m = l ? jn(e) : null;
  l && y();
  function y() {
    const b = jn(e);
    m && (b.x !== m.x || b.y !== m.y || b.width !== m.width || b.height !== m.height) && t(), m = b, v = requestAnimationFrame(y);
  }
  return t(), () => {
    var b;
    u.forEach((g) => {
      o && g.removeEventListener("scroll", t), i && g.removeEventListener("resize", t);
    }), d == null || d(), (b = p) == null || b.disconnect(), p = null, l && cancelAnimationFrame(v);
  };
}
const pd = e3, $s = X2, _c = G2, y3 = (e, r, t) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: Fs,
    ...t
  }, i = {
    ...o.platform,
    _c: n
  };
  return q2(e, r, {
    ...o,
    platform: i
  });
}, hd = (e) => {
  function r(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(t) : e;
      return n && r(n) ? n.current != null ? _c({
        element: n.current,
        padding: o
      }).fn(t) : {} : n ? _c({
        element: n,
        padding: o
      }).fn(t) : {};
    }
  };
};
var Fo = typeof document < "u" ? ao : fe;
function si(e, r) {
  if (e === r)
    return !0;
  if (typeof e != typeof r)
    return !1;
  if (typeof e == "function" && e.toString() === r.toString())
    return !0;
  let t, n, o;
  if (e && r && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!si(e[n], r[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), t = o.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!{}.hasOwnProperty.call(r, o[n]))
        return !1;
    for (n = t; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !si(e[i], r[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}
function vd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ec(e, r) {
  const t = vd(e);
  return Math.round(r * t) / t;
}
function Ic(e) {
  const r = T.useRef(e);
  return Fo(() => {
    r.current = e;
  }), r;
}
function md(e) {
  e === void 0 && (e = {});
  const {
    placement: r = "bottom",
    strategy: t = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = T.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = T.useState(n);
  si(h, n) || p(n);
  const [v, m] = T.useState(null), [y, b] = T.useState(null), g = T.useCallback((Z) => {
    Z !== O.current && (O.current = Z, m(Z));
  }, []), w = T.useCallback((Z) => {
    Z !== E.current && (E.current = Z, b(Z));
  }, []), x = i || v, C = a || y, O = T.useRef(null), E = T.useRef(null), _ = T.useRef(u), R = l != null, H = Ic(l), $ = Ic(o), Y = T.useCallback(() => {
    if (!O.current || !E.current)
      return;
    const Z = {
      placement: r,
      strategy: t,
      middleware: h
    };
    $.current && (Z.platform = $.current), y3(O.current, E.current, Z).then((J) => {
      const le = {
        ...J,
        isPositioned: !0
      };
      j.current && !si(_.current, le) && (_.current = le, Wp.flushSync(() => {
        d(le);
      }));
    });
  }, [h, r, t, $]);
  Fo(() => {
    c === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d((Z) => ({
      ...Z,
      isPositioned: !1
    })));
  }, [c]);
  const j = T.useRef(!1);
  Fo(() => (j.current = !0, () => {
    j.current = !1;
  }), []), Fo(() => {
    if (x && (O.current = x), C && (E.current = C), x && C) {
      if (H.current)
        return H.current(x, C, Y);
      Y();
    }
  }, [x, C, Y, H, R]);
  const A = T.useMemo(() => ({
    reference: O,
    floating: E,
    setReference: g,
    setFloating: w
  }), [g, w]), W = T.useMemo(() => ({
    reference: x,
    floating: C
  }), [x, C]), U = T.useMemo(() => {
    const Z = {
      position: t,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return Z;
    const J = Ec(W.floating, u.x), le = Ec(W.floating, u.y);
    return s ? {
      ...Z,
      transform: "translate(" + J + "px, " + le + "px)",
      ...vd(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: J,
      top: le
    };
  }, [t, s, W.floating, u.x, u.y]);
  return T.useMemo(() => ({
    ...u,
    update: Y,
    refs: A,
    elements: W,
    floatingStyles: U
  }), [u, Y, A, W, U]);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var w3 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ga = /* @__PURE__ */ w3.join(","), gd = typeof Element > "u", Ur = gd ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, li = !gd && Element.prototype.getRootNode ? function(e) {
  var r;
  return e == null || (r = e.getRootNode) === null || r === void 0 ? void 0 : r.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ci = function e(r, t) {
  var n;
  t === void 0 && (t = !0);
  var o = r == null || (n = r.getAttribute) === null || n === void 0 ? void 0 : n.call(r, "inert"), i = o === "" || o === "true", a = i || t && r && e(r.parentNode);
  return a;
}, x3 = function(r) {
  var t, n = r == null || (t = r.getAttribute) === null || t === void 0 ? void 0 : t.call(r, "contenteditable");
  return n === "" || n === "true";
}, C3 = function(r, t, n) {
  if (ci(r))
    return [];
  var o = Array.prototype.slice.apply(r.querySelectorAll(Ga));
  return t && Ur.call(r, Ga) && o.unshift(r), o = o.filter(n), o;
}, b3 = function e(r, t, n) {
  for (var o = [], i = Array.from(r); i.length; ) {
    var a = i.shift();
    if (!ci(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, n);
        n.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var u = Ur.call(a, Ga);
        u && n.filter(a) && (t || !r.includes(a)) && o.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(a), h = !ci(d, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
        if (d && h) {
          var p = e(d === !0 ? a.children : d.children, !0, n);
          n.flatten ? o.push.apply(o, p) : o.push({
            scopeParent: a,
            candidates: p
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, yd = function(r) {
  return !isNaN(parseInt(r.getAttribute("tabindex"), 10));
}, wd = function(r) {
  if (!r)
    throw new Error("No node provided");
  return r.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(r.tagName) || x3(r)) && !yd(r) ? 0 : r.tabIndex;
}, M3 = function(r, t) {
  var n = wd(r);
  return n < 0 && t && !yd(r) ? 0 : n;
}, D3 = function(r, t) {
  return r.tabIndex === t.tabIndex ? r.documentOrder - t.documentOrder : r.tabIndex - t.tabIndex;
}, xd = function(r) {
  return r.tagName === "INPUT";
}, _3 = function(r) {
  return xd(r) && r.type === "hidden";
}, E3 = function(r) {
  var t = r.tagName === "DETAILS" && Array.prototype.slice.apply(r.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return t;
}, I3 = function(r, t) {
  for (var n = 0; n < r.length; n++)
    if (r[n].checked && r[n].form === t)
      return r[n];
}, O3 = function(r) {
  if (!r.name)
    return !0;
  var t = r.form || li(r), n = function(s) {
    return t.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = n(window.CSS.escape(r.name));
  else
    try {
      o = n(r.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = I3(o, r.form);
  return !i || i === r;
}, N3 = function(r) {
  return xd(r) && r.type === "radio";
}, T3 = function(r) {
  return N3(r) && !O3(r);
}, k3 = function(r) {
  var t, n = r && li(r), o = (t = n) === null || t === void 0 ? void 0 : t.host, i = !1;
  if (n && n !== r) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || r != null && (l = r.ownerDocument) !== null && l !== void 0 && l.contains(r)); !i && o; ) {
      var c, u, d;
      n = li(o), o = (c = n) === null || c === void 0 ? void 0 : c.host, i = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return i;
}, Oc = function(r) {
  var t = r.getBoundingClientRect(), n = t.width, o = t.height;
  return n === 0 && o === 0;
}, S3 = function(r, t) {
  var n = t.displayCheck, o = t.getShadowRoot;
  if (getComputedStyle(r).visibility === "hidden")
    return !0;
  var i = Ur.call(r, "details>summary:first-of-type"), a = i ? r.parentElement : r;
  if (Ur.call(a, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof o == "function") {
      for (var s = r; r; ) {
        var l = r.parentElement, c = li(r);
        if (l && !l.shadowRoot && o(l) === !0)
          return Oc(r);
        r.assignedSlot ? r = r.assignedSlot : !l && c !== r.ownerDocument ? r = c.host : r = l;
      }
      r = s;
    }
    if (k3(r))
      return !r.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return Oc(r);
  return !1;
}, R3 = function(r) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(r.tagName))
    for (var t = r.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var n = 0; n < t.children.length; n++) {
          var o = t.children.item(n);
          if (o.tagName === "LEGEND")
            return Ur.call(t, "fieldset[disabled] *") ? !0 : !o.contains(r);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, j3 = function(r, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  ci(t) || _3(t) || S3(t, r) || // For a details element with a summary, the summary element gets the focus
  E3(t) || R3(t));
}, Nc = function(r, t) {
  return !(T3(t) || wd(t) < 0 || !j3(r, t));
}, P3 = function(r) {
  var t = parseInt(r.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, A3 = function e(r) {
  var t = [], n = [];
  return r.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = M3(s, a), c = a ? e(o.candidates) : s;
    l === 0 ? a ? t.push.apply(t, c) : t.push(s) : n.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: c
    });
  }), n.sort(D3).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(t);
}, zs = function(r, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = b3([r], t.includeContainer, {
    filter: Nc.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: P3
  }) : n = C3(r, t.includeContainer, Nc.bind(null, t)), A3(n);
};
const L3 = T[/* @__PURE__ */ "useInsertionEffect".toString()], V3 = L3 || ((e) => e());
function H3(e) {
  const r = T.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return V3(() => {
    r.current = e;
  }), T.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
var Cd = typeof document < "u" ? ao : fe;
function Xa() {
  return Xa = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Xa.apply(this, arguments);
}
let ua = !1, F3 = 0;
const Tc = () => "floating-ui-" + F3++;
function Y3() {
  const [e, r] = T.useState(() => ua ? Tc() : void 0);
  return Cd(() => {
    e == null && r(Tc());
  }, []), T.useEffect(() => {
    ua || (ua = !0);
  }, []), e;
}
const $3 = T[/* @__PURE__ */ "useId".toString()], bd = $3 || Y3, z3 = /* @__PURE__ */ T.forwardRef(function(r, t) {
  let {
    context: {
      placement: n,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: i
      }
    },
    width: a = 14,
    height: s = 7,
    tipRadius: l = 0,
    strokeWidth: c = 0,
    staticOffset: u,
    stroke: d,
    d: h,
    style: {
      transform: p,
      ...v
    } = {},
    ...m
  } = r;
  process.env.NODE_ENV !== "production" && (t || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const y = bd();
  if (!o)
    return null;
  c *= 2;
  const b = c / 2, g = a / 2 * (l / -8 + 1), w = s / 2 * l / 4, [x, C] = n.split("-"), O = Fs.isRTL(o), E = !!h, _ = x === "top" || x === "bottom", R = u && C === "end" ? "bottom" : "top";
  let H = u && C === "end" ? "right" : "left";
  u && O && (H = C === "end" ? "left" : "right");
  const $ = (i == null ? void 0 : i.x) != null ? u || i.x : "", Y = (i == null ? void 0 : i.y) != null ? u || i.y : "", j = h || // biome-ignore lint/style/useTemplate: readability
  "M0,0" + (" H" + a) + (" L" + (a - g) + "," + (s - w)) + (" Q" + a / 2 + "," + s + " " + g + "," + (s - w)) + " Z", A = {
    top: E ? "rotate(180deg)" : "",
    left: E ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: E ? "" : "rotate(180deg)",
    right: E ? "rotate(-90deg)" : "rotate(90deg)"
  }[x];
  return /* @__PURE__ */ T.createElement("svg", Xa({}, m, {
    "aria-hidden": !0,
    ref: t,
    width: E ? a : a + c,
    height: a,
    viewBox: "0 0 " + a + " " + (s > a ? s : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [H]: $,
      [R]: Y,
      [x]: _ || E ? "100%" : "calc(100% - " + c / 2 + "px)",
      transform: "" + A + (p ?? ""),
      ...v
    }
  }), c > 0 && /* @__PURE__ */ T.createElement("path", {
    clipPath: "url(#" + y + ")",
    fill: "none",
    stroke: d,
    strokeWidth: c + (h ? 0 : 1),
    d: j
  }), /* @__PURE__ */ T.createElement("path", {
    stroke: c && !h ? m.fill : "none",
    d: j
  }), /* @__PURE__ */ T.createElement("clipPath", {
    id: y
  }, /* @__PURE__ */ T.createElement("rect", {
    x: -b,
    y: b * (E ? -1 : 1),
    width: a + c,
    height: a
  })));
});
function Z3() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((o) => o(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      var n;
      e.set(r, ((n = e.get(r)) == null ? void 0 : n.filter((o) => o !== t)) || []);
    }
  };
}
const W3 = /* @__PURE__ */ T.createContext(null), B3 = /* @__PURE__ */ T.createContext(null), U3 = () => {
  var e;
  return ((e = T.useContext(W3)) == null ? void 0 : e.id) || null;
}, K3 = () => T.useContext(B3);
let Ja;
process.env.NODE_ENV !== "production" && (Ja = /* @__PURE__ */ new Set());
function Q3(e) {
  var r;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: n,
    nodeId: o
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var i;
    const _ = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((i = e.elements) != null && i.reference && !br(e.elements.reference)) {
      var a;
      if (!((a = Ja) != null && a.has(_))) {
        var s;
        (s = Ja) == null || s.add(_), console.error(_);
      }
    }
  }
  const [l, c] = T.useState(null), u = ((r = e.elements) == null ? void 0 : r.reference) || l, d = md(e), h = K3(), p = U3() != null, v = H3((_, R, H) => {
    _ && (y.current.openEvent = R), b.emit("openchange", {
      open: _,
      event: R,
      reason: H,
      nested: p
    }), n == null || n(_, R, H);
  }), m = T.useRef(null), y = T.useRef({}), b = T.useState(() => Z3())[0], g = bd(), w = T.useCallback((_) => {
    const R = br(_) ? {
      getBoundingClientRect: () => _.getBoundingClientRect(),
      contextElement: _
    } : _;
    d.refs.setReference(R);
  }, [d.refs]), x = T.useCallback((_) => {
    (br(_) || _ === null) && (m.current = _, c(_)), (br(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    _ !== null && !br(_)) && d.refs.setReference(_);
  }, [d.refs]), C = T.useMemo(() => ({
    ...d.refs,
    setReference: x,
    setPositionReference: w,
    domReference: m
  }), [d.refs, x, w]), O = T.useMemo(() => ({
    ...d.elements,
    domReference: u
  }), [d.elements, u]), E = T.useMemo(() => ({
    ...d,
    refs: C,
    elements: O,
    dataRef: y,
    nodeId: o,
    floatingId: g,
    events: b,
    open: t,
    onOpenChange: v
  }), [d, o, g, b, t, v, C, O]);
  return Cd(() => {
    const _ = h == null ? void 0 : h.nodesRef.current.find((R) => R.id === o);
    _ && (_.context = E);
  }), T.useMemo(() => ({
    ...d,
    context: E,
    refs: C,
    elements: O
  }), [d, C, O, E]);
}
function q3(e, r) {
  let t = oe(e);
  return isNaN(+t) ? Ie(e, NaN) : (r.year != null && t.setFullYear(r.year), r.month != null && (t = et(t, r.month)), r.date != null && t.setDate(r.date), r.hours != null && t.setHours(r.hours), r.minutes != null && t.setMinutes(r.minutes), r.seconds != null && t.setSeconds(r.seconds), r.milliseconds != null && t.setMilliseconds(r.milliseconds), t);
}
function We(e, r, t) {
  return r = ui(r), function(n, o) {
    if (o && (typeof o == "object" || typeof o == "function"))
      return o;
    if (o !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return D(n);
  }(e, Md() ? Reflect.construct(r, t || [], ui(e).constructor) : r.apply(e, t));
}
function Md() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Md = function() {
    return !!e;
  })();
}
function kc(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function $t(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? kc(Object(t), !0).forEach(function(n) {
      M(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kc(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Dd(e) {
  var r = function(t, n) {
    if (typeof t != "object" || !t)
      return t;
    var o = t[Symbol.toPrimitive];
    if (o !== void 0) {
      var i = o.call(t, n || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(t);
  }(e, "string");
  return typeof r == "symbol" ? r : String(r);
}
function es(e) {
  return es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, es(e);
}
function Be(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Sc(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dd(n.key), n);
  }
}
function Ue(e, r, t) {
  return r && Sc(e.prototype, r), t && Sc(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function M(e, r, t) {
  return (r = Dd(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Kr() {
  return Kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Kr.apply(this, arguments);
}
function Ke(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && ts(e, r);
}
function ui(e) {
  return ui = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ui(e);
}
function ts(e, r) {
  return ts = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, ts(e, r);
}
function D(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gn(e) {
  return function(r) {
    if (Array.isArray(r))
      return da(r);
  }(e) || function(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
      return Array.from(r);
  }(e) || function(r, t) {
    if (r) {
      if (typeof r == "string")
        return da(r, t);
      var n = Object.prototype.toString.call(r).slice(8, -1);
      if (n === "Object" && r.constructor && (n = r.constructor.name), n === "Map" || n === "Set")
        return Array.from(r);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return da(r, t);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function da(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
var Tr = 12, G3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ne(e) {
  var r = e ? typeof e == "string" || e instanceof String ? v2(e) : oe(e) : /* @__PURE__ */ new Date();
  return nn(r) ? r : null;
}
function nn(e, r) {
  return r = r || /* @__PURE__ */ new Date("1/1/1000"), zr(e) && !Sn(e, r);
}
function je(e, r, t) {
  if (t === "en")
    return pc(e, r, { useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
  var n = pn(t);
  return t && !n && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !n && Nn() && pn(Nn()) && (n = pn(Nn())), pc(e, r, { locale: n || null, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
}
function ut(e, r) {
  var t = r.dateFormat, n = r.locale;
  return e && je(e, Array.isArray(t) ? t[0] : t, n) || "";
}
function fa(e, r) {
  var t = r.hour, n = t === void 0 ? 0 : t, o = r.minute, i = o === void 0 ? 0 : o, a = r.second;
  return Ho(Vo(ch(e, a === void 0 ? 0 : a), i), n);
}
function dn(e, r, t) {
  var n = pn(r || Nn());
  return zt(e, { locale: n, weekStartsOn: t });
}
function fn(e) {
  return q1(e);
}
function Ir(e) {
  return Ns(e);
}
function Rc(e) {
  return za(e);
}
function jc() {
  return jt(Ne());
}
function an(e, r) {
  return e && r ? gh(e, r) : !e && !r;
}
function wt(e, r) {
  return e && r ? mh(e, r) : !e && !r;
}
function di(e, r) {
  return e && r ? yh(e, r) : !e && !r;
}
function Ee(e, r) {
  return e && r ? vh(e, r) : !e && !r;
}
function En(e, r) {
  return e && r ? hh(e, r) : !e && !r;
}
function Yo(e, r, t) {
  var n, o = jt(r), i = Za(t);
  try {
    n = Br(e, { start: o, end: i });
  } catch {
    n = !1;
  }
  return n;
}
function Nn() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function pn(e) {
  if (typeof e == "string") {
    var r = typeof window < "u" ? window : globalThis;
    return r.__localeData__ ? r.__localeData__[e] : null;
  }
  return e;
}
function Zs(e, r) {
  return je(et(Ne(), e), "LLLL", r);
}
function _d(e, r) {
  return je(et(Ne(), e), "LLL", r);
}
function Pi(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.maxDate, o = r.excludeDates, i = r.excludeDateIntervals, a = r.includeDates, s = r.includeDateIntervals, l = r.filterDate;
  return Ai(e, { minDate: t, maxDate: n }) || o && o.some(function(c) {
    return Ee(e, c.date ? c.date : c);
  }) || i && i.some(function(c) {
    var u = c.start, d = c.end;
    return Br(e, { start: u, end: d });
  }) || a && !a.some(function(c) {
    return Ee(e, c);
  }) || s && !s.some(function(c) {
    var u = c.start, d = c.end;
    return Br(e, { start: u, end: d });
  }) || l && !l(Ne(e)) || !1;
}
function Ws(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.excludeDates, n = r.excludeDateIntervals;
  return n && n.length > 0 ? n.some(function(o) {
    var i = o.start, a = o.end;
    return Br(e, { start: i, end: a });
  }) : t && t.some(function(o) {
    return Ee(e, o.date ? o.date : o);
  }) || !1;
}
function Ed(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.maxDate, o = r.excludeDates, i = r.includeDates, a = r.filterDate;
  return Ai(e, { minDate: q1(t), maxDate: fh(n) }) || o && o.some(function(s) {
    return wt(e, s);
  }) || i && !i.some(function(s) {
    return wt(e, s);
  }) || a && !a(Ne(e)) || !1;
}
function pa(e, r, t, n) {
  var o = de(e), i = tt(e), a = de(r), s = tt(r), l = de(n);
  return o === a && o === l ? i <= t && t <= s : o < a ? l === o && i <= t || l === a && s >= t || l < a && l > o : void 0;
}
function X3(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.maxDate, o = r.excludeDates, i = r.includeDates, a = r.filterDate;
  return Ai(e, { minDate: t, maxDate: n }) || o && o.some(function(s) {
    return di(e, s);
  }) || i && !i.some(function(s) {
    return di(e, s);
  }) || a && !a(Ne(e)) || !1;
}
function ha(e, r, t) {
  if (!zr(r) || !zr(t))
    return !1;
  var n = de(r), o = de(t);
  return n <= e && o >= e;
}
function Id(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.maxDate, o = r.excludeDates, i = r.includeDates, a = r.filterDate, s = new Date(e, 0, 1);
  return Ai(s, { minDate: Ns(t), maxDate: ph(n) }) || o && o.some(function(l) {
    return an(s, l);
  }) || i && !i.some(function(l) {
    return an(s, l);
  }) || a && !a(Ne(s)) || !1;
}
function va(e, r, t, n) {
  var o = de(e), i = Nr(e), a = de(r), s = Nr(r), l = de(n);
  return o === a && o === l ? i <= t && t <= s : o < a ? l === o && i <= t || l === a && s >= t || l < a && l > o : void 0;
}
function Ai(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.maxDate;
  return t && Zr(e, t) < 0 || n && Zr(e, n) > 0;
}
function Pc(e, r) {
  return r.some(function(t) {
    return At(t) === At(e) && Pt(t) === Pt(e);
  });
}
function Ac(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.excludeTimes, n = r.includeTimes, o = r.filterTime;
  return t && Pc(e, t) || n && !Pc(e, n) || o && !o(e) || !1;
}
function Lc(e, r) {
  var t = r.minTime, n = r.maxTime;
  if (!t || !n)
    throw new Error("Both minTime and maxTime props required");
  var o, i = Ne(), a = Ho(Vo(i, Pt(e)), At(e)), s = Ho(Vo(i, Pt(t)), At(t)), l = Ho(Vo(i, Pt(n)), At(n));
  try {
    o = !Br(a, { start: s, end: l });
  } catch {
    o = !1;
  }
  return o;
}
function Vc(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.includeDates, o = ar(e, 1);
  return t && ti(t, o) > 0 || n && n.every(function(i) {
    return ti(i, o) > 0;
  }) || !1;
}
function Hc(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.maxDate, n = r.includeDates, o = Dt(e, 1);
  return t && ti(o, t) > 0 || n && n.every(function(i) {
    return ti(o, i) > 0;
  }) || !1;
}
function Fc(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.minDate, n = r.includeDates, o = Wr(e, 1);
  return t && ni(t, o) > 0 || n && n.every(function(i) {
    return ni(i, o) > 0;
  }) || !1;
}
function Yc(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.maxDate, n = r.includeDates, o = on(e, 1);
  return t && ni(o, t) > 0 || n && n.every(function(i) {
    return ni(o, i) > 0;
  }) || !1;
}
function Od(e) {
  var r = e.minDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(o) {
      return Zr(o, r) >= 0;
    });
    return gc(n);
  }
  return t ? gc(t) : r;
}
function Nd(e) {
  var r = e.maxDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(o) {
      return Zr(o, r) <= 0;
    });
    return yc(n);
  }
  return t ? yc(t) : r;
}
function $c() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", t = /* @__PURE__ */ new Map(), n = 0, o = e.length; n < o; n++) {
    var i = e[n];
    if (kn(i)) {
      var a = je(i, "MM.dd.yyyy"), s = t.get(a) || [];
      s.includes(r) || (s.push(r), t.set(a, s));
    } else if (es(i) === "object") {
      var l = Object.keys(i), c = l[0], u = i[l[0]];
      if (typeof c == "string" && u.constructor === Array)
        for (var d = 0, h = u.length; d < h; d++) {
          var p = je(u[d], "MM.dd.yyyy"), v = t.get(p) || [];
          v.includes(c) || (v.push(c), t.set(p, v));
        }
    }
  }
  return t;
}
function J3() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", t = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    var o = n.date, i = n.holidayName;
    if (kn(o)) {
      var a = je(o, "MM.dd.yyyy"), s = t.get(a) || {};
      if (!("className" in s) || s.className !== r || (l = s.holidayNames, c = [i], l.length !== c.length || !l.every(function(d, h) {
        return d === c[h];
      }))) {
        var l, c;
        s.className = r;
        var u = s.holidayNames;
        s.holidayNames = u ? [].concat(gn(u), [i]) : [i], t.set(a, s);
      }
    }
  }), t;
}
function e5(e, r, t, n, o) {
  for (var i = o.length, a = [], s = 0; s < i; s++) {
    var l = Ya(ih(e, At(o[s])), Pt(o[s])), c = Ya(e, (t + 1) * n);
    hn(l, r) && Sn(l, c) && a.push(o[s]);
  }
  return a;
}
function zc(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Gn(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tr, t = Math.ceil(de(e) / r) * r;
  return { startPeriod: t - (r - 1), endPeriod: t };
}
function Zc(e) {
  var r = e.getSeconds(), t = e.getMilliseconds();
  return oe(e.getTime() - 1e3 * r - t);
}
function Wc(e) {
  if (!kn(e))
    throw new Error("Invalid date");
  var r = new Date(e);
  return r.setHours(0, 0, 0, 0), r;
}
function Bc(e, r) {
  if (!kn(e) || !kn(r))
    throw new Error("Invalid date received");
  var t = Wc(e), n = Wc(r);
  return Sn(t, n);
}
function Td(e) {
  return e.key === " ";
}
function t5(e, r, t, n) {
  for (var o = [], i = 0; i < 2 * r + 1; i++) {
    var a = e + r - i, s = !0;
    t && (s = de(t) <= a), n && s && (s = de(n) >= a), s && o.push(a);
  }
  return o;
}
var n5 = ki(function(e) {
  function r(t) {
    var n;
    Be(this, r), M(D(n = We(this, r, [t])), "renderOptions", function() {
      var s = n.props.year, l = n.state.yearsList.map(function(d) {
        return S.createElement("div", { className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: n.onChange.bind(D(n), d), "aria-selected": s === d ? "true" : void 0 }, s === d ? S.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", d);
      }), c = n.props.minDate ? de(n.props.minDate) : null, u = n.props.maxDate ? de(n.props.maxDate) : null;
      return u && n.state.yearsList.find(function(d) {
        return d === u;
      }) || l.unshift(S.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears }, S.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), c && n.state.yearsList.find(function(d) {
        return d === c;
      }) || l.push(S.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears }, S.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), l;
    }), M(D(n), "onChange", function(s) {
      n.props.onChange(s);
    }), M(D(n), "handleClickOutside", function() {
      n.props.onCancel();
    }), M(D(n), "shiftYears", function(s) {
      var l = n.state.yearsList.map(function(c) {
        return c + s;
      });
      n.setState({ yearsList: l });
    }), M(D(n), "incrementYears", function() {
      return n.shiftYears(1);
    }), M(D(n), "decrementYears", function() {
      return n.shiftYears(-1);
    });
    var o = t.yearDropdownItemNumber, i = t.scrollableYearDropdown, a = o || (i ? 10 : 5);
    return n.state = { yearsList: t5(n.props.year, a, n.props.minDate, n.props.maxDate) }, n.dropdownRef = $p(), n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    var t = this.dropdownRef.current;
    if (t) {
      var n = t.children ? Array.from(t.children) : null, o = n ? n.find(function(i) {
        return i.ariaSelected;
      }) : null;
      t.scrollTop = o ? o.offsetTop + (o.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var t = X({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return S.createElement("div", { className: t, ref: this.dropdownRef }, this.renderOptions());
  } }]), r;
}()), r5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), M(D(t), "renderSelectOptions", function() {
      for (var a = t.props.minDate ? de(t.props.minDate) : 1900, s = t.props.maxDate ? de(t.props.maxDate) : 2100, l = [], c = a; c <= s; c++)
        l.push(S.createElement("option", { key: c, value: c }, c));
      return l;
    }), M(D(t), "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), M(D(t), "renderSelectMode", function() {
      return S.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    }), M(D(t), "renderReadView", function(a) {
      return S.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(s) {
        return t.toggleDropdown(s);
      } }, S.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), S.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year));
    }), M(D(t), "renderDropdown", function() {
      return S.createElement(n5, { key: "dropdown", year: t.props.year, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableYearDropdown: t.props.scrollableYearDropdown, yearDropdownItemNumber: t.props.yearDropdownItemNumber });
    }), M(D(t), "renderScrollMode", function() {
      var a = t.state.dropdownVisible, s = [t.renderReadView(!a)];
      return a && s.unshift(t.renderDropdown()), s;
    }), M(D(t), "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.year && t.props.onChange(a);
    }), M(D(t), "toggleDropdown", function(a) {
      t.setState({ dropdownVisible: !t.state.dropdownVisible }, function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, a);
      });
    }), M(D(t), "handleYearChange", function(a, s) {
      t.onSelect(a, s), t.setOpen();
    }), M(D(t), "onSelect", function(a, s) {
      t.props.onSelect && t.props.onSelect(a, s);
    }), M(D(t), "setOpen", function() {
      t.props.setOpen && t.props.setOpen(!0);
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return S.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), r;
}(), o5 = ki(function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "isSelectedMonth", function(a) {
      return t.props.month === a;
    }), M(D(t), "renderOptions", function() {
      return t.props.monthNames.map(function(a, s) {
        return S.createElement("div", { className: t.isSelectedMonth(s) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: a, onClick: t.onChange.bind(D(t), s), "aria-selected": t.isSelectedMonth(s) ? "true" : void 0 }, t.isSelectedMonth(s) ? S.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", a);
      });
    }), M(D(t), "onChange", function(a) {
      return t.props.onChange(a);
    }), M(D(t), "handleClickOutside", function() {
      return t.props.onCancel();
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    return S.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), r;
}()), i5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), M(D(t), "renderSelectOptions", function(a) {
      return a.map(function(s, l) {
        return S.createElement("option", { key: l, value: l }, s);
      });
    }), M(D(t), "renderSelectMode", function(a) {
      return S.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(s) {
        return t.onChange(s.target.value);
      } }, t.renderSelectOptions(a));
    }), M(D(t), "renderReadView", function(a, s) {
      return S.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown }, S.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), S.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, s[t.props.month]));
    }), M(D(t), "renderDropdown", function(a) {
      return S.createElement(o5, { key: "dropdown", month: t.props.month, monthNames: a, onChange: t.onChange, onCancel: t.toggleDropdown });
    }), M(D(t), "renderScrollMode", function(a) {
      var s = t.state.dropdownVisible, l = [t.renderReadView(!s, a)];
      return s && l.unshift(t.renderDropdown(a)), l;
    }), M(D(t), "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.month && t.props.onChange(a);
    }), M(D(t), "toggleDropdown", function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t, n = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(i) {
      return _d(i, n.props.locale);
    } : function(i) {
      return Zs(i, n.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode(o);
        break;
      case "select":
        t = this.renderSelectMode(o);
    }
    return S.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), r;
}();
function a5(e, r) {
  for (var t = [], n = fn(e), o = fn(r); !hn(n, o); )
    t.push(Ne(n)), n = Dt(n, 1);
  return t;
}
var s5 = ki(function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "renderOptions", function() {
      return n.state.monthYearsList.map(function(o) {
        var i = $a(o), a = an(n.props.date, o) && wt(n.props.date, o);
        return S.createElement("div", { className: a ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: i, onClick: n.onChange.bind(D(n), i), "aria-selected": a ? "true" : void 0 }, a ? S.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", je(o, n.props.dateFormat, n.props.locale));
      });
    }), M(D(n), "onChange", function(o) {
      return n.props.onChange(o);
    }), M(D(n), "handleClickOutside", function() {
      n.props.onCancel();
    }), n.state = { monthYearsList: a5(n.props.minDate, n.props.maxDate) }, n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t = X({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return S.createElement("div", { className: t }, this.renderOptions());
  } }]), r;
}()), l5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), M(D(t), "renderSelectOptions", function() {
      for (var a = fn(t.props.minDate), s = fn(t.props.maxDate), l = []; !hn(a, s); ) {
        var c = $a(a);
        l.push(S.createElement("option", { key: c, value: c }, je(a, t.props.dateFormat, t.props.locale))), a = Dt(a, 1);
      }
      return l;
    }), M(D(t), "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), M(D(t), "renderSelectMode", function() {
      return S.createElement("select", { value: $a(fn(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    }), M(D(t), "renderReadView", function(a) {
      var s = je(t.props.date, t.props.dateFormat, t.props.locale);
      return S.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(l) {
        return t.toggleDropdown(l);
      } }, S.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), S.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, s));
    }), M(D(t), "renderDropdown", function() {
      return S.createElement(s5, { key: "dropdown", date: t.props.date, dateFormat: t.props.dateFormat, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown, locale: t.props.locale });
    }), M(D(t), "renderScrollMode", function() {
      var a = t.state.dropdownVisible, s = [t.renderReadView(!a)];
      return a && s.unshift(t.renderDropdown()), s;
    }), M(D(t), "onChange", function(a) {
      t.toggleDropdown();
      var s = Ne(parseInt(a));
      an(t.props.date, s) && wt(t.props.date, s) || t.props.onChange(s);
    }), M(D(t), "toggleDropdown", function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return S.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), r;
}(), c5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "dayEl", S.createRef()), M(D(t), "handleClick", function(a) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(a);
    }), M(D(t), "handleMouseEnter", function(a) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(a);
    }), M(D(t), "handleOnKeyDown", function(a) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), M(D(t), "isSameDay", function(a) {
      return Ee(t.props.day, a);
    }), M(D(t), "isKeyboardSelected", function() {
      var a;
      return !t.props.disabledKeyboardNavigation && !(t.props.selectsMultiple ? !((a = t.props.selectedDates) === null || a === void 0) && a.some(function(s) {
        return t.isSameDayOrWeek(s);
      }) : t.isSameDayOrWeek(t.props.selected)) && t.isSameDayOrWeek(t.props.preSelection);
    }), M(D(t), "isDisabled", function() {
      return Pi(t.props.day, t.props);
    }), M(D(t), "isExcluded", function() {
      return Ws(t.props.day, t.props);
    }), M(D(t), "isStartOfWeek", function() {
      return Ee(t.props.day, dn(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), M(D(t), "isSameWeek", function(a) {
      return t.props.showWeekPicker && Ee(a, dn(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), M(D(t), "isSameDayOrWeek", function(a) {
      return t.isSameDay(a) || t.isSameWeek(a);
    }), M(D(t), "getHighLightedClass", function() {
      var a = t.props, s = a.day, l = a.highlightDates;
      if (!l)
        return !1;
      var c = je(s, "MM.dd.yyyy");
      return l.get(c);
    }), M(D(t), "getHolidaysClass", function() {
      var a = t.props, s = a.day, l = a.holidays;
      if (!l)
        return !1;
      var c = je(s, "MM.dd.yyyy");
      return l.has(c) ? [l.get(c).className] : void 0;
    }), M(D(t), "isInRange", function() {
      var a = t.props, s = a.day, l = a.startDate, c = a.endDate;
      return !(!l || !c) && Yo(s, l, c);
    }), M(D(t), "isInSelectingRange", function() {
      var a, s = t.props, l = s.day, c = s.selectsStart, u = s.selectsEnd, d = s.selectsRange, h = s.selectsDisabledDaysInRange, p = s.startDate, v = s.endDate, m = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return !(!(c || u || d) || !m || !h && t.isDisabled()) && (c && v && (Sn(m, v) || En(m, v)) ? Yo(l, m, v) : (u && p && (hn(m, p) || En(m, p)) || !(!d || !p || v || !hn(m, p) && !En(m, p))) && Yo(l, p, m));
    }), M(D(t), "isSelectingRangeStart", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var s = t.props, l = s.day, c = s.startDate, u = s.selectsStart, d = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return Ee(l, u ? d : c);
    }), M(D(t), "isSelectingRangeEnd", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var s = t.props, l = s.day, c = s.endDate, u = s.selectsEnd, d = s.selectsRange, h = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return Ee(l, u || d ? h : c);
    }), M(D(t), "isRangeStart", function() {
      var a = t.props, s = a.day, l = a.startDate, c = a.endDate;
      return !(!l || !c) && Ee(l, s);
    }), M(D(t), "isRangeEnd", function() {
      var a = t.props, s = a.day, l = a.startDate, c = a.endDate;
      return !(!l || !c) && Ee(c, s);
    }), M(D(t), "isWeekend", function() {
      var a = lh(t.props.day);
      return a === 0 || a === 6;
    }), M(D(t), "isAfterMonth", function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === tt(t.props.day);
    }), M(D(t), "isBeforeMonth", function() {
      return t.props.month !== void 0 && (tt(t.props.day) + 1) % 12 === t.props.month;
    }), M(D(t), "isCurrentDay", function() {
      return t.isSameDay(Ne());
    }), M(D(t), "isSelected", function() {
      var a;
      return t.props.selectsMultiple ? (a = t.props.selectedDates) === null || a === void 0 ? void 0 : a.some(function(s) {
        return t.isSameDayOrWeek(s);
      }) : t.isSameDayOrWeek(t.props.selected);
    }), M(D(t), "getClassNames", function(a) {
      var s, l = t.props.dayClassName ? t.props.dayClassName(a) : void 0;
      return X("react-datepicker__day", l, "react-datepicker__day--" + je(t.props.day, "ddd", s), { "react-datepicker__day--disabled": t.isDisabled(), "react-datepicker__day--excluded": t.isExcluded(), "react-datepicker__day--selected": t.isSelected(), "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(), "react-datepicker__day--range-start": t.isRangeStart(), "react-datepicker__day--range-end": t.isRangeEnd(), "react-datepicker__day--in-range": t.isInRange(), "react-datepicker__day--in-selecting-range": t.isInSelectingRange(), "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(), "react-datepicker__day--today": t.isCurrentDay(), "react-datepicker__day--weekend": t.isWeekend(), "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth() }, t.getHighLightedClass("react-datepicker__day--highlighted"), t.getHolidaysClass());
    }), M(D(t), "getAriaLabel", function() {
      var a = t.props, s = a.day, l = a.ariaLabelPrefixWhenEnabled, c = l === void 0 ? "Choose" : l, u = a.ariaLabelPrefixWhenDisabled, d = u === void 0 ? "Not available" : u, h = t.isDisabled() || t.isExcluded() ? d : c;
      return "".concat(h, " ").concat(je(s, "PPPP", t.props.locale));
    }), M(D(t), "getTitle", function() {
      var a = t.props, s = a.day, l = a.holidays, c = l === void 0 ? /* @__PURE__ */ new Map() : l, u = a.excludeDates, d = je(s, "MM.dd.yyyy"), h = [];
      return c.has(d) && h.push.apply(h, gn(c.get(d).holidayNames)), t.isExcluded() && h.push(u == null ? void 0 : u.filter(function(p) {
        return Ee(p.date ? p.date : p, s);
      }).map(function(p) {
        return p.message;
      })), h.join(", ");
    }), M(D(t), "getTabIndex", function(a, s) {
      var l = a || t.props.selected, c = s || t.props.preSelection;
      return (!t.props.showWeekPicker || !t.props.showWeekNumber && t.isStartOfWeek()) && (t.isKeyboardSelected() || t.isSameDay(l) && Ee(c, l)) ? 0 : -1;
    }), M(D(t), "handleFocusDay", function() {
      var a, s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      t.getTabIndex() === 0 && !s.isInputFocused && t.isSameDay(t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), t.props.inline && !t.props.shouldFocusDayInline && (l = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (l = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (l = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (l = !1)), l && ((a = t.dayEl.current) === null || a === void 0 || a.focus({ preventScroll: !0 }));
    }), M(D(t), "renderDayContents", function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(mc(t.props.day), t.props.day) : mc(t.props.day);
    }), M(D(t), "render", function() {
      return S.createElement("div", { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() }, t.renderDayContents(), t.getTitle() !== "" && S.createElement("span", { className: "overlay" }, t.getTitle()));
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusDay(t);
  } }]), r;
}(), u5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "weekNumberEl", S.createRef()), M(D(t), "handleClick", function(a) {
      t.props.onClick && t.props.onClick(a);
    }), M(D(t), "handleOnKeyDown", function(a) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), M(D(t), "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ee(t.props.date, t.props.selected) && Ee(t.props.date, t.props.preSelection);
    }), M(D(t), "getTabIndex", function() {
      return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Ee(t.props.date, t.props.selected) && Ee(t.props.preSelection, t.props.selected)) ? 0 : -1;
    }), M(D(t), "handleFocusWeekNumber", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = !1;
      t.getTabIndex() === 0 && !a.isInputFocused && Ee(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (s = !0), t.props.inline && !t.props.shouldFocusDayInline && (s = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (s = !0)), s && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusWeekNumber(t);
  } }, { key: "render", value: function() {
    var t = this.props, n = t.weekNumber, o = t.ariaLabelPrefix, i = o === void 0 ? "week " : o, a = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!t.onClick, "react-datepicker__week-number--selected": Ee(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return S.createElement("div", { ref: this.weekNumberEl, className: X(a), "aria-label": "".concat(i, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), r;
}(), d5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "handleDayClick", function(a, s) {
      t.props.onDayClick && t.props.onDayClick(a, s);
    }), M(D(t), "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), M(D(t), "handleWeekClick", function(a, s, l) {
      typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(a, s, l), t.props.showWeekPicker && t.handleDayClick(a, l), t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    }), M(D(t), "formatWeekNumber", function(a) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(a) : function(s, l) {
        return l && pn(l) || Nn() && pn(Nn()), Ts(s);
      }(a);
    }), M(D(t), "renderDays", function() {
      var a = t.startOfWeek(), s = [], l = t.formatWeekNumber(a);
      if (t.props.showWeekNumber) {
        var c = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(D(t), a, l) : void 0;
        s.push(S.createElement(u5, { key: "W", weekNumber: l, date: a, onClick: c, selected: t.props.selected, preSelection: t.props.preSelection, ariaLabelPrefix: t.props.ariaLabelPrefix, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef }));
      }
      return s.concat([0, 1, 2, 3, 4, 5, 6].map(function(u) {
        var d = yn(a, u);
        return S.createElement(c5, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: d.valueOf(), day: d, month: t.props.month, onClick: t.handleDayClick.bind(D(t), d), usePointerEvent: t.props.usePointerEvent, onMouseEnter: t.handleDayMouseEnter.bind(D(t), d), minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, showWeekPicker: t.props.showWeekPicker, showWeekNumber: t.props.showWeekNumber, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, selectsMultiple: t.props.selectsMultiple, selectedDates: t.props.selectedDates, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, renderDayContents: t.props.renderDayContents, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart, locale: t.props.locale });
      }));
    }), M(D(t), "startOfWeek", function() {
      return dn(t.props.day, t.props.locale, t.props.calendarStartDay);
    }), M(D(t), "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ee(t.startOfWeek(), t.props.selected) && Ee(t.startOfWeek(), t.props.preSelection);
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t = { "react-datepicker__week": !0, "react-datepicker__week--selected": Ee(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return S.createElement("div", { className: X(t) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), r;
}(), kd = "two_columns", Sd = "three_columns", Rd = "four_columns", ma = M(M(M({}, kd, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), Sd, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), Rd, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function Uc(e, r) {
  return e ? Rd : r ? kd : Sd;
}
var f5 = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "MONTH_REFS", gn(Array(12)).map(function() {
      return S.createRef();
    })), M(D(t), "QUARTER_REFS", gn(Array(4)).map(function() {
      return S.createRef();
    })), M(D(t), "isDisabled", function(a) {
      return Pi(a, t.props);
    }), M(D(t), "isExcluded", function(a) {
      return Ws(a, t.props);
    }), M(D(t), "handleDayClick", function(a, s) {
      t.props.onDayClick && t.props.onDayClick(a, s, t.props.orderInDisplay);
    }), M(D(t), "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), M(D(t), "handleMouseLeave", function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    }), M(D(t), "isRangeStartMonth", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && wt(et(l, a), c);
    }), M(D(t), "isRangeStartQuarter", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && di(Bn(l, a), c);
    }), M(D(t), "isRangeEndMonth", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && wt(et(l, a), u);
    }), M(D(t), "isRangeEndQuarter", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && di(Bn(l, a), u);
    }), M(D(t), "isInSelectingRangeMonth", function(a) {
      var s, l = t.props, c = l.day, u = l.selectsStart, d = l.selectsEnd, h = l.selectsRange, p = l.startDate, v = l.endDate, m = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return !(!(u || d || h) || !m) && (u && v ? pa(m, v, a, c) : (d && p || !(!h || !p || v)) && pa(p, m, a, c));
    }), M(D(t), "isSelectingMonthRangeStart", function(a) {
      var s;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var l = t.props, c = l.day, u = l.startDate, d = l.selectsStart, h = et(c, a), p = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return wt(h, d ? p : u);
    }), M(D(t), "isSelectingMonthRangeEnd", function(a) {
      var s;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var l = t.props, c = l.day, u = l.endDate, d = l.selectsEnd, h = l.selectsRange, p = et(c, a), v = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return wt(p, d || h ? v : u);
    }), M(D(t), "isInSelectingRangeQuarter", function(a) {
      var s, l = t.props, c = l.day, u = l.selectsStart, d = l.selectsEnd, h = l.selectsRange, p = l.startDate, v = l.endDate, m = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return !(!(u || d || h) || !m) && (u && v ? va(m, v, a, c) : (d && p || !(!h || !p || v)) && va(p, m, a, c));
    }), M(D(t), "isWeekInMonth", function(a) {
      var s = t.props.day, l = yn(a, 6);
      return wt(a, s) || wt(l, s);
    }), M(D(t), "isCurrentMonth", function(a, s) {
      return de(a) === de(Ne()) && s === tt(Ne());
    }), M(D(t), "isCurrentQuarter", function(a, s) {
      return de(a) === de(Ne()) && s === Nr(Ne());
    }), M(D(t), "isSelectedMonth", function(a, s, l) {
      return tt(l) === s && de(a) === de(l);
    }), M(D(t), "isSelectedQuarter", function(a, s, l) {
      return Nr(a) === s && de(a) === de(l);
    }), M(D(t), "renderWeeks", function() {
      for (var a = [], s = t.props.fixedHeight, l = 0, c = !1, u = dn(fn(t.props.day), t.props.locale, t.props.calendarStartDay), d = t.props.showWeekPicker ? dn(t.props.selected, t.props.locale, t.props.calendarStartDay) : t.props.selected, h = t.props.showWeekPicker ? dn(t.props.preSelection, t.props.locale, t.props.calendarStartDay) : t.props.preSelection; a.push(S.createElement(d5, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, key: l, day: u, month: tt(t.props.day), onDayClick: t.handleDayClick, usePointerEvent: t.props.usePointerEvent, onDayMouseEnter: t.handleDayMouseEnter, onWeekSelect: t.props.onWeekSelect, formatWeekNumber: t.props.formatWeekNumber, locale: t.props.locale, minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: h, selected: d, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, selectsMultiple: t.props.selectsMultiple, selectedDates: t.props.selectedDates, showWeekNumber: t.props.showWeekNumbers, showWeekPicker: t.props.showWeekPicker, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, setOpen: t.props.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, renderDayContents: t.props.renderDayContents, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, calendarStartDay: t.props.calendarStartDay, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart })), !c; ) {
        l++, u = ei(u, 1);
        var p = s && l >= 6, v = !s && !t.isWeekInMonth(u);
        if (p || v) {
          if (!t.props.peekNextMonth)
            break;
          c = !0;
        }
      }
      return a;
    }), M(D(t), "onMonthClick", function(a, s) {
      t.handleDayClick(fn(et(t.props.day, s)), a);
    }), M(D(t), "onMonthMouseEnter", function(a) {
      t.handleDayMouseEnter(fn(et(t.props.day, a)));
    }), M(D(t), "handleMonthNavigation", function(a, s) {
      t.isDisabled(s) || t.isExcluded(s) || (t.props.setPreSelection(s), t.MONTH_REFS[a].current && t.MONTH_REFS[a].current.focus());
    }), M(D(t), "onMonthKeyDown", function(a, s) {
      var l = t.props, c = l.selected, u = l.preSelection, d = l.disabledKeyboardNavigation, h = l.showTwoColumnMonthYearPicker, p = l.showFourColumnMonthYearPicker, v = l.setPreSelection, m = l.handleOnMonthKeyDown, y = a.key;
      if (y !== "Tab" && a.preventDefault(), !d) {
        var b = Uc(p, h), g = ma[b].verticalNavigationOffset, w = ma[b].grid;
        switch (y) {
          case "Enter":
            t.onMonthClick(a, s), v(c);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(s === 11 ? 0 : s + 1, Dt(u, 1));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(s === 0 ? 11 : s - 1, ar(u, 1));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(w[0].includes(s) ? s + 12 - g : s - g, ar(u, g));
            break;
          case "ArrowDown":
            t.handleMonthNavigation(w[w.length - 1].includes(s) ? s - 12 + g : s + g, Dt(u, g));
        }
      }
      m && m(a);
    }), M(D(t), "onQuarterClick", function(a, s) {
      t.handleDayClick(Rc(Bn(t.props.day, s)), a);
    }), M(D(t), "onQuarterMouseEnter", function(a) {
      t.handleDayMouseEnter(Rc(Bn(t.props.day, a)));
    }), M(D(t), "handleQuarterNavigation", function(a, s) {
      t.isDisabled(s) || t.isExcluded(s) || (t.props.setPreSelection(s), t.QUARTER_REFS[a - 1].current && t.QUARTER_REFS[a - 1].current.focus());
    }), M(D(t), "onQuarterKeyDown", function(a, s) {
      var l = a.key;
      if (!t.props.disabledKeyboardNavigation)
        switch (l) {
          case "Enter":
            t.onQuarterClick(a, s), t.props.setPreSelection(t.props.selected);
            break;
          case "ArrowRight":
            t.handleQuarterNavigation(s === 4 ? 1 : s + 1, Q1(t.props.preSelection, 1));
            break;
          case "ArrowLeft":
            t.handleQuarterNavigation(s === 1 ? 4 : s - 1, sh(t.props.preSelection, 1));
        }
    }), M(D(t), "getMonthClassNames", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate, d = s.selected, h = s.minDate, p = s.maxDate, v = s.preSelection, m = s.monthClassName, y = s.excludeDates, b = s.includeDates, g = m ? m(et(l, a)) : void 0, w = et(l, a);
      return X("react-datepicker__month-text", "react-datepicker__month-".concat(a), g, { "react-datepicker__month-text--disabled": (h || p || y || b) && Ed(w, t.props), "react-datepicker__month-text--selected": t.isSelectedMonth(l, a, d), "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && t.isSelectedMonth(l, a, v), "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(a), "react-datepicker__month-text--in-range": pa(c, u, a, l), "react-datepicker__month-text--range-start": t.isRangeStartMonth(a), "react-datepicker__month-text--range-end": t.isRangeEndMonth(a), "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(a), "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(a), "react-datepicker__month-text--today": t.isCurrentMonth(l, a) });
    }), M(D(t), "getTabIndex", function(a) {
      var s = tt(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || a !== s ? "-1" : "0";
    }), M(D(t), "getQuarterTabIndex", function(a) {
      var s = Nr(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || a !== s ? "-1" : "0";
    }), M(D(t), "getAriaLabel", function(a) {
      var s = t.props, l = s.chooseDayAriaLabelPrefix, c = l === void 0 ? "Choose" : l, u = s.disabledDayAriaLabelPrefix, d = u === void 0 ? "Not available" : u, h = s.day, p = et(h, a), v = t.isDisabled(p) || t.isExcluded(p) ? d : c;
      return "".concat(v, " ").concat(je(p, "MMMM yyyy"));
    }), M(D(t), "getQuarterClassNames", function(a) {
      var s = t.props, l = s.day, c = s.startDate, u = s.endDate, d = s.selected, h = s.minDate, p = s.maxDate, v = s.preSelection, m = s.disabledKeyboardNavigation;
      return X("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(a), { "react-datepicker__quarter-text--disabled": (h || p) && X3(Bn(l, a), t.props), "react-datepicker__quarter-text--selected": t.isSelectedQuarter(l, a, d), "react-datepicker__quarter-text--keyboard-selected": !m && t.isSelectedQuarter(l, a, v), "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(a), "react-datepicker__quarter-text--in-range": va(c, u, a, l), "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(a), "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(a) });
    }), M(D(t), "getMonthContent", function(a) {
      var s = t.props, l = s.showFullMonthYearPicker, c = s.renderMonthContent, u = s.locale, d = s.day, h = _d(a, u), p = Zs(a, u);
      return c ? c(a, h, p, d) : l ? p : h;
    }), M(D(t), "getQuarterContent", function(a) {
      var s = t.props, l = s.renderQuarterContent, c = function(u, d) {
        return je(Bn(Ne(), u), "QQQ", d);
      }(a, s.locale);
      return l ? l(a, c) : c;
    }), M(D(t), "renderMonths", function() {
      var a = t.props, s = a.showTwoColumnMonthYearPicker, l = a.showFourColumnMonthYearPicker, c = a.day, u = a.selected;
      return ma[Uc(l, s)].grid.map(function(d, h) {
        return S.createElement("div", { className: "react-datepicker__month-wrapper", key: h }, d.map(function(p, v) {
          return S.createElement("div", { ref: t.MONTH_REFS[p], key: v, onClick: function(m) {
            t.onMonthClick(m, p);
          }, onKeyDown: function(m) {
            Td(m) && (m.preventDefault(), m.key = "Enter"), t.onMonthKeyDown(m, p);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onMonthMouseEnter(p);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onMonthMouseEnter(p);
          } : void 0, tabIndex: t.getTabIndex(p), className: t.getMonthClassNames(p), role: "option", "aria-label": t.getAriaLabel(p), "aria-current": t.isCurrentMonth(c, p) ? "date" : void 0, "aria-selected": t.isSelectedMonth(c, p, u) }, t.getMonthContent(p));
        }));
      });
    }), M(D(t), "renderQuarters", function() {
      var a = t.props, s = a.day, l = a.selected;
      return S.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(c, u) {
        return S.createElement("div", { key: u, ref: t.QUARTER_REFS[u], role: "option", onClick: function(d) {
          t.onQuarterClick(d, c);
        }, onKeyDown: function(d) {
          t.onQuarterKeyDown(d, c);
        }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
          return t.onQuarterMouseEnter(c);
        }, onPointerEnter: t.props.usePointerEvent ? function() {
          return t.onQuarterMouseEnter(c);
        } : void 0, className: t.getQuarterClassNames(c), "aria-selected": t.isSelectedQuarter(s, c, l), tabIndex: t.getQuarterTabIndex(c), "aria-current": t.isCurrentQuarter(s, c) ? "date" : void 0 }, t.getQuarterContent(c));
      }));
    }), M(D(t), "getClassNames", function() {
      var a = t.props, s = a.selectingDate, l = a.selectsStart, c = a.selectsEnd, u = a.showMonthYearPicker, d = a.showQuarterYearPicker, h = a.showWeekPicker;
      return X("react-datepicker__month", { "react-datepicker__month--selecting-range": s && (l || c) }, { "react-datepicker__monthPicker": u }, { "react-datepicker__quarterPicker": d }, { "react-datepicker__weekPicker": h });
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t = this.props, n = t.showMonthYearPicker, o = t.showQuarterYearPicker, i = t.day, a = t.ariaLabelPrefix, s = a === void 0 ? "Month " : a, l = s ? s.trim() + " " : "";
    return S.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(je(i, "MMMM, yyyy")), role: "listbox" }, n ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
  } }]), r;
}(), jd = function(e) {
  function r() {
    var t;
    Be(this, r);
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return M(D(t = We(this, r, [].concat(o))), "state", { height: null }), M(D(t), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        t.list && (t.list.scrollTop = t.centerLi && r.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - t.header.clientHeight : t.list.clientHeight, t.centerLi));
      });
    }), M(D(t), "handleClick", function(a) {
      (t.props.minTime || t.props.maxTime) && Lc(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Ac(a, t.props) || t.props.onChange(a);
    }), M(D(t), "isSelectedTime", function(a) {
      return t.props.selected && (s = t.props.selected, l = a, Zc(s).getTime() === Zc(l).getTime());
      var s, l;
    }), M(D(t), "isDisabledTime", function(a) {
      return (t.props.minTime || t.props.maxTime) && Lc(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Ac(a, t.props);
    }), M(D(t), "liClasses", function(a) {
      var s = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(a) : void 0];
      return t.isSelectedTime(a) && s.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(a) && s.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (60 * At(a) + Pt(a)) % t.props.intervals != 0 && s.push("react-datepicker__time-list-item--injected"), s.join(" ");
    }), M(D(t), "handleOnKeyDown", function(a, s) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), a.key !== "ArrowUp" && a.key !== "ArrowLeft" || !a.target.previousSibling || (a.preventDefault(), a.target.previousSibling.focus()), a.key !== "ArrowDown" && a.key !== "ArrowRight" || !a.target.nextSibling || (a.preventDefault(), a.target.nextSibling.focus()), a.key === "Enter" && t.handleClick(s), t.props.handleOnKeyDown(a);
    }), M(D(t), "renderTimes", function() {
      for (var a = [], s = t.props.format ? t.props.format : "p", l = t.props.intervals, c = t.props.selected || t.props.openToDate || Ne(), u = jt(c), d = t.props.injectTimes && t.props.injectTimes.sort(function(g, w) {
        return g - w;
      }), h = 60 * function(g) {
        var w = new Date(g.getFullYear(), g.getMonth(), g.getDate()), x = new Date(g.getFullYear(), g.getMonth(), g.getDate(), 24);
        return Math.round((+x - +w) / 36e5);
      }(c), p = h / l, v = 0; v < p; v++) {
        var m = Ya(u, v * l);
        if (a.push(m), d) {
          var y = e5(u, m, v, l, d);
          a = a.concat(y);
        }
      }
      var b = a.reduce(function(g, w) {
        return w.getTime() <= c.getTime() ? w : g;
      }, a[0]);
      return a.map(function(g, w) {
        return S.createElement("li", { key: w, onClick: t.handleClick.bind(D(t), g), className: t.liClasses(g), ref: function(x) {
          g === b && (t.centerLi = x);
        }, onKeyDown: function(x) {
          t.handleOnKeyDown(x, g);
        }, tabIndex: g === b ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(g) ? "true" : void 0, "aria-disabled": t.isDisabledTime(g) ? "true" : void 0 }, je(g, s, t.props.locale));
      });
    }), t;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t = this, n = this.state.height;
    return S.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, S.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
      t.header = o;
    } }, S.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), S.createElement("div", { className: "react-datepicker__time" }, S.createElement("div", { className: "react-datepicker__time-box" }, S.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
      t.list = o;
    }, style: n ? { height: n } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), r;
}();
M(jd, "calcCenterPosition", function(e, r) {
  return r.offsetTop - (e / 2 - r.clientHeight / 2);
});
var p5 = function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "YEAR_REFS", gn(Array(n.props.yearItemNumber)).map(function() {
      return S.createRef();
    })), M(D(n), "isDisabled", function(o) {
      return Pi(o, n.props);
    }), M(D(n), "isExcluded", function(o) {
      return Ws(o, n.props);
    }), M(D(n), "selectingDate", function() {
      var o;
      return (o = n.props.selectingDate) !== null && o !== void 0 ? o : n.props.preSelection;
    }), M(D(n), "updateFocusOnPaginate", function(o) {
      var i = function() {
        this.YEAR_REFS[o].current.focus();
      }.bind(D(n));
      window.requestAnimationFrame(i);
    }), M(D(n), "handleYearClick", function(o, i) {
      n.props.onDayClick && n.props.onDayClick(o, i);
    }), M(D(n), "handleYearNavigation", function(o, i) {
      var a = n.props, s = a.date, l = a.yearItemNumber, c = Gn(s, l).startPeriod;
      n.isDisabled(i) || n.isExcluded(i) || (n.props.setPreSelection(i), o - c == -1 ? n.updateFocusOnPaginate(l - 1) : o - c === l ? n.updateFocusOnPaginate(0) : n.YEAR_REFS[o - c].current.focus());
    }), M(D(n), "isSameDay", function(o, i) {
      return Ee(o, i);
    }), M(D(n), "isCurrentYear", function(o) {
      return o === de(Ne());
    }), M(D(n), "isRangeStart", function(o) {
      return n.props.startDate && n.props.endDate && an(Yt(Ne(), o), n.props.startDate);
    }), M(D(n), "isRangeEnd", function(o) {
      return n.props.startDate && n.props.endDate && an(Yt(Ne(), o), n.props.endDate);
    }), M(D(n), "isInRange", function(o) {
      return ha(o, n.props.startDate, n.props.endDate);
    }), M(D(n), "isInSelectingRange", function(o) {
      var i = n.props, a = i.selectsStart, s = i.selectsEnd, l = i.selectsRange, c = i.startDate, u = i.endDate;
      return !(!(a || s || l) || !n.selectingDate()) && (a && u ? ha(o, n.selectingDate(), u) : (s && c || !(!l || !c || u)) && ha(o, c, n.selectingDate()));
    }), M(D(n), "isSelectingRangeStart", function(o) {
      if (!n.isInSelectingRange(o))
        return !1;
      var i = n.props, a = i.startDate, s = i.selectsStart, l = Yt(Ne(), o);
      return an(l, s ? n.selectingDate() : a);
    }), M(D(n), "isSelectingRangeEnd", function(o) {
      if (!n.isInSelectingRange(o))
        return !1;
      var i = n.props, a = i.endDate, s = i.selectsEnd, l = i.selectsRange, c = Yt(Ne(), o);
      return an(c, s || l ? n.selectingDate() : a);
    }), M(D(n), "isKeyboardSelected", function(o) {
      var i = Ir(Yt(n.props.date, o));
      return !n.props.disabledKeyboardNavigation && !n.props.inline && !Ee(i, Ir(n.props.selected)) && Ee(i, Ir(n.props.preSelection));
    }), M(D(n), "onYearClick", function(o, i) {
      var a = n.props.date;
      n.handleYearClick(Ir(Yt(a, i)), o);
    }), M(D(n), "onYearKeyDown", function(o, i) {
      var a = o.key, s = n.props.handleOnKeyDown;
      if (!n.props.disabledKeyboardNavigation)
        switch (a) {
          case "Enter":
            n.onYearClick(o, i), n.props.setPreSelection(n.props.selected);
            break;
          case "ArrowRight":
            n.handleYearNavigation(i + 1, on(n.props.preSelection, 1));
            break;
          case "ArrowLeft":
            n.handleYearNavigation(i - 1, Wr(n.props.preSelection, 1));
        }
      s && s(o);
    }), M(D(n), "getYearClassNames", function(o) {
      var i = n.props, a = i.minDate, s = i.maxDate, l = i.selected, c = i.excludeDates, u = i.includeDates, d = i.filterDate;
      return X("react-datepicker__year-text", { "react-datepicker__year-text--selected": o === de(l), "react-datepicker__year-text--disabled": (a || s || c || u || d) && Id(o, n.props), "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(o), "react-datepicker__year-text--range-start": n.isRangeStart(o), "react-datepicker__year-text--range-end": n.isRangeEnd(o), "react-datepicker__year-text--in-range": n.isInRange(o), "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(o), "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(o), "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(o), "react-datepicker__year-text--today": n.isCurrentYear(o) });
    }), M(D(n), "getYearTabIndex", function(o) {
      return n.props.disabledKeyboardNavigation ? "-1" : o === de(n.props.preSelection) ? "0" : "-1";
    }), M(D(n), "getYearContainerClassNames", function() {
      var o = n.props, i = o.selectingDate, a = o.selectsStart, s = o.selectsEnd, l = o.selectsRange;
      return X("react-datepicker__year", { "react-datepicker__year--selecting-range": i && (a || s || l) });
    }), M(D(n), "getYearContent", function(o) {
      return n.props.renderYearContent ? n.props.renderYearContent(o) : o;
    }), n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    for (var t = this, n = [], o = this.props, i = o.date, a = o.yearItemNumber, s = o.onYearMouseEnter, l = o.onYearMouseLeave, c = Gn(i, a), u = c.startPeriod, d = c.endPeriod, h = function(v) {
      n.push(S.createElement("div", { ref: t.YEAR_REFS[v - u], onClick: function(m) {
        t.onYearClick(m, v);
      }, onKeyDown: function(m) {
        Td(m) && (m.preventDefault(), m.key = "Enter"), t.onYearKeyDown(m, v);
      }, tabIndex: t.getYearTabIndex(v), className: t.getYearClassNames(v), onMouseEnter: t.props.usePointerEvent ? void 0 : function(m) {
        return s(m, v);
      }, onPointerEnter: t.props.usePointerEvent ? function(m) {
        return s(m, v);
      } : void 0, onMouseLeave: t.props.usePointerEvent ? void 0 : function(m) {
        return l(m, v);
      }, onPointerLeave: t.props.usePointerEvent ? function(m) {
        return l(m, v);
      } : void 0, key: v, "aria-current": t.isCurrentYear(v) ? "date" : void 0 }, t.getYearContent(v)));
    }, p = u; p <= d; p++)
      h(p);
    return S.createElement("div", { className: this.getYearContainerClassNames() }, S.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, n));
  } }]), r;
}(), h5 = function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "onTimeChange", function(o) {
      n.setState({ time: o });
      var i = n.props.date, a = i instanceof Date && !isNaN(i) ? i : /* @__PURE__ */ new Date();
      a.setHours(o.split(":")[0]), a.setMinutes(o.split(":")[1]), n.props.onChange(a);
    }), M(D(n), "renderTimeInput", function() {
      var o = n.state.time, i = n.props, a = i.date, s = i.timeString, l = i.customTimeInput;
      return l ? S.cloneElement(l, { date: a, value: o, onChange: n.onTimeChange }) : S.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: o, onChange: function(c) {
        n.onTimeChange(c.target.value || s);
      } });
    }), n.state = { time: n.props.timeString }, n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    return S.createElement("div", { className: "react-datepicker__input-time-container" }, S.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), S.createElement("div", { className: "react-datepicker-time__input-container" }, S.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(t, n) {
    return t.timeString !== n.time ? { time: t.timeString } : null;
  } }]), r;
}();
function v5(e) {
  var r = e.className, t = e.children;
  return S.createElement("div", { className: r, role: "dialog", "aria-label": "Choose Date", "aria-modal": "true" }, t);
}
var m5 = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], g5 = function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "handleClickOutside", function(o) {
      n.props.onClickOutside(o);
    }), M(D(n), "setClickOutsideRef", function() {
      return n.containerRef.current;
    }), M(D(n), "handleDropdownFocus", function(o) {
      (function() {
        var i = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return m5.some(function(a) {
          return i.indexOf(a) >= 0;
        });
      })(o.target) && n.props.onDropdownFocus();
    }), M(D(n), "getDateInView", function() {
      var o = n.props, i = o.preSelection, a = o.selected, s = o.openToDate, l = Od(n.props), c = Nd(n.props), u = Ne(), d = s || a || i;
      return d || (l && Sn(u, l) ? l : c && hn(u, c) ? c : u);
    }), M(D(n), "increaseMonth", function() {
      n.setState(function(o) {
        var i = o.date;
        return { date: Dt(i, 1) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), M(D(n), "decreaseMonth", function() {
      n.setState(function(o) {
        var i = o.date;
        return { date: ar(i, 1) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), M(D(n), "handleDayClick", function(o, i, a) {
      n.props.onSelect(o, i, a), n.props.setPreSelection && n.props.setPreSelection(o);
    }), M(D(n), "handleDayMouseEnter", function(o) {
      n.setState({ selectingDate: o }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(o);
    }), M(D(n), "handleMonthMouseLeave", function() {
      n.setState({ selectingDate: null }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
    }), M(D(n), "handleYearMouseEnter", function(o, i) {
      n.setState({ selectingDate: Yt(Ne(), i) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(o, i);
    }), M(D(n), "handleYearMouseLeave", function(o, i) {
      n.props.onYearMouseLeave && n.props.onYearMouseLeave(o, i);
    }), M(D(n), "handleYearChange", function(o) {
      n.props.onYearChange && (n.props.onYearChange(o), n.setState({ isRenderAriaLiveMessage: !0 })), n.props.adjustDateOnChange && (n.props.onSelect && n.props.onSelect(o), n.props.setOpen && n.props.setOpen(!0)), n.props.setPreSelection && n.props.setPreSelection(o);
    }), M(D(n), "handleMonthChange", function(o) {
      n.handleCustomMonthChange(o), n.props.adjustDateOnChange && (n.props.onSelect && n.props.onSelect(o), n.props.setOpen && n.props.setOpen(!0)), n.props.setPreSelection && n.props.setPreSelection(o);
    }), M(D(n), "handleCustomMonthChange", function(o) {
      n.props.onMonthChange && (n.props.onMonthChange(o), n.setState({ isRenderAriaLiveMessage: !0 }));
    }), M(D(n), "handleMonthYearChange", function(o) {
      n.handleYearChange(o), n.handleMonthChange(o);
    }), M(D(n), "changeYear", function(o) {
      n.setState(function(i) {
        var a = i.date;
        return { date: Yt(a, o) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), M(D(n), "changeMonth", function(o) {
      n.setState(function(i) {
        var a = i.date;
        return { date: et(a, o) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), M(D(n), "changeMonthYear", function(o) {
      n.setState(function(i) {
        var a = i.date;
        return { date: Yt(et(a, tt(o)), de(o)) };
      }, function() {
        return n.handleMonthYearChange(n.state.date);
      });
    }), M(D(n), "header", function() {
      var o = dn(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.state.date, n.props.locale, n.props.calendarStartDay), i = [];
      return n.props.showWeekNumbers && i.push(S.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(a) {
        var s = yn(o, a), l = n.formatWeekday(s, n.props.locale), c = n.props.weekDayClassName ? n.props.weekDayClassName(s) : void 0;
        return S.createElement("div", { key: a, className: X("react-datepicker__day-name", c) }, l);
      }));
    }), M(D(n), "formatWeekday", function(o, i) {
      return n.props.formatWeekDay ? function(a, s, l) {
        return s(je(a, "EEEE", l));
      }(o, n.props.formatWeekDay, i) : n.props.useWeekdaysShort ? function(a, s) {
        return je(a, "EEE", s);
      }(o, i) : function(a, s) {
        return je(a, "EEEEEE", s);
      }(o, i);
    }), M(D(n), "decreaseYear", function() {
      n.setState(function(o) {
        var i = o.date;
        return { date: Wr(i, n.props.showYearPicker ? n.props.yearItemNumber : 1) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), M(D(n), "clearSelectingDate", function() {
      n.setState({ selectingDate: null });
    }), M(D(n), "renderPreviousButton", function() {
      if (!n.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case n.props.showMonthYearPicker:
            o = Fc(n.state.date, n.props);
            break;
          case n.props.showYearPicker:
            o = function(y) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = b.minDate, w = b.yearItemNumber, x = w === void 0 ? Tr : w, C = Gn(Ir(Wr(y, x)), x).endPeriod, O = g && de(g);
              return O && O > C || !1;
            }(n.state.date, n.props);
            break;
          default:
            o = Vc(n.state.date, n.props);
        }
        if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !o) && !n.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], a = n.decreaseMonth;
          (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (a = n.decreaseYear), o && n.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), a = null);
          var s = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, l = n.props, c = l.previousMonthButtonLabel, u = l.previousYearButtonLabel, d = n.props, h = d.previousMonthAriaLabel, p = h === void 0 ? typeof c == "string" ? c : "Previous Month" : h, v = d.previousYearAriaLabel, m = v === void 0 ? typeof u == "string" ? u : "Previous Year" : v;
          return S.createElement("button", { type: "button", className: i.join(" "), onClick: a, onKeyDown: n.props.handleOnKeyDown, "aria-label": s ? m : p }, S.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, s ? n.props.previousYearButtonLabel : n.props.previousMonthButtonLabel));
        }
      }
    }), M(D(n), "increaseYear", function() {
      n.setState(function(o) {
        var i = o.date;
        return { date: on(i, n.props.showYearPicker ? n.props.yearItemNumber : 1) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), M(D(n), "renderNextButton", function() {
      if (!n.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case n.props.showMonthYearPicker:
            o = Yc(n.state.date, n.props);
            break;
          case n.props.showYearPicker:
            o = function(y) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = b.maxDate, w = b.yearItemNumber, x = w === void 0 ? Tr : w, C = Gn(on(y, x), x).startPeriod, O = g && de(g);
              return O && O < C || !1;
            }(n.state.date, n.props);
            break;
          default:
            o = Hc(n.state.date, n.props);
        }
        if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !o) && !n.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          n.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
          var a = n.increaseMonth;
          (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (a = n.increaseYear), o && n.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), a = null);
          var s = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, l = n.props, c = l.nextMonthButtonLabel, u = l.nextYearButtonLabel, d = n.props, h = d.nextMonthAriaLabel, p = h === void 0 ? typeof c == "string" ? c : "Next Month" : h, v = d.nextYearAriaLabel, m = v === void 0 ? typeof u == "string" ? u : "Next Year" : v;
          return S.createElement("button", { type: "button", className: i.join(" "), onClick: a, onKeyDown: n.props.handleOnKeyDown, "aria-label": s ? m : p }, S.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, s ? n.props.nextYearButtonLabel : n.props.nextMonthButtonLabel));
        }
      }
    }), M(D(n), "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.state.date, i = ["react-datepicker__current-month"];
      return n.props.showYearDropdown && i.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && i.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && i.push("react-datepicker__current-month--hasMonthYearDropdown"), S.createElement("div", { className: i.join(" ") }, je(o, n.props.dateFormat, n.props.locale));
    }), M(D(n), "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showYearDropdown && !o)
        return S.createElement(r5, { adjustDateOnChange: n.props.adjustDateOnChange, date: n.state.date, onSelect: n.props.onSelect, setOpen: n.props.setOpen, dropdownMode: n.props.dropdownMode, onChange: n.changeYear, minDate: n.props.minDate, maxDate: n.props.maxDate, year: de(n.state.date), scrollableYearDropdown: n.props.scrollableYearDropdown, yearDropdownItemNumber: n.props.yearDropdownItemNumber });
    }), M(D(n), "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showMonthDropdown && !o)
        return S.createElement(i5, { dropdownMode: n.props.dropdownMode, locale: n.props.locale, onChange: n.changeMonth, month: tt(n.state.date), useShortMonthInDropdown: n.props.useShortMonthInDropdown });
    }), M(D(n), "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showMonthYearDropdown && !o)
        return S.createElement(l5, { dropdownMode: n.props.dropdownMode, locale: n.props.locale, dateFormat: n.props.dateFormat, onChange: n.changeMonthYear, minDate: n.props.minDate, maxDate: n.props.maxDate, date: n.state.date, scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown });
    }), M(D(n), "handleTodayButtonClick", function(o) {
      n.props.onSelect(jc(), o), n.props.setPreSelection && n.props.setPreSelection(jc());
    }), M(D(n), "renderTodayButton", function() {
      if (n.props.todayButton && !n.props.showTimeSelectOnly)
        return S.createElement("div", { className: "react-datepicker__today-button", onClick: function(o) {
          return n.handleTodayButtonClick(o);
        } }, n.props.todayButton);
    }), M(D(n), "renderDefaultHeader", function(o) {
      var i = o.monthDate, a = o.i;
      return S.createElement("div", { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, n.renderCurrentMonth(i), S.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus }, n.renderMonthDropdown(a !== 0), n.renderMonthYearDropdown(a !== 0), n.renderYearDropdown(a !== 0)), S.createElement("div", { className: "react-datepicker__day-names" }, n.header(i)));
    }), M(D(n), "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = o.monthDate, a = o.i;
      if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly)
        return null;
      var s = Vc(n.state.date, n.props), l = Hc(n.state.date, n.props), c = Fc(n.state.date, n.props), u = Yc(n.state.date, n.props), d = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
      return S.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus }, n.props.renderCustomHeader($t($t({}, n.state), {}, { customHeaderCount: a, monthDate: i, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: s, nextMonthButtonDisabled: l, prevYearButtonDisabled: c, nextYearButtonDisabled: u })), d && S.createElement("div", { className: "react-datepicker__day-names" }, n.header(i)));
    }), M(D(n), "renderYearHeader", function(o) {
      var i = o.monthDate, a = n.props, s = a.showYearPicker, l = Gn(i, a.yearItemNumber), c = l.startPeriod, u = l.endPeriod;
      return S.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(c, " - ").concat(u) : de(i));
    }), M(D(n), "renderHeader", function(o) {
      switch (!0) {
        case n.props.renderCustomHeader !== void 0:
          return n.renderCustomHeader(o);
        case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
          return n.renderYearHeader(o);
        default:
          return n.renderDefaultHeader(o);
      }
    }), M(D(n), "renderMonths", function() {
      var o;
      if (!n.props.showTimeSelectOnly && !n.props.showYearPicker) {
        for (var i = [], a = n.props.showPreviousMonths ? n.props.monthsShown - 1 : 0, s = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(n.state.date, a) : ar(n.state.date, a), l = (o = n.props.monthSelectedIn) !== null && o !== void 0 ? o : a, c = 0; c < n.props.monthsShown; ++c) {
          var u = c - l + a, d = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(s, u) : Dt(s, u), h = "month-".concat(c), p = c < n.props.monthsShown - 1, v = c > 0;
          i.push(S.createElement("div", { key: h, ref: function(m) {
            n.monthContainer = m;
          }, className: "react-datepicker__month-container" }, n.renderHeader({ monthDate: d, i: c }), S.createElement(f5, { chooseDayAriaLabelPrefix: n.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: n.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: n.props.weekAriaLabelPrefix, ariaLabelPrefix: n.props.monthAriaLabelPrefix, onChange: n.changeMonthYear, day: d, dayClassName: n.props.dayClassName, calendarStartDay: n.props.calendarStartDay, monthClassName: n.props.monthClassName, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, handleOnMonthKeyDown: n.props.handleOnKeyDown, usePointerEvent: n.props.usePointerEvent, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, onWeekSelect: n.props.onWeekSelect, orderInDisplay: c, formatWeekNumber: n.props.formatWeekNumber, locale: n.props.locale, minDate: n.props.minDate, maxDate: n.props.maxDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, highlightDates: n.props.highlightDates, holidays: n.props.holidays, selectingDate: n.state.selectingDate, includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, inline: n.props.inline, shouldFocusDayInline: n.props.shouldFocusDayInline, fixedHeight: n.props.fixedHeight, filterDate: n.props.filterDate, preSelection: n.props.preSelection, setPreSelection: n.props.setPreSelection, selected: n.props.selected, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, selectsMultiple: n.props.selectsMultiple, selectedDates: n.props.selectedDates, showWeekNumbers: n.props.showWeekNumbers, startDate: n.props.startDate, endDate: n.props.endDate, peekNextMonth: n.props.peekNextMonth, setOpen: n.props.setOpen, shouldCloseOnSelect: n.props.shouldCloseOnSelect, renderDayContents: n.props.renderDayContents, renderMonthContent: n.props.renderMonthContent, renderQuarterContent: n.props.renderQuarterContent, renderYearContent: n.props.renderYearContent, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, showMonthYearPicker: n.props.showMonthYearPicker, showFullMonthYearPicker: n.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: n.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: n.props.showFourColumnMonthYearPicker, showYearPicker: n.props.showYearPicker, showQuarterYearPicker: n.props.showQuarterYearPicker, showWeekPicker: n.props.showWeekPicker, isInputFocused: n.props.isInputFocused, containerRef: n.containerRef, monthShowsDuplicateDaysEnd: p, monthShowsDuplicateDaysStart: v })));
        }
        return i;
      }
    }), M(D(n), "renderYears", function() {
      if (!n.props.showTimeSelectOnly)
        return n.props.showYearPicker ? S.createElement("div", { className: "react-datepicker__year--container" }, n.renderHeader({ monthDate: n.state.date }), S.createElement(p5, Kr({ onDayClick: n.handleDayClick, selectingDate: n.state.selectingDate, clearSelectingDate: n.clearSelectingDate, date: n.state.date }, n.props, { onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))) : void 0;
    }), M(D(n), "renderTimeSection", function() {
      if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly))
        return S.createElement(jd, { selected: n.props.selected, openToDate: n.props.openToDate, onChange: n.props.onTimeChange, timeClassName: n.props.timeClassName, format: n.props.timeFormat, includeTimes: n.props.includeTimes, intervals: n.props.timeIntervals, minTime: n.props.minTime, maxTime: n.props.maxTime, excludeTimes: n.props.excludeTimes, filterTime: n.props.filterTime, timeCaption: n.props.timeCaption, todayButton: n.props.todayButton, showMonthDropdown: n.props.showMonthDropdown, showMonthYearDropdown: n.props.showMonthYearDropdown, showYearDropdown: n.props.showYearDropdown, withPortal: n.props.withPortal, monthRef: n.state.monthContainer, injectTimes: n.props.injectTimes, locale: n.props.locale, handleOnKeyDown: n.props.handleOnKeyDown, showTimeSelectOnly: n.props.showTimeSelectOnly });
    }), M(D(n), "renderInputTimeSection", function() {
      var o = new Date(n.props.selected), i = nn(o) && n.props.selected ? "".concat(zc(o.getHours()), ":").concat(zc(o.getMinutes())) : "";
      if (n.props.showTimeInput)
        return S.createElement(h5, { date: o, timeString: i, timeInputLabel: n.props.timeInputLabel, onChange: n.props.onTimeChange, customTimeInput: n.props.customTimeInput });
    }), M(D(n), "renderAriaLiveRegion", function() {
      var o, i = Gn(n.state.date, n.props.yearItemNumber), a = i.startPeriod, s = i.endPeriod;
      return o = n.props.showYearPicker ? "".concat(a, " - ").concat(s) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? de(n.state.date) : "".concat(Zs(tt(n.state.date), n.props.locale), " ").concat(de(n.state.date)), S.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && o);
    }), M(D(n), "renderChildren", function() {
      if (n.props.children)
        return S.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
    }), n.containerRef = S.createRef(), n.state = { date: n.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    var t = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void t.setState({ monthContainer: t.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(t) {
    var n = this;
    if (!this.props.preSelection || Ee(this.props.preSelection, t.preSelection) && this.props.monthSelectedIn === t.monthSelectedIn)
      this.props.openToDate && !Ee(this.props.openToDate, t.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var o = !wt(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return o && n.handleCustomMonthChange(n.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var t = this.props.container || v5;
    return S.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, S.createElement(t, { className: X("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }) }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: Tr };
  } }]), r;
}(), y5 = function(e) {
  var r = e.icon, t = e.className, n = t === void 0 ? "" : t, o = e.onClick, i = "react-datepicker__calendar-icon";
  return S.isValidElement(r) ? S.cloneElement(r, { className: "".concat(r.props.className || "", " ").concat(i, " ").concat(n), onClick: function(a) {
    typeof r.props.onClick == "function" && r.props.onClick(a), typeof o == "function" && o(a);
  } }) : typeof r == "string" ? S.createElement("i", { className: "".concat(i, " ").concat(r, " ").concat(n), "aria-hidden": "true", onClick: o }) : S.createElement("svg", { className: "".concat(i, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: o }, S.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, Pd = function(e) {
  function r(t) {
    var n;
    return Be(this, r), (n = We(this, r, [t])).el = document.createElement("div"), n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return Bp.createPortal(this.props.children, this.el);
  } }]), r;
}(), w5 = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, Ad = function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "getTabChildren", function() {
      return Array.prototype.slice.call(n.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(w5);
    }), M(D(n), "handleFocusStart", function() {
      var o = n.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), M(D(n), "handleFocusEnd", function() {
      var o = n.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), n.tabLoopRef = S.createRef(), n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? S.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, S.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, S.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), r;
}(), Kc, x5 = (Kc = function(e) {
  function r() {
    return Be(this, r), We(this, r, arguments);
  }
  return Ke(r, S.Component), Ue(r, [{ key: "render", value: function() {
    var t, n = this.props, o = n.className, i = n.wrapperClassName, a = n.hidePopper, s = n.popperComponent, l = n.targetComponent, c = n.enableTabLoop, u = n.popperOnKeyDown, d = n.portalId, h = n.portalHost, p = n.popperProps, v = n.showArrow;
    if (!a) {
      var m = X("react-datepicker-popper", o);
      t = S.createElement(Ad, { enableTabLoop: c }, S.createElement("div", { ref: p.refs.setFloating, style: p.floatingStyles, className: m, "data-placement": p.placement, onKeyDown: u }, s, v && S.createElement(z3, { ref: p.arrowRef, context: p.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })));
    }
    this.props.popperContainer && (t = S.createElement(this.props.popperContainer, {}, t)), d && !a && (t = S.createElement(Pd, { portalId: d, portalHost: h }, t));
    var y = X("react-datepicker-wrapper", i);
    return S.createElement(S.Fragment, null, S.createElement("div", { ref: p.refs.setReference, className: y }, l), t);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0 };
  } }]), r;
}(), function(e) {
  var r = $t($t({}, e), {}, { popperModifiers: e.popperModifiers || [], popperProps: e.popperProps || {}, hidePopper: typeof e.hidePopper != "boolean" || e.hidePopper }), t = S.useRef(), n = Q3($t({ open: !r.hidePopper, whileElementsMounted: Ys, placement: r.popperPlacement, middleware: [$s({ padding: 15 }), As(10), hd({ element: t })].concat(gn(r.popperModifiers)) }, r.popperProps));
  return S.createElement(Kc, Kr({}, r, { popperProps: $t($t({}, n), {}, { arrowRef: t }) }));
}), Qc = "react-datepicker-ignore-onclickoutside", C5 = ki(g5), ga = "Date input not valid.", b5 = function(e) {
  function r(t) {
    var n;
    return Be(this, r), M(D(n = We(this, r, [t])), "getPreSelection", function() {
      return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : Ne();
    }), M(D(n), "modifyHolidays", function() {
      var o;
      return (o = n.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(i, a) {
        var s = new Date(a.date);
        return zr(s) ? [].concat(gn(i), [$t($t({}, a), {}, { date: s })]) : i;
      }, []);
    }), M(D(n), "calcInitialState", function() {
      var o, i = n.getPreSelection(), a = Od(n.props), s = Nd(n.props), l = a && Sn(i, jt(a)) ? a : s && hn(i, Za(s)) ? s : i;
      return { open: n.props.startOpen || !1, preventFocus: !1, preSelection: (o = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && o !== void 0 ? o : l, highlightDates: $c(n.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), M(D(n), "clearPreventFocusTimeout", function() {
      n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
    }), M(D(n), "setFocus", function() {
      n.input && n.input.focus && n.input.focus({ preventScroll: !0 });
    }), M(D(n), "setBlur", function() {
      n.input && n.input.blur && n.input.blur(), n.cancelFocusInput();
    }), M(D(n), "setOpen", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      n.setState({ open: o, preSelection: o && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection, lastPreSelectChange: ya }, function() {
        o || n.setState(function(a) {
          return { focused: !!i && a.focused };
        }, function() {
          !i && n.setBlur(), n.setState({ inputValue: null });
        });
      });
    }), M(D(n), "inputOk", function() {
      return kn(n.state.preSelection);
    }), M(D(n), "isCalendarOpen", function() {
      return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
    }), M(D(n), "handleFocus", function(o) {
      n.state.preventFocus || (n.props.onFocus(o), n.props.preventOpenOnFocus || n.props.readOnly || n.setOpen(!0)), n.setState({ focused: !0 });
    }), M(D(n), "sendFocusBackToInput", function() {
      n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
        n.preventFocusTimeout = setTimeout(function() {
          n.setFocus(), n.setState({ preventFocus: !1 });
        });
      });
    }), M(D(n), "cancelFocusInput", function() {
      clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = null;
    }), M(D(n), "deferFocusInput", function() {
      n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
        return n.setFocus();
      }, 1);
    }), M(D(n), "handleDropdownFocus", function() {
      n.cancelFocusInput();
    }), M(D(n), "handleBlur", function(o) {
      (!n.state.open || n.props.withPortal || n.props.showTimeInput) && n.props.onBlur(o), n.setState({ focused: !1 });
    }), M(D(n), "handleCalendarClickOutside", function(o) {
      n.props.inline || n.setOpen(!1), n.props.onClickOutside(o), n.props.withPortal && o.preventDefault();
    }), M(D(n), "handleChange", function() {
      for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
        i[a] = arguments[a];
      var s = i[0];
      if (!n.props.onChangeRaw || (n.props.onChangeRaw.apply(D(n), i), typeof s.isDefaultPrevented == "function" && !s.isDefaultPrevented())) {
        n.setState({ inputValue: s.target.value, lastPreSelectChange: M5 });
        var l, c, u, d, h, p, v, m, y = (l = s.target.value, c = n.props.dateFormat, u = n.props.locale, d = n.props.strictParsing, h = n.props.minDate, p = null, v = pn(u) || pn(Nn()), m = !0, Array.isArray(c) ? (c.forEach(function(b) {
          var g = sa(l, b, /* @__PURE__ */ new Date(), { locale: v, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
          d && (m = nn(g, h) && l === je(g, b, u)), nn(g, h) && m && (p = g);
        }), p) : (p = sa(l, c, /* @__PURE__ */ new Date(), { locale: v, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 }), d ? m = nn(p) && l === je(p, c, u) : nn(p) || (c = c.match(G3).map(function(b) {
          var g = b[0];
          if (g === "p" || g === "P") {
            var w = Jo[g];
            return v ? w(b, v.formatLong) : g;
          }
          return b;
        }).join(""), l.length > 0 && (p = sa(l, c.slice(0, l.length), /* @__PURE__ */ new Date(), { useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 })), nn(p) || (p = new Date(l))), nn(p) && m ? p : null));
        n.props.showTimeSelectOnly && n.props.selected && y && !Ee(y, n.props.selected) && (y = q3(n.props.selected, { hours: At(y), minutes: Pt(y), seconds: vc(y) })), !y && s.target.value || n.setSelected(y, s, !0);
      }
    }), M(D(n), "handleSelect", function(o, i, a) {
      if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(i), n.setSelected(o, i, !1, a), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect)
        n.setPreSelection(o);
      else if (!n.props.inline) {
        n.props.selectsRange || n.setOpen(!1);
        var s = n.props, l = s.startDate, c = s.endDate;
        !l || c || Bc(o, l) || n.setOpen(!1);
      }
    }), M(D(n), "setSelected", function(o, i, a, s) {
      var l = o;
      if (n.props.showYearPicker) {
        if (l !== null && Id(de(l), n.props))
          return;
      } else if (n.props.showMonthYearPicker) {
        if (l !== null && Ed(l, n.props))
          return;
      } else if (l !== null && Pi(l, n.props))
        return;
      var c = n.props, u = c.onChange, d = c.selectsRange, h = c.startDate, p = c.endDate, v = c.selectsMultiple, m = c.selectedDates, y = c.minTime;
      if (!En(n.props.selected, l) || n.props.allowSameDay || d || v)
        if (l !== null && (!n.props.selected || a && (n.props.showTimeSelect || n.props.showTimeSelectOnly || n.props.showTimeInput) || (l = fa(l, { hour: At(n.props.selected), minute: Pt(n.props.selected), second: vc(n.props.selected) })), (n.props.showTimeSelect || n.props.showTimeSelectOnly) && y && (l = fa(l, { hour: y.getHours(), minute: y.getMinutes(), second: y.getSeconds() })), n.props.inline || n.setState({ preSelection: l }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: s })), d) {
          var b = h && !p, g = h && p;
          !h && !p ? u([l, null], i) : b && (l === null ? u([null, null], i) : Bc(l, h) ? u([l, null], i) : u([h, l], i)), g && u([l, null], i);
        } else
          v ? m != null && m.length ? m.some(function(w) {
            return Ee(w, l);
          }) ? u(m.filter(function(w) {
            return !Ee(w, l);
          }), i) : u([].concat(gn(m), [l]), i) : u([l], i) : u(l, i);
      a || (n.props.onSelect(l, i), n.setState({ inputValue: null }));
    }), M(D(n), "setPreSelection", function(o) {
      var i = n.props.minDate !== void 0, a = n.props.maxDate !== void 0, s = !0;
      if (o) {
        var l = jt(o);
        if (i && a)
          s = Yo(o, n.props.minDate, n.props.maxDate);
        else if (i) {
          var c = jt(n.props.minDate);
          s = hn(o, c) || En(l, c);
        } else if (a) {
          var u = Za(n.props.maxDate);
          s = Sn(o, u) || En(l, u);
        }
      }
      s && n.setState({ preSelection: o });
    }), M(D(n), "toggleCalendar", function() {
      n.setOpen(!n.state.open);
    }), M(D(n), "handleTimeChange", function(o) {
      var i = n.props.selected ? n.props.selected : n.getPreSelection(), a = n.props.selected ? o : fa(i, { hour: At(o), minute: Pt(o) });
      n.setState({ preSelection: a }), n.props.onChange(a), n.props.shouldCloseOnSelect && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
    }), M(D(n), "onInputClick", function() {
      n.props.disabled || n.props.readOnly || n.setOpen(!0), n.props.onInputClick();
    }), M(D(n), "onInputKeyDown", function(o) {
      n.props.onKeyDown(o);
      var i = o.key;
      if (n.state.open || n.props.inline || n.props.preventOpenOnFocus) {
        if (n.state.open) {
          if (i === "ArrowDown" || i === "ArrowUp") {
            o.preventDefault();
            var a = n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', s = n.calendar.componentNode && n.calendar.componentNode.querySelector(a);
            return void (s && s.focus({ preventScroll: !0 }));
          }
          var l = Ne(n.state.preSelection);
          i === "Enter" ? (o.preventDefault(), n.inputOk() && n.state.lastPreSelectChange === ya ? (n.handleSelect(l, o), !n.props.shouldCloseOnSelect && n.setPreSelection(l)) : n.setOpen(!1)) : i === "Escape" ? (o.preventDefault(), n.sendFocusBackToInput(), n.setOpen(!1)) : i === "Tab" && n.setOpen(!1), n.inputOk() || n.props.onInputError({ code: 1, msg: ga });
        }
      } else
        i !== "ArrowDown" && i !== "ArrowUp" && i !== "Enter" || n.onInputClick();
    }), M(D(n), "onPortalKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), n.setState({ preventFocus: !0 }, function() {
        n.setOpen(!1), setTimeout(function() {
          n.setFocus(), n.setState({ preventFocus: !1 });
        });
      }));
    }), M(D(n), "onDayKeyDown", function(o) {
      n.props.onKeyDown(o);
      var i = o.key, a = o.shiftKey, s = Ne(n.state.preSelection);
      if (i === "Enter")
        o.preventDefault(), n.handleSelect(s, o), !n.props.shouldCloseOnSelect && n.setPreSelection(s);
      else if (i === "Escape")
        o.preventDefault(), n.setOpen(!1), n.inputOk() || n.props.onInputError({ code: 1, msg: ga });
      else if (!n.props.disabledKeyboardNavigation) {
        var l;
        switch (i) {
          case "ArrowLeft":
            l = n.props.showWeekPicker ? hc(s, 1) : ah(s, 1);
            break;
          case "ArrowRight":
            l = n.props.showWeekPicker ? ei(s, 1) : yn(s, 1);
            break;
          case "ArrowUp":
            l = hc(s, 1);
            break;
          case "ArrowDown":
            l = ei(s, 1);
            break;
          case "PageUp":
            l = a ? Wr(s, 1) : ar(s, 1);
            break;
          case "PageDown":
            l = a ? on(s, 1) : Dt(s, 1);
            break;
          case "Home":
            l = dn(s, n.props.locale, n.props.calendarStartDay);
            break;
          case "End":
            l = dh(s);
            break;
          default:
            l = null;
        }
        if (!l)
          return void (n.props.onInputError && n.props.onInputError({ code: 1, msg: ga }));
        if (o.preventDefault(), n.setState({ lastPreSelectChange: ya }), n.props.adjustDateOnChange && n.setSelected(l), n.setPreSelection(l), n.props.inline) {
          var c = tt(s), u = tt(l), d = de(s), h = de(l);
          c !== u || d !== h ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), M(D(n), "onPopperKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), n.sendFocusBackToInput());
    }), M(D(n), "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), n.sendFocusBackToInput(), n.props.selectsRange ? n.props.onChange([null, null], o) : n.props.onChange(null, o), n.setState({ inputValue: null });
    }), M(D(n), "clear", function() {
      n.onClearClick();
    }), M(D(n), "onScroll", function(o) {
      typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? o.target !== document && o.target !== document.documentElement && o.target !== document.body || n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(o) && n.setOpen(!1);
    }), M(D(n), "renderCalendar", function() {
      return n.props.inline || n.isCalendarOpen() ? S.createElement(C5, { ref: function(o) {
        n.calendar = o;
      }, locale: n.props.locale, calendarStartDay: n.props.calendarStartDay, chooseDayAriaLabelPrefix: n.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: n.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: n.props.weekAriaLabelPrefix, monthAriaLabelPrefix: n.props.monthAriaLabelPrefix, adjustDateOnChange: n.props.adjustDateOnChange, setOpen: n.setOpen, shouldCloseOnSelect: n.props.shouldCloseOnSelect, dateFormat: n.props.dateFormatCalendar, useWeekdaysShort: n.props.useWeekdaysShort, formatWeekDay: n.props.formatWeekDay, dropdownMode: n.props.dropdownMode, selected: n.props.selected, preSelection: n.state.preSelection, onSelect: n.handleSelect, onWeekSelect: n.props.onWeekSelect, openToDate: n.props.openToDate, minDate: n.props.minDate, maxDate: n.props.maxDate, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, selectsMultiple: n.props.selectsMultiple, selectedDates: n.props.selectedDates, startDate: n.props.startDate, endDate: n.props.endDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, filterDate: n.props.filterDate, onClickOutside: n.handleCalendarClickOutside, formatWeekNumber: n.props.formatWeekNumber, highlightDates: n.state.highlightDates, holidays: J3(n.modifyHolidays()), includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, includeTimes: n.props.includeTimes, injectTimes: n.props.injectTimes, inline: n.props.inline, shouldFocusDayInline: n.state.shouldFocusDayInline, peekNextMonth: n.props.peekNextMonth, showMonthDropdown: n.props.showMonthDropdown, showPreviousMonths: n.props.showPreviousMonths, useShortMonthInDropdown: n.props.useShortMonthInDropdown, showMonthYearDropdown: n.props.showMonthYearDropdown, showWeekNumbers: n.props.showWeekNumbers, showYearDropdown: n.props.showYearDropdown, withPortal: n.props.withPortal, forceShowMonthNavigation: n.props.forceShowMonthNavigation, showDisabledMonthNavigation: n.props.showDisabledMonthNavigation, scrollableYearDropdown: n.props.scrollableYearDropdown, scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown, todayButton: n.props.todayButton, weekLabel: n.props.weekLabel, outsideClickIgnoreClass: Qc, fixedHeight: n.props.fixedHeight, monthsShown: n.props.monthsShown, monthSelectedIn: n.state.monthSelectedIn, onDropdownFocus: n.handleDropdownFocus, onMonthChange: n.props.onMonthChange, onYearChange: n.props.onYearChange, dayClassName: n.props.dayClassName, weekDayClassName: n.props.weekDayClassName, monthClassName: n.props.monthClassName, timeClassName: n.props.timeClassName, showDateSelect: n.props.showDateSelect, showTimeSelect: n.props.showTimeSelect, showTimeSelectOnly: n.props.showTimeSelectOnly, onTimeChange: n.handleTimeChange, timeFormat: n.props.timeFormat, timeIntervals: n.props.timeIntervals, minTime: n.props.minTime, maxTime: n.props.maxTime, excludeTimes: n.props.excludeTimes, filterTime: n.props.filterTime, timeCaption: n.props.timeCaption, className: n.props.calendarClassName, container: n.props.calendarContainer, yearItemNumber: n.props.yearItemNumber, yearDropdownItemNumber: n.props.yearDropdownItemNumber, previousMonthAriaLabel: n.props.previousMonthAriaLabel, previousMonthButtonLabel: n.props.previousMonthButtonLabel, nextMonthAriaLabel: n.props.nextMonthAriaLabel, nextMonthButtonLabel: n.props.nextMonthButtonLabel, previousYearAriaLabel: n.props.previousYearAriaLabel, previousYearButtonLabel: n.props.previousYearButtonLabel, nextYearAriaLabel: n.props.nextYearAriaLabel, nextYearButtonLabel: n.props.nextYearButtonLabel, timeInputLabel: n.props.timeInputLabel, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, renderCustomHeader: n.props.renderCustomHeader, popperProps: n.props.popperProps, renderDayContents: n.props.renderDayContents, renderMonthContent: n.props.renderMonthContent, renderQuarterContent: n.props.renderQuarterContent, renderYearContent: n.props.renderYearContent, onDayMouseEnter: n.props.onDayMouseEnter, onMonthMouseLeave: n.props.onMonthMouseLeave, onYearMouseEnter: n.props.onYearMouseEnter, onYearMouseLeave: n.props.onYearMouseLeave, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, showTimeInput: n.props.showTimeInput, showMonthYearPicker: n.props.showMonthYearPicker, showFullMonthYearPicker: n.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: n.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: n.props.showFourColumnMonthYearPicker, showYearPicker: n.props.showYearPicker, showQuarterYearPicker: n.props.showQuarterYearPicker, showWeekPicker: n.props.showWeekPicker, excludeScrollbar: n.props.excludeScrollbar, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, isInputFocused: n.state.focused, customTimeInput: n.props.customTimeInput, setPreSelection: n.setPreSelection, usePointerEvent: n.props.usePointerEvent }, n.props.children) : null;
    }), M(D(n), "renderAriaLiveRegion", function() {
      var o, i = n.props, a = i.dateFormat, s = i.locale, l = n.props.showTimeInput || n.props.showTimeSelect ? "PPPPp" : "PPPP";
      return o = n.props.selectsRange ? "Selected start date: ".concat(ut(n.props.startDate, { dateFormat: l, locale: s }), ". ").concat(n.props.endDate ? "End date: " + ut(n.props.endDate, { dateFormat: l, locale: s }) : "") : n.props.showTimeSelectOnly ? "Selected time: ".concat(ut(n.props.selected, { dateFormat: a, locale: s })) : n.props.showYearPicker ? "Selected year: ".concat(ut(n.props.selected, { dateFormat: "yyyy", locale: s })) : n.props.showMonthYearPicker ? "Selected month: ".concat(ut(n.props.selected, { dateFormat: "MMMM yyyy", locale: s })) : n.props.showQuarterYearPicker ? "Selected quarter: ".concat(ut(n.props.selected, { dateFormat: "yyyy, QQQ", locale: s })) : "Selected date: ".concat(ut(n.props.selected, { dateFormat: l, locale: s })), S.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, o);
    }), M(D(n), "renderDateInput", function() {
      var o, i = X(n.props.className, M({}, Qc, n.state.open)), a = n.props.customInput || S.createElement("input", { type: "text" }), s = n.props.customInputRef || "ref", l = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? function(c, u, d) {
        if (!c)
          return "";
        var h = ut(c, d), p = u ? ut(u, d) : "";
        return "".concat(h, " - ").concat(p);
      }(n.props.startDate, n.props.endDate, n.props) : n.props.selectsMultiple ? function(c, u) {
        if (c == null || !c.length)
          return "";
        var d = ut(c[0], u);
        if (c.length === 1)
          return d;
        if (c.length === 2) {
          var h = ut(c[1], u);
          return "".concat(d, ", ").concat(h);
        }
        var p = c.length - 1;
        return "".concat(d, " (+").concat(p, ")");
      }(n.props.selectedDates, n.props) : ut(n.props.selected, n.props);
      return S.cloneElement(a, (M(M(M(M(M(M(M(M(M(M(o = {}, s, function(c) {
        n.input = c;
      }), "value", l), "onBlur", n.handleBlur), "onChange", n.handleChange), "onClick", n.onInputClick), "onFocus", n.handleFocus), "onKeyDown", n.onInputKeyDown), "id", n.props.id), "name", n.props.name), "form", n.props.form), M(M(M(M(M(M(M(M(M(M(o, "autoFocus", n.props.autoFocus), "placeholder", n.props.placeholderText), "disabled", n.props.disabled), "autoComplete", n.props.autoComplete), "className", X(a.props.className, i)), "title", n.props.title), "readOnly", n.props.readOnly), "required", n.props.required), "tabIndex", n.props.tabIndex), "aria-describedby", n.props.ariaDescribedBy), M(M(M(o, "aria-invalid", n.props.ariaInvalid), "aria-labelledby", n.props.ariaLabelledBy), "aria-required", n.props.ariaRequired)));
    }), M(D(n), "renderClearButton", function() {
      var o = n.props, i = o.isClearable, a = o.disabled, s = o.selected, l = o.startDate, c = o.endDate, u = o.clearButtonTitle, d = o.clearButtonClassName, h = d === void 0 ? "" : d, p = o.ariaLabelClose, v = p === void 0 ? "Close" : p, m = o.selectedDates;
      return i && (s != null || l != null || c != null || m != null && m.length) ? S.createElement("button", { type: "button", className: X("react-datepicker__close-icon", h, { "react-datepicker__close-icon--disabled": a }), disabled: a, "aria-label": v, onClick: n.onClearClick, title: u, tabIndex: -1 }) : null;
    }), n.state = n.calcInitialState(), n.preventFocusTimeout = null, n;
  }
  return Ke(r, S.Component), Ue(r, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(t, n) {
    var o, i;
    t.inline && (o = t.selected, i = this.props.selected, o && i ? tt(o) !== tt(i) || de(o) !== de(i) : o !== i) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: $c(this.props.highlightDates) }), n.focused || En(t.selected, this.props.selected) || this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), n.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var t = this.props, n = t.showIcon, o = t.icon, i = t.calendarIconClassname, a = t.toggleCalendarOnIconClick, s = this.state.open;
    return S.createElement("div", { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") }, n && S.createElement(y5, Kr({ icon: o, className: "".concat(i, " ").concat(s && "react-datepicker-ignore-onclickoutside") }, a ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var t = this.renderCalendar();
    if (this.props.inline)
      return t;
    if (this.props.withPortal) {
      var n = this.state.open ? S.createElement(Ad, { enableTabLoop: this.props.enableTabLoop }, S.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)) : null;
      return this.state.open && this.props.portalId && (n = S.createElement(Pd, { portalId: this.props.portalId, portalHost: this.props.portalHost }, n)), S.createElement("div", null, this.renderInputContainer(), n);
    }
    return S.createElement(x5, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: t, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop, showArrow: this.props.showPopperArrow });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: Tr, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1, usePointerEvent: !1 };
  } }]), r;
}(), M5 = "input", ya = "navigate";
const D5 = ({
  children: e,
  primaryActionButton: r,
  secondaryActionButton: t,
  tertiaryActionButton: n,
  className: o
}) => /* @__PURE__ */ f.jsxs(vr, { elevation: "level-2", padding: "no", className: o, children: [
  e,
  /* @__PURE__ */ f.jsx(
    Yd,
    {
      primaryActionButton: r,
      secondaryActionButton: t,
      tertiaryActionButton: n,
      className: "sp-picker__footer"
    }
  )
] });
function _t(e) {
  const r = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && r === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || r === "[object Number]" || typeof e == "string" || r === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Pn(e, r) {
  return e instanceof Date ? new e.constructor(r) : new Date(r);
}
const Ld = 6048e5, _5 = 864e5;
let E5 = {};
function Li() {
  return E5;
}
function Qr(e, r) {
  var s, l, c, u;
  const t = Li(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = _t(e), i = o.getDay(), a = (i < n ? 7 : 0) + i - n;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function fi(e) {
  return Qr(e, { weekStartsOn: 1 });
}
function Vd(e) {
  const r = _t(e), t = r.getFullYear(), n = Pn(e, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = fi(n), i = Pn(e, 0);
  i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0);
  const a = fi(i);
  return r.getTime() >= o.getTime() ? t + 1 : r.getTime() >= a.getTime() ? t : t - 1;
}
function qc(e) {
  const r = _t(e);
  return r.setHours(0, 0, 0, 0), r;
}
function Gc(e) {
  const r = _t(e), t = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return t.setUTCFullYear(r.getFullYear()), +e - +t;
}
function I5(e, r) {
  const t = qc(e), n = qc(r), o = +t - Gc(t), i = +n - Gc(n);
  return Math.round((o - i) / _5);
}
function O5(e) {
  const r = Vd(e), t = Pn(e, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), fi(t);
}
function N5(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function T5(e) {
  if (!N5(e) && typeof e != "number")
    return !1;
  const r = _t(e);
  return !isNaN(Number(r));
}
function k5(e) {
  const r = _t(e), t = Pn(e, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const S5 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, R5 = (e, r, t) => {
  let n;
  const o = S5[e];
  return typeof o == "string" ? n = o : r === 1 ? n = o.one : n = o.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function wa(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const j5 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, P5 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, A5 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, L5 = {
  date: wa({
    formats: j5,
    defaultWidth: "full"
  }),
  time: wa({
    formats: P5,
    defaultWidth: "full"
  }),
  dateTime: wa({
    formats: A5,
    defaultWidth: "full"
  })
}, V5 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, H5 = (e, r, t, n) => V5[e];
function Mr(e) {
  return (r, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(r) : r;
    return o[i];
  };
}
const F5 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Y5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, z5 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Z5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, W5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, B5 = (e, r) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, U5 = {
  ordinalNumber: B5,
  era: Mr({
    values: F5,
    defaultWidth: "wide"
  }),
  quarter: Mr({
    values: Y5,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Mr({
    values: $5,
    defaultWidth: "wide"
  }),
  day: Mr({
    values: z5,
    defaultWidth: "wide"
  }),
  dayPeriod: Mr({
    values: Z5,
    defaultWidth: "wide",
    formattingValues: W5,
    defaultFormattingWidth: "wide"
  })
};
function Dr(e) {
  return (r, t = {}) => {
    const n = t.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = r.match(o);
    if (!i)
      return null;
    const a = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Q5(s, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      K5(s, (d) => d.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(c)
    ) : c;
    const u = r.slice(a.length);
    return { value: c, rest: u };
  };
}
function K5(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function Q5(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function q5(e) {
  return (r, t = {}) => {
    const n = r.match(e.matchPattern);
    if (!n)
      return null;
    const o = n[0], i = r.match(e.parsePattern);
    if (!i)
      return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const s = r.slice(o.length);
    return { value: a, rest: s };
  };
}
const G5 = /^(\d+)(th|st|nd|rd)?/i, X5 = /\d+/i, J5 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, e4 = {
  any: [/^b/i, /^(a|c)/i]
}, t4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, n4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, r4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, o4 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, i4 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, a4 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, s4 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, l4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, c4 = {
  ordinalNumber: q5({
    matchPattern: G5,
    parsePattern: X5,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Dr({
    matchPatterns: J5,
    defaultMatchWidth: "wide",
    parsePatterns: e4,
    defaultParseWidth: "any"
  }),
  quarter: Dr({
    matchPatterns: t4,
    defaultMatchWidth: "wide",
    parsePatterns: n4,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Dr({
    matchPatterns: r4,
    defaultMatchWidth: "wide",
    parsePatterns: o4,
    defaultParseWidth: "any"
  }),
  day: Dr({
    matchPatterns: i4,
    defaultMatchWidth: "wide",
    parsePatterns: a4,
    defaultParseWidth: "any"
  }),
  dayPeriod: Dr({
    matchPatterns: s4,
    defaultMatchWidth: "any",
    parsePatterns: l4,
    defaultParseWidth: "any"
  })
}, u4 = {
  code: "en-US",
  formatDistance: R5,
  formatLong: L5,
  formatRelative: H5,
  localize: U5,
  match: c4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function d4(e) {
  const r = _t(e);
  return I5(r, k5(r)) + 1;
}
function f4(e) {
  const r = _t(e), t = +fi(r) - +O5(r);
  return Math.round(t / Ld) + 1;
}
function Hd(e, r) {
  var u, d, h, p;
  const t = _t(e), n = t.getFullYear(), o = Li(), i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = Pn(e, 0);
  a.setFullYear(n + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Qr(a, r), l = Pn(e, 0);
  l.setFullYear(n, 0, i), l.setHours(0, 0, 0, 0);
  const c = Qr(l, r);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= c.getTime() ? n : n - 1;
}
function p4(e, r) {
  var s, l, c, u;
  const t = Li(), n = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Hd(e, r), i = Pn(e, 0);
  return i.setFullYear(o, 0, n), i.setHours(0, 0, 0, 0), Qr(i, r);
}
function h4(e, r) {
  const t = _t(e), n = +Qr(t, r) - +p4(t, r);
  return Math.round(n / Ld) + 1;
}
function _e(e, r) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(r, "0");
  return t + n;
}
const Jt = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return _e(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : _e(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return _e(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return _e(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return _e(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return _e(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return _e(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, n = e.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return _e(o, r.length);
  }
}, Un = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Xc = {
  // Era
  G: function(e, r, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return Jt.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, n) {
    const o = Hd(e, n), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      const a = i % 100;
      return _e(a, 2);
    }
    return r === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : _e(i, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = Vd(e);
    return _e(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return _e(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return _e(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return _e(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return Jt.M(e, r);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return _e(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, n) {
    const o = h4(e, n);
    return r === "wo" ? t.ordinalNumber(o, { unit: "week" }) : _e(o, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const n = f4(e);
    return r === "Io" ? t.ordinalNumber(n, { unit: "week" }) : _e(n, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Jt.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const n = d4(e);
    return r === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : _e(n, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const n = e.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return _e(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return _e(i, r.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return _e(o, r.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = Un.noon : n === 0 ? o = Un.midnight : o = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = Un.evening : n >= 12 ? o = Un.afternoon : n >= 4 ? o = Un.morning : o = Un.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return Jt.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Jt.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const n = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : _e(n, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), r === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : _e(n, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jt.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jt.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return Jt.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (r) {
      case "X":
        return eu(n);
      case "XXXX":
      case "XX":
        return Mn(n);
      case "XXXXX":
      case "XXX":
      default:
        return Mn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "x":
        return eu(n);
      case "xxxx":
      case "xx":
        return Mn(n);
      case "xxxxx":
      case "xxx":
      default:
        return Mn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Jc(n, ":");
      case "OOOO":
      default:
        return "GMT" + Mn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Jc(n, ":");
      case "zzzz":
      default:
        return "GMT" + Mn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t) {
    const n = Math.trunc(e.getTime() / 1e3);
    return _e(n, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t) {
    const n = e.getTime();
    return _e(n, r.length);
  }
};
function Jc(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? t + String(o) : t + String(o) + r + _e(i, 2);
}
function eu(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + _e(Math.abs(e) / 60, 2) : Mn(e, r);
}
function Mn(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = _e(Math.trunc(n / 60), 2), i = _e(n % 60, 2);
  return t + o + r + i;
}
const tu = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, Fd = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, v4 = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], o = t[2];
  if (!o)
    return tu(e, r);
  let i;
  switch (n) {
    case "P":
      i = r.dateTime({ width: "short" });
      break;
    case "PP":
      i = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = r.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", tu(n, r)).replace("{{time}}", Fd(o, r));
}, m4 = {
  p: Fd,
  P: v4
}, g4 = /^D+$/, y4 = /^Y+$/, w4 = ["D", "DD", "YY", "YYYY"];
function x4(e) {
  return g4.test(e);
}
function C4(e) {
  return y4.test(e);
}
function b4(e, r, t) {
  const n = M4(e, r, t);
  if (console.warn(n), w4.includes(e))
    throw new RangeError(n);
}
function M4(e, r, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const D4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, E4 = /^'([^]*?)'?$/, I4 = /''/g, O4 = /[a-zA-Z]/;
function nu(e, r, t) {
  var u, d, h, p, v, m, y, b;
  const n = Li(), o = (t == null ? void 0 : t.locale) ?? n.locale ?? u4, i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = _t(e);
  if (!T5(s))
    throw new RangeError("Invalid time value");
  let l = r.match(_4).map((g) => {
    const w = g[0];
    if (w === "p" || w === "P") {
      const x = m4[w];
      return x(g, o.formatLong);
    }
    return g;
  }).join("").match(D4).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const w = g[0];
    if (w === "'")
      return { isToken: !1, value: N4(g) };
    if (Xc[w])
      return { isToken: !0, value: g };
    if (w.match(O4))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: g };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((g) => {
    if (!g.isToken)
      return g.value;
    const w = g.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && C4(w) || !(t != null && t.useAdditionalDayOfYearTokens) && x4(w)) && b4(w, r, String(e));
    const x = Xc[w[0]];
    return x(s, w, o.localize, c);
  }).join("");
}
function N4(e) {
  const r = e.match(E4);
  return r ? r[1].replace(I4, "'") : e;
}
const T4 = [
  {
    label: "Jan",
    value: 0
  },
  {
    label: "Feb",
    value: 1
  },
  {
    label: "Mar",
    value: 2
  },
  {
    label: "Apr",
    value: 3
  },
  {
    label: "May",
    value: 4
  },
  {
    label: "Jun",
    value: 5
  },
  {
    label: "Jul",
    value: 6
  },
  {
    label: "Aug",
    value: 7
  },
  {
    label: "Sep",
    value: 8
  },
  {
    label: "Oct",
    value: 9
  },
  {
    label: "Nov",
    value: 10
  },
  {
    label: "Dec",
    value: 11
  }
], k4 = ({
  nextButtonAction: e,
  prevButtonAction: r,
  startYear: t,
  endYear: n,
  changeMonth: o,
  changeYear: i,
  date: a,
  showMonthDropdown: s
}) => {
  const l = ({
    startYear: c,
    endYear: u
  }) => Array.from(
    { length: u - c + 1 },
    (d, h) => h + c
  ).map((d) => ({ label: d.toString(), value: d }));
  return /* @__PURE__ */ f.jsxs(vr, { elevation: "ground", padding: "medium", className: "sp-date-picker-header", children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        className: "sp-date-picker-header__button",
        onClick: r,
        type: "button",
        children: /* @__PURE__ */ f.jsx(jp, { size: "24", iconColor: "var(--icon-default)" })
      }
    ),
    /* @__PURE__ */ f.jsxs("div", { className: "sp-date-picker-header__dropdowns", children: [
      s && /* @__PURE__ */ f.jsxs(
        Ds,
        {
          onSelect: (c) => o(c),
          options: T4,
          elevation: "level-3",
          radius: "m",
          className: "sp-date-picker-header__dropdowns__dropdown",
          children: [
            /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", weight: 600, children: nu(a, "MMM") }),
            /* @__PURE__ */ f.jsx(Es, { iconColor: "var(--icon-strong)", size: "16" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs(
        Ds,
        {
          onSelect: (c) => {
            console.log(c), i(c);
          },
          options: l({ startYear: t, endYear: n }),
          selected: !0,
          showSelectedIndex: !0,
          elevation: "level-3",
          radius: "m",
          className: "sp-date-picker-header__dropdowns__dropdown",
          children: [
            /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", weight: 600, children: nu(a, "yyyy") }),
            /* @__PURE__ */ f.jsx(Es, { iconColor: "var(--icon-strong)", size: "16" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        className: "sp-date-picker-header__button",
        onClick: e,
        type: "button",
        children: /* @__PURE__ */ f.jsx(Pp, { size: "24", iconColor: "var(--icon-default)" })
      }
    )
  ] });
};
const S4 = qe(
  ({
    primaryActionButton: e,
    secondaryActionButton: r,
    tertiaryActionButton: t,
    startYear: n = (/* @__PURE__ */ new Date()).getFullYear() - 10,
    endYear: o = (/* @__PURE__ */ new Date()).getFullYear() + 10,
    showMonthYearPicker: i,
    showYearPicker: a,
    ...s
  }, l) => {
    const c = /* @__PURE__ */ f.jsx(Pp, { size: "24", iconColor: "var(--icon-default)" }), u = /* @__PURE__ */ f.jsx(jp, { size: "24", iconColor: "var(--icon-default)" }), d = ({ children: h }) => /* @__PURE__ */ f.jsx(
      D5,
      {
        className: "sp-date-picker",
        primaryActionButton: e,
        secondaryActionButton: r,
        tertiaryActionButton: t,
        children: /* @__PURE__ */ f.jsx("div", { className: "sp-date-picker__container", children: h })
      }
    );
    return /* @__PURE__ */ f.jsx(
      b5,
      {
        previousMonthButtonLabel: u,
        nextMonthButtonLabel: c,
        previousYearButtonLabel: u,
        nextYearButtonLabel: c,
        calendarContainer: d,
        renderDayContents: (h) => /* @__PURE__ */ f.jsx("div", { className: "day", children: h }),
        renderCustomHeader: a ? void 0 : ({
          increaseMonth: h,
          decreaseMonth: p,
          date: v,
          changeMonth: m,
          changeYear: y
        }) => /* @__PURE__ */ f.jsx(
          k4,
          {
            nextButtonAction: h,
            prevButtonAction: p,
            changeMonth: m,
            changeYear: y,
            date: v,
            endYear: o,
            startYear: n,
            showMonthDropdown: !i
          }
        ),
        renderMonthContent: (h, p) => /* @__PURE__ */ f.jsx("div", { className: "month", children: p }),
        renderYearContent: (h) => /* @__PURE__ */ f.jsx("div", { className: "year", children: h }),
        showYearPicker: a,
        showMonthYearPicker: i,
        customInput: /* @__PURE__ */ f.jsx(
          V4.Text,
          {
            name: "date-picker",
            "data-testid": "date-input",
            type: "text",
            ref: l
          }
        ),
        ...s
      }
    );
  }
);
S4.displayName = "DatePicker";
const R4 = qe(
  ({
    description: e,
    headline: r,
    actionButtonText: t,
    onClickActionButton: n,
    withIllustration: o = !0
  }, i) => /* @__PURE__ */ f.jsxs("section", { className: "sp-empty-state", ref: i, children: [
    o && /* @__PURE__ */ f.jsx(ZC, { size: 120 }),
    /* @__PURE__ */ f.jsx(pe, { variant: "headline-content", tag: "h3", size: "xs", children: r }),
    /* @__PURE__ */ f.jsx(pe, { variant: "body-content", size: "s", tag: "p", children: e }),
    t != null && t.length ? /* @__PURE__ */ f.jsx(
      Xe,
      {
        variant: "primary",
        onClick: n,
        className: "sp-empty-state__button",
        children: t
      }
    ) : null
  ] })
);
R4.displayName = "EmptyState";
const Yd = ({
  primaryActionButton: e,
  secondaryActionButton: r,
  tertiaryActionButton: t,
  className: n,
  ...o
}) => {
  const i = (e == null ? void 0 : e.variant) ?? "primary", a = (r == null ? void 0 : r.variant) ?? "secondary", s = (t == null ? void 0 : t.variant) ?? "tertiary";
  return /* @__PURE__ */ f.jsxs(
    vr,
    {
      className: X("sp-footer", n),
      elevation: "ground",
      padding: "medium",
      ...o,
      children: [
        t && /* @__PURE__ */ f.jsx(
          Xe,
          {
            onClick: t.action,
            disabled: t.disabled,
            loading: t.loading,
            icon: t.icon,
            variant: s,
            children: t == null ? void 0 : t.title
          }
        ),
        /* @__PURE__ */ f.jsxs("div", { className: "sp-footer__right", children: [
          r && /* @__PURE__ */ f.jsx(
            Xe,
            {
              onClick: r.action,
              disabled: r.disabled,
              loading: r.loading,
              icon: r.icon,
              variant: a,
              children: r == null ? void 0 : r.title
            }
          ),
          /* @__PURE__ */ f.jsx(
            Xe,
            {
              onClick: e.action,
              disabled: e.disabled,
              loading: e.loading,
              icon: e.icon,
              variant: i,
              children: e.title
            }
          )
        ] })
      ]
    }
  );
};
const j4 = qe(
  ({ className: e, children: r }, t) => /* @__PURE__ */ f.jsx("section", { ref: t, className: X(["sp-grid", e]), children: r })
);
j4.displayName = "Grid";
const P4 = ({
  htmlFor: e,
  className: r,
  variant: t,
  children: n,
  ...o
}) => /* @__PURE__ */ f.jsxs(
  "label",
  {
    htmlFor: e,
    ...o,
    className: X("sp-label", r),
    children: [
      /* @__PURE__ */ f.jsx(pe, { size: "s", variant: "body-content", weight: 600, children: n }),
      t ? /* @__PURE__ */ f.jsx(
        pe,
        {
          size: "s",
          variant: "body-content",
          className: `sp-label--${t}`,
          children: t === "required" ? "*" : "(Optional)"
        }
      ) : null
    ]
  }
), A4 = P4;
const $d = qe(
  ({
    type: e,
    className: r,
    name: t,
    required: n,
    id: o,
    errorMessage: i,
    hint: a,
    textAlign: s = "left",
    ...l
  }, c) => {
    let u;
    i != null && i.length ? u = "error" : a != null && a.length && (u = "hint");
    const [d, h] = $e(e), [p, v] = $e("Show Password"), m = (y) => {
      h(y ? "text" : "password"), v(y ? "Hide Password" : "Show Password");
    };
    return /* @__PURE__ */ f.jsxs("div", { className: X(["sp-input", r]), children: [
      /* @__PURE__ */ f.jsx(
        "input",
        {
          className: X([
            "sp-input__field",
            `sp-input__field--${s}`,
            i && i.length > 0 && "sp-input__field--invalid",
            `sp-input__field--${e}`
          ]),
          type: d,
          name: t,
          required: n,
          id: t || o,
          ...l,
          ref: c
        }
      ),
      e === "password" && /* @__PURE__ */ f.jsx(
        "button",
        {
          className: "sp-input__toggle-btn",
          onClick: () => m(d !== "text"),
          title: p,
          type: "button",
          children: d === "text" ? /* @__PURE__ */ f.jsx(zx, { size: "24", iconColor: "var(--icon-subtle)" }) : /* @__PURE__ */ f.jsx(Ix, { size: "24", iconColor: "var(--icon-subtle)" })
        }
      ),
      u ? /* @__PURE__ */ f.jsxs(
        pe,
        {
          className: X([`sp-input__${u}`]),
          variant: "body-content",
          size: "caption-m",
          children: [
            i ? /* @__PURE__ */ f.jsx(Vp, { iconColor: "currentColor", size: "16" }) : null,
            /* @__PURE__ */ f.jsx("span", { children: i ?? a })
          ]
        }
      ) : null
    ] });
  }
);
$d.displayName = "Text";
const L4 = $d, V4 = { Label: A4, Text: L4 }, V = (e) => e === "24" ? { width: 24, height: 24 } : { width: 16, height: 16 }, H4 = (() => {
  let e = 0;
  return () => (++e).toString();
})();
const F4 = ({ className: e, size: r, variant: t, ...n }) => {
  const { width: o, height: i } = V(r === "s" ? "16" : "24");
  let a;
  switch (t) {
    case "brand":
      a = "var(--text-body-brand)";
      break;
    case "danger":
      a = "var(--red-050)";
      break;
    case "success":
      a = "var(--green-090)";
      break;
    case "inverse":
      a = "var(--white-0)";
      break;
    default:
      a = "var(--white-0)";
      break;
  }
  return /* @__PURE__ */ f.jsx("span", { className: X(["sp-spinner", e]), ...n, children: /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: o,
      height: i,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.40003 6.76755C3.14251 7.72861 3.1925 8.7462 3.54298 9.6774C3.89346 10.6086 4.52682 11.4066 5.3541 11.9594C6.18139 12.5122 7.16104 12.7919 8.15548 12.7594C9.14992 12.7268 10.1092 12.3836 10.8985 11.7779C11.6879 11.1722 12.2677 10.3345 12.5565 9.38233C12.8454 8.4302 12.8287 7.41152 12.5089 6.46936C12.189 5.52719 11.5821 4.70887 10.7734 4.12932C9.96462 3.54978 8.99464 3.23812 7.99967 3.23812C7.47369 3.23812 7.04729 2.81172 7.04729 2.28573C7.04729 1.75975 7.47369 1.33335 7.99967 1.33335C9.39263 1.33335 10.7506 1.76968 11.8829 2.58104C13.0151 3.39241 13.8648 4.53806 14.3125 5.85709C14.7603 7.17612 14.7836 8.60227 14.3793 9.93525C13.9749 11.2682 13.1632 12.4411 12.0581 13.289C10.953 14.137 9.61001 14.6175 8.2178 14.6631C6.82559 14.7087 5.45407 14.317 4.29587 13.5431C3.13767 12.7693 2.25097 11.652 1.7603 10.3484C1.26963 9.04468 1.19965 7.62005 1.56017 6.27456C1.6963 5.7665 2.21853 5.46499 2.72659 5.60112C3.23466 5.73726 3.53616 6.25949 3.40003 6.76755Z",
          style: { fill: a }
        }
      )
    }
  ) });
}, Y4 = F4;
const $4 = ({ className: e, fillPercentage: r, ...t }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    role: "meter",
    ...t,
    className: X(["sp-progress", e]),
    children: /* @__PURE__ */ f.jsx("div", { className: "sp-progress__wrapper", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        width: "100",
        height: "100",
        className: "sp-progress__wrapper__fill",
        "aria-hidden": "true",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        style: { fill: "var(--navy-050)", width: `${r}%` },
        children: /* @__PURE__ */ f.jsx(
          "rect",
          {
            x: "0",
            y: "0",
            width: "100%",
            height: "100%",
            fill: "currentcolor"
          }
        )
      }
    ) })
  }
), z4 = $4, Z4 = { Spinner: Y4, Progress: z4 };
var ns = function(e, r) {
  return ns = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
  }, ns(e, r);
};
function zd(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  ns(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var Q = function() {
  return Q = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, Q.apply(this, arguments);
};
function Ht(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
function W4(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Le(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), o, i = [], a;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function bt(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, o = r.length, i; n < o; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}
var ru = "production", Bs = typeof process > "u" || process.env === void 0 ? ru : process.env.NODE_ENV || ru, Ft = function(e) {
  return {
    isEnabled: function(r) {
      return e.some(function(t) {
        return !!r[t];
      });
    }
  };
}, qr = {
  measureLayout: Ft(["layout", "layoutId", "drag"]),
  animation: Ft([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ft(["exit"]),
  drag: Ft(["drag", "dragControls"]),
  focus: Ft(["whileFocus"]),
  hover: Ft(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ft(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ft([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ft([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function B4(e) {
  for (var r in e)
    e[r] !== null && (r === "projectionNodeConstructor" ? qr.projectionNodeConstructor = e[r] : qr[r].Component = e[r]);
}
var uo = function() {
}, ht = function() {
};
process.env.NODE_ENV !== "production" && (uo = function(e, r) {
  !e && typeof console < "u" && console.warn(r);
}, ht = function(e, r) {
  if (!e)
    throw new Error(r);
});
var Zd = Kt({ strict: !1 }), Wd = Object.keys(qr), U4 = Wd.length;
function K4(e, r, t) {
  var n = [], o = ze(Zd);
  if (!r)
    return null;
  Bs !== "production" && t && o.strict && ht(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var i = 0; i < U4; i++) {
    var a = Wd[i], s = qr[a], l = s.isEnabled, c = s.Component;
    l(e) && c && n.push(T.createElement(c, Q({ key: a }, e, { visualElement: r })));
  }
  return n;
}
var Us = Kt({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), Vi = Kt({});
function Q4() {
  return ze(Vi).visualElement;
}
var fo = Kt(null), mr = typeof document < "u", pi = mr ? ao : fe, rs = { current: null }, Bd = !1;
function q4() {
  if (Bd = !0, !!mr)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), r = function() {
        return rs.current = e.matches;
      };
      e.addListener(r), r();
    } else
      rs.current = !1;
}
function G4() {
  !Bd && q4();
  var e = Le($e(rs.current), 1), r = e[0];
  return r;
}
function X4() {
  var e = G4(), r = ze(Us).reducedMotion;
  return r === "never" ? !1 : r === "always" ? !0 : e;
}
function J4(e, r, t, n) {
  var o = ze(Zd), i = Q4(), a = ze(fo), s = X4(), l = me(void 0);
  n || (n = o.renderer), !l.current && n && (l.current = n(e, {
    visualState: r,
    parent: i,
    props: t,
    presenceId: a == null ? void 0 : a.id,
    blockInitialAnimation: (a == null ? void 0 : a.initial) === !1,
    shouldReduceMotion: s
  }));
  var c = l.current;
  return pi(function() {
    c == null || c.syncRender();
  }), fe(function() {
    var u;
    (u = c == null ? void 0 : c.animationState) === null || u === void 0 || u.animateChanges();
  }), pi(function() {
    return function() {
      return c == null ? void 0 : c.notifyUnmount();
    };
  }, []), c;
}
function Xn(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function ev(e, r, t) {
  return Oe(
    function(n) {
      var o;
      n && ((o = e.mount) === null || o === void 0 || o.call(e, n)), r && (n ? r.mount(n) : r.unmount()), t && (typeof t == "function" ? t(n) : Xn(t) && (t.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [r]
  );
}
function Ud(e) {
  return Array.isArray(e);
}
function yt(e) {
  return typeof e == "string" || Ud(e);
}
function tv(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.get();
  }), r;
}
function nv(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.getVelocity();
  }), r;
}
function Kd(e, r, t, n, o) {
  var i;
  return n === void 0 && (n = {}), o === void 0 && (o = {}), typeof r == "function" && (r = r(t ?? e.custom, n, o)), typeof r == "string" && (r = (i = e.variants) === null || i === void 0 ? void 0 : i[r]), typeof r == "function" && (r = r(t ?? e.custom, n, o)), r;
}
function Hi(e, r, t) {
  var n = e.getProps();
  return Kd(n, r, t ?? n.custom, tv(e), nv(e));
}
function Fi(e) {
  var r;
  return typeof ((r = e.animate) === null || r === void 0 ? void 0 : r.start) == "function" || yt(e.initial) || yt(e.animate) || yt(e.whileHover) || yt(e.whileDrag) || yt(e.whileTap) || yt(e.whileFocus) || yt(e.exit);
}
function Qd(e) {
  return !!(Fi(e) || e.variants);
}
function rv(e, r) {
  if (Fi(e)) {
    var t = e.initial, n = e.animate;
    return {
      initial: t === !1 || yt(t) ? t : void 0,
      animate: yt(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? r : {};
}
function ov(e) {
  var r = rv(e, ze(Vi)), t = r.initial, n = r.animate;
  return it(function() {
    return { initial: t, animate: n };
  }, [ou(t), ou(n)]);
}
function ou(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function po(e) {
  var r = me(null);
  return r.current === null && (r.current = e()), r.current;
}
var kr = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, iv = 1;
function av() {
  return po(function() {
    if (kr.hasEverUpdated)
      return iv++;
  });
}
var Gr = Kt({}), qd = Kt({});
function sv(e, r, t, n) {
  var o, i = r.layoutId, a = r.layout, s = r.drag, l = r.dragConstraints, c = r.layoutScroll, u = ze(qd);
  !n || !t || t != null && t.projection || (t.projection = new n(e, t.getLatestValues(), (o = t.parent) === null || o === void 0 ? void 0 : o.projection), t.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!s || l && Xn(l),
    visualElement: t,
    scheduleRender: function() {
      return t.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: u,
    layoutScroll: c
  }));
}
var lv = (
  /** @class */
  function(e) {
    zd(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, r.prototype.componentDidUpdate = function() {
    }, r.prototype.updateProps = function() {
      var t = this.props, n = t.visualElement, o = t.props;
      n && n.setProps(o);
    }, r.prototype.render = function() {
      return this.props.children;
    }, r;
  }(S.Component)
);
function cv(e) {
  var r = e.preloadedFeatures, t = e.createVisualElement, n = e.projectionNodeConstructor, o = e.useRender, i = e.useVisualState, a = e.Component;
  r && B4(r);
  function s(l, c) {
    var u = uv(l);
    l = Q(Q({}, l), { layoutId: u });
    var d = ze(Us), h = null, p = ov(l), v = d.isStatic ? void 0 : av(), m = i(l, d.isStatic);
    return !d.isStatic && mr && (p.visualElement = J4(a, m, Q(Q({}, d), l), t), sv(v, l, p.visualElement, n || qr.projectionNodeConstructor), h = K4(l, p.visualElement, r)), T.createElement(
      lv,
      { visualElement: p.visualElement, props: Q(Q({}, d), l) },
      h,
      T.createElement(Vi.Provider, { value: p }, o(a, l, v, ev(m, p.visualElement, c), m, d.isStatic, p.visualElement))
    );
  }
  return qe(s);
}
function uv(e) {
  var r, t = e.layoutId, n = (r = ze(Gr)) === null || r === void 0 ? void 0 : r.id;
  return n && t !== void 0 ? n + "-" + t : t;
}
function dv(e) {
  function r(n, o) {
    return o === void 0 && (o = {}), cv(e(n, o));
  }
  if (typeof Proxy > "u")
    return r;
  var t = /* @__PURE__ */ new Map();
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(n, o) {
      return t.has(o) || t.set(o, r(o)), t.get(o);
    }
  });
}
var fv = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function Ks(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(fv.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var hi = {};
function pv(e) {
  Object.assign(hi, e);
}
var os = ["", "X", "Y", "Z"], hv = ["translate", "scale", "rotate", "skew"], Xr = ["transformPerspective", "x", "y", "z"];
hv.forEach(function(e) {
  return os.forEach(function(r) {
    return Xr.push(e + r);
  });
});
function vv(e, r) {
  return Xr.indexOf(e) - Xr.indexOf(r);
}
var mv = new Set(Xr);
function ho(e) {
  return mv.has(e);
}
var gv = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function Gd(e) {
  return gv.has(e);
}
function Xd(e, r) {
  var t = r.layout, n = r.layoutId;
  return ho(e) || Gd(e) || (t || n !== void 0) && (!!hi[e] || e === "opacity");
}
var Wt = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, yv = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function wv(e, r, t, n) {
  var o = e.transform, i = e.transformKeys, a = r.enableHardwareAcceleration, s = a === void 0 ? !0 : a, l = r.allowTransformNone, c = l === void 0 ? !0 : l, u = "";
  i.sort(vv);
  for (var d = !1, h = i.length, p = 0; p < h; p++) {
    var v = i[p];
    u += "".concat(yv[v] || v, "(").concat(o[v], ") "), v === "z" && (d = !0);
  }
  return !d && s ? u += "translateZ(0)" : u = u.trim(), n ? u = n(o, t ? "" : u) : c && t && (u = "none"), u;
}
function xv(e) {
  var r = e.originX, t = r === void 0 ? "50%" : r, n = e.originY, o = n === void 0 ? "50%" : n, i = e.originZ, a = i === void 0 ? 0 : i;
  return "".concat(t, " ").concat(o, " ").concat(a);
}
function Jd(e) {
  return e.startsWith("--");
}
var Cv = function(e, r) {
  return r && typeof e == "number" ? r.transform(e) : e;
};
const e0 = (e, r) => (t) => Math.max(Math.min(t, r), e), Sr = (e) => e % 1 ? Number(e.toFixed(5)) : e, Jr = /(-)?([\d]*\.?[\d])+/g, is = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, bv = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function vo(e) {
  return typeof e == "string";
}
const Vn = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Rr = Object.assign(Object.assign({}, Vn), { transform: e0(0, 1) }), Do = Object.assign(Object.assign({}, Vn), { default: 1 }), mo = (e) => ({
  test: (r) => vo(r) && r.endsWith(e) && r.split(" ").length === 1,
  parse: parseFloat,
  transform: (r) => `${r}${e}`
}), en = mo("deg"), Lt = mo("%"), ce = mo("px"), Mv = mo("vh"), Dv = mo("vw"), iu = Object.assign(Object.assign({}, Lt), { parse: (e) => Lt.parse(e) / 100, transform: (e) => Lt.transform(e * 100) }), Qs = (e, r) => (t) => !!(vo(t) && bv.test(t) && t.startsWith(e) || r && Object.prototype.hasOwnProperty.call(t, r)), t0 = (e, r, t) => (n) => {
  if (!vo(n))
    return n;
  const [o, i, a, s] = n.match(Jr);
  return {
    [e]: parseFloat(o),
    [r]: parseFloat(i),
    [t]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, In = {
  test: Qs("hsl", "hue"),
  parse: t0("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: r, lightness: t, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + Lt.transform(Sr(r)) + ", " + Lt.transform(Sr(t)) + ", " + Sr(Rr.transform(n)) + ")"
}, _v = e0(0, 255), xa = Object.assign(Object.assign({}, Vn), { transform: (e) => Math.round(_v(e)) }), sn = {
  test: Qs("rgb", "red"),
  parse: t0("red", "green", "blue"),
  transform: ({ red: e, green: r, blue: t, alpha: n = 1 }) => "rgba(" + xa.transform(e) + ", " + xa.transform(r) + ", " + xa.transform(t) + ", " + Sr(Rr.transform(n)) + ")"
};
function Ev(e) {
  let r = "", t = "", n = "", o = "";
  return e.length > 5 ? (r = e.substr(1, 2), t = e.substr(3, 2), n = e.substr(5, 2), o = e.substr(7, 2)) : (r = e.substr(1, 1), t = e.substr(2, 1), n = e.substr(3, 1), o = e.substr(4, 1), r += r, t += t, n += n, o += o), {
    red: parseInt(r, 16),
    green: parseInt(t, 16),
    blue: parseInt(n, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const as = {
  test: Qs("#"),
  parse: Ev,
  transform: sn.transform
}, Je = {
  test: (e) => sn.test(e) || as.test(e) || In.test(e),
  parse: (e) => sn.test(e) ? sn.parse(e) : In.test(e) ? In.parse(e) : as.parse(e),
  transform: (e) => vo(e) ? e : e.hasOwnProperty("red") ? sn.transform(e) : In.transform(e)
}, n0 = "${c}", r0 = "${n}";
function Iv(e) {
  var r, t, n, o;
  return isNaN(e) && vo(e) && ((t = (r = e.match(Jr)) === null || r === void 0 ? void 0 : r.length) !== null && t !== void 0 ? t : 0) + ((o = (n = e.match(is)) === null || n === void 0 ? void 0 : n.length) !== null && o !== void 0 ? o : 0) > 0;
}
function o0(e) {
  typeof e == "number" && (e = `${e}`);
  const r = [];
  let t = 0;
  const n = e.match(is);
  n && (t = n.length, e = e.replace(is, n0), r.push(...n.map(Je.parse)));
  const o = e.match(Jr);
  return o && (e = e.replace(Jr, r0), r.push(...o.map(Vn.parse))), { values: r, numColors: t, tokenised: e };
}
function i0(e) {
  return o0(e).values;
}
function a0(e) {
  const { values: r, numColors: t, tokenised: n } = o0(e), o = r.length;
  return (i) => {
    let a = n;
    for (let s = 0; s < o; s++)
      a = a.replace(s < t ? n0 : r0, s < t ? Je.transform(i[s]) : Sr(i[s]));
    return a;
  };
}
const Ov = (e) => typeof e == "number" ? 0 : e;
function Nv(e) {
  const r = i0(e);
  return a0(e)(r.map(Ov));
}
const Bt = { test: Iv, parse: i0, createTransformer: a0, getAnimatableNone: Nv }, Tv = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function kv(e) {
  let [r, t] = e.slice(0, -1).split("(");
  if (r === "drop-shadow")
    return e;
  const [n] = t.match(Jr) || [];
  if (!n)
    return e;
  const o = t.replace(n, "");
  let i = Tv.has(r) ? 1 : 0;
  return n !== t && (i *= 100), r + "(" + i + o + ")";
}
const Sv = /([a-z-]*)\(.*?\)/g, ss = Object.assign(Object.assign({}, Bt), { getAnimatableNone: (e) => {
  const r = e.match(Sv);
  return r ? r.map(kv).join(" ") : e;
} });
var au = Q(Q({}, Vn), { transform: Math.round }), s0 = {
  // Border props
  borderWidth: ce,
  borderTopWidth: ce,
  borderRightWidth: ce,
  borderBottomWidth: ce,
  borderLeftWidth: ce,
  borderRadius: ce,
  radius: ce,
  borderTopLeftRadius: ce,
  borderTopRightRadius: ce,
  borderBottomRightRadius: ce,
  borderBottomLeftRadius: ce,
  // Positioning props
  width: ce,
  maxWidth: ce,
  height: ce,
  maxHeight: ce,
  size: ce,
  top: ce,
  right: ce,
  bottom: ce,
  left: ce,
  // Spacing props
  padding: ce,
  paddingTop: ce,
  paddingRight: ce,
  paddingBottom: ce,
  paddingLeft: ce,
  margin: ce,
  marginTop: ce,
  marginRight: ce,
  marginBottom: ce,
  marginLeft: ce,
  // Transform props
  rotate: en,
  rotateX: en,
  rotateY: en,
  rotateZ: en,
  scale: Do,
  scaleX: Do,
  scaleY: Do,
  scaleZ: Do,
  skew: en,
  skewX: en,
  skewY: en,
  distance: ce,
  translateX: ce,
  translateY: ce,
  translateZ: ce,
  x: ce,
  y: ce,
  z: ce,
  perspective: ce,
  transformPerspective: ce,
  opacity: Rr,
  originX: iu,
  originY: iu,
  originZ: ce,
  // Misc
  zIndex: au,
  // SVG
  fillOpacity: Rr,
  strokeOpacity: Rr,
  numOctaves: au
};
function qs(e, r, t, n) {
  var o, i = e.style, a = e.vars, s = e.transform, l = e.transformKeys, c = e.transformOrigin;
  l.length = 0;
  var u = !1, d = !1, h = !0;
  for (var p in r) {
    var v = r[p];
    if (Jd(p)) {
      a[p] = v;
      continue;
    }
    var m = s0[p], y = Cv(v, m);
    if (ho(p)) {
      if (u = !0, s[p] = y, l.push(p), !h)
        continue;
      v !== ((o = m.default) !== null && o !== void 0 ? o : 0) && (h = !1);
    } else
      Gd(p) ? (c[p] = y, d = !0) : i[p] = y;
  }
  u ? i.transform = wv(e, t, h, n) : n ? i.transform = n({}, "") : !r.transform && i.transform && (i.transform = "none"), d && (i.transformOrigin = xv(c));
}
var Gs = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function l0(e, r, t) {
  for (var n in r)
    !Wt(r[n]) && !Xd(n, t) && (e[n] = r[n]);
}
function Rv(e, r, t) {
  var n = e.transformTemplate;
  return it(function() {
    var o = Gs();
    qs(o, r, { enableHardwareAcceleration: !t }, n);
    var i = o.vars, a = o.style;
    return Q(Q({}, i), a);
  }, [r]);
}
function jv(e, r, t) {
  var n = e.style || {}, o = {};
  return l0(o, n, e), Object.assign(o, Rv(e, r, t)), e.transformValues && (o = e.transformValues(o)), o;
}
function Pv(e, r, t) {
  var n = {}, o = jv(e, r, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), n.style = o, n;
}
var Av = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function vi(e) {
  return Av.has(e);
}
var c0 = function(e) {
  return !vi(e);
};
function Lv(e) {
  e && (c0 = function(r) {
    return r.startsWith("on") ? !vi(r) : e(r);
  });
}
try {
  Lv(require("@emotion/is-prop-valid").default);
} catch {
}
function Vv(e, r, t) {
  var n = {};
  for (var o in e)
    (c0(o) || t === !0 && vi(o) || !r && !vi(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (n[o] = e[o]);
  return n;
}
function su(e, r, t) {
  return typeof e == "string" ? e : ce.transform(r + t * e);
}
function Hv(e, r, t) {
  var n = su(r, e.x, e.width), o = su(t, e.y, e.height);
  return "".concat(n, " ").concat(o);
}
var Fv = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Yv = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function $v(e, r, t, n, o) {
  t === void 0 && (t = 1), n === void 0 && (n = 0), o === void 0 && (o = !0), e.pathLength = 1;
  var i = o ? Fv : Yv;
  e[i.offset] = ce.transform(-n);
  var a = ce.transform(r), s = ce.transform(t);
  e[i.array] = "".concat(a, " ").concat(s);
}
function Xs(e, r, t, n) {
  var o = r.attrX, i = r.attrY, a = r.originX, s = r.originY, l = r.pathLength, c = r.pathSpacing, u = c === void 0 ? 1 : c, d = r.pathOffset, h = d === void 0 ? 0 : d, p = Ht(r, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  qs(e, p, t, n), e.attrs = e.style, e.style = {};
  var v = e.attrs, m = e.style, y = e.dimensions;
  v.transform && (y && (m.transform = v.transform), delete v.transform), y && (a !== void 0 || s !== void 0 || m.transform) && (m.transformOrigin = Hv(y, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), o !== void 0 && (v.x = o), i !== void 0 && (v.y = i), l !== void 0 && $v(v, l, u, h, !1);
}
var u0 = function() {
  return Q(Q({}, Gs()), { attrs: {} });
};
function zv(e, r) {
  var t = it(function() {
    var o = u0();
    return Xs(o, r, { enableHardwareAcceleration: !1 }, e.transformTemplate), Q(Q({}, o.attrs), { style: Q({}, o.style) });
  }, [r]);
  if (e.style) {
    var n = {};
    l0(n, e.style, e), t.style = Q(Q({}, n), t.style);
  }
  return t;
}
function Zv(e) {
  e === void 0 && (e = !1);
  var r = function(t, n, o, i, a, s) {
    var l = a.latestValues, c = Ks(t) ? zv : Pv, u = c(n, l, s), d = Vv(n, typeof t == "string", e), h = Q(Q(Q({}, d), u), { ref: i });
    return o && (h["data-projection-id"] = o), R1(t, h);
  };
  return r;
}
var Wv = /([a-z])([A-Z])/g, Bv = "$1-$2", d0 = function(e) {
  return e.replace(Wv, Bv).toLowerCase();
};
function f0(e, r, t, n) {
  var o = r.style, i = r.vars;
  Object.assign(e.style, o, n && n.getProjectionStyles(t));
  for (var a in i)
    e.style.setProperty(a, i[a]);
}
var p0 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function h0(e, r, t, n) {
  f0(e, r, void 0, n);
  for (var o in r.attrs)
    e.setAttribute(p0.has(o) ? o : d0(o), r.attrs[o]);
}
function Js(e) {
  var r = e.style, t = {};
  for (var n in r)
    (Wt(r[n]) || Xd(n, e)) && (t[n] = r[n]);
  return t;
}
function v0(e) {
  var r = Js(e);
  for (var t in e)
    if (Wt(e[t])) {
      var n = t === "x" || t === "y" ? "attr" + t.toUpperCase() : t;
      r[n] = e[t];
    }
  return r;
}
function el(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var eo = function(e) {
  return Array.isArray(e);
}, Uv = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, m0 = function(e) {
  return eo(e) ? e[e.length - 1] || 0 : e;
};
function $o(e) {
  var r = Wt(e) ? e.get() : e;
  return Uv(r) ? r.toValue() : r;
}
function lu(e, r, t, n) {
  var o = e.scrapeMotionValuesFromProps, i = e.createRenderState, a = e.onMount, s = {
    latestValues: Kv(r, t, n, o),
    renderState: i()
  };
  return a && (s.mount = function(l) {
    return a(r, l, s);
  }), s;
}
var g0 = function(e) {
  return function(r, t) {
    var n = ze(Vi), o = ze(fo);
    return t ? lu(e, r, n, o) : po(function() {
      return lu(e, r, n, o);
    });
  };
};
function Kv(e, r, t, n) {
  var o = {}, i = (t == null ? void 0 : t.initial) === !1, a = n(e);
  for (var s in a)
    o[s] = $o(a[s]);
  var l = e.initial, c = e.animate, u = Fi(e), d = Qd(e);
  r && d && !u && e.inherit !== !1 && (l ?? (l = r.initial), c ?? (c = r.animate));
  var h = i || l === !1, p = h ? c : l;
  if (p && typeof p != "boolean" && !el(p)) {
    var v = Array.isArray(p) ? p : [p];
    v.forEach(function(m) {
      var y = Kd(e, m);
      if (y) {
        var b = y.transitionEnd;
        y.transition;
        var g = Ht(y, ["transitionEnd", "transition"]);
        for (var w in g) {
          var x = g[w];
          if (Array.isArray(x)) {
            var C = h ? x.length - 1 : 0;
            x = x[C];
          }
          x !== null && (o[w] = x);
        }
        for (var w in b)
          o[w] = b[w];
      }
    });
  }
  return o;
}
var Qv = {
  useVisualState: g0({
    scrapeMotionValuesFromProps: v0,
    createRenderState: u0,
    onMount: function(e, r, t) {
      var n = t.renderState, o = t.latestValues;
      try {
        n.dimensions = typeof r.getBBox == "function" ? r.getBBox() : r.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Xs(n, o, { enableHardwareAcceleration: !1 }, e.transformTemplate), h0(r, n);
    }
  })
}, qv = {
  useVisualState: g0({
    scrapeMotionValuesFromProps: Js,
    createRenderState: Gs
  })
};
function Gv(e, r, t, n, o) {
  var i = r.forwardMotionProps, a = i === void 0 ? !1 : i, s = Ks(e) ? Qv : qv;
  return Q(Q({}, s), { preloadedFeatures: t, useRender: Zv(a), createVisualElement: n, projectionNodeConstructor: o, Component: e });
}
var Te;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(Te || (Te = {}));
function Yi(e, r, t, n) {
  return n === void 0 && (n = { passive: !0 }), e.addEventListener(r, t, n), function() {
    return e.removeEventListener(r, t);
  };
}
function ls(e, r, t, n) {
  fe(function() {
    var o = e.current;
    if (t && o)
      return Yi(o, r, t, n);
  }, [e, r, t, n]);
}
function Xv(e) {
  var r = e.whileFocus, t = e.visualElement, n = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(Te.Focus, !0);
  }, o = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(Te.Focus, !1);
  };
  ls(t, "focus", r ? n : void 0), ls(t, "blur", r ? o : void 0);
}
function y0(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function w0(e) {
  var r = !!e.touches;
  return r;
}
function Jv(e) {
  return function(r) {
    var t = r instanceof MouseEvent, n = !t || t && r.button === 0;
    n && e(r);
  };
}
var em = { pageX: 0, pageY: 0 };
function tm(e, r) {
  r === void 0 && (r = "page");
  var t = e.touches[0] || e.changedTouches[0], n = t || em;
  return {
    x: n[r + "X"],
    y: n[r + "Y"]
  };
}
function nm(e, r) {
  return r === void 0 && (r = "page"), {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function tl(e, r) {
  return r === void 0 && (r = "page"), {
    point: w0(e) ? tm(e, r) : nm(e, r)
  };
}
var x0 = function(e, r) {
  r === void 0 && (r = !1);
  var t = function(n) {
    return e(n, tl(n));
  };
  return r ? Jv(t) : t;
}, rm = function() {
  return mr && window.onpointerdown === null;
}, om = function() {
  return mr && window.ontouchstart === null;
}, im = function() {
  return mr && window.onmousedown === null;
}, am = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, sm = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function C0(e) {
  return rm() ? e : om() ? sm[e] : im() ? am[e] : e;
}
function rr(e, r, t, n) {
  return Yi(e, C0(r), x0(t, r === "pointerdown"), n);
}
function mi(e, r, t, n) {
  return ls(e, C0(r), t && x0(t, r === "pointerdown"), n);
}
function b0(e) {
  var r = null;
  return function() {
    var t = function() {
      r = null;
    };
    return r === null ? (r = e, t) : !1;
  };
}
var cu = b0("dragHorizontal"), uu = b0("dragVertical");
function M0(e) {
  var r = !1;
  if (e === "y")
    r = uu();
  else if (e === "x")
    r = cu();
  else {
    var t = cu(), n = uu();
    t && n ? r = function() {
      t(), n();
    } : (t && t(), n && n());
  }
  return r;
}
function D0() {
  var e = M0(!0);
  return e ? (e(), !1) : !0;
}
function du(e, r, t) {
  return function(n, o) {
    var i;
    !y0(n) || D0() || ((i = e.animationState) === null || i === void 0 || i.setActive(Te.Hover, r), t == null || t(n, o));
  };
}
function lm(e) {
  var r = e.onHoverStart, t = e.onHoverEnd, n = e.whileHover, o = e.visualElement;
  mi(o, "pointerenter", r || n ? du(o, !0, r) : void 0, { passive: !r }), mi(o, "pointerleave", t || n ? du(o, !1, t) : void 0, { passive: !t });
}
var _0 = function(e, r) {
  return r ? e === r ? !0 : _0(e, r.parentElement) : !1;
};
function nl(e) {
  return fe(function() {
    return function() {
      return e();
    };
  }, []);
}
function E0(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
const gi = (e, r, t) => Math.min(Math.max(t, e), r), Ca = 1e-3, cm = 0.01, fu = 10, um = 0.05, dm = 1;
function fm({ duration: e = 800, bounce: r = 0.25, velocity: t = 0, mass: n = 1 }) {
  let o, i;
  uo(e <= fu * 1e3, "Spring duration must be 10 seconds or less");
  let a = 1 - r;
  a = gi(um, dm, a), e = gi(cm, fu, e / 1e3), a < 1 ? (o = (c) => {
    const u = c * a, d = u * e, h = u - t, p = cs(c, a), v = Math.exp(-d);
    return Ca - h / p * v;
  }, i = (c) => {
    const d = c * a * e, h = d * t + t, p = Math.pow(a, 2) * Math.pow(c, 2) * e, v = Math.exp(-d), m = cs(Math.pow(c, 2), a);
    return (-o(c) + Ca > 0 ? -1 : 1) * ((h - p) * v) / m;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), d = (c - t) * e + 1;
    return -Ca + u * d;
  }, i = (c) => {
    const u = Math.exp(-c * e), d = (t - c) * (e * e);
    return u * d;
  });
  const s = 5 / e, l = hm(o, i, s);
  if (e = e * 1e3, isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * n;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(n * c),
      duration: e
    };
  }
}
const pm = 12;
function hm(e, r, t) {
  let n = t;
  for (let o = 1; o < pm; o++)
    n = n - e(n) / r(n);
  return n;
}
function cs(e, r) {
  return e * Math.sqrt(1 - r * r);
}
const vm = ["duration", "bounce"], mm = ["stiffness", "damping", "mass"];
function pu(e, r) {
  return r.some((t) => e[t] !== void 0);
}
function gm(e) {
  let r = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!pu(e, mm) && pu(e, vm)) {
    const t = fm(e);
    r = Object.assign(Object.assign(Object.assign({}, r), t), { velocity: 0, mass: 1 }), r.isResolvedFromDuration = !0;
  }
  return r;
}
function rl(e) {
  var { from: r = 0, to: t = 1, restSpeed: n = 2, restDelta: o } = e, i = E0(e, ["from", "to", "restSpeed", "restDelta"]);
  const a = { done: !1, value: r };
  let { stiffness: s, damping: l, mass: c, velocity: u, duration: d, isResolvedFromDuration: h } = gm(i), p = hu, v = hu;
  function m() {
    const y = u ? -(u / 1e3) : 0, b = t - r, g = l / (2 * Math.sqrt(s * c)), w = Math.sqrt(s / c) / 1e3;
    if (o === void 0 && (o = Math.min(Math.abs(t - r) / 100, 0.4)), g < 1) {
      const x = cs(w, g);
      p = (C) => {
        const O = Math.exp(-g * w * C);
        return t - O * ((y + g * w * b) / x * Math.sin(x * C) + b * Math.cos(x * C));
      }, v = (C) => {
        const O = Math.exp(-g * w * C);
        return g * w * O * (Math.sin(x * C) * (y + g * w * b) / x + b * Math.cos(x * C)) - O * (Math.cos(x * C) * (y + g * w * b) - x * b * Math.sin(x * C));
      };
    } else if (g === 1)
      p = (x) => t - Math.exp(-w * x) * (b + (y + w * b) * x);
    else {
      const x = w * Math.sqrt(g * g - 1);
      p = (C) => {
        const O = Math.exp(-g * w * C), E = Math.min(x * C, 300);
        return t - O * ((y + g * w * b) * Math.sinh(E) + x * b * Math.cosh(E)) / x;
      };
    }
  }
  return m(), {
    next: (y) => {
      const b = p(y);
      if (h)
        a.done = y >= d;
      else {
        const g = v(y) * 1e3, w = Math.abs(g) <= n, x = Math.abs(t - b) <= o;
        a.done = w && x;
      }
      return a.value = a.done ? t : b, a;
    },
    flipTarget: () => {
      u = -u, [r, t] = [t, r], m();
    }
  };
}
rl.needsInterpolation = (e, r) => typeof e == "string" || typeof r == "string";
const hu = (e) => 0, to = (e, r, t) => {
  const n = r - e;
  return n === 0 ? 1 : (t - e) / n;
}, Ve = (e, r, t) => -t * e + t * r + e;
function ba(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * 6 * t : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function vu({ hue: e, saturation: r, lightness: t, alpha: n }) {
  e /= 360, r /= 100, t /= 100;
  let o = 0, i = 0, a = 0;
  if (!r)
    o = i = a = t;
  else {
    const s = t < 0.5 ? t * (1 + r) : t + r - t * r, l = 2 * t - s;
    o = ba(l, s, e + 1 / 3), i = ba(l, s, e), a = ba(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: n
  };
}
const ym = (e, r, t) => {
  const n = e * e, o = r * r;
  return Math.sqrt(Math.max(0, t * (o - n) + n));
}, wm = [as, sn, In], mu = (e) => wm.find((r) => r.test(e)), gu = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, I0 = (e, r) => {
  let t = mu(e), n = mu(r);
  ht(!!t, gu(e)), ht(!!n, gu(r));
  let o = t.parse(e), i = n.parse(r);
  t === In && (o = vu(o), t = sn), n === In && (i = vu(i), n = sn);
  const a = Object.assign({}, o);
  return (s) => {
    for (const l in a)
      l !== "alpha" && (a[l] = ym(o[l], i[l], s));
    return a.alpha = Ve(o.alpha, i.alpha, s), t.transform(a);
  };
}, us = (e) => typeof e == "number", xm = (e, r) => (t) => r(e(t)), $i = (...e) => e.reduce(xm);
function O0(e, r) {
  return us(e) ? (t) => Ve(e, r, t) : Je.test(e) ? I0(e, r) : T0(e, r);
}
const N0 = (e, r) => {
  const t = [...e], n = t.length, o = e.map((i, a) => O0(i, r[a]));
  return (i) => {
    for (let a = 0; a < n; a++)
      t[a] = o[a](i);
    return t;
  };
}, Cm = (e, r) => {
  const t = Object.assign(Object.assign({}, e), r), n = {};
  for (const o in t)
    e[o] !== void 0 && r[o] !== void 0 && (n[o] = O0(e[o], r[o]));
  return (o) => {
    for (const i in n)
      t[i] = n[i](o);
    return t;
  };
};
function yu(e) {
  const r = Bt.parse(e), t = r.length;
  let n = 0, o = 0, i = 0;
  for (let a = 0; a < t; a++)
    n || typeof r[a] == "number" ? n++ : r[a].hue !== void 0 ? i++ : o++;
  return { parsed: r, numNumbers: n, numRGB: o, numHSL: i };
}
const T0 = (e, r) => {
  const t = Bt.createTransformer(r), n = yu(e), o = yu(r);
  return n.numHSL === o.numHSL && n.numRGB === o.numRGB && n.numNumbers >= o.numNumbers ? $i(N0(n.parsed, o.parsed), t) : (uo(!0, `Complex values '${e}' and '${r}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? r : e}`);
}, bm = (e, r) => (t) => Ve(e, r, t);
function Mm(e) {
  if (typeof e == "number")
    return bm;
  if (typeof e == "string")
    return Je.test(e) ? I0 : T0;
  if (Array.isArray(e))
    return N0;
  if (typeof e == "object")
    return Cm;
}
function Dm(e, r, t) {
  const n = [], o = t || Mm(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let s = o(e[a], e[a + 1]);
    if (r) {
      const l = Array.isArray(r) ? r[a] : r;
      s = $i(l, s);
    }
    n.push(s);
  }
  return n;
}
function _m([e, r], [t]) {
  return (n) => t(to(e, r, n));
}
function Em(e, r) {
  const t = e.length, n = t - 1;
  return (o) => {
    let i = 0, a = !1;
    if (o <= e[0] ? a = !0 : o >= e[n] && (i = n - 1, a = !0), !a) {
      let l = 1;
      for (; l < t && !(e[l] > o || l === n); l++)
        ;
      i = l - 1;
    }
    const s = to(e[i], e[i + 1], o);
    return r[i](s);
  };
}
function k0(e, r, { clamp: t = !0, ease: n, mixer: o } = {}) {
  const i = e.length;
  ht(i === r.length, "Both input and output ranges must be the same length"), ht(!n || !Array.isArray(n) || n.length === i - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[i - 1] && (e = [].concat(e), r = [].concat(r), e.reverse(), r.reverse());
  const a = Dm(r, n, o), s = i === 2 ? _m(e, a) : Em(e, a);
  return t ? (l) => s(gi(e[0], e[i - 1], l)) : s;
}
const zi = (e) => (r) => 1 - e(1 - r), ol = (e) => (r) => r <= 0.5 ? e(2 * r) / 2 : (2 - e(2 * (1 - r))) / 2, Im = (e) => (r) => Math.pow(r, e), S0 = (e) => (r) => r * r * ((e + 1) * r - e), Om = (e) => {
  const r = S0(e);
  return (t) => (t *= 2) < 1 ? 0.5 * r(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1)));
}, R0 = 1.525, Nm = 4 / 11, Tm = 8 / 11, km = 9 / 10, il = (e) => e, al = Im(2), Sm = zi(al), j0 = ol(al), P0 = (e) => 1 - Math.sin(Math.acos(e)), sl = zi(P0), Rm = ol(sl), ll = S0(R0), jm = zi(ll), Pm = ol(ll), Am = Om(R0), Lm = 4356 / 361, Vm = 35442 / 1805, Hm = 16061 / 1805, yi = (e) => {
  if (e === 1 || e === 0)
    return e;
  const r = e * e;
  return e < Nm ? 7.5625 * r : e < Tm ? 9.075 * r - 9.9 * e + 3.4 : e < km ? Lm * r - Vm * e + Hm : 10.8 * e * e - 20.52 * e + 10.72;
}, Fm = zi(yi), Ym = (e) => e < 0.5 ? 0.5 * (1 - yi(1 - e * 2)) : 0.5 * yi(e * 2 - 1) + 0.5;
function $m(e, r) {
  return e.map(() => r || j0).splice(0, e.length - 1);
}
function zm(e) {
  const r = e.length;
  return e.map((t, n) => n !== 0 ? n / (r - 1) : 0);
}
function Zm(e, r) {
  return e.map((t) => t * r);
}
function zo({ from: e = 0, to: r = 1, ease: t, offset: n, duration: o = 300 }) {
  const i = { done: !1, value: e }, a = Array.isArray(r) ? r : [e, r], s = Zm(n && n.length === a.length ? n : zm(a), o);
  function l() {
    return k0(s, a, {
      ease: Array.isArray(t) ? t : $m(a, t)
    });
  }
  let c = l();
  return {
    next: (u) => (i.value = c(u), i.done = u >= o, i),
    flipTarget: () => {
      a.reverse(), c = l();
    }
  };
}
function Wm({ velocity: e = 0, from: r = 0, power: t = 0.8, timeConstant: n = 350, restDelta: o = 0.5, modifyTarget: i }) {
  const a = { done: !1, value: r };
  let s = t * e;
  const l = r + s, c = i === void 0 ? l : i(l);
  return c !== l && (s = c - r), {
    next: (u) => {
      const d = -s * Math.exp(-u / n);
      return a.done = !(d > o || d < -o), a.value = a.done ? c : c + d, a;
    },
    flipTarget: () => {
    }
  };
}
const wu = { keyframes: zo, spring: rl, decay: Wm };
function Bm(e) {
  if (Array.isArray(e.to))
    return zo;
  if (wu[e.type])
    return wu[e.type];
  const r = new Set(Object.keys(e));
  return r.has("ease") || r.has("duration") && !r.has("dampingRatio") ? zo : r.has("dampingRatio") || r.has("stiffness") || r.has("mass") || r.has("damping") || r.has("restSpeed") || r.has("restDelta") ? rl : zo;
}
const A0 = 1 / 60 * 1e3, Um = typeof performance < "u" ? () => performance.now() : () => Date.now(), L0 = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(Um()), A0);
function Km(e) {
  let r = [], t = [], n = 0, o = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    schedule: (l, c = !1, u = !1) => {
      const d = u && o, h = d ? r : t;
      return c && a.add(l), h.indexOf(l) === -1 && (h.push(l), d && o && (n = r.length)), l;
    },
    cancel: (l) => {
      const c = t.indexOf(l);
      c !== -1 && t.splice(c, 1), a.delete(l);
    },
    process: (l) => {
      if (o) {
        i = !0;
        return;
      }
      if (o = !0, [r, t] = [t, r], t.length = 0, n = r.length, n)
        for (let c = 0; c < n; c++) {
          const u = r[c];
          u(l), a.has(u) && (s.schedule(u), e());
        }
      o = !1, i && (i = !1, s.process(l));
    }
  };
  return s;
}
const Qm = 40;
let ds = !0, no = !1, fs = !1;
const or = {
  delta: 0,
  timestamp: 0
}, go = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], Zi = go.reduce((e, r) => (e[r] = Km(() => no = !0), e), {}), Mt = go.reduce((e, r) => {
  const t = Zi[r];
  return e[r] = (n, o = !1, i = !1) => (no || Gm(), t.schedule(n, o, i)), e;
}, {}), lr = go.reduce((e, r) => (e[r] = Zi[r].cancel, e), {}), Ma = go.reduce((e, r) => (e[r] = () => Zi[r].process(or), e), {}), qm = (e) => Zi[e].process(or), V0 = (e) => {
  no = !1, or.delta = ds ? A0 : Math.max(Math.min(e - or.timestamp, Qm), 1), or.timestamp = e, fs = !0, go.forEach(qm), fs = !1, no && (ds = !1, L0(V0));
}, Gm = () => {
  no = !0, ds = !0, fs || L0(V0);
}, wi = () => or;
function H0(e, r, t = 0) {
  return e - r - t;
}
function Xm(e, r, t = 0, n = !0) {
  return n ? H0(r + -e, r, t) : r - (e - r) + t;
}
function Jm(e, r, t, n) {
  return n ? e >= r + t : e <= -t;
}
const e7 = (e) => {
  const r = ({ delta: t }) => e(t);
  return {
    start: () => Mt.update(r, !0),
    stop: () => lr.update(r)
  };
};
function F0(e) {
  var r, t, { from: n, autoplay: o = !0, driver: i = e7, elapsed: a = 0, repeat: s = 0, repeatType: l = "loop", repeatDelay: c = 0, onPlay: u, onStop: d, onComplete: h, onRepeat: p, onUpdate: v } = e, m = E0(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: y } = m, b, g = 0, w = m.duration, x, C = !1, O = !0, E;
  const _ = Bm(m);
  !((t = (r = _).needsInterpolation) === null || t === void 0) && t.call(r, n, y) && (E = k0([0, 100], [n, y], {
    clamp: !1
  }), n = 0, y = 100);
  const R = _(Object.assign(Object.assign({}, m), { from: n, to: y }));
  function H() {
    g++, l === "reverse" ? (O = g % 2 === 0, a = Xm(a, w, c, O)) : (a = H0(a, w, c), l === "mirror" && R.flipTarget()), C = !1, p && p();
  }
  function $() {
    b.stop(), h && h();
  }
  function Y(A) {
    if (O || (A = -A), a += A, !C) {
      const W = R.next(Math.max(0, a));
      x = W.value, E && (x = E(x)), C = O ? W.done : a <= 0;
    }
    v == null || v(x), C && (g === 0 && (w ?? (w = a)), g < s ? Jm(a, w, c, O) && H() : $());
  }
  function j() {
    u == null || u(), b = i(Y), b.start();
  }
  return o && j(), {
    stop: () => {
      d == null || d(), b.stop();
    }
  };
}
function Y0(e, r) {
  return r ? e * (1e3 / r) : 0;
}
function t7({ from: e = 0, velocity: r = 0, min: t, max: n, power: o = 0.8, timeConstant: i = 750, bounceStiffness: a = 500, bounceDamping: s = 10, restDelta: l = 1, modifyTarget: c, driver: u, onUpdate: d, onComplete: h, onStop: p }) {
  let v;
  function m(w) {
    return t !== void 0 && w < t || n !== void 0 && w > n;
  }
  function y(w) {
    return t === void 0 ? n : n === void 0 || Math.abs(t - w) < Math.abs(n - w) ? t : n;
  }
  function b(w) {
    v == null || v.stop(), v = F0(Object.assign(Object.assign({}, w), {
      driver: u,
      onUpdate: (x) => {
        var C;
        d == null || d(x), (C = w.onUpdate) === null || C === void 0 || C.call(w, x);
      },
      onComplete: h,
      onStop: p
    }));
  }
  function g(w) {
    b(Object.assign({ type: "spring", stiffness: a, damping: s, restDelta: l }, w));
  }
  if (m(e))
    g({ from: e, velocity: r, to: y(e) });
  else {
    let w = o * r + e;
    typeof c < "u" && (w = c(w));
    const x = y(w), C = x === t ? -1 : 1;
    let O, E;
    const _ = (R) => {
      O = E, E = R, r = Y0(R - O, wi().delta), (C === 1 && R > x || C === -1 && R < x) && g({ from: R, to: x, velocity: r });
    };
    b({
      type: "decay",
      from: e,
      velocity: r,
      timeConstant: i,
      power: o,
      restDelta: l,
      modifyTarget: c,
      onUpdate: m(w) ? _ : void 0
    });
  }
  return {
    stop: () => v == null ? void 0 : v.stop()
  };
}
const ps = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), xu = (e) => ps(e) && e.hasOwnProperty("z"), _o = (e, r) => Math.abs(e - r);
function $0(e, r) {
  if (us(e) && us(r))
    return _o(e, r);
  if (ps(e) && ps(r)) {
    const t = _o(e.x, r.x), n = _o(e.y, r.y), o = xu(e) && xu(r) ? _o(e.z, r.z) : 0;
    return Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2) + Math.pow(o, 2));
  }
}
const z0 = (e, r) => 1 - 3 * r + 3 * e, Z0 = (e, r) => 3 * r - 6 * e, W0 = (e) => 3 * e, xi = (e, r, t) => ((z0(r, t) * e + Z0(r, t)) * e + W0(r)) * e, B0 = (e, r, t) => 3 * z0(r, t) * e * e + 2 * Z0(r, t) * e + W0(r), n7 = 1e-7, r7 = 10;
function o7(e, r, t, n, o) {
  let i, a, s = 0;
  do
    a = r + (t - r) / 2, i = xi(a, n, o) - e, i > 0 ? t = a : r = a;
  while (Math.abs(i) > n7 && ++s < r7);
  return a;
}
const i7 = 8, a7 = 1e-3;
function s7(e, r, t, n) {
  for (let o = 0; o < i7; ++o) {
    const i = B0(r, t, n);
    if (i === 0)
      return r;
    const a = xi(r, t, n) - e;
    r -= a / i;
  }
  return r;
}
const Zo = 11, Eo = 1 / (Zo - 1);
function l7(e, r, t, n) {
  if (e === r && t === n)
    return il;
  const o = new Float32Array(Zo);
  for (let a = 0; a < Zo; ++a)
    o[a] = xi(a * Eo, e, t);
  function i(a) {
    let s = 0, l = 1;
    const c = Zo - 1;
    for (; l !== c && o[l] <= a; ++l)
      s += Eo;
    --l;
    const u = (a - o[l]) / (o[l + 1] - o[l]), d = s + u * Eo, h = B0(d, e, t);
    return h >= a7 ? s7(a, d, e, t) : h === 0 ? d : o7(a, s, s + Eo, e, t);
  }
  return (a) => a === 0 || a === 1 ? a : xi(i(a), r, n);
}
function c7(e) {
  var r = e.onTap, t = e.onTapStart, n = e.onTapCancel, o = e.whileTap, i = e.visualElement, a = r || t || n || o, s = me(!1), l = me(null), c = {
    passive: !(t || r || n || v)
  };
  function u() {
    var m;
    (m = l.current) === null || m === void 0 || m.call(l), l.current = null;
  }
  function d() {
    var m;
    return u(), s.current = !1, (m = i.animationState) === null || m === void 0 || m.setActive(Te.Tap, !1), !D0();
  }
  function h(m, y) {
    d() && (_0(i.getInstance(), m.target) ? r == null || r(m, y) : n == null || n(m, y));
  }
  function p(m, y) {
    d() && (n == null || n(m, y));
  }
  function v(m, y) {
    var b;
    u(), !s.current && (s.current = !0, l.current = $i(rr(window, "pointerup", h, c), rr(window, "pointercancel", p, c)), (b = i.animationState) === null || b === void 0 || b.setActive(Te.Tap, !0), t == null || t(m, y));
  }
  mi(i, "pointerdown", a ? v : void 0, c), nl(u);
}
var Cu = /* @__PURE__ */ new Set();
function U0(e, r, t) {
  e || Cu.has(r) || (console.warn(r), t && console.warn(t), Cu.add(r));
}
var hs = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), u7 = function(e) {
  var r;
  (r = hs.get(e.target)) === null || r === void 0 || r(e);
}, d7 = function(e) {
  e.forEach(u7);
};
function f7(e) {
  var r = e.root, t = Ht(e, ["root"]), n = r || document;
  Da.has(n) || Da.set(n, {});
  var o = Da.get(n), i = JSON.stringify(t);
  return o[i] || (o[i] = new IntersectionObserver(d7, Q({ root: r }, t))), o[i];
}
function p7(e, r, t) {
  var n = f7(r);
  return hs.set(e, t), n.observe(e), function() {
    hs.delete(e), n.unobserve(e);
  };
}
function h7(e) {
  var r = e.visualElement, t = e.whileInView, n = e.onViewportEnter, o = e.onViewportLeave, i = e.viewport, a = i === void 0 ? {} : i, s = me({
    hasEnteredView: !1,
    isInView: !1
  }), l = !!(t || n || o);
  a.once && s.current.hasEnteredView && (l = !1);
  var c = typeof IntersectionObserver > "u" ? g7 : m7;
  c(l, s.current, r, a);
}
var v7 = {
  some: 0,
  all: 1
};
function m7(e, r, t, n) {
  var o = n.root, i = n.margin, a = n.amount, s = a === void 0 ? "some" : a, l = n.once;
  fe(function() {
    if (e) {
      var c = {
        root: o == null ? void 0 : o.current,
        rootMargin: i,
        threshold: typeof s == "number" ? s : v7[s]
      }, u = function(d) {
        var h, p = d.isIntersecting;
        if (r.isInView !== p && (r.isInView = p, !(l && !p && r.hasEnteredView))) {
          p && (r.hasEnteredView = !0), (h = t.animationState) === null || h === void 0 || h.setActive(Te.InView, p);
          var v = t.getProps(), m = p ? v.onViewportEnter : v.onViewportLeave;
          m == null || m(d);
        }
      };
      return p7(t.getInstance(), c, u);
    }
  }, [e, o, i, s]);
}
function g7(e, r, t, n) {
  var o = n.fallback, i = o === void 0 ? !0 : o;
  fe(function() {
    !e || !i || (Bs !== "production" && U0(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var a;
      r.hasEnteredView = !0;
      var s = t.getProps().onViewportEnter;
      s == null || s(null), (a = t.animationState) === null || a === void 0 || a.setActive(Te.InView, !0);
    }));
  }, [e]);
}
var ln = function(e) {
  return function(r) {
    return e(r), null;
  };
}, y7 = {
  inView: ln(h7),
  tap: ln(c7),
  focus: ln(Xv),
  hover: ln(lm)
}, w7 = 0, x7 = function() {
  return w7++;
}, K0 = function() {
  return po(x7);
};
function Q0() {
  var e = ze(fo);
  if (e === null)
    return [!0, null];
  var r = e.isPresent, t = e.onExitComplete, n = e.register, o = K0();
  fe(function() {
    return n(o);
  }, []);
  var i = function() {
    return t == null ? void 0 : t(o);
  };
  return !r && t ? [!1, i] : [!0];
}
function q0(e, r) {
  if (!Array.isArray(r))
    return !1;
  var t = r.length;
  if (t !== e.length)
    return !1;
  for (var n = 0; n < t; n++)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
var Ci = function(e) {
  return e * 1e3;
}, bu = {
  linear: il,
  easeIn: al,
  easeInOut: j0,
  easeOut: Sm,
  circIn: P0,
  circInOut: Rm,
  circOut: sl,
  backIn: ll,
  backInOut: Pm,
  backOut: jm,
  anticipate: Am,
  bounceIn: Fm,
  bounceInOut: Ym,
  bounceOut: yi
}, Mu = function(e) {
  if (Array.isArray(e)) {
    ht(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var r = Le(e, 4), t = r[0], n = r[1], o = r[2], i = r[3];
    return l7(t, n, o, i);
  } else if (typeof e == "string")
    return ht(bu[e] !== void 0, "Invalid easing type '".concat(e, "'")), bu[e];
  return e;
}, C7 = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, Du = function(e, r) {
  return e === "zIndex" ? !1 : !!(typeof r == "number" || Array.isArray(r) || typeof r == "string" && // It's animatable if we have a string
  Bt.test(r) && // And it contains numbers and/or colors
  !r.startsWith("url("));
}, wn = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, Io = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, _a = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, b7 = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, _u = {
  x: wn,
  y: wn,
  z: wn,
  rotate: wn,
  rotateX: wn,
  rotateY: wn,
  rotateZ: wn,
  scaleX: Io,
  scaleY: Io,
  scale: Io,
  opacity: _a,
  backgroundColor: _a,
  color: _a,
  default: Io
}, M7 = function(e, r) {
  var t;
  return eo(r) ? t = b7 : t = _u[e] || _u.default, Q({ to: r }, t(r));
}, D7 = Q(Q({}, s0), {
  // Color props
  color: Je,
  backgroundColor: Je,
  outlineColor: Je,
  fill: Je,
  stroke: Je,
  // Border props
  borderColor: Je,
  borderTopColor: Je,
  borderRightColor: Je,
  borderBottomColor: Je,
  borderLeftColor: Je,
  filter: ss,
  WebkitFilter: ss
}), cl = function(e) {
  return D7[e];
};
function ul(e, r) {
  var t, n = cl(e);
  return n !== ss && (n = Bt), (t = n.getAnimatableNone) === null || t === void 0 ? void 0 : t.call(n, r);
}
function _7(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var r = Ht(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(r).length;
}
var Eu = !1;
function E7(e) {
  var r = e.ease, t = e.times, n = e.yoyo, o = e.flip, i = e.loop, a = Ht(e, ["ease", "times", "yoyo", "flip", "loop"]), s = Q({}, a);
  return t && (s.offset = t), a.duration && (s.duration = Ci(a.duration)), a.repeatDelay && (s.repeatDelay = Ci(a.repeatDelay)), r && (s.ease = C7(r) ? r.map(Mu) : Mu(r)), a.type === "tween" && (s.type = "keyframes"), (n || i || o) && (uo(!Eu, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), Eu = !0, n ? s.repeatType = "reverse" : i ? s.repeatType = "loop" : o && (s.repeatType = "mirror"), s.repeat = i || n || o || a.repeat), a.type !== "spring" && (s.type = "keyframes"), s;
}
function I7(e, r) {
  var t, n, o = dl(e, r) || {};
  return (n = (t = o.delay) !== null && t !== void 0 ? t : e.delay) !== null && n !== void 0 ? n : 0;
}
function O7(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = bt([], Le(e.to), !1), e.to[0] = e.from), e;
}
function N7(e, r, t) {
  var n;
  return Array.isArray(r.to) && ((n = e.duration) !== null && n !== void 0 || (e.duration = 0.8)), O7(r), _7(e) || (e = Q(Q({}, e), M7(t, r.to))), Q(Q({}, r), E7(e));
}
function T7(e, r, t, n, o) {
  var i, a = dl(n, e), s = (i = a.from) !== null && i !== void 0 ? i : r.get(), l = Du(e, t);
  s === "none" && l && typeof t == "string" ? s = ul(e, t) : Iu(s) && typeof t == "string" ? s = Ou(t) : !Array.isArray(t) && Iu(t) && typeof s == "string" && (t = Ou(s));
  var c = Du(e, s);
  uo(c === l, "You are trying to animate ".concat(e, ' from "').concat(s, '" to "').concat(t, '". ').concat(s, " is not an animatable value - to enable this animation set ").concat(s, " to a value animatable to ").concat(t, " via the `style` property."));
  function u() {
    var h = {
      from: s,
      to: t,
      velocity: r.getVelocity(),
      onComplete: o,
      onUpdate: function(p) {
        return r.set(p);
      }
    };
    return a.type === "inertia" || a.type === "decay" ? t7(Q(Q({}, h), a)) : F0(Q(Q({}, N7(a, h, e)), { onUpdate: function(p) {
      var v;
      h.onUpdate(p), (v = a.onUpdate) === null || v === void 0 || v.call(a, p);
    }, onComplete: function() {
      var p;
      h.onComplete(), (p = a.onComplete) === null || p === void 0 || p.call(a);
    } }));
  }
  function d() {
    var h, p, v = m0(t);
    return r.set(v), o(), (h = a == null ? void 0 : a.onUpdate) === null || h === void 0 || h.call(a, v), (p = a == null ? void 0 : a.onComplete) === null || p === void 0 || p.call(a), { stop: function() {
    } };
  }
  return !c || !l || a.type === !1 ? d : u;
}
function Iu(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function Ou(e) {
  return typeof e == "number" ? 0 : ul("", e);
}
function dl(e, r) {
  return e[r] || e.default || e;
}
function fl(e, r, t, n) {
  return n === void 0 && (n = {}), r.start(function(o) {
    var i, a, s = T7(e, r, t, n, o), l = I7(n, e), c = function() {
      return a = s();
    };
    return l ? i = window.setTimeout(c, Ci(l)) : c(), function() {
      clearTimeout(i), a == null || a.stop();
    };
  });
}
var k7 = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, S7 = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function pl(e, r) {
  e.indexOf(r) === -1 && e.push(r);
}
function hl(e, r) {
  var t = e.indexOf(r);
  t > -1 && e.splice(t, 1);
}
var jr = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(r) {
      var t = this;
      return pl(this.subscriptions, r), function() {
        return hl(t.subscriptions, r);
      };
    }, e.prototype.notify = function(r, t, n) {
      var o = this.subscriptions.length;
      if (o)
        if (o === 1)
          this.subscriptions[0](r, t, n);
        else
          for (var i = 0; i < o; i++) {
            var a = this.subscriptions[i];
            a && a(r, t, n);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), R7 = function(e) {
  return !isNaN(parseFloat(e));
}, j7 = (
  /** @class */
  function() {
    function e(r) {
      var t = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new jr(), this.velocityUpdateSubscribers = new jr(), this.renderSubscribers = new jr(), this.canTrackVelocity = !1, this.updateAndNotify = function(n, o) {
        o === void 0 && (o = !0), t.prev = t.current, t.current = n;
        var i = wi(), a = i.delta, s = i.timestamp;
        t.lastUpdated !== s && (t.timeDelta = a, t.lastUpdated = s, Mt.postRender(t.scheduleVelocityCheck)), t.prev !== t.current && t.updateSubscribers.notify(t.current), t.velocityUpdateSubscribers.getSize() && t.velocityUpdateSubscribers.notify(t.getVelocity()), o && t.renderSubscribers.notify(t.current);
      }, this.scheduleVelocityCheck = function() {
        return Mt.postRender(t.velocityCheck);
      }, this.velocityCheck = function(n) {
        var o = n.timestamp;
        o !== t.lastUpdated && (t.prev = t.current, t.velocityUpdateSubscribers.notify(t.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = r, this.canTrackVelocity = R7(this.current);
    }
    return e.prototype.onChange = function(r) {
      return this.updateSubscribers.add(r);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(r) {
      return r(this.get()), this.renderSubscribers.add(r);
    }, e.prototype.attach = function(r) {
      this.passiveEffect = r;
    }, e.prototype.set = function(r, t) {
      t === void 0 && (t = !0), !t || !this.passiveEffect ? this.updateAndNotify(r, t) : this.passiveEffect(r, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        Y0(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(r) {
      var t = this;
      return this.stop(), new Promise(function(n) {
        t.hasAnimated = !0, t.stopAnimation = r(n);
      }).then(function() {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function cr(e) {
  return new j7(e);
}
var G0 = function(e) {
  return function(r) {
    return r.test(e);
  };
}, P7 = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, X0 = [Vn, ce, Lt, en, Dv, Mv, P7], _r = function(e) {
  return X0.find(G0(e));
}, A7 = bt(bt([], Le(X0), !1), [Je, Bt], !1), L7 = function(e) {
  return A7.find(G0(e));
};
function V7(e, r, t) {
  e.hasValue(r) ? e.getValue(r).set(t) : e.addValue(r, cr(t));
}
function H7(e, r) {
  var t = Hi(e, r), n = t ? e.makeTargetAnimatable(t, !1) : {}, o = n.transitionEnd, i = o === void 0 ? {} : o;
  n.transition;
  var a = Ht(n, ["transitionEnd", "transition"]);
  a = Q(Q({}, a), i);
  for (var s in a) {
    var l = m0(a[s]);
    V7(e, s, l);
  }
}
function F7(e, r, t) {
  var n, o, i, a, s = Object.keys(r).filter(function(p) {
    return !e.hasValue(p);
  }), l = s.length;
  if (l)
    for (var c = 0; c < l; c++) {
      var u = s[c], d = r[u], h = null;
      Array.isArray(d) && (h = d[0]), h === null && (h = (o = (n = t[u]) !== null && n !== void 0 ? n : e.readValue(u)) !== null && o !== void 0 ? o : r[u]), h != null && (typeof h == "string" && (k7(h) || S7(h)) ? h = parseFloat(h) : !L7(h) && Bt.test(d) && (h = ul(u, d)), e.addValue(u, cr(h)), (i = (a = t)[u]) !== null && i !== void 0 || (a[u] = h), e.setBaseTarget(u, h));
    }
}
function Y7(e, r) {
  if (r) {
    var t = r[e] || r.default || r;
    return t.from;
  }
}
function $7(e, r, t) {
  var n, o, i = {};
  for (var a in e)
    i[a] = (n = Y7(a, r)) !== null && n !== void 0 ? n : (o = t.getValue(a)) === null || o === void 0 ? void 0 : o.get();
  return i;
}
function z7(e, r, t) {
  t === void 0 && (t = {}), e.notifyAnimationStart(r);
  var n;
  if (Array.isArray(r)) {
    var o = r.map(function(a) {
      return vs(e, a, t);
    });
    n = Promise.all(o);
  } else if (typeof r == "string")
    n = vs(e, r, t);
  else {
    var i = typeof r == "function" ? Hi(e, r, t.custom) : r;
    n = J0(e, i, t);
  }
  return n.then(function() {
    return e.notifyAnimationComplete(r);
  });
}
function vs(e, r, t) {
  var n;
  t === void 0 && (t = {});
  var o = Hi(e, r, t.custom), i = (o || {}).transition, a = i === void 0 ? e.getDefaultTransition() || {} : i;
  t.transitionOverride && (a = t.transitionOverride);
  var s = o ? function() {
    return J0(e, o, t);
  } : function() {
    return Promise.resolve();
  }, l = !((n = e.variantChildren) === null || n === void 0) && n.size ? function(p) {
    p === void 0 && (p = 0);
    var v = a.delayChildren, m = v === void 0 ? 0 : v, y = a.staggerChildren, b = a.staggerDirection;
    return Z7(e, r, m + p, y, b, t);
  } : function() {
    return Promise.resolve();
  }, c = a.when;
  if (c) {
    var u = Le(c === "beforeChildren" ? [s, l] : [l, s], 2), d = u[0], h = u[1];
    return d().then(h);
  } else
    return Promise.all([s(), l(t.delay)]);
}
function J0(e, r, t) {
  var n, o = t === void 0 ? {} : t, i = o.delay, a = i === void 0 ? 0 : i, s = o.transitionOverride, l = o.type, c = e.makeTargetAnimatable(r), u = c.transition, d = u === void 0 ? e.getDefaultTransition() : u, h = c.transitionEnd, p = Ht(c, ["transition", "transitionEnd"]);
  s && (d = s);
  var v = [], m = l && ((n = e.animationState) === null || n === void 0 ? void 0 : n.getState()[l]);
  for (var y in p) {
    var b = e.getValue(y), g = p[y];
    if (!(!b || g === void 0 || m && B7(m, y))) {
      var w = Q({ delay: a }, d);
      e.shouldReduceMotion && ho(y) && (w = Q(Q({}, w), { type: !1, delay: 0 }));
      var x = fl(y, b, g, w);
      v.push(x);
    }
  }
  return Promise.all(v).then(function() {
    h && H7(e, h);
  });
}
function Z7(e, r, t, n, o, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 0), o === void 0 && (o = 1);
  var a = [], s = (e.variantChildren.size - 1) * n, l = o === 1 ? function(c) {
    return c === void 0 && (c = 0), c * n;
  } : function(c) {
    return c === void 0 && (c = 0), s - c * n;
  };
  return Array.from(e.variantChildren).sort(W7).forEach(function(c, u) {
    a.push(vs(c, r, Q(Q({}, i), { delay: t + l(u) })).then(function() {
      return c.notifyAnimationComplete(r);
    }));
  }), Promise.all(a);
}
function W7(e, r) {
  return e.sortNodePosition(r);
}
function B7(e, r) {
  var t = e.protectedKeys, n = e.needsAnimating, o = t.hasOwnProperty(r) && n[r] !== !0;
  return n[r] = !1, o;
}
var vl = [
  Te.Animate,
  Te.InView,
  Te.Focus,
  Te.Hover,
  Te.Tap,
  Te.Drag,
  Te.Exit
], U7 = bt([], Le(vl), !1).reverse(), K7 = vl.length;
function Q7(e) {
  return function(r) {
    return Promise.all(r.map(function(t) {
      var n = t.animation, o = t.options;
      return z7(e, n, o);
    }));
  };
}
function q7(e) {
  var r = Q7(e), t = X7(), n = {}, o = !0, i = function(u, d) {
    var h = Hi(e, d);
    if (h) {
      h.transition;
      var p = h.transitionEnd, v = Ht(h, ["transition", "transitionEnd"]);
      u = Q(Q(Q({}, u), v), p);
    }
    return u;
  };
  function a(u) {
    return n[u] !== void 0;
  }
  function s(u) {
    r = u(e);
  }
  function l(u, d) {
    for (var h, p = e.getProps(), v = e.getVariantContext(!0) || {}, m = [], y = /* @__PURE__ */ new Set(), b = {}, g = 1 / 0, w = function(E) {
      var _ = U7[E], R = t[_], H = (h = p[_]) !== null && h !== void 0 ? h : v[_], $ = yt(H), Y = _ === d ? R.isActive : null;
      Y === !1 && (g = E);
      var j = H === v[_] && H !== p[_] && $;
      if (j && o && e.manuallyAnimateOnMount && (j = !1), R.protectedKeys = Q({}, b), // If it isn't active and hasn't *just* been set as inactive
      !R.isActive && Y === null || // If we didn't and don't have any defined prop for this animation type
      !H && !R.prevProp || // Or if the prop doesn't define an animation
      el(H) || typeof H == "boolean")
        return "continue";
      var A = G7(R.prevProp, H), W = A || // If we're making this variant active, we want to always make it active
      _ === d && R.isActive && !j && $ || // If we removed a higher-priority variant (i is in reverse order)
      E > g && $, U = Array.isArray(H) ? H : [H], Z = U.reduce(i, {});
      Y === !1 && (Z = {});
      var J = R.prevResolvedValues, le = J === void 0 ? {} : J, z = Q(Q({}, le), Z), F = function(P) {
        W = !0, y.delete(P), R.needsAnimating[P] = !0;
      };
      for (var L in z) {
        var N = Z[L], I = le[L];
        b.hasOwnProperty(L) || (N !== I ? eo(N) && eo(I) ? !q0(N, I) || A ? F(L) : R.protectedKeys[L] = !0 : N !== void 0 ? F(L) : y.add(L) : N !== void 0 && y.has(L) ? F(L) : R.protectedKeys[L] = !0);
      }
      R.prevProp = H, R.prevResolvedValues = Z, R.isActive && (b = Q(Q({}, b), Z)), o && e.blockInitialAnimation && (W = !1), W && !j && m.push.apply(m, bt([], Le(U.map(function(P) {
        return {
          animation: P,
          options: Q({ type: _ }, u)
        };
      })), !1));
    }, x = 0; x < K7; x++)
      w(x);
    if (n = Q({}, b), y.size) {
      var C = {};
      y.forEach(function(E) {
        var _ = e.getBaseTarget(E);
        _ !== void 0 && (C[E] = _);
      }), m.push({ animation: C });
    }
    var O = !!m.length;
    return o && p.initial === !1 && !e.manuallyAnimateOnMount && (O = !1), o = !1, O ? r(m) : Promise.resolve();
  }
  function c(u, d, h) {
    var p;
    if (t[u].isActive === d)
      return Promise.resolve();
    (p = e.variantChildren) === null || p === void 0 || p.forEach(function(y) {
      var b;
      return (b = y.animationState) === null || b === void 0 ? void 0 : b.setActive(u, d);
    }), t[u].isActive = d;
    var v = l(h, u);
    for (var m in t)
      t[m].protectedKeys = {};
    return v;
  }
  return {
    isAnimated: a,
    animateChanges: l,
    setActive: c,
    setAnimateFunction: s,
    getState: function() {
      return t;
    }
  };
}
function G7(e, r) {
  return typeof r == "string" ? r !== e : Ud(r) ? !q0(r, e) : !1;
}
function xn(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function X7() {
  var e;
  return e = {}, e[Te.Animate] = xn(!0), e[Te.InView] = xn(), e[Te.Hover] = xn(), e[Te.Tap] = xn(), e[Te.Drag] = xn(), e[Te.Focus] = xn(), e[Te.Exit] = xn(), e;
}
var J7 = {
  animation: ln(function(e) {
    var r = e.visualElement, t = e.animate;
    r.animationState || (r.animationState = q7(r)), el(t) && fe(function() {
      return t.subscribe(r);
    }, [t]);
  }),
  exit: ln(function(e) {
    var r = e.custom, t = e.visualElement, n = Le(Q0(), 2), o = n[0], i = n[1], a = ze(fo);
    fe(function() {
      var s, l;
      t.isPresent = o;
      var c = (s = t.animationState) === null || s === void 0 ? void 0 : s.setActive(Te.Exit, !o, { custom: (l = a == null ? void 0 : a.custom) !== null && l !== void 0 ? l : r });
      !o && (c == null || c.then(i));
    }, [o]);
  })
}, ef = (
  /** @class */
  function() {
    function e(r, t, n) {
      var o = this, i = n === void 0 ? {} : n, a = i.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (o.lastMoveEvent && o.lastMoveEventInfo) {
          var h = Ia(o.lastMoveEventInfo, o.history), p = o.startEvent !== null, v = $0(h.offset, { x: 0, y: 0 }) >= 3;
          if (!(!p && !v)) {
            var m = h.point, y = wi().timestamp;
            o.history.push(Q(Q({}, m), { timestamp: y }));
            var b = o.handlers, g = b.onStart, w = b.onMove;
            p || (g && g(o.lastMoveEvent, h), o.startEvent = o.lastMoveEvent), w && w(o.lastMoveEvent, h);
          }
        }
      }, this.handlePointerMove = function(h, p) {
        if (o.lastMoveEvent = h, o.lastMoveEventInfo = Ea(p, o.transformPagePoint), y0(h) && h.buttons === 0) {
          o.handlePointerUp(h, p);
          return;
        }
        Mt.update(o.updatePoint, !0);
      }, this.handlePointerUp = function(h, p) {
        o.end();
        var v = o.handlers, m = v.onEnd, y = v.onSessionEnd, b = Ia(Ea(p, o.transformPagePoint), o.history);
        o.startEvent && m && m(h, b), y && y(h, b);
      }, !(w0(r) && r.touches.length > 1)) {
        this.handlers = t, this.transformPagePoint = a;
        var s = tl(r), l = Ea(s, this.transformPagePoint), c = l.point, u = wi().timestamp;
        this.history = [Q(Q({}, c), { timestamp: u })];
        var d = t.onSessionStart;
        d && d(r, Ia(l, this.history)), this.removeListeners = $i(rr(window, "pointermove", this.handlePointerMove), rr(window, "pointerup", this.handlePointerUp), rr(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(r) {
      this.handlers = r;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), lr.update(this.updatePoint);
    }, e;
  }()
);
function Ea(e, r) {
  return r ? { point: r(e.point) } : e;
}
function Nu(e, r) {
  return { x: e.x - r.x, y: e.y - r.y };
}
function Ia(e, r) {
  var t = e.point;
  return {
    point: t,
    delta: Nu(t, tf(r)),
    offset: Nu(t, eg(r)),
    velocity: tg(r, 0.1)
  };
}
function eg(e) {
  return e[0];
}
function tf(e) {
  return e[e.length - 1];
}
function tg(e, r) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var t = e.length - 1, n = null, o = tf(e); t >= 0 && (n = e[t], !(o.timestamp - n.timestamp > Ci(r))); )
    t--;
  if (!n)
    return { x: 0, y: 0 };
  var i = (o.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var a = {
    x: (o.x - n.x) / i,
    y: (o.y - n.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function Ut(e) {
  return e.max - e.min;
}
function Tu(e, r, t) {
  return r === void 0 && (r = 0), t === void 0 && (t = 0.01), $0(e, r) < t;
}
function ku(e, r, t, n) {
  n === void 0 && (n = 0.5), e.origin = n, e.originPoint = Ve(r.min, r.max, e.origin), e.scale = Ut(t) / Ut(r), (Tu(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Ve(t.min, t.max, e.origin) - e.originPoint, (Tu(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Pr(e, r, t, n) {
  ku(e.x, r.x, t.x, n == null ? void 0 : n.originX), ku(e.y, r.y, t.y, n == null ? void 0 : n.originY);
}
function Su(e, r, t) {
  e.min = t.min + r.min, e.max = e.min + Ut(r);
}
function ng(e, r, t) {
  Su(e.x, r.x, t.x), Su(e.y, r.y, t.y);
}
function Ru(e, r, t) {
  e.min = r.min - t.min, e.max = e.min + Ut(r);
}
function Ar(e, r, t) {
  Ru(e.x, r.x, t.x), Ru(e.y, r.y, t.y);
}
function rg(e, r, t) {
  var n = r.min, o = r.max;
  return n !== void 0 && e < n ? e = t ? Ve(n, e, t.min) : Math.max(e, n) : o !== void 0 && e > o && (e = t ? Ve(o, e, t.max) : Math.min(e, o)), e;
}
function ju(e, r, t) {
  return {
    min: r !== void 0 ? e.min + r : void 0,
    max: t !== void 0 ? e.max + t - (e.max - e.min) : void 0
  };
}
function og(e, r) {
  var t = r.top, n = r.left, o = r.bottom, i = r.right;
  return {
    x: ju(e.x, n, i),
    y: ju(e.y, t, o)
  };
}
function Pu(e, r) {
  var t, n = r.min - e.min, o = r.max - e.max;
  return r.max - r.min < e.max - e.min && (t = Le([o, n], 2), n = t[0], o = t[1]), { min: n, max: o };
}
function ig(e, r) {
  return {
    x: Pu(e.x, r.x),
    y: Pu(e.y, r.y)
  };
}
function ag(e, r) {
  var t = 0.5, n = Ut(e), o = Ut(r);
  return o > n ? t = to(r.min, r.max - n, e.min) : n > o && (t = to(e.min, e.max - o, r.min)), gi(0, 1, t);
}
function sg(e, r) {
  var t = {};
  return r.min !== void 0 && (t.min = r.min - e.min), r.max !== void 0 && (t.max = r.max - e.min), t;
}
var ms = 0.35;
function lg(e) {
  return e === void 0 && (e = ms), e === !1 ? e = 0 : e === !0 && (e = ms), {
    x: Au(e, "left", "right"),
    y: Au(e, "top", "bottom")
  };
}
function Au(e, r, t) {
  return {
    min: Lu(e, r),
    max: Lu(e, t)
  };
}
function Lu(e, r) {
  var t;
  return typeof e == "number" ? e : (t = e[r]) !== null && t !== void 0 ? t : 0;
}
var Vu = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, Lr = function() {
  return {
    x: Vu(),
    y: Vu()
  };
}, Hu = function() {
  return { min: 0, max: 0 };
}, Ge = function() {
  return {
    x: Hu(),
    y: Hu()
  };
};
function Tt(e) {
  return [e("x"), e("y")];
}
function nf(e) {
  var r = e.top, t = e.left, n = e.right, o = e.bottom;
  return {
    x: { min: t, max: n },
    y: { min: r, max: o }
  };
}
function cg(e) {
  var r = e.x, t = e.y;
  return { top: t.min, right: r.max, bottom: t.max, left: r.min };
}
function ug(e, r) {
  if (!r)
    return e;
  var t = r({ x: e.left, y: e.top }), n = r({ x: e.right, y: e.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: n.y,
    right: n.x
  };
}
function Oa(e) {
  return e === void 0 || e === 1;
}
function rf(e) {
  var r = e.scale, t = e.scaleX, n = e.scaleY;
  return !Oa(r) || !Oa(t) || !Oa(n);
}
function tn(e) {
  return rf(e) || Fu(e.x) || Fu(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function Fu(e) {
  return e && e !== "0%";
}
function bi(e, r, t) {
  var n = e - t, o = r * n;
  return t + o;
}
function Yu(e, r, t, n, o) {
  return o !== void 0 && (e = bi(e, o, n)), bi(e, t, n) + r;
}
function gs(e, r, t, n, o) {
  r === void 0 && (r = 0), t === void 0 && (t = 1), e.min = Yu(e.min, r, t, n, o), e.max = Yu(e.max, r, t, n, o);
}
function of(e, r) {
  var t = r.x, n = r.y;
  gs(e.x, t.translate, t.scale, t.originPoint), gs(e.y, n.translate, n.scale, n.originPoint);
}
function dg(e, r, t, n) {
  var o, i;
  n === void 0 && (n = !1);
  var a = t.length;
  if (a) {
    r.x = r.y = 1;
    for (var s, l, c = 0; c < a; c++)
      s = t[c], l = s.projectionDelta, ((i = (o = s.instance) === null || o === void 0 ? void 0 : o.style) === null || i === void 0 ? void 0 : i.display) !== "contents" && (n && s.options.layoutScroll && s.scroll && s !== s.root && Jn(e, { x: -s.scroll.x, y: -s.scroll.y }), l && (r.x *= l.x.scale, r.y *= l.y.scale, of(e, l)), n && tn(s.latestValues) && Jn(e, s.latestValues));
  }
}
function rn(e, r) {
  e.min = e.min + r, e.max = e.max + r;
}
function $u(e, r, t) {
  var n = Le(t, 3), o = n[0], i = n[1], a = n[2], s = r[a] !== void 0 ? r[a] : 0.5, l = Ve(e.min, e.max, s);
  gs(e, r[o], r[i], l, r.scale);
}
var fg = ["x", "scaleX", "originX"], pg = ["y", "scaleY", "originY"];
function Jn(e, r) {
  $u(e.x, r, fg), $u(e.y, r, pg);
}
function af(e, r) {
  return nf(ug(e.getBoundingClientRect(), r));
}
function hg(e, r, t) {
  var n = af(e, t), o = r.scroll;
  return o && (rn(n.x, o.x), rn(n.y, o.y)), n;
}
var vg = /* @__PURE__ */ new WeakMap(), mg = (
  /** @class */
  function() {
    function e(r) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Ge(), this.visualElement = r;
    }
    return e.prototype.start = function(r, t) {
      var n = this, o = t === void 0 ? {} : t, i = o.snapToCursor, a = i === void 0 ? !1 : i;
      if (this.visualElement.isPresent !== !1) {
        var s = function(d) {
          n.stopAnimation(), a && n.snapToCursor(tl(d, "page").point);
        }, l = function(d, h) {
          var p, v = n.getProps(), m = v.drag, y = v.dragPropagation, b = v.onDragStart;
          m && !y && (n.openGlobalLock && n.openGlobalLock(), n.openGlobalLock = M0(m), !n.openGlobalLock) || (n.isDragging = !0, n.currentDirection = null, n.resolveConstraints(), n.visualElement.projection && (n.visualElement.projection.isAnimationBlocked = !0, n.visualElement.projection.target = void 0), Tt(function(g) {
            var w, x, C = n.getAxisMotionValue(g).get() || 0;
            if (Lt.test(C)) {
              var O = (x = (w = n.visualElement.projection) === null || w === void 0 ? void 0 : w.layout) === null || x === void 0 ? void 0 : x.actual[g];
              if (O) {
                var E = Ut(O);
                C = E * (parseFloat(C) / 100);
              }
            }
            n.originPoint[g] = C;
          }), b == null || b(d, h), (p = n.visualElement.animationState) === null || p === void 0 || p.setActive(Te.Drag, !0));
        }, c = function(d, h) {
          var p = n.getProps(), v = p.dragPropagation, m = p.dragDirectionLock, y = p.onDirectionLock, b = p.onDrag;
          if (!(!v && !n.openGlobalLock)) {
            var g = h.offset;
            if (m && n.currentDirection === null) {
              n.currentDirection = gg(g), n.currentDirection !== null && (y == null || y(n.currentDirection));
              return;
            }
            n.updateAxis("x", h.point, g), n.updateAxis("y", h.point, g), n.visualElement.syncRender(), b == null || b(d, h);
          }
        }, u = function(d, h) {
          return n.stop(d, h);
        };
        this.panSession = new ef(r, {
          onSessionStart: s,
          onStart: l,
          onMove: c,
          onSessionEnd: u
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(r, t) {
      var n = this.isDragging;
      if (this.cancel(), !!n) {
        var o = t.velocity;
        this.startAnimation(o);
        var i = this.getProps().onDragEnd;
        i == null || i(r, t);
      }
    }, e.prototype.cancel = function() {
      var r, t;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (r = this.panSession) === null || r === void 0 || r.end(), this.panSession = void 0;
      var n = this.getProps().dragPropagation;
      !n && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (t = this.visualElement.animationState) === null || t === void 0 || t.setActive(Te.Drag, !1);
    }, e.prototype.updateAxis = function(r, t, n) {
      var o = this.getProps().drag;
      if (!(!n || !Oo(r, o, this.currentDirection))) {
        var i = this.getAxisMotionValue(r), a = this.originPoint[r] + n[r];
        this.constraints && this.constraints[r] && (a = rg(a, this.constraints[r], this.elastic[r])), i.set(a);
      }
    }, e.prototype.resolveConstraints = function() {
      var r = this, t = this.getProps(), n = t.dragConstraints, o = t.dragElastic, i = (this.visualElement.projection || {}).layout, a = this.constraints;
      n && Xn(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = og(i.actual, n) : this.constraints = !1, this.elastic = lg(o), a !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Tt(function(s) {
        r.getAxisMotionValue(s) && (r.constraints[s] = sg(i.actual[s], r.constraints[s]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var r = this.getProps(), t = r.dragConstraints, n = r.onMeasureDragConstraints;
      if (!t || !Xn(t))
        return !1;
      var o = t.current;
      ht(o !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var i = this.visualElement.projection;
      if (!i || !i.layout)
        return !1;
      var a = hg(o, i.root, this.visualElement.getTransformPagePoint()), s = ig(i.layout.actual, a);
      if (n) {
        var l = n(cg(s));
        this.hasMutatedConstraints = !!l, l && (s = nf(l));
      }
      return s;
    }, e.prototype.startAnimation = function(r) {
      var t = this, n = this.getProps(), o = n.drag, i = n.dragMomentum, a = n.dragElastic, s = n.dragTransition, l = n.dragSnapToOrigin, c = n.onDragTransitionEnd, u = this.constraints || {}, d = Tt(function(h) {
        var p;
        if (Oo(h, o, t.currentDirection)) {
          var v = (p = u == null ? void 0 : u[h]) !== null && p !== void 0 ? p : {};
          l && (v = { min: 0, max: 0 });
          var m = a ? 200 : 1e6, y = a ? 40 : 1e7, b = Q(Q({ type: "inertia", velocity: i ? r[h] : 0, bounceStiffness: m, bounceDamping: y, timeConstant: 750, restDelta: 1, restSpeed: 10 }, s), v);
          return t.startAxisValueAnimation(h, b);
        }
      });
      return Promise.all(d).then(c);
    }, e.prototype.startAxisValueAnimation = function(r, t) {
      var n = this.getAxisMotionValue(r);
      return fl(r, n, 0, t);
    }, e.prototype.stopAnimation = function() {
      var r = this;
      Tt(function(t) {
        return r.getAxisMotionValue(t).stop();
      });
    }, e.prototype.getAxisMotionValue = function(r) {
      var t, n, o = "_drag" + r.toUpperCase(), i = this.visualElement.getProps()[o];
      return i || this.visualElement.getValue(r, (n = (t = this.visualElement.getProps().initial) === null || t === void 0 ? void 0 : t[r]) !== null && n !== void 0 ? n : 0);
    }, e.prototype.snapToCursor = function(r) {
      var t = this;
      Tt(function(n) {
        var o = t.getProps().drag;
        if (Oo(n, o, t.currentDirection)) {
          var i = t.visualElement.projection, a = t.getAxisMotionValue(n);
          if (i && i.layout) {
            var s = i.layout.actual[n], l = s.min, c = s.max;
            a.set(r[n] - Ve(l, c, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var r = this, t, n = this.getProps(), o = n.drag, i = n.dragConstraints, a = this.visualElement.projection;
      if (!(!Xn(i) || !a || !this.constraints)) {
        this.stopAnimation();
        var s = { x: 0, y: 0 };
        Tt(function(c) {
          var u = r.getAxisMotionValue(c);
          if (u) {
            var d = u.get();
            s[c] = ag({ min: d, max: d }, r.constraints[c]);
          }
        });
        var l = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = l ? l({}, "") : "none", (t = a.root) === null || t === void 0 || t.updateScroll(), a.updateLayout(), this.resolveConstraints(), Tt(function(c) {
          if (Oo(c, o, null)) {
            var u = r.getAxisMotionValue(c), d = r.constraints[c], h = d.min, p = d.max;
            u.set(Ve(h, p, s[c]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var r = this, t;
      vg.set(this.visualElement, this);
      var n = this.visualElement.getInstance(), o = rr(n, "pointerdown", function(c) {
        var u = r.getProps(), d = u.drag, h = u.dragListener, p = h === void 0 ? !0 : h;
        d && p && r.start(c);
      }), i = function() {
        var c = r.getProps().dragConstraints;
        Xn(c) && (r.constraints = r.resolveRefConstraints());
      }, a = this.visualElement.projection, s = a.addEventListener("measure", i);
      a && !a.layout && ((t = a.root) === null || t === void 0 || t.updateScroll(), a.updateLayout()), i();
      var l = Yi(window, "resize", function() {
        return r.scalePositionWithinConstraints();
      });
      return a.addEventListener("didUpdate", function(c) {
        var u = c.delta, d = c.hasLayoutChanged;
        r.isDragging && d && (Tt(function(h) {
          var p = r.getAxisMotionValue(h);
          p && (r.originPoint[h] += u[h].translate, p.set(p.get() + u[h].translate));
        }), r.visualElement.syncRender());
      }), function() {
        l(), o(), s();
      };
    }, e.prototype.getProps = function() {
      var r = this.visualElement.getProps(), t = r.drag, n = t === void 0 ? !1 : t, o = r.dragDirectionLock, i = o === void 0 ? !1 : o, a = r.dragPropagation, s = a === void 0 ? !1 : a, l = r.dragConstraints, c = l === void 0 ? !1 : l, u = r.dragElastic, d = u === void 0 ? ms : u, h = r.dragMomentum, p = h === void 0 ? !0 : h;
      return Q(Q({}, r), { drag: n, dragDirectionLock: i, dragPropagation: s, dragConstraints: c, dragElastic: d, dragMomentum: p });
    }, e;
  }()
);
function Oo(e, r, t) {
  return (r === !0 || r === e) && (t === null || t === e);
}
function gg(e, r) {
  r === void 0 && (r = 10);
  var t = null;
  return Math.abs(e.y) > r ? t = "y" : Math.abs(e.x) > r && (t = "x"), t;
}
function yg(e) {
  var r = e.dragControls, t = e.visualElement, n = po(function() {
    return new mg(t);
  });
  fe(function() {
    return r && r.subscribe(n);
  }, [n, r]), fe(function() {
    return n.addListeners();
  }, [n]);
}
function wg(e) {
  var r = e.onPan, t = e.onPanStart, n = e.onPanEnd, o = e.onPanSessionStart, i = e.visualElement, a = r || t || n || o, s = me(null), l = ze(Us).transformPagePoint, c = {
    onSessionStart: o,
    onStart: t,
    onMove: r,
    onEnd: function(d, h) {
      s.current = null, n && n(d, h);
    }
  };
  fe(function() {
    s.current !== null && s.current.updateHandlers(c);
  });
  function u(d) {
    s.current = new ef(d, c, {
      transformPagePoint: l
    });
  }
  mi(i, "pointerdown", a && u), nl(function() {
    return s.current && s.current.end();
  });
}
var xg = {
  pan: ln(wg),
  drag: ln(yg)
}, No = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function Cg() {
  var e = No.map(function() {
    return new jr();
  }), r = {}, t = {
    clearAllListeners: function() {
      return e.forEach(function(n) {
        return n.clear();
      });
    },
    updatePropListeners: function(n) {
      No.forEach(function(o) {
        var i, a = "on" + o, s = n[a];
        (i = r[o]) === null || i === void 0 || i.call(r), s && (r[o] = t[a](s));
      });
    }
  };
  return e.forEach(function(n, o) {
    t["on" + No[o]] = function(i) {
      return n.add(i);
    }, t["notify" + No[o]] = function() {
      for (var i = [], a = 0; a < arguments.length; a++)
        i[a] = arguments[a];
      return n.notify.apply(n, bt([], Le(i), !1));
    };
  }), t;
}
function bg(e, r, t) {
  var n;
  for (var o in r) {
    var i = r[o], a = t[o];
    if (Wt(i))
      e.addValue(o, i), process.env.NODE_ENV === "development" && U0(i.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(i.version, " with 6.5.1 may not work as expected."));
    else if (Wt(a))
      e.addValue(o, cr(i));
    else if (a !== i)
      if (e.hasValue(o)) {
        var s = e.getValue(o);
        !s.hasAnimated && s.set(i);
      } else
        e.addValue(o, cr((n = e.getStaticValue(o)) !== null && n !== void 0 ? n : i));
  }
  for (var o in t)
    r[o] === void 0 && e.removeValue(o);
  return r;
}
var sf = function(e) {
  var r = e.treeType, t = r === void 0 ? "" : r, n = e.build, o = e.getBaseTarget, i = e.makeTargetAnimatable, a = e.measureViewportBox, s = e.render, l = e.readValueFromInstance, c = e.removeValueFromRenderState, u = e.sortNodePosition, d = e.scrapeMotionValuesFromProps;
  return function(h, p) {
    var v = h.parent, m = h.props, y = h.presenceId, b = h.blockInitialAnimation, g = h.visualState, w = h.shouldReduceMotion;
    p === void 0 && (p = {});
    var x = !1, C = g.latestValues, O = g.renderState, E, _ = Cg(), R = /* @__PURE__ */ new Map(), H = /* @__PURE__ */ new Map(), $ = {}, Y = Q({}, C), j;
    function A() {
      !E || !x || (W(), s(E, O, m.style, N.projection));
    }
    function W() {
      n(N, O, C, p, m);
    }
    function U() {
      _.notifyUpdate(C);
    }
    function Z(I, P) {
      var B = P.onChange(function(te) {
        C[I] = te, m.onUpdate && Mt.update(U, !1, !0);
      }), ee = P.onRenderRequest(N.scheduleRender);
      H.set(I, function() {
        B(), ee();
      });
    }
    var J = d(m);
    for (var le in J) {
      var z = J[le];
      C[le] !== void 0 && Wt(z) && z.set(C[le], !1);
    }
    var F = Fi(m), L = Qd(m), N = Q(Q({
      treeType: t,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: v ? v.depth + 1 : 0,
      parent: v,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: y,
      shouldReduceMotion: w,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: L ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(v != null && v.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: b,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!E;
      },
      mount: function(I) {
        x = !0, E = N.current = I, N.projection && N.projection.mount(I), L && v && !F && (j = v == null ? void 0 : v.addVariantChild(N)), R.forEach(function(P, B) {
          return Z(B, P);
        }), v == null || v.children.add(N), N.setProps(m);
      },
      /**
       *
       */
      unmount: function() {
        var I;
        (I = N.projection) === null || I === void 0 || I.unmount(), lr.update(U), lr.render(A), H.forEach(function(P) {
          return P();
        }), j == null || j(), v == null || v.children.delete(N), _.clearAllListeners(), E = void 0, x = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(I) {
        var P, B = N.getClosestVariantNode();
        if (B)
          return (P = B.variantChildren) === null || P === void 0 || P.add(I), function() {
            return B.variantChildren.delete(I);
          };
      },
      sortNodePosition: function(I) {
        return !u || t !== I.treeType ? 0 : u(N.getInstance(), I.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return L ? N : v == null ? void 0 : v.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return m.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return E;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(I) {
        return C[I];
      },
      setStaticValue: function(I, P) {
        return C[I] = P;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return C;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(I) {
        N.isVisible !== I && (N.isVisible = I, N.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(I, P) {
        return P === void 0 && (P = !0), i(N, I, m, P);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return a(E, m);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(I, P) {
        N.hasValue(I) && N.removeValue(I), R.set(I, P), C[I] = P.get(), Z(I, P);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(I) {
        var P;
        R.delete(I), (P = H.get(I)) === null || P === void 0 || P(), H.delete(I), delete C[I], c(I, O);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(I) {
        return R.has(I);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(I, P) {
        var B = R.get(I);
        return B === void 0 && P !== void 0 && (B = cr(P), N.addValue(I, B)), B;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(I) {
        return R.forEach(I);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(I) {
        var P;
        return (P = C[I]) !== null && P !== void 0 ? P : l(E, I, p);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(I, P) {
        Y[I] = P;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(I) {
        if (o) {
          var P = o(m, I);
          if (P !== void 0 && !Wt(P))
            return P;
        }
        return Y[I];
      }
    }, _), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return W(), O;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        Mt.render(A, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: A,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(I) {
        (I.transformTemplate || m.transformTemplate) && N.scheduleRender(), m = I, _.updatePropListeners(I), $ = bg(N, d(m), $);
      },
      getProps: function() {
        return m;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(I) {
        var P;
        return (P = m.variants) === null || P === void 0 ? void 0 : P[I];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return m.transition;
      },
      getTransformPagePoint: function() {
        return m.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(I) {
        if (I === void 0 && (I = !1), I)
          return v == null ? void 0 : v.getVariantContext();
        if (!F) {
          var P = (v == null ? void 0 : v.getVariantContext()) || {};
          return m.initial !== void 0 && (P.initial = m.initial), P;
        }
        for (var B = {}, ee = 0; ee < Mg; ee++) {
          var te = lf[ee], ae = m[te];
          (yt(ae) || ae === !1) && (B[te] = ae);
        }
        return B;
      }
    });
    return N;
  };
}, lf = bt(["initial"], Le(vl), !1), Mg = lf.length;
function ys(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var cf = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Dg(e) {
  var r = cf.exec(e);
  if (!r)
    return [,];
  var t = Le(r, 3), n = t[1], o = t[2];
  return [n, o];
}
var _g = 4;
function ws(e, r, t) {
  t === void 0 && (t = 1), ht(t <= _g, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var n = Le(Dg(e), 2), o = n[0], i = n[1];
  if (o) {
    var a = window.getComputedStyle(r).getPropertyValue(o);
    return a ? a.trim() : ys(i) ? ws(i, r, t + 1) : i;
  }
}
function Eg(e, r, t) {
  var n, o = Ht(r, []), i = e.getInstance();
  if (!(i instanceof Element))
    return { target: o, transitionEnd: t };
  t && (t = Q({}, t)), e.forEachValue(function(c) {
    var u = c.get();
    if (ys(u)) {
      var d = ws(u, i);
      d && c.set(d);
    }
  });
  for (var a in o) {
    var s = o[a];
    if (ys(s)) {
      var l = ws(s, i);
      l && (o[a] = l, t && ((n = t[a]) !== null && n !== void 0 || (t[a] = s)));
    }
  }
  return { target: o, transitionEnd: t };
}
var Ig = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), uf = function(e) {
  return Ig.has(e);
}, Og = function(e) {
  return Object.keys(e).some(uf);
}, df = function(e, r) {
  e.set(r, !1), e.set(r);
}, To = function(e) {
  return e === Vn || e === ce;
}, zu;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(zu || (zu = {}));
var Zu = function(e, r) {
  return parseFloat(e.split(", ")[r]);
}, Wu = function(e, r) {
  return function(t, n) {
    var o = n.transform;
    if (o === "none" || !o)
      return 0;
    var i = o.match(/^matrix3d\((.+)\)$/);
    if (i)
      return Zu(i[1], r);
    var a = o.match(/^matrix\((.+)\)$/);
    return a ? Zu(a[1], e) : 0;
  };
}, Ng = /* @__PURE__ */ new Set(["x", "y", "z"]), Tg = Xr.filter(function(e) {
  return !Ng.has(e);
});
function kg(e) {
  var r = [];
  return Tg.forEach(function(t) {
    var n = e.getValue(t);
    n !== void 0 && (r.push([t, n.get()]), n.set(t.startsWith("scale") ? 1 : 0));
  }), r.length && e.syncRender(), r;
}
var Bu = {
  // Dimensions
  width: function(e, r) {
    var t = e.x, n = r.paddingLeft, o = n === void 0 ? "0" : n, i = r.paddingRight, a = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(o) - parseFloat(a);
  },
  height: function(e, r) {
    var t = e.y, n = r.paddingTop, o = n === void 0 ? "0" : n, i = r.paddingBottom, a = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(o) - parseFloat(a);
  },
  top: function(e, r) {
    var t = r.top;
    return parseFloat(t);
  },
  left: function(e, r) {
    var t = r.left;
    return parseFloat(t);
  },
  bottom: function(e, r) {
    var t = e.y, n = r.top;
    return parseFloat(n) + (t.max - t.min);
  },
  right: function(e, r) {
    var t = e.x, n = r.left;
    return parseFloat(n) + (t.max - t.min);
  },
  // Transform
  x: Wu(4, 13),
  y: Wu(5, 14)
}, Sg = function(e, r, t) {
  var n = r.measureViewportBox(), o = r.getInstance(), i = getComputedStyle(o), a = i.display, s = {};
  a === "none" && r.setStaticValue("display", e.display || "block"), t.forEach(function(c) {
    s[c] = Bu[c](n, i);
  }), r.syncRender();
  var l = r.measureViewportBox();
  return t.forEach(function(c) {
    var u = r.getValue(c);
    df(u, s[c]), e[c] = Bu[c](l, i);
  }), e;
}, Rg = function(e, r, t, n) {
  t === void 0 && (t = {}), n === void 0 && (n = {}), r = Q({}, r), n = Q({}, n);
  var o = Object.keys(r).filter(uf), i = [], a = !1, s = [];
  if (o.forEach(function(u) {
    var d = e.getValue(u);
    if (e.hasValue(u)) {
      var h = t[u], p = _r(h), v = r[u], m;
      if (eo(v)) {
        var y = v.length, b = v[0] === null ? 1 : 0;
        h = v[b], p = _r(h);
        for (var g = b; g < y; g++)
          m ? ht(_r(v[g]) === m, "All keyframes must be of the same type") : (m = _r(v[g]), ht(m === p || To(p) && To(m), "Keyframes must be of the same dimension as the current value"));
      } else
        m = _r(v);
      if (p !== m)
        if (To(p) && To(m)) {
          var w = d.get();
          typeof w == "string" && d.set(parseFloat(w)), typeof v == "string" ? r[u] = parseFloat(v) : Array.isArray(v) && m === ce && (r[u] = v.map(parseFloat));
        } else
          p != null && p.transform && (m != null && m.transform) && (h === 0 || v === 0) ? h === 0 ? d.set(m.transform(h)) : r[u] = p.transform(v) : (a || (i = kg(e), a = !0), s.push(u), n[u] = n[u] !== void 0 ? n[u] : r[u], df(d, v));
    }
  }), s.length) {
    var l = s.indexOf("height") >= 0 ? window.pageYOffset : null, c = Sg(r, e, s);
    return i.length && i.forEach(function(u) {
      var d = Le(u, 2), h = d[0], p = d[1];
      e.getValue(h).set(p);
    }), e.syncRender(), l !== null && window.scrollTo({ top: l }), { target: c, transitionEnd: n };
  } else
    return { target: r, transitionEnd: n };
};
function jg(e, r, t, n) {
  return Og(r) ? Rg(e, r, t, n) : { target: r, transitionEnd: n };
}
var Pg = function(e, r, t, n) {
  var o = Eg(e, r, n);
  return r = o.target, n = o.transitionEnd, jg(e, r, t, n);
};
function Ag(e) {
  return window.getComputedStyle(e);
}
var ff = {
  treeType: "dom",
  readValueFromInstance: function(e, r) {
    if (ho(r)) {
      var t = cl(r);
      return t && t.default || 0;
    } else {
      var n = Ag(e);
      return (Jd(r) ? n.getPropertyValue(r) : n[r]) || 0;
    }
  },
  sortNodePosition: function(e, r) {
    return e.compareDocumentPosition(r) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, r) {
    var t;
    return (t = e.style) === null || t === void 0 ? void 0 : t[r];
  },
  measureViewportBox: function(e, r) {
    var t = r.transformPagePoint;
    return af(e, t);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, r, t) {
    var n = t.transformTemplate;
    r.style.transform = n ? n({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, r) {
    e.style.transform = r.style.transform;
  },
  removeValueFromRenderState: function(e, r) {
    var t = r.vars, n = r.style;
    delete t[e], delete n[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, r, t, n) {
    var o = t.transformValues;
    n === void 0 && (n = !0);
    var i = r.transition, a = r.transitionEnd, s = Ht(r, ["transition", "transitionEnd"]), l = $7(s, i || {}, e);
    if (o && (a && (a = o(a)), s && (s = o(s)), l && (l = o(l))), n) {
      F7(e, s, l);
      var c = Pg(e, s, l, a);
      a = c.transitionEnd, s = c.target;
    }
    return Q({ transition: i, transitionEnd: a }, s);
  },
  scrapeMotionValuesFromProps: Js,
  build: function(e, r, t, n, o) {
    e.isVisible !== void 0 && (r.style.visibility = e.isVisible ? "visible" : "hidden"), qs(r, t, n, o.transformTemplate);
  },
  render: f0
}, Lg = sf(ff), Vg = sf(Q(Q({}, ff), { getBaseTarget: function(e, r) {
  return e[r];
}, readValueFromInstance: function(e, r) {
  var t;
  return ho(r) ? ((t = cl(r)) === null || t === void 0 ? void 0 : t.default) || 0 : (r = p0.has(r) ? r : d0(r), e.getAttribute(r));
}, scrapeMotionValuesFromProps: v0, build: function(e, r, t, n, o) {
  Xs(r, t, n, o.transformTemplate);
}, render: h0 })), Hg = function(e, r) {
  return Ks(e) ? Vg(r, { enableHardwareAcceleration: !1 }) : Lg(r, { enableHardwareAcceleration: !0 });
};
function Uu(e, r) {
  return r.max === r.min ? 0 : e / (r.max - r.min) * 100;
}
var Er = {
  correct: function(e, r) {
    if (!r.target)
      return e;
    if (typeof e == "string")
      if (ce.test(e))
        e = parseFloat(e);
      else
        return e;
    var t = Uu(e, r.target.x), n = Uu(e, r.target.y);
    return "".concat(t, "% ").concat(n, "%");
  }
}, Ku = "_$css", Fg = {
  correct: function(e, r) {
    var t = r.treeScale, n = r.projectionDelta, o = e, i = e.includes("var("), a = [];
    i && (e = e.replace(cf, function(m) {
      return a.push(m), Ku;
    }));
    var s = Bt.parse(e);
    if (s.length > 5)
      return o;
    var l = Bt.createTransformer(e), c = typeof s[0] != "number" ? 1 : 0, u = n.x.scale * t.x, d = n.y.scale * t.y;
    s[0 + c] /= u, s[1 + c] /= d;
    var h = Ve(u, d, 0.5);
    typeof s[2 + c] == "number" && (s[2 + c] /= h), typeof s[3 + c] == "number" && (s[3 + c] /= h);
    var p = l(s);
    if (i) {
      var v = 0;
      p = p.replace(Ku, function() {
        var m = a[v];
        return v++, m;
      });
    }
    return p;
  }
}, Yg = (
  /** @class */
  function(e) {
    zd(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.componentDidMount = function() {
      var t = this, n = this.props, o = n.visualElement, i = n.layoutGroup, a = n.switchLayoutGroup, s = n.layoutId, l = o.projection;
      pv(zg), l && (i != null && i.group && i.group.add(l), a != null && a.register && s && a.register(l), l.root.didUpdate(), l.addEventListener("animationComplete", function() {
        t.safeToRemove();
      }), l.setOptions(Q(Q({}, l.options), { onExitComplete: function() {
        return t.safeToRemove();
      } }))), kr.hasEverUpdated = !0;
    }, r.prototype.getSnapshotBeforeUpdate = function(t) {
      var n = this, o = this.props, i = o.layoutDependency, a = o.visualElement, s = o.drag, l = o.isPresent, c = a.projection;
      return c && (c.isPresent = l, s || t.layoutDependency !== i || i === void 0 ? c.willUpdate() : this.safeToRemove(), t.isPresent !== l && (l ? c.promote() : c.relegate() || Mt.postRender(function() {
        var u;
        !((u = c.getStack()) === null || u === void 0) && u.members.length || n.safeToRemove();
      }))), null;
    }, r.prototype.componentDidUpdate = function() {
      var t = this.props.visualElement.projection;
      t && (t.root.didUpdate(), !t.currentAnimation && t.isLead() && this.safeToRemove());
    }, r.prototype.componentWillUnmount = function() {
      var t = this.props, n = t.visualElement, o = t.layoutGroup, i = t.switchLayoutGroup, a = n.projection;
      a && (a.scheduleCheckAfterUnmount(), o != null && o.group && o.group.remove(a), i != null && i.deregister && i.deregister(a));
    }, r.prototype.safeToRemove = function() {
      var t = this.props.safeToRemove;
      t == null || t();
    }, r.prototype.render = function() {
      return null;
    }, r;
  }(S.Component)
);
function $g(e) {
  var r = Le(Q0(), 2), t = r[0], n = r[1], o = ze(Gr);
  return S.createElement(Yg, Q({}, e, { layoutGroup: o, switchLayoutGroup: ze(qd), isPresent: t, safeToRemove: n }));
}
var zg = {
  borderRadius: Q(Q({}, Er), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Er,
  borderTopRightRadius: Er,
  borderBottomLeftRadius: Er,
  borderBottomRightRadius: Er,
  boxShadow: Fg
}, Zg = {
  measureLayout: $g
};
function Wg(e, r, t) {
  t === void 0 && (t = {});
  var n = Wt(e) ? e : cr(e);
  return fl("", n, r, t), {
    stop: function() {
      return n.stop();
    },
    isAnimating: function() {
      return n.isAnimating();
    }
  };
}
var pf = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Bg = pf.length, Qu = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, qu = function(e) {
  return typeof e == "number" || ce.test(e);
};
function Ug(e, r, t, n, o, i) {
  var a, s, l, c;
  o ? (e.opacity = Ve(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (a = t.opacity) !== null && a !== void 0 ? a : 1,
    Kg(n)
  ), e.opacityExit = Ve((s = r.opacity) !== null && s !== void 0 ? s : 1, 0, Qg(n))) : i && (e.opacity = Ve((l = r.opacity) !== null && l !== void 0 ? l : 1, (c = t.opacity) !== null && c !== void 0 ? c : 1, n));
  for (var u = 0; u < Bg; u++) {
    var d = "border".concat(pf[u], "Radius"), h = Gu(r, d), p = Gu(t, d);
    if (!(h === void 0 && p === void 0)) {
      h || (h = 0), p || (p = 0);
      var v = h === 0 || p === 0 || qu(h) === qu(p);
      v ? (e[d] = Math.max(Ve(Qu(h), Qu(p), n), 0), (Lt.test(p) || Lt.test(h)) && (e[d] += "%")) : e[d] = p;
    }
  }
  (r.rotate || t.rotate) && (e.rotate = Ve(r.rotate || 0, t.rotate || 0, n));
}
function Gu(e, r) {
  var t;
  return (t = e[r]) !== null && t !== void 0 ? t : e.borderRadius;
}
var Kg = hf(0, 0.5, sl), Qg = hf(0.5, 0.95, il);
function hf(e, r, t) {
  return function(n) {
    return n < e ? 0 : n > r ? 1 : t(to(e, r, n));
  };
}
function Xu(e, r) {
  e.min = r.min, e.max = r.max;
}
function gt(e, r) {
  Xu(e.x, r.x), Xu(e.y, r.y);
}
function Ju(e, r, t, n, o) {
  return e -= r, e = bi(e, 1 / t, n), o !== void 0 && (e = bi(e, 1 / o, n)), e;
}
function qg(e, r, t, n, o, i, a) {
  if (r === void 0 && (r = 0), t === void 0 && (t = 1), n === void 0 && (n = 0.5), i === void 0 && (i = e), a === void 0 && (a = e), Lt.test(r)) {
    r = parseFloat(r);
    var s = Ve(a.min, a.max, r / 100);
    r = s - a.min;
  }
  if (typeof r == "number") {
    var l = Ve(i.min, i.max, n);
    e === i && (l -= r), e.min = Ju(e.min, r, t, l, o), e.max = Ju(e.max, r, t, l, o);
  }
}
function e1(e, r, t, n, o) {
  var i = Le(t, 3), a = i[0], s = i[1], l = i[2];
  qg(e, r[a], r[s], r[l], r.scale, n, o);
}
var Gg = ["x", "scaleX", "originX"], Xg = ["y", "scaleY", "originY"];
function t1(e, r, t, n) {
  e1(e.x, r, Gg, t == null ? void 0 : t.x, n == null ? void 0 : n.x), e1(e.y, r, Xg, t == null ? void 0 : t.y, n == null ? void 0 : n.y);
}
function n1(e) {
  return e.translate === 0 && e.scale === 1;
}
function vf(e) {
  return n1(e.x) && n1(e.y);
}
function mf(e, r) {
  return e.x.min === r.x.min && e.x.max === r.x.max && e.y.min === r.y.min && e.y.max === r.y.max;
}
var Jg = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(r) {
      pl(this.members, r), r.scheduleRender();
    }, e.prototype.remove = function(r) {
      if (hl(this.members, r), r === this.prevLead && (this.prevLead = void 0), r === this.lead) {
        var t = this.members[this.members.length - 1];
        t && this.promote(t);
      }
    }, e.prototype.relegate = function(r) {
      var t = this.members.findIndex(function(a) {
        return r === a;
      });
      if (t === 0)
        return !1;
      for (var n, o = t; o >= 0; o--) {
        var i = this.members[o];
        if (i.isPresent !== !1) {
          n = i;
          break;
        }
      }
      return n ? (this.promote(n), !0) : !1;
    }, e.prototype.promote = function(r, t) {
      var n, o = this.lead;
      if (r !== o && (this.prevLead = o, this.lead = r, r.show(), o)) {
        o.instance && o.scheduleRender(), r.scheduleRender(), r.resumeFrom = o, t && (r.resumeFrom.preserveOpacity = !0), o.snapshot && (r.snapshot = o.snapshot, r.snapshot.latestValues = o.animationValues || o.latestValues, r.snapshot.isShared = !0), !((n = r.root) === null || n === void 0) && n.isUpdating && (r.isLayoutDirty = !0);
        var i = r.options.crossfade;
        i === !1 && o.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(r) {
        var t, n, o, i, a;
        (n = (t = r.options).onExitComplete) === null || n === void 0 || n.call(t), (a = (o = r.resumingFrom) === null || o === void 0 ? void 0 : (i = o.options).onExitComplete) === null || a === void 0 || a.call(i);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(r) {
        r.instance && r.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), e8 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function r1(e, r, t) {
  var n = e.x.translate / r.x, o = e.y.translate / r.y, i = "translate3d(".concat(n, "px, ").concat(o, "px, 0) ");
  if (i += "scale(".concat(1 / r.x, ", ").concat(1 / r.y, ") "), t) {
    var a = t.rotate, s = t.rotateX, l = t.rotateY;
    a && (i += "rotate(".concat(a, "deg) ")), s && (i += "rotateX(".concat(s, "deg) ")), l && (i += "rotateY(".concat(l, "deg) "));
  }
  var c = e.x.scale * r.x, u = e.y.scale * r.y;
  return i += "scale(".concat(c, ", ").concat(u, ")"), i === e8 ? "none" : i;
}
var t8 = function(e, r) {
  return e.depth - r.depth;
}, n8 = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(r) {
      pl(this.children, r), this.isDirty = !0;
    }, e.prototype.remove = function(r) {
      hl(this.children, r), this.isDirty = !0;
    }, e.prototype.forEach = function(r) {
      this.isDirty && this.children.sort(t8), this.isDirty = !1, this.children.forEach(r);
    }, e;
  }()
), o1 = 1e3;
function gf(e) {
  var r = e.attachResizeListener, t = e.defaultParent, n = e.measureScroll, o = e.checkIsScrollRoot, i = e.resetTransform;
  return (
    /** @class */
    function() {
      function a(s, l, c) {
        var u = this;
        l === void 0 && (l = {}), c === void 0 && (c = t == null ? void 0 : t()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          u.isUpdating && (u.isUpdating = !1, u.clearAllSnapshots());
        }, this.updateProjection = function() {
          u.nodes.forEach(l8), u.nodes.forEach(c8);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = s, this.latestValues = l, this.root = c ? c.root || c : this, this.path = c ? bt(bt([], Le(c.path), !1), [c], !1) : [], this.parent = c, this.depth = c ? c.depth + 1 : 0, s && this.root.registerPotentialNode(s, this);
        for (var d = 0; d < this.path.length; d++)
          this.path[d].shouldResetTransform = !0;
        this.root === this && (this.nodes = new n8());
      }
      return a.prototype.addEventListener = function(s, l) {
        return this.eventHandlers.has(s) || this.eventHandlers.set(s, new jr()), this.eventHandlers.get(s).add(l);
      }, a.prototype.notifyListeners = function(s) {
        for (var l = [], c = 1; c < arguments.length; c++)
          l[c - 1] = arguments[c];
        var u = this.eventHandlers.get(s);
        u == null || u.notify.apply(u, bt([], Le(l), !1));
      }, a.prototype.hasListeners = function(s) {
        return this.eventHandlers.has(s);
      }, a.prototype.registerPotentialNode = function(s, l) {
        this.potentialNodes.set(s, l);
      }, a.prototype.mount = function(s, l) {
        var c = this, u;
        if (l === void 0 && (l = !1), !this.instance) {
          this.isSVG = s instanceof SVGElement && s.tagName !== "svg", this.instance = s;
          var d = this.options, h = d.layoutId, p = d.layout, v = d.visualElement;
          if (v && !v.getInstance() && v.mount(s), this.root.nodes.add(this), (u = this.parent) === null || u === void 0 || u.children.add(this), this.id && this.root.potentialNodes.delete(this.id), l && (p || h) && (this.isLayoutDirty = !0), r) {
            var m, y = function() {
              return c.root.updateBlockedByResize = !1;
            };
            r(s, function() {
              c.root.updateBlockedByResize = !0, clearTimeout(m), m = window.setTimeout(y, 250), kr.hasAnimatedSinceResize && (kr.hasAnimatedSinceResize = !1, c.nodes.forEach(s8));
            });
          }
          h && this.root.registerSharedNode(h, this), this.options.animate !== !1 && v && (h || p) && this.addEventListener("didUpdate", function(b) {
            var g, w, x, C, O, E = b.delta, _ = b.hasLayoutChanged, R = b.hasRelativeTargetChanged, H = b.layout;
            if (c.isTreeAnimationBlocked()) {
              c.target = void 0, c.relativeTarget = void 0;
              return;
            }
            var $ = (w = (g = c.options.transition) !== null && g !== void 0 ? g : v.getDefaultTransition()) !== null && w !== void 0 ? w : h8, Y = v.getProps(), j = Y.onLayoutAnimationStart, A = Y.onLayoutAnimationComplete, W = !c.targetLayout || !mf(c.targetLayout, H) || R, U = !_ && R;
            if (!((x = c.resumeFrom) === null || x === void 0) && x.instance || U || _ && (W || !c.currentAnimation)) {
              c.resumeFrom && (c.resumingFrom = c.resumeFrom, c.resumingFrom.resumingFrom = void 0), c.setAnimationOrigin(E, U);
              var Z = Q(Q({}, dl($, "layout")), { onPlay: j, onComplete: A });
              v.shouldReduceMotion && (Z.delay = 0, Z.type = !1), c.startAnimation(Z);
            } else
              !_ && c.animationProgress === 0 && c.finishAnimation(), c.isLead() && ((O = (C = c.options).onExitComplete) === null || O === void 0 || O.call(C));
            c.targetLayout = H;
          });
        }
      }, a.prototype.unmount = function() {
        var s, l;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (s = this.getStack()) === null || s === void 0 || s.remove(this), (l = this.parent) === null || l === void 0 || l.children.delete(this), this.instance = void 0, lr.preRender(this.updateProjection);
      }, a.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, a.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, a.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, a.prototype.isTreeAnimationBlocked = function() {
        var s;
        return this.isAnimationBlocked || ((s = this.parent) === null || s === void 0 ? void 0 : s.isTreeAnimationBlocked()) || !1;
      }, a.prototype.startUpdate = function() {
        var s;
        this.isUpdateBlocked() || (this.isUpdating = !0, (s = this.nodes) === null || s === void 0 || s.forEach(u8));
      }, a.prototype.willUpdate = function(s) {
        var l, c, u;
        if (s === void 0 && (s = !0), this.root.isUpdateBlocked()) {
          (c = (l = this.options).onExitComplete) === null || c === void 0 || c.call(l);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var d = 0; d < this.path.length; d++) {
            var h = this.path[d];
            h.shouldResetTransform = !0, h.updateScroll();
          }
          var p = this.options, v = p.layoutId, m = p.layout;
          if (!(v === void 0 && !m)) {
            var y = (u = this.options.visualElement) === null || u === void 0 ? void 0 : u.getProps().transformTemplate;
            this.prevTransformTemplateValue = y == null ? void 0 : y(this.latestValues, ""), this.updateSnapshot(), s && this.notifyListeners("willUpdate");
          }
        }
      }, a.prototype.didUpdate = function() {
        var s = this.isUpdateBlocked();
        if (s) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(i1);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(v8), this.potentialNodes.clear()), this.nodes.forEach(a8), this.nodes.forEach(r8), this.nodes.forEach(o8), this.clearAllSnapshots(), Ma.update(), Ma.preRender(), Ma.render());
      }, a.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(i8), this.sharedNodes.forEach(d8);
      }, a.prototype.scheduleUpdateProjection = function() {
        Mt.preRender(this.updateProjection, !1, !0);
      }, a.prototype.scheduleCheckAfterUnmount = function() {
        var s = this;
        Mt.postRender(function() {
          s.isLayoutDirty ? s.root.didUpdate() : s.root.checkUpdateFailed();
        });
      }, a.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var s = this.measure(), l = this.removeTransform(this.removeElementScroll(s));
          c1(l), this.snapshot = {
            measured: s,
            layout: l,
            latestValues: {}
          };
        }
      }, a.prototype.updateLayout = function() {
        var s;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var l = 0; l < this.path.length; l++) {
              var c = this.path[l];
              c.updateScroll();
            }
          var u = this.measure();
          c1(u);
          var d = this.layout;
          this.layout = {
            measured: u,
            actual: this.removeElementScroll(u)
          }, this.layoutCorrected = Ge(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (s = this.options.visualElement) === null || s === void 0 || s.notifyLayoutMeasure(this.layout.actual, d == null ? void 0 : d.actual);
        }
      }, a.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = o(this.instance), this.scroll = n(this.instance));
      }, a.prototype.resetTransform = function() {
        var s;
        if (i) {
          var l = this.isLayoutDirty || this.shouldResetTransform, c = this.projectionDelta && !vf(this.projectionDelta), u = (s = this.options.visualElement) === null || s === void 0 ? void 0 : s.getProps().transformTemplate, d = u == null ? void 0 : u(this.latestValues, ""), h = d !== this.prevTransformTemplateValue;
          l && (c || tn(this.latestValues) || h) && (i(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, a.prototype.measure = function() {
        var s = this.options.visualElement;
        if (!s)
          return Ge();
        var l = s.measureViewportBox(), c = this.root.scroll;
        return c && (rn(l.x, c.x), rn(l.y, c.y)), l;
      }, a.prototype.removeElementScroll = function(s) {
        var l = Ge();
        gt(l, s);
        for (var c = 0; c < this.path.length; c++) {
          var u = this.path[c], d = u.scroll, h = u.options, p = u.isScrollRoot;
          if (u !== this.root && d && h.layoutScroll) {
            if (p) {
              gt(l, s);
              var v = this.root.scroll;
              v && (rn(l.x, -v.x), rn(l.y, -v.y));
            }
            rn(l.x, d.x), rn(l.y, d.y);
          }
        }
        return l;
      }, a.prototype.applyTransform = function(s, l) {
        l === void 0 && (l = !1);
        var c = Ge();
        gt(c, s);
        for (var u = 0; u < this.path.length; u++) {
          var d = this.path[u];
          !l && d.options.layoutScroll && d.scroll && d !== d.root && Jn(c, {
            x: -d.scroll.x,
            y: -d.scroll.y
          }), tn(d.latestValues) && Jn(c, d.latestValues);
        }
        return tn(this.latestValues) && Jn(c, this.latestValues), c;
      }, a.prototype.removeTransform = function(s) {
        var l, c = Ge();
        gt(c, s);
        for (var u = 0; u < this.path.length; u++) {
          var d = this.path[u];
          if (d.instance && tn(d.latestValues)) {
            rf(d.latestValues) && d.updateSnapshot();
            var h = Ge(), p = d.measure();
            gt(h, p), t1(c, d.latestValues, (l = d.snapshot) === null || l === void 0 ? void 0 : l.layout, h);
          }
        }
        return tn(this.latestValues) && t1(c, this.latestValues), c;
      }, a.prototype.setTargetDelta = function(s) {
        this.targetDelta = s, this.root.scheduleUpdateProjection();
      }, a.prototype.setOptions = function(s) {
        var l;
        this.options = Q(Q(Q({}, this.options), s), { crossfade: (l = s.crossfade) !== null && l !== void 0 ? l : !0 });
      }, a.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, a.prototype.resolveTargetDelta = function() {
        var s, l = this.options, c = l.layout, u = l.layoutId;
        !this.layout || !(c || u) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = Ge(), this.relativeTargetOrigin = Ge(), Ar(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), gt(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Ge(), this.targetWithTransforms = Ge()), this.relativeTarget && this.relativeTargetOrigin && (!((s = this.relativeParent) === null || s === void 0) && s.target) ? ng(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : gt(this.target, this.layout.actual), of(this.target, this.targetDelta)) : gt(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = Ge(), this.relativeTargetOrigin = Ge(), Ar(this.relativeTargetOrigin, this.target, this.relativeParent.target), gt(this.relativeTarget, this.relativeTargetOrigin)))));
      }, a.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || tn(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, a.prototype.calcProjection = function() {
        var s, l = this.options, c = l.layout, u = l.layoutId;
        if (this.isTreeAnimating = !!(!((s = this.parent) === null || s === void 0) && s.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(c || u))) {
          var d = this.getLead();
          gt(this.layoutCorrected, this.layout.actual), dg(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== d);
          var h = d.target;
          if (h) {
            this.projectionDelta || (this.projectionDelta = Lr(), this.projectionDeltaWithTransform = Lr());
            var p = this.treeScale.x, v = this.treeScale.y, m = this.projectionTransform;
            Pr(this.projectionDelta, this.layoutCorrected, h, this.latestValues), this.projectionTransform = r1(this.projectionDelta, this.treeScale), (this.projectionTransform !== m || this.treeScale.x !== p || this.treeScale.y !== v) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
          }
        }
      }, a.prototype.hide = function() {
        this.isVisible = !1;
      }, a.prototype.show = function() {
        this.isVisible = !0;
      }, a.prototype.scheduleRender = function(s) {
        var l, c, u;
        s === void 0 && (s = !0), (c = (l = this.options).scheduleRender) === null || c === void 0 || c.call(l), s && ((u = this.getStack()) === null || u === void 0 || u.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, a.prototype.setAnimationOrigin = function(s, l) {
        var c = this, u;
        l === void 0 && (l = !1);
        var d = this.snapshot, h = (d == null ? void 0 : d.latestValues) || {}, p = Q({}, this.latestValues), v = Lr();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !l;
        var m = Ge(), y = d == null ? void 0 : d.isShared, b = (((u = this.getStack()) === null || u === void 0 ? void 0 : u.members.length) || 0) <= 1, g = !!(y && !b && this.options.crossfade === !0 && !this.path.some(p8));
        this.animationProgress = 0, this.mixTargetDelta = function(w) {
          var x, C = w / 1e3;
          a1(v.x, s.x, C), a1(v.y, s.y, C), c.setTargetDelta(v), c.relativeTarget && c.relativeTargetOrigin && c.layout && (!((x = c.relativeParent) === null || x === void 0) && x.layout) && (Ar(m, c.layout.actual, c.relativeParent.layout.actual), f8(c.relativeTarget, c.relativeTargetOrigin, m, C)), y && (c.animationValues = p, Ug(p, h, c.latestValues, C, g, b)), c.root.scheduleUpdateProjection(), c.scheduleRender(), c.animationProgress = C;
        }, this.mixTargetDelta(0);
      }, a.prototype.startAnimation = function(s) {
        var l = this, c, u;
        this.notifyListeners("animationStart"), (c = this.currentAnimation) === null || c === void 0 || c.stop(), this.resumingFrom && ((u = this.resumingFrom.currentAnimation) === null || u === void 0 || u.stop()), this.pendingAnimation && (lr.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Mt.update(function() {
          kr.hasAnimatedSinceResize = !0, l.currentAnimation = Wg(0, o1, Q(Q({}, s), { onUpdate: function(d) {
            var h;
            l.mixTargetDelta(d), (h = s.onUpdate) === null || h === void 0 || h.call(s, d);
          }, onComplete: function() {
            var d;
            (d = s.onComplete) === null || d === void 0 || d.call(s), l.completeAnimation();
          } })), l.resumingFrom && (l.resumingFrom.currentAnimation = l.currentAnimation), l.pendingAnimation = void 0;
        });
      }, a.prototype.completeAnimation = function() {
        var s;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (s = this.getStack()) === null || s === void 0 || s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, a.prototype.finishAnimation = function() {
        var s;
        this.currentAnimation && ((s = this.mixTargetDelta) === null || s === void 0 || s.call(this, o1), this.currentAnimation.stop()), this.completeAnimation();
      }, a.prototype.applyTransformsToTarget = function() {
        var s = this.getLead(), l = s.targetWithTransforms, c = s.target, u = s.layout, d = s.latestValues;
        !l || !c || !u || (gt(l, c), Jn(l, d), Pr(this.projectionDeltaWithTransform, this.layoutCorrected, l, d));
      }, a.prototype.registerSharedNode = function(s, l) {
        var c, u, d;
        this.sharedNodes.has(s) || this.sharedNodes.set(s, new Jg());
        var h = this.sharedNodes.get(s);
        h.add(l), l.promote({
          transition: (c = l.options.initialPromotionConfig) === null || c === void 0 ? void 0 : c.transition,
          preserveFollowOpacity: (d = (u = l.options.initialPromotionConfig) === null || u === void 0 ? void 0 : u.shouldPreserveFollowOpacity) === null || d === void 0 ? void 0 : d.call(u, l)
        });
      }, a.prototype.isLead = function() {
        var s = this.getStack();
        return s ? s.lead === this : !0;
      }, a.prototype.getLead = function() {
        var s, l = this.options.layoutId;
        return l ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
      }, a.prototype.getPrevLead = function() {
        var s, l = this.options.layoutId;
        return l ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
      }, a.prototype.getStack = function() {
        var s = this.options.layoutId;
        if (s)
          return this.root.sharedNodes.get(s);
      }, a.prototype.promote = function(s) {
        var l = s === void 0 ? {} : s, c = l.needsReset, u = l.transition, d = l.preserveFollowOpacity, h = this.getStack();
        h && h.promote(this, d), c && (this.projectionDelta = void 0, this.needsReset = !0), u && this.setOptions({ transition: u });
      }, a.prototype.relegate = function() {
        var s = this.getStack();
        return s ? s.relegate(this) : !1;
      }, a.prototype.resetRotation = function() {
        var s = this.options.visualElement;
        if (s) {
          for (var l = !1, c = {}, u = 0; u < os.length; u++) {
            var d = os[u], h = "rotate" + d;
            s.getStaticValue(h) && (l = !0, c[h] = s.getStaticValue(h), s.setStaticValue(h, 0));
          }
          if (l) {
            s == null || s.syncRender();
            for (var h in c)
              s.setStaticValue(h, c[h]);
            s.scheduleRender();
          }
        }
      }, a.prototype.getProjectionStyles = function(s) {
        var l, c, u, d, h, p;
        s === void 0 && (s = {});
        var v = {};
        if (!this.instance || this.isSVG)
          return v;
        if (this.isVisible)
          v.visibility = "";
        else
          return { visibility: "hidden" };
        var m = (l = this.options.visualElement) === null || l === void 0 ? void 0 : l.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, v.opacity = "", v.pointerEvents = $o(s.pointerEvents) || "", v.transform = m ? m(this.latestValues, "") : "none", v;
        var y = this.getLead();
        if (!this.projectionDelta || !this.layout || !y.target) {
          var b = {};
          return this.options.layoutId && (b.opacity = (c = this.latestValues.opacity) !== null && c !== void 0 ? c : 1, b.pointerEvents = $o(s.pointerEvents) || ""), this.hasProjected && !tn(this.latestValues) && (b.transform = m ? m({}, "") : "none", this.hasProjected = !1), b;
        }
        var g = y.animationValues || y.latestValues;
        this.applyTransformsToTarget(), v.transform = r1(this.projectionDeltaWithTransform, this.treeScale, g), m && (v.transform = m(g, v.transform));
        var w = this.projectionDelta, x = w.x, C = w.y;
        v.transformOrigin = "".concat(x.origin * 100, "% ").concat(C.origin * 100, "% 0"), y.animationValues ? v.opacity = y === this ? (d = (u = g.opacity) !== null && u !== void 0 ? u : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : g.opacityExit : v.opacity = y === this ? (h = g.opacity) !== null && h !== void 0 ? h : "" : (p = g.opacityExit) !== null && p !== void 0 ? p : 0;
        for (var O in hi)
          if (g[O] !== void 0) {
            var E = hi[O], _ = E.correct, R = E.applyTo, H = _(g[O], y);
            if (R)
              for (var $ = R.length, Y = 0; Y < $; Y++)
                v[R[Y]] = H;
            else
              v[O] = H;
          }
        return this.options.layoutId && (v.pointerEvents = y === this ? $o(s.pointerEvents) || "" : "none"), v;
      }, a.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, a.prototype.resetTree = function() {
        this.root.nodes.forEach(function(s) {
          var l;
          return (l = s.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
        }), this.root.nodes.forEach(i1), this.root.sharedNodes.clear();
      }, a;
    }()
  );
}
function r8(e) {
  e.updateLayout();
}
function o8(e) {
  var r, t, n, o, i = (t = (r = e.resumeFrom) === null || r === void 0 ? void 0 : r.snapshot) !== null && t !== void 0 ? t : e.snapshot;
  if (e.isLead() && e.layout && i && e.hasListeners("didUpdate")) {
    var a = e.layout, s = a.actual, l = a.measured;
    e.options.animationType === "size" ? Tt(function(g) {
      var w = i.isShared ? i.measured[g] : i.layout[g], x = Ut(w);
      w.min = s[g].min, w.max = w.min + x;
    }) : e.options.animationType === "position" && Tt(function(g) {
      var w = i.isShared ? i.measured[g] : i.layout[g], x = Ut(s[g]);
      w.max = w.min + x;
    });
    var c = Lr();
    Pr(c, s, i.layout);
    var u = Lr();
    i.isShared ? Pr(u, e.applyTransform(l, !0), i.measured) : Pr(u, s, i.layout);
    var d = !vf(c), h = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var p = e.relativeParent, v = p.snapshot, m = p.layout;
      if (v && m) {
        var y = Ge();
        Ar(y, i.layout, v.layout);
        var b = Ge();
        Ar(b, s, m.actual), mf(y, b) || (h = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: s,
      snapshot: i,
      delta: u,
      layoutDelta: c,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: h
    });
  } else
    e.isLead() && ((o = (n = e.options).onExitComplete) === null || o === void 0 || o.call(n));
  e.options.transition = void 0;
}
function i8(e) {
  e.clearSnapshot();
}
function i1(e) {
  e.clearMeasurements();
}
function a8(e) {
  var r = e.options.visualElement;
  r != null && r.getProps().onBeforeLayoutMeasure && r.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function s8(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function l8(e) {
  e.resolveTargetDelta();
}
function c8(e) {
  e.calcProjection();
}
function u8(e) {
  e.resetRotation();
}
function d8(e) {
  e.removeLeadSnapshot();
}
function a1(e, r, t) {
  e.translate = Ve(r.translate, 0, t), e.scale = Ve(r.scale, 1, t), e.origin = r.origin, e.originPoint = r.originPoint;
}
function s1(e, r, t, n) {
  e.min = Ve(r.min, t.min, n), e.max = Ve(r.max, t.max, n);
}
function f8(e, r, t, n) {
  s1(e.x, r.x, t.x, n), s1(e.y, r.y, t.y, n);
}
function p8(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var h8 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function v8(e, r) {
  for (var t = e.root, n = e.path.length - 1; n >= 0; n--)
    if (e.path[n].instance) {
      t = e.path[n];
      break;
    }
  var o = t && t !== e.root ? t.instance : document, i = o.querySelector('[data-projection-id="'.concat(r, '"]'));
  i && e.mount(i, !0);
}
function l1(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function c1(e) {
  l1(e.x), l1(e.y);
}
var m8 = gf({
  attachResizeListener: function(e, r) {
    return Yi(e, "resize", r);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), Na = {
  current: void 0
}, g8 = gf({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!Na.current) {
      var e = new m8(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Na.current = e;
    }
    return Na.current;
  },
  resetTransform: function(e, r) {
    e.style.transform = r ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), y8 = Q(Q(Q(Q({}, J7), y7), xg), Zg), gr = /* @__PURE__ */ dv(function(e, r) {
  return Gv(e, r, y8, Hg, g8);
});
function yf() {
  var e = me(!1);
  return pi(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function wf() {
  var e = yf(), r = Le($e(0), 2), t = r[0], n = r[1], o = Oe(function() {
    e.current && n(t + 1);
  }, [t]), i = Oe(function() {
    return Mt.postRender(o);
  }, [o]);
  return [i, t];
}
var Ta = function(e) {
  var r = e.children, t = e.initial, n = e.isPresent, o = e.onExitComplete, i = e.custom, a = e.presenceAffectsLayout, s = po(w8), l = K0(), c = it(
    function() {
      return {
        id: l,
        initial: t,
        isPresent: n,
        custom: i,
        onExitComplete: function(u) {
          var d, h;
          s.set(u, !0);
          try {
            for (var p = W4(s.values()), v = p.next(); !v.done; v = p.next()) {
              var m = v.value;
              if (!m)
                return;
            }
          } catch (y) {
            d = { error: y };
          } finally {
            try {
              v && !v.done && (h = p.return) && h.call(p);
            } finally {
              if (d)
                throw d.error;
            }
          }
          o == null || o();
        },
        register: function(u) {
          return s.set(u, !1), function() {
            return s.delete(u);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [n]
  );
  return it(function() {
    s.forEach(function(u, d) {
      return s.set(d, !1);
    });
  }, [n]), T.useEffect(function() {
    !n && !s.size && (o == null || o());
  }, [n]), T.createElement(fo.Provider, { value: c }, r);
};
function w8() {
  return /* @__PURE__ */ new Map();
}
var Qn = function(e) {
  return e.key || "";
};
function x8(e, r) {
  e.forEach(function(t) {
    var n = Qn(t);
    r.set(n, t);
  });
}
function C8(e) {
  var r = [];
  return zp.forEach(e, function(t) {
    Is(t) && r.push(t);
  }), r;
}
var xf = function(e) {
  var r = e.children, t = e.custom, n = e.initial, o = n === void 0 ? !0 : n, i = e.onExitComplete, a = e.exitBeforeEnter, s = e.presenceAffectsLayout, l = s === void 0 ? !0 : s, c = Le(wf(), 1), u = c[0], d = ze(Gr).forceRender;
  d && (u = d);
  var h = yf(), p = C8(r), v = p, m = /* @__PURE__ */ new Set(), y = me(v), b = me(/* @__PURE__ */ new Map()).current, g = me(!0);
  if (pi(function() {
    g.current = !1, x8(p, b), y.current = v;
  }), nl(function() {
    g.current = !0, b.clear(), m.clear();
  }), g.current)
    return T.createElement(T.Fragment, null, v.map(function(_) {
      return T.createElement(Ta, { key: Qn(_), isPresent: !0, initial: o ? void 0 : !1, presenceAffectsLayout: l }, _);
    }));
  v = bt([], Le(v), !1);
  for (var w = y.current.map(Qn), x = p.map(Qn), C = w.length, O = 0; O < C; O++) {
    var E = w[O];
    x.indexOf(E) === -1 && m.add(E);
  }
  return a && m.size && (v = []), m.forEach(function(_) {
    if (x.indexOf(_) === -1) {
      var R = b.get(_);
      if (R) {
        var H = w.indexOf(_), $ = function() {
          b.delete(_), m.delete(_);
          var Y = y.current.findIndex(function(j) {
            return j.key === _;
          });
          if (y.current.splice(Y, 1), !m.size) {
            if (y.current = p, h.current === !1)
              return;
            u(), i && i();
          }
        };
        v.splice(H, 0, T.createElement(Ta, { key: Qn(R), isPresent: !1, onExitComplete: $, custom: t, presenceAffectsLayout: l }, R));
      }
    }
  }), v = v.map(function(_) {
    var R = _.key;
    return m.has(R) ? _ : T.createElement(Ta, { key: Qn(_), isPresent: !0, presenceAffectsLayout: l }, _);
  }), Bs !== "production" && a && v.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), T.createElement(T.Fragment, null, m.size ? v : v.map(function(_) {
    return Oi(_);
  }));
}, b8 = Kt(null), M8 = function(e) {
  return !e.isLayoutDirty && e.willUpdate(!1);
};
function u1() {
  var e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new WeakMap(), t = function() {
    return e.forEach(M8);
  };
  return {
    add: function(n) {
      e.add(n), r.set(n, n.addEventListener("willUpdate", t));
    },
    remove: function(n) {
      var o;
      e.delete(n), (o = r.get(n)) === null || o === void 0 || o(), r.delete(n), t();
    },
    dirty: t
  };
}
var Cf = function(e) {
  return e === !0;
}, D8 = function(e) {
  return Cf(e === !0) || e === "id";
}, _8 = function(e) {
  var r, t, n = e.children, o = e.id, i = e.inheritId, a = e.inherit, s = a === void 0 ? !0 : a;
  i !== void 0 && (s = i);
  var l = ze(Gr), c = ze(b8), u = Le(wf(), 2), d = u[0], h = u[1], p = me(null), v = (r = l.id) !== null && r !== void 0 ? r : c;
  p.current === null && (D8(s) && v && (o = o ? v + "-" + o : v), p.current = {
    id: o,
    group: Cf(s) && (t = l == null ? void 0 : l.group) !== null && t !== void 0 ? t : u1()
  });
  var m = it(function() {
    return Q(Q({}, p.current), { forceRender: d });
  }, [h]);
  return T.createElement(Gr.Provider, { value: m }, n);
};
const E8 = ({
  primaryActionButton: e,
  secondaryActionButton: r,
  tertiaryActionButton: t,
  footerFullWidthButtons: n,
  footerButtonAlignment: o = "end"
}) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: X(
      "sp-modal-footer",
      {
        "sp-modal-footer--full-width": n
      },
      `sp-modal-footer--${o}`
    ),
    children: [
      o === "end" && !n ? /* @__PURE__ */ f.jsx("div", { className: "sp-modal-footer__tertiary", children: t ? /* @__PURE__ */ f.jsx(
        Xe,
        {
          variant: t.variant ?? "tertiary",
          onClick: t.action,
          size: "l",
          disabled: t.disabled,
          loading: t.loading,
          icon: t.icon,
          children: t.title
        }
      ) : null }) : null,
      r ? /* @__PURE__ */ f.jsx(
        Xe,
        {
          variant: r.variant ?? "secondary",
          onClick: r.action,
          className: "sp-modal-footer__secondary",
          size: "l",
          disabled: r.disabled,
          loading: r.loading,
          icon: r.icon,
          children: r.title
        }
      ) : null,
      e ? /* @__PURE__ */ f.jsx(
        Xe,
        {
          variant: e.variant ?? "primary",
          onClick: e.action,
          className: "sp-modal-footer__primary",
          size: "l",
          disabled: e.disabled,
          loading: e.loading,
          icon: e.icon,
          children: e.title
        }
      ) : null
    ]
  }
), I8 = E8;
const O8 = ({ title: e, onClose: r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: X("sp-modal-header", {
      ["sp-modal-header--with-cross"]: r
    }),
    children: [
      /* @__PURE__ */ f.jsx(
        pe,
        {
          className: "sp-modal-header__title",
          variant: "body-content",
          size: "l",
          weight: 600,
          tag: "h4",
          children: e
        }
      ),
      r ? /* @__PURE__ */ f.jsx(
        "button",
        {
          className: "sp-modal-header__button",
          "aria-label": "Close Modal",
          title: "Close Modal",
          onClick: r,
          children: /* @__PURE__ */ f.jsx(yr, { size: "24", iconColor: "var(--icon-default)" })
        }
      ) : null
    ]
  }
), N8 = O8;
const T8 = {
  initial: {
    opacity: 0
  },
  dissolve: {
    opacity: 1,
    transition: {
      duration: 4,
      type: "spring",
      damping: 15,
      stiffness: 100,
      mass: 1
    }
  }
}, XC = ({
  size: e,
  title: r,
  onClose: t,
  children: n,
  primaryActionButton: o,
  secondaryActionButton: i,
  tertiaryActionButton: a,
  showModal: s,
  className: l,
  footerButtonAlignment: c,
  footerFullWidthButtons: u,
  ...d
}) => {
  const h = o ?? i ?? a;
  return fe(() => (s && (document.body.style.overflow = "hidden"), () => {
    document.body.style.removeProperty("overflow");
  }), [s]), s ? /* @__PURE__ */ f.jsx(Op, { onClickOutside: t, children: /* @__PURE__ */ f.jsx(
    gr.div,
    {
      role: "dialog",
      "aria-modal": "true",
      className: X(["sp-modal", `sp-modal--${e}`]),
      variants: T8,
      animate: "dissolve",
      initial: "initial",
      children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(N8, { title: r, onClose: t }),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            ...d,
            className: X("sp-modal__content", l),
            children: n
          }
        ),
        h ? /* @__PURE__ */ f.jsx(
          I8,
          {
            primaryActionButton: o,
            secondaryActionButton: i,
            tertiaryActionButton: a,
            footerButtonAlignment: c,
            footerFullWidthButtons: u
          }
        ) : null
      ] })
    }
  ) }) : null;
};
function xt(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function ue() {
  return ue = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ue.apply(this, arguments);
}
function xs(e, r) {
  return xs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, xs(e, r);
}
function k8(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, xs(e, r);
}
var Cs = { exports: {} }, Ce = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d1;
function S8() {
  if (d1)
    return Ce;
  d1 = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function m(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case e:
          switch (y = y.type, y) {
            case t:
            case o:
            case n:
            case c:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case a:
                case l:
                case h:
                case d:
                case i:
                  return y;
                default:
                  return b;
              }
          }
        case r:
          return b;
      }
    }
  }
  return Ce.ContextConsumer = a, Ce.ContextProvider = i, Ce.Element = e, Ce.ForwardRef = l, Ce.Fragment = t, Ce.Lazy = h, Ce.Memo = d, Ce.Portal = r, Ce.Profiler = o, Ce.StrictMode = n, Ce.Suspense = c, Ce.SuspenseList = u, Ce.isAsyncMode = function() {
    return !1;
  }, Ce.isConcurrentMode = function() {
    return !1;
  }, Ce.isContextConsumer = function(y) {
    return m(y) === a;
  }, Ce.isContextProvider = function(y) {
    return m(y) === i;
  }, Ce.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Ce.isForwardRef = function(y) {
    return m(y) === l;
  }, Ce.isFragment = function(y) {
    return m(y) === t;
  }, Ce.isLazy = function(y) {
    return m(y) === h;
  }, Ce.isMemo = function(y) {
    return m(y) === d;
  }, Ce.isPortal = function(y) {
    return m(y) === r;
  }, Ce.isProfiler = function(y) {
    return m(y) === o;
  }, Ce.isStrictMode = function(y) {
    return m(y) === n;
  }, Ce.isSuspense = function(y) {
    return m(y) === c;
  }, Ce.isSuspenseList = function(y) {
    return m(y) === u;
  }, Ce.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === t || y === o || y === n || y === c || y === u || y === p || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === d || y.$$typeof === i || y.$$typeof === a || y.$$typeof === l || y.$$typeof === v || y.getModuleId !== void 0);
  }, Ce.typeOf = m, Ce;
}
var be = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f1;
function R8() {
  return f1 || (f1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = !1, m = !1, y = !1, b = !1, g = !1, w;
    w = Symbol.for("react.module.reference");
    function x(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === t || ne === o || g || ne === n || ne === c || ne === u || b || ne === p || v || m || y || typeof ne == "object" && ne !== null && (ne.$$typeof === h || ne.$$typeof === d || ne.$$typeof === i || ne.$$typeof === a || ne.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === w || ne.getModuleId !== void 0));
    }
    function C(ne) {
      if (typeof ne == "object" && ne !== null) {
        var Ze = ne.$$typeof;
        switch (Ze) {
          case e:
            var Qe = ne.type;
            switch (Qe) {
              case t:
              case o:
              case n:
              case c:
              case u:
                return Qe;
              default:
                var vt = Qe && Qe.$$typeof;
                switch (vt) {
                  case s:
                  case a:
                  case l:
                  case h:
                  case d:
                  case i:
                    return vt;
                  default:
                    return Ze;
                }
            }
          case r:
            return Ze;
        }
      }
    }
    var O = a, E = i, _ = e, R = l, H = t, $ = h, Y = d, j = r, A = o, W = n, U = c, Z = u, J = !1, le = !1;
    function z(ne) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(ne) {
      return le || (le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(ne) {
      return C(ne) === a;
    }
    function N(ne) {
      return C(ne) === i;
    }
    function I(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === e;
    }
    function P(ne) {
      return C(ne) === l;
    }
    function B(ne) {
      return C(ne) === t;
    }
    function ee(ne) {
      return C(ne) === h;
    }
    function te(ne) {
      return C(ne) === d;
    }
    function ae(ne) {
      return C(ne) === r;
    }
    function se(ne) {
      return C(ne) === o;
    }
    function ge(ne) {
      return C(ne) === n;
    }
    function q(ne) {
      return C(ne) === c;
    }
    function ke(ne) {
      return C(ne) === u;
    }
    be.ContextConsumer = O, be.ContextProvider = E, be.Element = _, be.ForwardRef = R, be.Fragment = H, be.Lazy = $, be.Memo = Y, be.Portal = j, be.Profiler = A, be.StrictMode = W, be.Suspense = U, be.SuspenseList = Z, be.isAsyncMode = z, be.isConcurrentMode = F, be.isContextConsumer = L, be.isContextProvider = N, be.isElement = I, be.isForwardRef = P, be.isFragment = B, be.isLazy = ee, be.isMemo = te, be.isPortal = ae, be.isProfiler = se, be.isStrictMode = ge, be.isSuspense = q, be.isSuspenseList = ke, be.isValidElementType = x, be.typeOf = C;
  }()), be;
}
process.env.NODE_ENV === "production" ? Cs.exports = S8() : Cs.exports = R8();
var p1 = Cs.exports;
const h1 = (e) => typeof e == "object" && e != null && e.nodeType === 1, v1 = (e, r) => (!r || e !== "hidden") && e !== "visible" && e !== "clip", ka = (e, r) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const t = getComputedStyle(e, null);
    return v1(t.overflowY, r) || v1(t.overflowX, r) || ((n) => {
      const o = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(n);
      return !!o && (o.clientHeight < n.scrollHeight || o.clientWidth < n.scrollWidth);
    })(e);
  }
  return !1;
}, ko = (e, r, t, n, o, i, a, s) => i < e && a > r || i > e && a < r ? 0 : i <= e && s <= t || a >= r && s >= t ? i - e - n : a > r && s < t || i < e && s > t ? a - r + o : 0, j8 = (e) => {
  const r = e.parentElement;
  return r ?? (e.getRootNode().host || null);
}, P8 = (e, r) => {
  var t, n, o, i;
  if (typeof document > "u")
    return [];
  const { scrollMode: a, block: s, inline: l, boundary: c, skipOverflowHiddenElements: u } = r, d = typeof c == "function" ? c : (U) => U !== c;
  if (!h1(e))
    throw new TypeError("Invalid target");
  const h = document.scrollingElement || document.documentElement, p = [];
  let v = e;
  for (; h1(v) && d(v); ) {
    if (v = j8(v), v === h) {
      p.push(v);
      break;
    }
    v != null && v === document.body && ka(v) && !ka(document.documentElement) || v != null && ka(v, u) && p.push(v);
  }
  const m = (n = (t = window.visualViewport) == null ? void 0 : t.width) != null ? n : innerWidth, y = (i = (o = window.visualViewport) == null ? void 0 : o.height) != null ? i : innerHeight, { scrollX: b, scrollY: g } = window, { height: w, width: x, top: C, right: O, bottom: E, left: _ } = e.getBoundingClientRect(), { top: R, right: H, bottom: $, left: Y } = ((U) => {
    const Z = window.getComputedStyle(U);
    return { top: parseFloat(Z.scrollMarginTop) || 0, right: parseFloat(Z.scrollMarginRight) || 0, bottom: parseFloat(Z.scrollMarginBottom) || 0, left: parseFloat(Z.scrollMarginLeft) || 0 };
  })(e);
  let j = s === "start" || s === "nearest" ? C - R : s === "end" ? E + $ : C + w / 2 - R + $, A = l === "center" ? _ + x / 2 - Y + H : l === "end" ? O + H : _ - Y;
  const W = [];
  for (let U = 0; U < p.length; U++) {
    const Z = p[U], { height: J, width: le, top: z, right: F, bottom: L, left: N } = Z.getBoundingClientRect();
    if (a === "if-needed" && C >= 0 && _ >= 0 && E <= y && O <= m && C >= z && E <= L && _ >= N && O <= F)
      return W;
    const I = getComputedStyle(Z), P = parseInt(I.borderLeftWidth, 10), B = parseInt(I.borderTopWidth, 10), ee = parseInt(I.borderRightWidth, 10), te = parseInt(I.borderBottomWidth, 10);
    let ae = 0, se = 0;
    const ge = "offsetWidth" in Z ? Z.offsetWidth - Z.clientWidth - P - ee : 0, q = "offsetHeight" in Z ? Z.offsetHeight - Z.clientHeight - B - te : 0, ke = "offsetWidth" in Z ? Z.offsetWidth === 0 ? 0 : le / Z.offsetWidth : 0, ne = "offsetHeight" in Z ? Z.offsetHeight === 0 ? 0 : J / Z.offsetHeight : 0;
    if (h === Z)
      ae = s === "start" ? j : s === "end" ? j - y : s === "nearest" ? ko(g, g + y, y, B, te, g + j, g + j + w, w) : j - y / 2, se = l === "start" ? A : l === "center" ? A - m / 2 : l === "end" ? A - m : ko(b, b + m, m, P, ee, b + A, b + A + x, x), ae = Math.max(0, ae + g), se = Math.max(0, se + b);
    else {
      ae = s === "start" ? j - z - B : s === "end" ? j - L + te + q : s === "nearest" ? ko(z, L, J, B, te + q, j, j + w, w) : j - (z + J / 2) + q / 2, se = l === "start" ? A - N - P : l === "center" ? A - (N + le / 2) + ge / 2 : l === "end" ? A - F + ee + ge : ko(N, F, le, P, ee + ge, A, A + x, x);
      const { scrollLeft: Ze, scrollTop: Qe } = Z;
      ae = ne === 0 ? 0 : Math.max(0, Math.min(Qe + ae / ne, Z.scrollHeight - J / ne + q)), se = ke === 0 ? 0 : Math.max(0, Math.min(Ze + se / ke, Z.scrollWidth - le / ke + ge)), j += Qe - ae, A += Ze - se;
    }
    W.push({ el: Z, top: ae, left: se });
  }
  return W;
};
var ur = function() {
  return ur = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, ur.apply(this, arguments);
};
var A8 = 0;
function m1(e) {
  return typeof e == "function" ? e : ot;
}
function ot() {
}
function bf(e, r) {
  if (e) {
    var t = P8(e, {
      boundary: r,
      block: "nearest",
      scrollMode: "if-needed"
    });
    t.forEach(function(n) {
      var o = n.el, i = n.top, a = n.left;
      o.scrollTop = i, o.scrollLeft = a;
    });
  }
}
function g1(e, r, t) {
  var n = e === r || r instanceof t.Node && e.contains && e.contains(r);
  return n;
}
function ml(e, r) {
  var t;
  function n() {
    t && clearTimeout(t);
  }
  function o() {
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    n(), t = setTimeout(function() {
      t = null, e.apply(void 0, a);
    }, r);
  }
  return o.cancel = n, o;
}
function Pe() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
      i[a - 1] = arguments[a];
    return r.some(function(s) {
      return s && s.apply(void 0, [n].concat(i)), n.preventDownshiftDefault || n.hasOwnProperty("nativeEvent") && n.nativeEvent.preventDownshiftDefault;
    });
  };
}
function cn() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    r.forEach(function(o) {
      typeof o == "function" ? o(n) : o && (o.current = n);
    });
  };
}
function Mf() {
  return String(A8++);
}
function L8(e) {
  var r = e.isOpen, t = e.resultCount, n = e.previousResultCount;
  return r ? t ? t !== n ? t + " result" + (t === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function y1(e, r) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && r ? r : e;
}
function Df(e) {
  return typeof e.type == "string";
}
function _f(e) {
  return e.props;
}
function V8(e, r) {
  console.error('The property "' + r + '" is required in "' + e + '"');
}
var H8 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function So(e) {
  e === void 0 && (e = {});
  var r = {};
  return H8.forEach(function(t) {
    e.hasOwnProperty(t) && (r[t] = e[t]);
  }), r;
}
function ro(e, r) {
  return !e || !r ? e : Object.keys(e).reduce(function(t, n) {
    return t[n] = Mi(r, n) ? r[n] : e[n], t;
  }, {});
}
function Mi(e, r) {
  return e[r] !== void 0;
}
function oo(e) {
  var r = e.key, t = e.keyCode;
  return t >= 37 && t <= 40 && r.indexOf("Arrow") !== 0 ? "Arrow" + r : r;
}
function F8(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function On(e, r, t, n, o) {
  o === void 0 && (o = !1);
  var i = t.length;
  if (i === 0)
    return -1;
  var a = i - 1;
  (typeof e != "number" || e < 0 || e > a) && (e = r > 0 ? -1 : a + 1);
  var s = e + r;
  s < 0 ? s = o ? a : 0 : s > a && (s = o ? 0 : a);
  var l = dr(s, r < 0, t, n, o);
  return l === -1 ? e >= i ? -1 : e : l;
}
function dr(e, r, t, n, o) {
  o === void 0 && (o = !1);
  var i = t.length;
  if (r) {
    for (var a = e; a >= 0; a--)
      if (!n(t[a], a))
        return a;
  } else
    for (var s = e; s < i; s++)
      if (!n(t[s], s))
        return s;
  return o ? dr(r ? i - 1 : 0, r, t, n) : -1;
}
function Di(e, r, t, n) {
  return n === void 0 && (n = !0), t && r.some(function(o) {
    return o && (g1(o, e, t) || n && g1(o, t.document.activeElement, t));
  });
}
var gl = ot;
process.env.NODE_ENV !== "production" && (gl = function(r, t, n) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(r).forEach(function(i) {
    t[i] !== void 0 && n[i] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + i + '" to be uncontrolled. ' + o) : t[i] === void 0 && n[i] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + i + '" to be controlled. ' + o);
  });
});
var Y8 = ml(function(e) {
  Ef(e).textContent = "";
}, 500);
function Ef(e) {
  var r = e.getElementById("a11y-status-message");
  return r || (r = e.createElement("div"), r.setAttribute("id", "a11y-status-message"), r.setAttribute("role", "status"), r.setAttribute("aria-live", "polite"), r.setAttribute("aria-relevant", "additions text"), Object.assign(r.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(r), r);
}
function If(e, r) {
  if (!(!e || !r)) {
    var t = Ef(r);
    t.textContent = e, Y8(r);
  }
}
function $8(e) {
  var r = e == null ? void 0 : e.getElementById("a11y-status-message");
  r && r.remove();
}
var Of = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Nf = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Tf = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Wo = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Bo = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, kf = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Sf = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Rf = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, jf = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Pf = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Af = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Lf = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Vf = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, bs = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Hf = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Ff = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Yf = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, z8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: Of,
  mouseUp: Nf,
  itemMouseEnter: Tf,
  keyDownArrowUp: Wo,
  keyDownArrowDown: Bo,
  keyDownEscape: kf,
  keyDownEnter: Sf,
  keyDownHome: Rf,
  keyDownEnd: jf,
  clickItem: Pf,
  blurInput: Af,
  changeInput: Lf,
  keyDownSpaceButton: Vf,
  clickButton: bs,
  blurButton: Hf,
  controlledPropUpdatedSelectedItem: Ff,
  touchEnd: Yf
}), Z8 = ["refKey", "ref"], W8 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], B8 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], U8 = ["refKey", "ref"], K8 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Q8 = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(r) {
    function t(o) {
      var i;
      i = r.call(this, o) || this, i.id = i.props.id || "downshift-" + Mf(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(g) {
        return i.id + "-item-" + g;
      }, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(g, w) {
        var x = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(C) {
            return C !== x;
          }), g();
        }, w);
        i.timeoutIds.push(x);
      }, i.setItemCount = function(g) {
        i.itemCount = g;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.isItemDisabled = function(g, w) {
        var x = i.getItemNodeFromIndex(w);
        return x && x.hasAttribute("disabled");
      }, i.setHighlightedIndex = function(g, w) {
        g === void 0 && (g = i.props.defaultHighlightedIndex), w === void 0 && (w = {}), w = So(w), i.internalSetState(ue({
          highlightedIndex: g
        }, w));
      }, i.clearSelection = function(g) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, g);
      }, i.selectItem = function(g, w, x) {
        w = So(w), i.internalSetState(ue({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: g,
          inputValue: i.props.itemToString(g)
        }, w), x);
      }, i.selectItemAtIndex = function(g, w, x) {
        var C = i.items[g];
        C != null && i.selectItem(C, w, x);
      }, i.selectHighlightedItem = function(g, w) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, g, w);
      }, i.internalSetState = function(g, w) {
        var x, C, O = {}, E = typeof g == "function";
        return !E && g.hasOwnProperty("inputValue") && i.props.onInputValueChange(g.inputValue, ue({}, i.getStateAndHelpers(), g)), i.setState(function(_) {
          var R;
          _ = i.getState(_);
          var H = E ? g(_) : g;
          H = i.props.stateReducer(_, H), x = H.hasOwnProperty("selectedItem");
          var $ = {};
          return x && H.selectedItem !== _.selectedItem && (C = H.selectedItem), (R = H).type || (R.type = Of), Object.keys(H).forEach(function(Y) {
            _[Y] !== H[Y] && (O[Y] = H[Y]), Y !== "type" && (H[Y], Mi(i.props, Y) || ($[Y] = H[Y]));
          }), E && H.hasOwnProperty("inputValue") && i.props.onInputValueChange(H.inputValue, ue({}, i.getStateAndHelpers(), H)), $;
        }, function() {
          m1(w)();
          var _ = Object.keys(O).length > 1;
          _ && i.props.onStateChange(O, i.getStateAndHelpers()), x && i.props.onSelect(g.selectedItem, i.getStateAndHelpers()), C !== void 0 && i.props.onChange(C, i.getStateAndHelpers()), i.props.onUserAction(O, i.getStateAndHelpers());
        });
      }, i.rootRef = function(g) {
        return i._rootNode = g;
      }, i.getRootProps = function(g, w) {
        var x, C = g === void 0 ? {} : g, O = C.refKey, E = O === void 0 ? "ref" : O, _ = C.ref, R = xt(C, Z8), H = w === void 0 ? {} : w, $ = H.suppressRefError, Y = $ === void 0 ? !1 : $;
        i.getRootProps.called = !0, i.getRootProps.refKey = E, i.getRootProps.suppressRefError = Y;
        var j = i.getState(), A = j.isOpen;
        return ue((x = {}, x[E] = cn(_, i.rootRef), x.role = "combobox", x["aria-expanded"] = A, x["aria-haspopup"] = "listbox", x["aria-owns"] = A ? i.menuId : void 0, x["aria-labelledby"] = i.labelId, x), R);
      }, i.keyDownHandlers = {
        ArrowDown: function(w) {
          var x = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var C = w.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(C, {
              type: Bo
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Bo
            }, function() {
              var O = x.getItemCount();
              if (O > 0) {
                var E = x.getState(), _ = E.highlightedIndex, R = On(_, 1, {
                  length: O
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(R, {
                  type: Bo
                });
              }
            });
        },
        ArrowUp: function(w) {
          var x = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var C = w.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(C, {
              type: Wo
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Wo
            }, function() {
              var O = x.getItemCount();
              if (O > 0) {
                var E = x.getState(), _ = E.highlightedIndex, R = On(_, -1, {
                  length: O
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(R, {
                  type: Wo
                });
              }
            });
        },
        Enter: function(w) {
          if (w.which !== 229) {
            var x = this.getState(), C = x.isOpen, O = x.highlightedIndex;
            if (C && O != null) {
              w.preventDefault();
              var E = this.items[O], _ = this.getItemNodeFromIndex(O);
              if (E == null || _ && _.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Sf
              });
            }
          }
        },
        Escape: function(w) {
          w.preventDefault(), this.reset(ue({
            type: kf
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = ue({}, i.keyDownHandlers, {
        " ": function(w) {
          w.preventDefault(), this.toggleMenu({
            type: Vf
          });
        }
      }), i.inputKeyDownHandlers = ue({}, i.keyDownHandlers, {
        Home: function(w) {
          var x = this.getState(), C = x.isOpen;
          if (C) {
            w.preventDefault();
            var O = this.getItemCount();
            if (!(O <= 0 || !C)) {
              var E = dr(0, !1, {
                length: O
              }, this.isItemDisabled);
              this.setHighlightedIndex(E, {
                type: Rf
              });
            }
          }
        },
        End: function(w) {
          var x = this.getState(), C = x.isOpen;
          if (C) {
            w.preventDefault();
            var O = this.getItemCount();
            if (!(O <= 0 || !C)) {
              var E = dr(O - 1, !0, {
                length: O
              }, this.isItemDisabled);
              this.setHighlightedIndex(E, {
                type: jf
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(g) {
        var w = g === void 0 ? {} : g, x = w.onClick;
        w.onPress;
        var C = w.onKeyDown, O = w.onKeyUp, E = w.onBlur, _ = xt(w, W8), R = i.getState(), H = R.isOpen, $ = {
          onClick: Pe(x, i.buttonHandleClick),
          onKeyDown: Pe(C, i.buttonHandleKeyDown),
          onKeyUp: Pe(O, i.buttonHandleKeyUp),
          onBlur: Pe(E, i.buttonHandleBlur)
        }, Y = _.disabled ? {} : $;
        return ue({
          type: "button",
          role: "button",
          "aria-label": H ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, Y, _);
      }, i.buttonHandleKeyUp = function(g) {
        g.preventDefault();
      }, i.buttonHandleKeyDown = function(g) {
        var w = oo(g);
        i.buttonKeyDownHandlers[w] && i.buttonKeyDownHandlers[w].call(i, g);
      }, i.buttonHandleClick = function(g) {
        if (g.preventDefault(), i.props.environment) {
          var w = i.props.environment.document, x = w.body, C = w.activeElement;
          x && x === C && g.target.focus();
        }
        process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: bs
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: bs
          });
        });
      }, i.buttonHandleBlur = function(g) {
        var w = g.target;
        i.internalSetTimeout(function() {
          if (!(i.isMouseDown || !i.props.environment)) {
            var x = i.props.environment.document.activeElement;
            (x == null || x.id !== i.inputId) && x !== w && i.reset({
              type: Hf
            });
          }
        });
      }, i.getLabelProps = function(g) {
        return ue({
          htmlFor: i.inputId,
          id: i.labelId
        }, g);
      }, i.getInputProps = function(g) {
        var w = g === void 0 ? {} : g, x = w.onKeyDown, C = w.onBlur, O = w.onChange, E = w.onInput;
        w.onChangeText;
        var _ = xt(w, B8), R, H = {};
        R = "onChange";
        var $ = i.getState(), Y = $.inputValue, j = $.isOpen, A = $.highlightedIndex;
        if (!_.disabled) {
          var W;
          H = (W = {}, W[R] = Pe(O, E, i.inputHandleChange), W.onKeyDown = Pe(x, i.inputHandleKeyDown), W.onBlur = Pe(C, i.inputHandleBlur), W);
        }
        return ue({
          "aria-autocomplete": "list",
          "aria-activedescendant": j && typeof A == "number" && A >= 0 ? i.getItemId(A) : void 0,
          "aria-controls": j ? i.menuId : void 0,
          "aria-labelledby": _ && _["aria-label"] ? void 0 : i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: Y,
          id: i.inputId
        }, H, _);
      }, i.inputHandleKeyDown = function(g) {
        var w = oo(g);
        w && i.inputKeyDownHandlers[w] && i.inputKeyDownHandlers[w].call(i, g);
      }, i.inputHandleChange = function(g) {
        i.internalSetState({
          type: Lf,
          isOpen: !0,
          inputValue: g.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var g;
          if (!(i.isMouseDown || !i.props.environment)) {
            var w = i.props.environment.document.activeElement, x = (w == null || (g = w.dataset) == null ? void 0 : g.toggle) && i._rootNode && i._rootNode.contains(w);
            x || i.reset({
              type: Af
            });
          }
        });
      }, i.menuRef = function(g) {
        i._menuNode = g;
      }, i.getMenuProps = function(g, w) {
        var x, C = g === void 0 ? {} : g, O = C.refKey, E = O === void 0 ? "ref" : O, _ = C.ref, R = xt(C, U8), H = w === void 0 ? {} : w, $ = H.suppressRefError, Y = $ === void 0 ? !1 : $;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = E, i.getMenuProps.suppressRefError = Y, ue((x = {}, x[E] = cn(_, i.menuRef), x.role = "listbox", x["aria-labelledby"] = R && R["aria-label"] ? void 0 : i.labelId, x.id = i.menuId, x), R);
      }, i.getItemProps = function(g) {
        var w, x = g === void 0 ? {} : g, C = x.onMouseMove, O = x.onMouseDown, E = x.onClick;
        x.onPress;
        var _ = x.index, R = x.item, H = R === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : V8("getItemProps", "item") : R, $ = xt(x, K8);
        _ === void 0 ? (i.items.push(H), _ = i.items.indexOf(H)) : i.items[_] = H;
        var Y = "onClick", j = E, A = (w = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Pe(C, function() {
            _ !== i.getState().highlightedIndex && (i.setHighlightedIndex(_, {
              type: Tf
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Pe(O, function(U) {
            U.preventDefault();
          })
        }, w[Y] = Pe(j, function() {
          i.selectItemAtIndex(_, {
            type: Pf
          });
        }), w), W = $.disabled ? {
          onMouseDown: A.onMouseDown
        } : A;
        return ue({
          id: i.getItemId(_),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === _
        }, W, $);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(g, w) {
        g === void 0 && (g = {}), g = So(g), i.internalSetState(function(x) {
          var C = x.selectedItem;
          return ue({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(C)
          }, g);
        }, w);
      }, i.toggleMenu = function(g, w) {
        g === void 0 && (g = {}), g = So(g), i.internalSetState(function(x) {
          var C = x.isOpen;
          return ue({
            isOpen: !C
          }, C && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, g);
        }, function() {
          var x = i.getState(), C = x.isOpen, O = x.highlightedIndex;
          C && i.getItemCount() > 0 && typeof O == "number" && i.setHighlightedIndex(O, g), m1(w)();
        });
      }, i.openMenu = function(g) {
        i.internalSetState({
          isOpen: !0
        }, g);
      }, i.closeMenu = function(g) {
        i.internalSetState({
          isOpen: !1
        }, g);
      }, i.updateStatus = ml(function() {
        var g;
        if ((g = i.props) != null && (g = g.environment) != null && g.document) {
          var w = i.getState(), x = i.items[w.highlightedIndex], C = i.getItemCount(), O = i.props.getA11yStatusMessage(ue({
            itemToString: i.props.itemToString,
            previousResultCount: i.previousResultCount,
            resultCount: C,
            highlightedItem: x
          }, w));
          i.previousResultCount = C, If(O, i.props.environment.document);
        }
      }, 200);
      var a = i.props, s = a.defaultHighlightedIndex, l = a.initialHighlightedIndex, c = l === void 0 ? s : l, u = a.defaultIsOpen, d = a.initialIsOpen, h = d === void 0 ? u : d, p = a.initialInputValue, v = p === void 0 ? "" : p, m = a.initialSelectedItem, y = m === void 0 ? null : m, b = i.getState({
        highlightedIndex: c,
        isOpen: h,
        inputValue: v,
        selectedItem: y
      });
      return b.selectedItem != null && i.props.initialInputValue === void 0 && (b.inputValue = i.props.itemToString(b.selectedItem)), i.state = b, i;
    }
    k8(t, r);
    var n = t.prototype;
    return n.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(i) {
        clearTimeout(i);
      }), this.timeoutIds = [];
    }, n.getState = function(i) {
      return i === void 0 && (i = this.state), ro(i, this.props);
    }, n.getItemCount = function() {
      var i = this.items.length;
      return this.itemCount != null ? i = this.itemCount : this.props.itemCount !== void 0 && (i = this.props.itemCount), i;
    }, n.getItemNodeFromIndex = function(i) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(i)) : null;
    }, n.scrollHighlightedItemIntoView = function() {
      {
        var i = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(i, this._menuNode);
      }
    }, n.moveHighlightedIndex = function(i, a) {
      var s = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (s > 0) {
        var u = On(c, i, {
          length: s
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, a);
      }
    }, n.getStateAndHelpers = function() {
      var i = this.getState(), a = i.highlightedIndex, s = i.inputValue, l = i.selectedItem, c = i.isOpen, u = this.props.itemToString, d = this.id, h = this.getRootProps, p = this.getToggleButtonProps, v = this.getLabelProps, m = this.getMenuProps, y = this.getInputProps, b = this.getItemProps, g = this.openMenu, w = this.closeMenu, x = this.toggleMenu, C = this.selectItem, O = this.selectItemAtIndex, E = this.selectHighlightedItem, _ = this.setHighlightedIndex, R = this.clearSelection, H = this.clearItems, $ = this.reset, Y = this.setItemCount, j = this.unsetItemCount, A = this.internalSetState;
      return {
        // prop getters
        getRootProps: h,
        getToggleButtonProps: p,
        getLabelProps: v,
        getMenuProps: m,
        getInputProps: y,
        getItemProps: b,
        // actions
        reset: $,
        openMenu: g,
        closeMenu: w,
        toggleMenu: x,
        selectItem: C,
        selectItemAtIndex: O,
        selectHighlightedItem: E,
        setHighlightedIndex: _,
        clearSelection: R,
        clearItems: H,
        setItemCount: Y,
        unsetItemCount: j,
        setState: A,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: a,
        inputValue: s,
        isOpen: c,
        selectedItem: l
      };
    }, n.componentDidMount = function() {
      var i = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && w1(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          i.internalClearTimeouts();
        };
      else {
        var a = function() {
          i.isMouseDown = !0;
        }, s = function(p) {
          i.isMouseDown = !1;
          var v = Di(p.target, [i._rootNode, i._menuNode], i.props.environment);
          !v && i.getState().isOpen && i.reset({
            type: Nf
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, l = function() {
          i.isTouchMove = !1;
        }, c = function() {
          i.isTouchMove = !0;
        }, u = function(p) {
          var v = Di(p.target, [i._rootNode, i._menuNode], i.props.environment, !1);
          !i.isTouchMove && !v && i.getState().isOpen && i.reset({
            type: Yf
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", a), d.addEventListener("mouseup", s), d.addEventListener("touchstart", l), d.addEventListener("touchmove", c), d.addEventListener("touchend", u), this.cleanup = function() {
          i.internalClearTimeouts(), i.updateStatus.cancel(), d.removeEventListener("mousedown", a), d.removeEventListener("mouseup", s), d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", c), d.removeEventListener("touchend", u);
        };
      }
    }, n.shouldScroll = function(i, a) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = s.highlightedIndex, c = a.highlightedIndex === void 0 ? i : a, u = c.highlightedIndex, d = l && this.getState().isOpen && !i.isOpen, h = l !== u;
      return d || h;
    }, n.componentDidUpdate = function(i, a) {
      process.env.NODE_ENV !== "production" && (gl(this.state, i, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && w1(this._menuNode, this.getMenuProps)), Mi(this.props, "selectedItem") && this.props.selectedItemChanged(i.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Ff,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(a, i) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, n.componentWillUnmount = function() {
      this.cleanup();
    }, n.render = function() {
      var i = y1(this.props.children, ot);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var a = y1(i(this.getStateAndHelpers()));
      if (!a)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && q8(a, this.getRootProps), a;
      if (Df(a))
        return /* @__PURE__ */ Oi(a, this.getRootProps(_f(a)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, t;
  }(j1);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: L8,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && F8(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: ot,
    onInputValueChange: ot,
    onUserAction: ot,
    onChange: ot,
    onSelect: ot,
    onOuterClick: ot,
    selectedItemChanged: function(t, n) {
      return t !== n;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, n) {
      return n;
    },
    suppressRefError: !1,
    scrollIntoView: bf
  }, e.stateChangeTypes = z8, e;
}();
process.env.NODE_ENV !== "production" && (Q8.propTypes = {
  children: K.func,
  defaultHighlightedIndex: K.number,
  defaultIsOpen: K.bool,
  initialHighlightedIndex: K.number,
  initialSelectedItem: K.any,
  initialInputValue: K.string,
  initialIsOpen: K.bool,
  getA11yStatusMessage: K.func,
  itemToString: K.func,
  onChange: K.func,
  onSelect: K.func,
  onStateChange: K.func,
  onInputValueChange: K.func,
  onUserAction: K.func,
  onOuterClick: K.func,
  selectedItemChanged: K.func,
  stateReducer: K.func,
  itemCount: K.number,
  id: K.string,
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  suppressRefError: K.bool,
  scrollIntoView: K.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: K.any,
  isOpen: K.bool,
  inputValue: K.string,
  highlightedIndex: K.number,
  labelId: K.string,
  inputId: K.string,
  menuId: K.string,
  getItemId: K.func
  /* eslint-enable react/no-unused-prop-types */
});
function w1(e, r) {
  var t = r.refKey;
  e || console.error('downshift: The ref prop "' + t + '" from getMenuProps was not applied correctly on your menu element.');
}
function q8(e, r) {
  var t = r.refKey, n = t !== "ref", o = !Df(e);
  o && !n && !p1.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && n && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + t + '"'), !p1.isForwardRef(e) && !_f(e)[t] && console.error('downshift: You must apply the ref prop "' + t + '" from getRootProps onto your root element.');
}
var $f = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function G8(e, r, t) {
  var n = e.props, o = e.type, i = {};
  Object.keys(r).forEach(function(a) {
    X8(a, e, r, t), t[a] !== r[a] && (i[a] = t[a]);
  }), n.onStateChange && Object.keys(i).length && n.onStateChange(ue({
    type: o
  }, i));
}
function X8(e, r, t, n) {
  var o = r.props, i = r.type, a = "on" + yl(e) + "Change";
  o[a] && n[e] !== void 0 && n[e] !== t[e] && o[a](ue({
    type: i
  }, n));
}
function J8(e, r) {
  return r.changes;
}
var x1 = ml(function(e, r) {
  If(e, r);
}, 200), e9 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ao : fe, t9 = "useId" in S ? function(r) {
  var t = r.id, n = r.labelId, o = r.menuId, i = r.getItemId, a = r.toggleButtonId, s = r.inputId, l = "downshift-" + S.useId();
  t || (t = l);
  var c = me({
    labelId: n || t + "-label",
    menuId: o || t + "-menu",
    getItemId: i || function(u) {
      return t + "-item-" + u;
    },
    toggleButtonId: a || t + "-toggle-button",
    inputId: s || t + "-input"
  });
  return c.current;
} : function(r) {
  var t = r.id, n = t === void 0 ? "downshift-" + Mf() : t, o = r.labelId, i = r.menuId, a = r.getItemId, s = r.toggleButtonId, l = r.inputId, c = me({
    labelId: o || n + "-label",
    menuId: i || n + "-menu",
    getItemId: a || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: l || n + "-input"
  });
  return c.current;
};
function zf(e, r, t, n) {
  var o, i;
  if (e === void 0) {
    if (r === void 0)
      throw new Error(n);
    o = t[r], i = r;
  } else
    i = r === void 0 ? t.indexOf(e) : r, o = e;
  return [o, i];
}
function yl(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function wl(e) {
  var r = me(e);
  return r.current = e, r;
}
function Zf(e, r, t, n) {
  var o = me(), i = me(), a = Oe(function(p, v) {
    i.current = v, p = ro(p, v.props);
    var m = e(p, v), y = v.props.stateReducer(p, ue({}, v, {
      changes: m
    }));
    return y;
  }, [e]), s = Zp(a, r, t), l = s[0], c = s[1], u = wl(r), d = Oe(function(p) {
    return c(ue({
      props: u.current
    }, p));
  }, [u]), h = i.current;
  return fe(function() {
    var p = ro(o.current, h == null ? void 0 : h.props), v = h && o.current && !n(p, l);
    v && G8(h, p, l), o.current = l;
  }, [l, h, n]), [l, d];
}
function n9(e, r, t, n) {
  var o = Zf(e, r, t, n), i = o[0], a = o[1];
  return [ro(i, r), a];
}
var Vr = {
  itemToString: function(r) {
    return r ? String(r) : "";
  },
  itemToKey: function(r) {
    return r;
  },
  stateReducer: J8,
  scrollIntoView: bf,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Ct(e, r, t) {
  t === void 0 && (t = $f);
  var n = e["default" + yl(r)];
  return n !== void 0 ? n : t[r];
}
function er(e, r, t) {
  t === void 0 && (t = $f);
  var n = e[r];
  if (n !== void 0)
    return n;
  var o = e["initial" + yl(r)];
  return o !== void 0 ? o : Ct(e, r, t);
}
function r9(e) {
  var r = er(e, "selectedItem"), t = er(e, "isOpen"), n = er(e, "highlightedIndex"), o = er(e, "inputValue");
  return {
    highlightedIndex: n < 0 && r && t ? e.items.findIndex(function(i) {
      return e.itemToKey(i) === e.itemToKey(r);
    }) : n,
    isOpen: t,
    selectedItem: r,
    inputValue: o
  };
}
function Hr(e, r, t) {
  var n = e.items, o = e.initialHighlightedIndex, i = e.defaultHighlightedIndex, a = e.isItemDisabled, s = e.itemToKey, l = r.selectedItem, c = r.highlightedIndex;
  return n.length === 0 ? -1 : o !== void 0 && c === o && !a(n[o]) ? o : i !== void 0 && !a(n[i]) ? i : l ? n.findIndex(function(u) {
    return s(l) === s(u);
  }) : t < 0 && !a(n[n.length - 1]) ? n.length - 1 : t > 0 && !a(n[0]) ? 0 : -1;
}
function o9(e, r, t) {
  var n = me({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return fe(function() {
    if (!e)
      return ot;
    var o = r.map(function(u) {
      return u.current;
    });
    function i() {
      n.current.isTouchEnd = !1, n.current.isMouseDown = !0;
    }
    function a(u) {
      n.current.isMouseDown = !1, Di(u.target, o, e) || t();
    }
    function s() {
      n.current.isTouchEnd = !1, n.current.isTouchMove = !1;
    }
    function l() {
      n.current.isTouchMove = !0;
    }
    function c(u) {
      n.current.isTouchEnd = !0, !n.current.isTouchMove && !Di(u.target, o, e, !1) && t();
    }
    return e.addEventListener("mousedown", i), e.addEventListener("mouseup", a), e.addEventListener("touchstart", s), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function() {
      e.removeEventListener("mousedown", i), e.removeEventListener("mouseup", a), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [e, t]), n.current;
}
var xl = function() {
  return ot;
};
process.env.NODE_ENV !== "production" && (xl = function() {
  for (var r = me(!0), t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  var i = me(n.reduce(function(s, l) {
    return s[l] = {}, s;
  }, {}));
  fe(function() {
    Object.keys(i.current).forEach(function(s) {
      var l = i.current[s];
      if (r.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + s + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError, u = l.refKey, d = l.elementRef;
      (!d || !d.current) && !c && console.error('downshift: The ref prop "' + u + '" from ' + s + " was not applied correctly on your element.");
    }), r.current = !1;
  });
  var a = Oe(function(s, l, c, u) {
    i.current[s] = {
      suppressRefError: l,
      refKey: c,
      elementRef: u
    };
  }, []);
  return a;
});
function Wf(e, r, t, n) {
  n === void 0 && (n = {});
  var o = n.document, i = yo();
  fe(function() {
    if (!(!e || i || !o)) {
      var a = e(r);
      x1(a, o);
    }
  }, t), fe(function() {
    return function() {
      x1.cancel(), $8(o);
    };
  }, [o]);
}
function i9(e) {
  var r = e.highlightedIndex, t = e.isOpen, n = e.itemRefs, o = e.getItemNodeFromIndex, i = e.menuElement, a = e.scrollIntoView, s = me(!0);
  return e9(function() {
    r < 0 || !t || !Object.keys(n.current).length || (s.current === !1 ? s.current = !0 : a(o(r), i));
  }, [r]), s;
}
var Cl = ot;
process.env.NODE_ENV !== "production" && (Cl = function(r) {
  var t = r.props, n = r.state, o = me(t), i = yo();
  fe(function() {
    i || (gl(n, o.current, t), o.current = t);
  }, [n, t, i]);
});
function C1(e, r, t) {
  var n;
  t === void 0 && (t = !0);
  var o = ((n = e.items) == null ? void 0 : n.length) && r >= 0;
  return ue({
    isOpen: !1,
    highlightedIndex: -1
  }, o && ue({
    selectedItem: e.items[r],
    isOpen: Ct(e, "isOpen"),
    highlightedIndex: Ct(e, "highlightedIndex")
  }, t && {
    inputValue: e.itemToString(e.items[r])
  }));
}
function a9(e, r) {
  return e.isOpen === r.isOpen && e.inputValue === r.inputValue && e.highlightedIndex === r.highlightedIndex && e.selectedItem === r.selectedItem;
}
function yo() {
  var e = S.useRef(!0);
  return S.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
var Uo = {
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  itemToString: K.func,
  itemToKey: K.func,
  stateReducer: K.func
}, Bf = ue({}, Uo, {
  getA11yStatusMessage: K.func,
  highlightedIndex: K.number,
  defaultHighlightedIndex: K.number,
  initialHighlightedIndex: K.number,
  isOpen: K.bool,
  defaultIsOpen: K.bool,
  initialIsOpen: K.bool,
  selectedItem: K.any,
  initialSelectedItem: K.any,
  defaultSelectedItem: K.any,
  id: K.string,
  labelId: K.string,
  menuId: K.string,
  getItemId: K.func,
  toggleButtonId: K.string,
  onSelectedItemChange: K.func,
  onHighlightedIndexChange: K.func,
  onStateChange: K.func,
  onIsOpenChange: K.func,
  scrollIntoView: K.func
});
function s9(e, r, t) {
  var n = r.type, o = r.props, i;
  switch (n) {
    case t.ItemMouseMove:
      i = {
        highlightedIndex: r.disabled ? -1 : r.index
      };
      break;
    case t.MenuMouseLeave:
      i = {
        highlightedIndex: -1
      };
      break;
    case t.ToggleButtonClick:
    case t.FunctionToggleMenu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Hr(o, e, 0)
      };
      break;
    case t.FunctionOpenMenu:
      i = {
        isOpen: !0,
        highlightedIndex: Hr(o, e, 0)
      };
      break;
    case t.FunctionCloseMenu:
      i = {
        isOpen: !1
      };
      break;
    case t.FunctionSetHighlightedIndex:
      i = {
        highlightedIndex: r.highlightedIndex
      };
      break;
    case t.FunctionSetInputValue:
      i = {
        inputValue: r.inputValue
      };
      break;
    case t.FunctionReset:
      i = {
        highlightedIndex: Ct(o, "highlightedIndex"),
        isOpen: Ct(o, "isOpen"),
        selectedItem: Ct(o, "selectedItem"),
        inputValue: Ct(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ue({}, e, i);
}
ur(ur({}, Bf), { items: K.array.isRequired, isItemDisabled: K.func });
ur(ur({}, Vr), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var bl = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Ml = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Dl = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, _l = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, El = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Il = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Ol = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Nl = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Tl = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, _i = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, kl = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Uf = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Kf = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Sl = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Qf = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, qf = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Gf = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Xf = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Jf = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Rl = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, ep = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, tp = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, jl = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, np = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: bl,
  InputKeyDownArrowUp: Ml,
  InputKeyDownEscape: Dl,
  InputKeyDownHome: _l,
  InputKeyDownEnd: El,
  InputKeyDownPageUp: Il,
  InputKeyDownPageDown: Ol,
  InputKeyDownEnter: Nl,
  InputChange: Tl,
  InputBlur: _i,
  InputClick: kl,
  MenuMouseLeave: Uf,
  ItemMouseMove: Kf,
  ItemClick: Sl,
  ToggleButtonClick: Qf,
  FunctionToggleMenu: qf,
  FunctionOpenMenu: Gf,
  FunctionCloseMenu: Xf,
  FunctionSetHighlightedIndex: Jf,
  FunctionSelectItem: Rl,
  FunctionSetInputValue: ep,
  FunctionReset: tp,
  ControlledPropUpdatedSelectedItem: jl
});
function l9(e) {
  var r = r9(e), t = r.selectedItem, n = r.inputValue;
  return n === "" && t && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (n = e.itemToString(t)), ue({}, r, {
    inputValue: n
  });
}
var c9 = ue({}, Bf, {
  items: K.array.isRequired,
  isItemDisabled: K.func,
  inputValue: K.string,
  defaultInputValue: K.string,
  initialInputValue: K.string,
  inputId: K.string,
  onInputValueChange: K.func
});
function u9(e, r, t, n) {
  var o = me(), i = Zf(e, r, t, n), a = i[0], s = i[1], l = yo();
  return fe(function() {
    if (Mi(r, "selectedItem")) {
      if (!l) {
        var c = r.itemToKey(r.selectedItem) !== r.itemToKey(o.current);
        c && s({
          type: jl,
          inputValue: r.itemToString(r.selectedItem)
        });
      }
      o.current = a.selectedItem === o.current ? r.selectedItem : a.selectedItem;
    }
  }, [a.selectedItem, r.selectedItem]), [ro(a, r), s];
}
var rp = ot;
process.env.NODE_ENV !== "production" && (rp = function(r, t) {
  K.checkPropTypes(c9, r, "prop", t.name);
});
var d9 = ue({}, Vr, {
  isItemDisabled: function() {
    return !1;
  }
});
function f9(e, r) {
  var t, n = r.type, o = r.props, i = r.altKey, a;
  switch (n) {
    case Sl:
      a = {
        isOpen: Ct(o, "isOpen"),
        highlightedIndex: Ct(o, "highlightedIndex"),
        selectedItem: o.items[r.index],
        inputValue: o.itemToString(o.items[r.index])
      };
      break;
    case bl:
      e.isOpen ? a = {
        highlightedIndex: On(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : a = {
        highlightedIndex: i && e.selectedItem == null ? -1 : Hr(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case Ml:
      e.isOpen ? i ? a = C1(o, e.highlightedIndex) : a = {
        highlightedIndex: On(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : a = {
        highlightedIndex: Hr(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case Nl:
      a = C1(o, e.highlightedIndex);
      break;
    case Dl:
      a = ue({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Il:
      a = {
        highlightedIndex: On(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Ol:
      a = {
        highlightedIndex: On(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case _l:
      a = {
        highlightedIndex: dr(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case El:
      a = {
        highlightedIndex: dr(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case _i:
      a = ue({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((t = o.items) == null ? void 0 : t.length) && r.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case Tl:
      a = {
        isOpen: !0,
        highlightedIndex: Ct(o, "highlightedIndex"),
        inputValue: r.inputValue
      };
      break;
    case kl:
      a = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Hr(o, e, 0)
      };
      break;
    case Rl:
      a = {
        selectedItem: r.selectedItem,
        inputValue: o.itemToString(r.selectedItem)
      };
      break;
    case jl:
      a = {
        inputValue: r.inputValue
      };
      break;
    default:
      return s9(e, r, np);
  }
  return ue({}, e, a);
}
var p9 = ["onMouseLeave", "refKey", "ref"], h9 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], v9 = ["onClick", "onPress", "refKey", "ref"], m9 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
kt.stateChangeTypes = np;
function kt(e) {
  e === void 0 && (e = {}), rp(e, kt);
  var r = ue({}, d9, e), t = r.items, n = r.scrollIntoView, o = r.environment, i = r.getA11yStatusMessage, a = u9(f9, r, l9, a9), s = a[0], l = a[1], c = s.isOpen, u = s.highlightedIndex, d = s.selectedItem, h = s.inputValue, p = me(null), v = me({}), m = me(null), y = me(null), b = yo(), g = t9(r), w = me(), x = wl({
    state: s,
    props: r
  }), C = Oe(function(L) {
    return v.current[g.getItemId(L)];
  }, [g]);
  Wf(i, s, [c, u, d, h], o);
  var O = i9({
    menuElement: p.current,
    highlightedIndex: u,
    isOpen: c,
    itemRefs: v,
    scrollIntoView: n,
    getItemNodeFromIndex: C
  });
  Cl({
    props: r,
    state: s
  }), fe(function() {
    var L = er(r, "isOpen");
    L && m.current && m.current.focus();
  }, []), fe(function() {
    b || (w.current = t.length);
  });
  var E = o9(o, [y, p, m], Oe(function() {
    x.current.state.isOpen && l({
      type: _i,
      selectItem: !1
    });
  }, [l, x])), _ = xl("getInputProps", "getMenuProps");
  fe(function() {
    c || (v.current = {});
  }, [c]), fe(function() {
    var L;
    !c || !(o != null && o.document) || !(m != null && (L = m.current) != null && L.focus) || o.document.activeElement !== m.current && m.current.focus();
  }, [c, o]);
  var R = it(function() {
    return {
      ArrowDown: function(N) {
        N.preventDefault(), l({
          type: bl,
          altKey: N.altKey
        });
      },
      ArrowUp: function(N) {
        N.preventDefault(), l({
          type: Ml,
          altKey: N.altKey
        });
      },
      Home: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: _l
        }));
      },
      End: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: El
        }));
      },
      Escape: function(N) {
        var I = x.current.state;
        (I.isOpen || I.inputValue || I.selectedItem || I.highlightedIndex > -1) && (N.preventDefault(), l({
          type: Dl
        }));
      },
      Enter: function(N) {
        var I = x.current.state;
        !I.isOpen || N.which === 229 || (N.preventDefault(), l({
          type: Nl
        }));
      },
      PageUp: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: Il
        }));
      },
      PageDown: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: Ol
        }));
      }
    };
  }, [l, x]), H = Oe(function(L) {
    return ue({
      id: g.labelId,
      htmlFor: g.inputId
    }, L);
  }, [g]), $ = Oe(function(L, N) {
    var I, P = L === void 0 ? {} : L, B = P.onMouseLeave, ee = P.refKey, te = ee === void 0 ? "ref" : ee, ae = P.ref, se = xt(P, p9), ge = N === void 0 ? {} : N, q = ge.suppressRefError, ke = q === void 0 ? !1 : q;
    return _("getMenuProps", ke, te, p), ue((I = {}, I[te] = cn(ae, function(ne) {
      p.current = ne;
    }), I.id = g.menuId, I.role = "listbox", I["aria-labelledby"] = se && se["aria-label"] ? void 0 : "" + g.labelId, I.onMouseLeave = Pe(B, function() {
      l({
        type: Uf
      });
    }), I), se);
  }, [l, _, g]), Y = Oe(function(L) {
    var N, I, P = L === void 0 ? {} : L, B = P.item, ee = P.index, te = P.refKey, ae = te === void 0 ? "ref" : te, se = P.ref, ge = P.onMouseMove, q = P.onMouseDown, ke = P.onClick;
    P.onPress;
    var ne = P.disabled, Ze = xt(P, h9);
    ne !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Qe = x.current, vt = Qe.props, ct = Qe.state, Hn = zf(B, ee, vt.items, "Pass either item or index to getItemProps!"), Fn = Hn[0], mt = Hn[1], qt = vt.isItemDisabled(Fn, mt), Yn = "onClick", $n = ke, Et = function() {
      E.isTouchEnd || mt === ct.highlightedIndex || (O.current = !1, l({
        type: Kf,
        index: mt,
        disabled: qt
      }));
    }, It = function() {
      l({
        type: Sl,
        index: mt
      });
    }, Ot = function(Gi) {
      return Gi.preventDefault();
    };
    return ue((N = {}, N[ae] = cn(se, function(at) {
      at && (v.current[g.getItemId(mt)] = at);
    }), N["aria-disabled"] = qt, N["aria-selected"] = "" + (mt === ct.highlightedIndex), N.id = g.getItemId(mt), N.role = "option", N), !qt && (I = {}, I[Yn] = Pe($n, It), I), {
      onMouseMove: Pe(ge, Et),
      onMouseDown: Pe(q, Ot)
    }, Ze);
  }, [l, g, x, E, O]), j = Oe(function(L) {
    var N, I = L === void 0 ? {} : L, P = I.onClick;
    I.onPress;
    var B = I.refKey, ee = B === void 0 ? "ref" : B, te = I.ref, ae = xt(I, v9), se = x.current.state, ge = function() {
      l({
        type: Qf
      });
    };
    return ue((N = {}, N[ee] = cn(te, function(q) {
      y.current = q;
    }), N["aria-controls"] = g.menuId, N["aria-expanded"] = se.isOpen, N.id = g.toggleButtonId, N.tabIndex = -1, N), !ae.disabled && ue({}, {
      onClick: Pe(P, ge)
    }), ae);
  }, [l, x, g]), A = Oe(function(L, N) {
    var I, P = L === void 0 ? {} : L, B = P.onKeyDown, ee = P.onChange, te = P.onInput, ae = P.onBlur;
    P.onChangeText;
    var se = P.onClick, ge = P.refKey, q = ge === void 0 ? "ref" : ge, ke = P.ref, ne = xt(P, m9), Ze = N === void 0 ? {} : N, Qe = Ze.suppressRefError, vt = Qe === void 0 ? !1 : Qe;
    _("getInputProps", vt, q, m);
    var ct = x.current.state, Hn = function(Ot) {
      var at = oo(Ot);
      at && R[at] && R[at](Ot);
    }, Fn = function(Ot) {
      l({
        type: Tl,
        inputValue: Ot.target.value
      });
    }, mt = function(Ot) {
      if (o != null && o.document && ct.isOpen && !E.isMouseDown) {
        var at = Ot.relatedTarget === null && o.document.activeElement !== o.document.body;
        l({
          type: _i,
          selectItem: !at
        });
      }
    }, qt = function() {
      l({
        type: kl
      });
    }, Yn = "onChange", $n = {};
    if (!ne.disabled) {
      var Et;
      $n = (Et = {}, Et[Yn] = Pe(ee, te, Fn), Et.onKeyDown = Pe(B, Hn), Et.onBlur = Pe(ae, mt), Et.onClick = Pe(se, qt), Et);
    }
    return ue((I = {}, I[q] = cn(ke, function(It) {
      m.current = It;
    }), I["aria-activedescendant"] = ct.isOpen && ct.highlightedIndex > -1 ? g.getItemId(ct.highlightedIndex) : "", I["aria-autocomplete"] = "list", I["aria-controls"] = g.menuId, I["aria-expanded"] = ct.isOpen, I["aria-labelledby"] = ne && ne["aria-label"] ? void 0 : g.labelId, I.autoComplete = "off", I.id = g.inputId, I.role = "combobox", I.value = ct.inputValue, I), $n, ne);
  }, [l, g, o, R, x, E, _]), W = Oe(function() {
    l({
      type: qf
    });
  }, [l]), U = Oe(function() {
    l({
      type: Xf
    });
  }, [l]), Z = Oe(function() {
    l({
      type: Gf
    });
  }, [l]), J = Oe(function(L) {
    l({
      type: Jf,
      highlightedIndex: L
    });
  }, [l]), le = Oe(function(L) {
    l({
      type: Rl,
      selectedItem: L
    });
  }, [l]), z = Oe(function(L) {
    l({
      type: ep,
      inputValue: L
    });
  }, [l]), F = Oe(function() {
    l({
      type: tp
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: Y,
    getLabelProps: H,
    getMenuProps: $,
    getInputProps: A,
    getToggleButtonProps: j,
    // actions.
    toggleMenu: W,
    openMenu: Z,
    closeMenu: U,
    setHighlightedIndex: J,
    setInputValue: z,
    selectItem: le,
    reset: F,
    // state.
    highlightedIndex: u,
    isOpen: c,
    selectedItem: d,
    inputValue: h
  };
}
var op = {
  activeIndex: -1,
  selectedItems: []
};
function b1(e, r) {
  return er(e, r, op);
}
function M1(e, r) {
  return Ct(e, r, op);
}
function g9(e) {
  var r = b1(e, "activeIndex"), t = b1(e, "selectedItems");
  return {
    activeIndex: r,
    selectedItems: t
  };
}
function D1(e) {
  if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey)
    return !1;
  var r = e.target;
  return !(r instanceof HTMLInputElement && // if element is a text input
  r.value !== "" && // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  (r.selectionStart !== 0 || r.selectionEnd !== 0));
}
function y9(e, r) {
  return e.selectedItems === r.selectedItems && e.activeIndex === r.activeIndex;
}
var w9 = {
  stateReducer: Uo.stateReducer,
  itemToKey: Uo.itemToKey,
  environment: Uo.environment,
  selectedItems: K.array,
  initialSelectedItems: K.array,
  defaultSelectedItems: K.array,
  getA11yStatusMessage: K.func,
  activeIndex: K.number,
  initialActiveIndex: K.number,
  defaultActiveIndex: K.number,
  onActiveIndexChange: K.func,
  onSelectedItemsChange: K.func,
  keyNavigationNext: K.string,
  keyNavigationPrevious: K.string
}, x9 = {
  itemToKey: Vr.itemToKey,
  stateReducer: Vr.stateReducer,
  environment: Vr.environment,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
}, ip = ot;
process.env.NODE_ENV !== "production" && (ip = function(r, t) {
  K.checkPropTypes(w9, r, "prop", t.name);
});
var Pl = process.env.NODE_ENV !== "production" ? "__selected_item_click__" : 0, Al = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_delete__" : 1, Ll = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_backspace__" : 2, Vl = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_next__" : 3, Hl = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_previous__" : 4, Fl = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_navigation_previous__" : 5, Yl = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_backspace__" : 6, $l = process.env.NODE_ENV !== "production" ? "__dropdown_click__" : 7, zl = process.env.NODE_ENV !== "production" ? "__function_add_selected_item__" : 8, Zl = process.env.NODE_ENV !== "production" ? "__function_remove_selected_item__" : 9, Wl = process.env.NODE_ENV !== "production" ? "__function_set_selected_items__" : 10, Bl = process.env.NODE_ENV !== "production" ? "__function_set_active_index__" : 11, Ul = process.env.NODE_ENV !== "production" ? "__function_reset__" : 12, C9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  SelectedItemClick: Pl,
  SelectedItemKeyDownDelete: Al,
  SelectedItemKeyDownBackspace: Ll,
  SelectedItemKeyDownNavigationNext: Vl,
  SelectedItemKeyDownNavigationPrevious: Hl,
  DropdownKeyDownNavigationPrevious: Fl,
  DropdownKeyDownBackspace: Yl,
  DropdownClick: $l,
  FunctionAddSelectedItem: zl,
  FunctionRemoveSelectedItem: Zl,
  FunctionSetSelectedItems: Wl,
  FunctionSetActiveIndex: Bl,
  FunctionReset: Ul
});
function b9(e, r) {
  var t = r.type, n = r.index, o = r.props, i = r.selectedItem, a = e.activeIndex, s = e.selectedItems, l;
  switch (t) {
    case Pl:
      l = {
        activeIndex: n
      };
      break;
    case Hl:
      l = {
        activeIndex: a - 1 < 0 ? 0 : a - 1
      };
      break;
    case Vl:
      l = {
        activeIndex: a + 1 >= s.length ? -1 : a + 1
      };
      break;
    case Ll:
    case Al: {
      if (a < 0)
        break;
      var c = a;
      s.length === 1 ? c = -1 : a === s.length - 1 && (c = s.length - 2), l = ue({
        selectedItems: [].concat(s.slice(0, a), s.slice(a + 1))
      }, {
        activeIndex: c
      });
      break;
    }
    case Fl:
      l = {
        activeIndex: s.length - 1
      };
      break;
    case Yl:
      l = {
        selectedItems: s.slice(0, s.length - 1)
      };
      break;
    case zl:
      l = {
        selectedItems: [].concat(s, [i])
      };
      break;
    case $l:
      l = {
        activeIndex: -1
      };
      break;
    case Zl: {
      var u = a, d = s.findIndex(function(v) {
        return o.itemToKey(v) === o.itemToKey(i);
      });
      if (d < 0)
        break;
      s.length === 1 ? u = -1 : d === s.length - 1 && (u = s.length - 2), l = {
        selectedItems: [].concat(s.slice(0, d), s.slice(d + 1)),
        activeIndex: u
      };
      break;
    }
    case Wl: {
      var h = r.selectedItems;
      l = {
        selectedItems: h
      };
      break;
    }
    case Bl: {
      var p = r.activeIndex;
      l = {
        activeIndex: p
      };
      break;
    }
    case Ul:
      l = {
        activeIndex: M1(o, "activeIndex"),
        selectedItems: M1(o, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ue({}, e, l);
}
var M9 = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"], D9 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
Dn.stateChangeTypes = C9;
function Dn(e) {
  e === void 0 && (e = {}), ip(e, Dn);
  var r = ue({}, x9, e), t = r.getA11yStatusMessage, n = r.environment, o = r.keyNavigationNext, i = r.keyNavigationPrevious, a = n9(b9, r, g9, y9), s = a[0], l = a[1], c = s.activeIndex, u = s.selectedItems, d = yo(), h = me(null), p = me();
  p.current = [];
  var v = wl({
    state: s,
    props: r
  });
  Wf(t, s, [c, u], n), fe(function() {
    d || (c === -1 && h.current ? h.current.focus() : p.current[c] && p.current[c].focus());
  }, [c]), Cl({
    props: r,
    state: s
  });
  var m = xl("getDropdownProps"), y = it(function() {
    var R;
    return R = {}, R[i] = function() {
      l({
        type: Hl
      });
    }, R[o] = function() {
      l({
        type: Vl
      });
    }, R.Delete = function() {
      l({
        type: Al
      });
    }, R.Backspace = function() {
      l({
        type: Ll
      });
    }, R;
  }, [l, o, i]), b = it(function() {
    var R;
    return R = {}, R[i] = function(H) {
      D1(H) && l({
        type: Fl
      });
    }, R.Backspace = function($) {
      D1($) && l({
        type: Yl
      });
    }, R;
  }, [l, i]), g = Oe(function(R) {
    var H, $ = R === void 0 ? {} : R, Y = $.refKey, j = Y === void 0 ? "ref" : Y, A = $.ref, W = $.onClick, U = $.onKeyDown, Z = $.selectedItem, J = $.index, le = xt($, M9), z = v.current.state, F = zf(Z, J, z.selectedItems, "Pass either item or index to getSelectedItemProps!"), L = F[1], N = L > -1 && L === z.activeIndex, I = function() {
      l({
        type: Pl,
        index: L
      });
    }, P = function(ee) {
      var te = oo(ee);
      te && y[te] && y[te](ee);
    };
    return ue((H = {}, H[j] = cn(A, function(B) {
      B && p.current.push(B);
    }), H.tabIndex = N ? 0 : -1, H.onClick = Pe(W, I), H.onKeyDown = Pe(U, P), H), le);
  }, [l, v, y]), w = Oe(function(R, H) {
    var $, Y = R === void 0 ? {} : R, j = Y.refKey, A = j === void 0 ? "ref" : j, W = Y.ref, U = Y.onKeyDown, Z = Y.onClick, J = Y.preventKeyAction, le = J === void 0 ? !1 : J, z = xt(Y, D9), F = H === void 0 ? {} : H, L = F.suppressRefError, N = L === void 0 ? !1 : L;
    m("getDropdownProps", N, A, h);
    var I = function(ee) {
      var te = oo(ee);
      te && b[te] && b[te](ee);
    }, P = function() {
      l({
        type: $l
      });
    };
    return ue(($ = {}, $[A] = cn(W, function(B) {
      B && (h.current = B);
    }), $), !le && {
      onKeyDown: Pe(U, I),
      onClick: Pe(Z, P)
    }, z);
  }, [l, b, m]), x = Oe(function(R) {
    l({
      type: zl,
      selectedItem: R
    });
  }, [l]), C = Oe(function(R) {
    l({
      type: Zl,
      selectedItem: R
    });
  }, [l]), O = Oe(function(R) {
    l({
      type: Wl,
      selectedItems: R
    });
  }, [l]), E = Oe(function(R) {
    l({
      type: Bl,
      activeIndex: R
    });
  }, [l]), _ = Oe(function() {
    l({
      type: Ul
    });
  }, [l]);
  return {
    getSelectedItemProps: g,
    getDropdownProps: w,
    addSelectedItem: x,
    removeSelectedItem: C,
    setSelectedItems: O,
    setActiveIndex: E,
    reset: _,
    selectedItems: u,
    activeIndex: c
  };
}
const JC = ({
  items: e,
  initialSelectedItems: r = [],
  hideTags: t,
  primaryAction: n,
  className: o,
  closeOnBlur: i,
  size: a = "m",
  optionsClassName: s,
  inputProps: l,
  ...c
}) => {
  const u = (j) => {
    const A = j.toLowerCase();
    return e.filter((W) => W.title.toLowerCase().includes(A));
  }, [d, h] = $e(""), [p, v] = $e(r), m = it(() => u(d), [d]), { removeSelectedItem: y, getDropdownProps: b, getSelectedItemProps: g } = Dn({
    selectedItems: p,
    onStateChange({ selectedItems: j, type: A }) {
      switch (A) {
        case Dn.stateChangeTypes.SelectedItemKeyDownBackspace:
        case Dn.stateChangeTypes.SelectedItemKeyDownDelete:
        case Dn.stateChangeTypes.DropdownKeyDownBackspace:
        case Dn.stateChangeTypes.FunctionRemoveSelectedItem:
          v(j || []);
          break;
      }
    }
  }), {
    isOpen: w,
    highlightedIndex: x,
    getItemProps: C,
    getInputProps: O,
    selectedItem: E,
    closeMenu: _,
    getLabelProps: R,
    getMenuProps: H,
    getToggleButtonProps: $
  } = kt({
    items: m,
    itemToString(j) {
      return j ? j.title : "";
    },
    defaultHighlightedIndex: 0,
    // after selection, highlight the first item.
    selectedItem: null,
    inputValue: d,
    stateReducer(j, A) {
      const { changes: W, type: U } = A;
      switch (U) {
        case kt.stateChangeTypes.InputKeyDownEnter:
        case kt.stateChangeTypes.InputBlur:
          return {
            ...W,
            isOpen: i = i ?? !1
            // keep the menu open after selection.
          };
        case kt.stateChangeTypes.ItemClick:
          return {
            ...W,
            isOpen: !0,
            // keep the menu open after selection.
            highlightedIndex: 0
            // with the first option highlighted.
          };
        default:
          return W;
      }
    },
    onStateChange({
      inputValue: j,
      type: A,
      selectedItem: W
    }) {
      const U = p == null ? void 0 : p.find(
        (Z) => Z === W
      );
      switch (A) {
        case kt.stateChangeTypes.InputKeyDownEnter:
        case kt.stateChangeTypes.ItemClick:
          U ? y(W) : W && (v([...p, W]), h(""));
          break;
        case kt.stateChangeTypes.InputBlur:
          n(p);
          break;
        case kt.stateChangeTypes.InputChange:
          h(j ?? "");
          break;
      }
    }
  });
  let Y;
  switch (a) {
    case "xs":
      Y = "caption-m";
      break;
    case "s":
      Y = "s";
      break;
    case "m":
      Y = "m";
      break;
  }
  return /* @__PURE__ */ f.jsxs("div", { className: X("sp-multiselect", o), ...c, children: [
    /* @__PURE__ */ f.jsx("div", { className: "sp-multiselect__wrapper", children: /* @__PURE__ */ f.jsxs("label", { className: "sp-multiselect__wrapper__input", ...R(), children: [
      /* @__PURE__ */ f.jsxs("div", { className: "sp-multiselect__wrapper__input__tags", children: [
        t ? null : p.map((j, A) => /* @__PURE__ */ f.jsxs(
          "div",
          {
            children: [
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  ...g({
                    selectedItem: j,
                    index: A
                  })
                }
              ),
              /* @__PURE__ */ f.jsx(
                An.Label,
                {
                  dismissible: !0,
                  hierarchy: "default",
                  label: j.title,
                  variant: "info",
                  onDismiss: () => y(j)
                }
              )
            ]
          },
          `selected-item-${A}-${j.id}`
        )),
        /* @__PURE__ */ f.jsx(
          "input",
          {
            className: "sp-multiselect__wrapper__input__tags__field",
            ...O({
              ...b({ preventKeyAction: w }),
              ...l,
              onKeyDown: (j) => {
                j.key === "Enter" && j.preventDefault();
              }
            })
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          ...$(
            b({ preventKeyAction: w })
          ),
          className: "sp-multiselect__wrapper__input__toggle",
          children: /* @__PURE__ */ f.jsx(
            Rp,
            {
              size: "24",
              iconColor: "var(--icon-default)",
              className: X(
                "sp-multiselect__wrapper__input__toggle__icon",
                {
                  "sp-multiselect__wrapper__input__toggle__icon--open": w
                }
              )
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ f.jsxs(
      vr,
      {
        elevation: "level-3",
        radius: "s",
        padding: "no",
        className: "sp-multiselect__items",
        style: w ? void 0 : { height: 0, visibility: "hidden" },
        children: [
          /* @__PURE__ */ f.jsx(
            "ul",
            {
              className: X(
                "sp-multiselect__items__list",
                s
              ),
              ...H(),
              children: m.map((j, A) => {
                const W = j.icon ?? void 0;
                return /* @__PURE__ */ f.jsx(
                  "li",
                  {
                    className: X(
                      {
                        "sp-multiselect__items__list__item--highlighted": x === A,
                        "sp-multiselect__items__list__item--pressed": E === j
                      },
                      "sp-multiselect__items__list__item",
                      `sp-multiselect__items__list__item--${a}`
                    ),
                    ...C({ item: j, index: A }),
                    children: /* @__PURE__ */ f.jsxs(
                      V1,
                      {
                        className: "sp-multiselect__items__list__item__checkbox",
                        onClick: () => {
                          p.includes(j) ? y(j) : v([...p, j]);
                        },
                        checked: !!p.find(
                          (U) => U === j
                        ),
                        size: "s",
                        children: [
                          W ? /* @__PURE__ */ f.jsx(W, { size: "16", iconColor: "var(--icon-default)" }) : null,
                          /* @__PURE__ */ f.jsx(pe, { size: Y, variant: "body-content", children: j.title })
                        ]
                      }
                    )
                  },
                  `${j.id}${A}`
                );
              })
            }
          ),
          /* @__PURE__ */ f.jsx(
            Yd,
            {
              primaryActionButton: {
                action: () => {
                  n(p), _();
                },
                title: "Apply"
              },
              tertiaryActionButton: {
                action: () => {
                  v([]);
                },
                title: "Clear"
              }
            }
          )
        ]
      }
    )
  ] });
};
const ap = qe(
  ({
    title: e,
    subtitle: r,
    suffixIcon: t,
    isActive: n = !1,
    showAvatar: o = !1,
    avatarShape: i = "square",
    nonInteractive: a = !1,
    className: s = "",
    ...l
  }, c) => {
    const u = t, [d = "", h = ""] = e.split(" "), p = (d[0] + ((h == null ? void 0 : h[0]) ?? "")).toUpperCase();
    return /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: X([
          "sp-header",
          { "sp-header--active": n },
          { "sp-header--non-interactive": a },
          s
        ]),
        ...l,
        ref: c,
        children: [
          o && /* @__PURE__ */ f.jsx(Np, { initial: p, shape: i, size: "l", variant: "blue" }),
          /* @__PURE__ */ f.jsxs(
            "div",
            {
              className: X([
                "sp-header__content",
                { "sp-header__content--with-suffix-icon": t }
              ]),
              children: [
                /* @__PURE__ */ f.jsx(
                  pe,
                  {
                    className: "sp-header__content__title",
                    size: "caption-m",
                    variant: "body-content",
                    weight: 800,
                    children: e
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  pe,
                  {
                    className: "sp-header__content__subtitle",
                    size: "caption-m",
                    variant: "body-content",
                    children: r
                  }
                )
              ]
            }
          ),
          u ? /* @__PURE__ */ f.jsx(u, { size: "16", iconColor: "var(--icon-default)" }) : null
        ]
      }
    );
  }
);
ap.displayName = "Header";
const _9 = "data:image/svg+xml;base64,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";
const sp = ({
  variant: e,
  className: r = "",
  hasBanner: t = !1,
  isFloating: n = !1
}) => {
  let o, i;
  switch (e) {
    case "essential":
      o = "Essential", i = "premium";
      break;
    case "custom":
      o = "Custom", i = "premium";
      break;
    case "starter":
    default:
      o = "Starter", i = "starter";
      break;
  }
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: X([
        "sp-nav-footer",
        { "sp-nav-footer--floating": n },
        r
      ]),
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "sp-nav-footer__content", children: [
          /* @__PURE__ */ f.jsx(
            "img",
            {
              id: "companyLogo",
              src: _9,
              alt: "Spenmo Logo",
              className: "sp-nav-footer__content__brand-logo"
            }
          ),
          e && /* @__PURE__ */ f.jsx(An.Tier, { variant: i, label: o })
        ] }),
        t && /* @__PURE__ */ f.jsxs(
          "a",
          {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://spenmo.com/pricing",
            className: "sp-nav-footer__banner",
            children: [
              /* @__PURE__ */ f.jsx(
                pe,
                {
                  size: "caption-m",
                  variant: "body-content",
                  weight: 600,
                  className: "sp-nav-footer__banner__caption",
                  children: "Upgrade to Essential"
                }
              ),
              /* @__PURE__ */ f.jsx(Lp, { iconColor: "var(--icon-default-inverse)", size: "16" })
            ]
          }
        )
      ]
    }
  );
};
sp.displayName = "Footer";
const E9 = ({ prefixIcon: e, isSelected: r = !1 }) => {
  const t = e;
  return t ? /* @__PURE__ */ f.jsx(
    t,
    {
      size: "16",
      iconColor: r ? "var(--text-body-brand)" : "var(--icon-strong)"
    }
  ) : null;
}, lp = qe(
  ({
    label: e,
    prefixIcon: r,
    isSelected: t = !1,
    badgeType: n,
    badgeProps: o,
    className: i = "",
    badgeLabel: a = 0,
    ...s
  }, l) => {
    const c = it(() => {
      const d = Number(a) >= 100 ? "99+" : a;
      return isNaN(Number(a)) ? "0" : d;
    }, [a]), u = () => {
      switch (!0) {
        case (n === "label" && typeof a == "string" && a.length > 0):
          return /* @__PURE__ */ f.jsx(
            An.Label,
            {
              size: "s",
              variant: "success",
              hierarchy: "default",
              className: X("sp-menu__badge", "sp-menu__badge__label"),
              ...o,
              label: `${a}`
            }
          );
        case (n === "notification" && `${c}` != "0"):
          return /* @__PURE__ */ f.jsx(
            An.Notification,
            {
              size: "l",
              className: "sp-menu__badge",
              ...o,
              label: `${c}`
            }
          );
        case (n === "label" && typeof a == "string" && `${a}`.length === 0):
        case (n === "label" && typeof a == "number"):
        case (n === "notification" && `${c}` == "0"):
        default:
          return null;
      }
    };
    return /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: X([
          "sp-menu",
          { "sp-menu--selected": t },
          i
        ]),
        ...s,
        ref: l,
        children: [
          /* @__PURE__ */ f.jsx(E9, { isSelected: t, prefixIcon: r }),
          /* @__PURE__ */ f.jsx(
            pe,
            {
              className: X(
                "sp-menu__label",
                {
                  "sp-menu__label--selected": t
                },
                {
                  "sp-menu__label--with-prefix-icon": r && !n,
                  "sp-menu__label--with-badge": !r && n,
                  "sp-menu__label--with-prefix-icon-and-badge": r && n
                }
              ),
              size: "caption-m",
              variant: "body-content",
              weight: t ? 600 : void 0,
              children: e
            }
          ),
          u()
        ]
      }
    );
  }
);
lp.displayName = "Menu";
const eb = { Header: ap, Footer: sp, Menu: lp }, I9 = ({
  tag: e,
  variant: r,
  children: t,
  className: n,
  size: o,
  weight: i,
  ...a
}) => {
  const s = e ?? "span", l = X([
    n,
    "sp__fonts",
    r ? `sp__fonts__${r}` : null,
    r && o ? `sp__fonts__${r}--${o}` : null,
    r && o && i ? `sp__fonts__${r}--${o}--${i}` : null
  ]);
  return /* @__PURE__ */ f.jsx(s, { className: l, ...a, children: t });
}, pe = I9;
function Wi(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function dt(e) {
  return e instanceof Element || e instanceof Wi(e).Element;
}
function fr(e) {
  return e instanceof HTMLElement || e instanceof Wi(e).HTMLElement;
}
function O9(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Wi(e).ShadowRoot;
}
function N9(e) {
  return Wi(e).getComputedStyle(e);
}
function _n(e) {
  let r = e.activeElement;
  for (; ((t = r) == null || (n = t.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var t, n;
    r = r.shadowRoot.activeElement;
  }
  return r;
}
function rt(e, r) {
  if (!e || !r)
    return !1;
  const t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && O9(t)) {
    let n = r;
    for (; n; ) {
      if (e === n)
        return !0;
      n = n.parentNode || n.host;
    }
  }
  return !1;
}
function T9() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function k9() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((r) => {
    let {
      brand: t,
      version: n
    } = r;
    return t + "/" + n;
  }).join(" ") : navigator.userAgent;
}
function S9(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return !0;
  const r = /Android/i;
  return (r.test(T9()) || r.test(k9())) && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function R9(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0;
}
function j9() {
  return /apple/i.test(navigator.vendor);
}
function Ei(e, r) {
  const t = ["mouse", "pen"];
  return r || t.push("", void 0), t.includes(e);
}
function P9(e) {
  return "nativeEvent" in e;
}
function st(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Ko(e, r) {
  if (r == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(r);
  const t = e;
  return t.target != null && r.contains(t.target);
}
function cp(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const A9 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function up(e) {
  return fr(e) && e.matches(A9);
}
function Sa(e) {
  e.preventDefault(), e.stopPropagation();
}
var dp = function(e) {
  if (typeof document > "u")
    return null;
  var r = Array.isArray(e) ? e[0] : e;
  return r.ownerDocument.body;
}, Kn = /* @__PURE__ */ new WeakMap(), Ro = /* @__PURE__ */ new WeakMap(), jo = {}, Ra = 0, fp = function(e) {
  return e && (e.host || fp(e.parentNode));
}, L9 = function(e, r) {
  return r.map(function(t) {
    if (e.contains(t))
      return t;
    var n = fp(t);
    return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, pp = function(e, r, t, n) {
  var o = L9(r, Array.isArray(e) ? e : [e]);
  jo[t] || (jo[t] = /* @__PURE__ */ new WeakMap());
  var i = jo[t], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else {
        var p = h.getAttribute(n), v = p !== null && p !== "false", m = (Kn.get(h) || 0) + 1, y = (i.get(h) || 0) + 1;
        Kn.set(h, m), i.set(h, y), a.push(h), m === 1 && v && Ro.set(h, !0), y === 1 && h.setAttribute(t, "true"), v || h.setAttribute(n, "true");
      }
    });
  };
  return u(r), s.clear(), Ra++, function() {
    a.forEach(function(d) {
      var h = Kn.get(d) - 1, p = i.get(d) - 1;
      Kn.set(d, h), i.set(d, p), h || (Ro.has(d) || d.removeAttribute(n), Ro.delete(d)), p || d.removeAttribute(t);
    }), Ra--, Ra || (Kn = /* @__PURE__ */ new WeakMap(), Kn = /* @__PURE__ */ new WeakMap(), Ro = /* @__PURE__ */ new WeakMap(), jo = {});
  };
}, hp = function(e, r, t) {
  t === void 0 && (t = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = r || dp(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), pp(n, o, t, "aria-hidden")) : function() {
    return null;
  };
}, V9 = function(e, r, t) {
  t === void 0 && (t = "data-inert-ed");
  var n = r || dp(e);
  return n ? pp(e, n, t, "inert") : function() {
    return null;
  };
}, vp = function() {
  return typeof HTMLElement < "u" && HTMLElement.prototype.hasOwnProperty("inert");
}, H9 = function(e, r, t) {
  return t === void 0 && (t = "data-suppressed"), (vp() ? V9 : hp)(e, r, t);
};
function io() {
  return io = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, io.apply(this, arguments);
}
var ft = typeof document < "u" ? ao : fe;
let ja = !1, F9 = 0;
const _1 = () => "floating-ui-" + F9++;
function Y9() {
  const [e, r] = T.useState(() => ja ? _1() : void 0);
  return ft(() => {
    e == null && r(_1());
  }, []), T.useEffect(() => {
    ja || (ja = !0);
  }, []), e;
}
const $9 = T[/* @__PURE__ */ "useId".toString()], Bi = $9 || Y9, z9 = /* @__PURE__ */ T.forwardRef(function(r, t) {
  let {
    context: {
      placement: n,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: i
      }
    },
    width: a = 14,
    height: s = 7,
    tipRadius: l = 0,
    strokeWidth: c = 0,
    staticOffset: u,
    stroke: d,
    d: h,
    style: {
      transform: p,
      ...v
    } = {},
    ...m
  } = r;
  process.env.NODE_ENV !== "production" && (t || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const y = Bi();
  if (!o)
    return null;
  c *= 2;
  const b = c / 2, g = a / 2 * (l / -8 + 1), w = s / 2 * l / 4, [x, C] = n.split("-"), O = Fs.isRTL(o), E = !!h, _ = x === "top" || x === "bottom", R = u && C === "end" ? "bottom" : "top";
  let H = u && C === "end" ? "right" : "left";
  u && O && (H = C === "end" ? "left" : "right");
  const $ = (i == null ? void 0 : i.x) != null ? u || i.x : "", Y = (i == null ? void 0 : i.y) != null ? u || i.y : "", j = h || "M0,0" + (" H" + a) + (" L" + (a - g) + "," + (s - w)) + (" Q" + a / 2 + "," + s + " " + g + "," + (s - w)) + " Z", A = {
    top: E ? "rotate(180deg)" : "",
    left: E ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: E ? "" : "rotate(180deg)",
    right: E ? "rotate(-90deg)" : "rotate(90deg)"
  }[x];
  return /* @__PURE__ */ T.createElement("svg", io({}, m, {
    "aria-hidden": !0,
    ref: t,
    width: E ? a : a + c,
    height: a,
    viewBox: "0 0 " + a + " " + (s > a ? s : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [H]: $,
      [R]: Y,
      [x]: _ || E ? "100%" : "calc(100% - " + c / 2 + "px)",
      transform: "" + A + (p ?? ""),
      ...v
    }
  }), c > 0 && /* @__PURE__ */ T.createElement("path", {
    clipPath: "url(#" + y + ")",
    fill: "none",
    stroke: d,
    strokeWidth: c + (h ? 0 : 1),
    d: j
  }), /* @__PURE__ */ T.createElement("path", {
    stroke: c && !h ? m.fill : "none",
    d: j
  }), /* @__PURE__ */ T.createElement("clipPath", {
    id: y
  }, /* @__PURE__ */ T.createElement("rect", {
    x: -b,
    y: b * (E ? -1 : 1),
    width: a + c,
    height: a
  })));
});
function Z9() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((o) => o(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      var n;
      e.set(r, ((n = e.get(r)) == null ? void 0 : n.filter((o) => o !== t)) || []);
    }
  };
}
const W9 = /* @__PURE__ */ T.createContext(null), B9 = /* @__PURE__ */ T.createContext(null), mp = () => {
  var e;
  return ((e = T.useContext(W9)) == null ? void 0 : e.id) || null;
}, Ui = () => T.useContext(B9);
function Tn(e) {
  return "data-floating-ui-" + e;
}
function Fr(e) {
  const r = me(e);
  return ft(() => {
    r.current = e;
  }), r;
}
const E1 = /* @__PURE__ */ Tn("safe-polygon");
function Pa(e, r, t) {
  return t && !Ei(t) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[r];
}
function U9(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    dataRef: o,
    events: i,
    elements: {
      domReference: a,
      floating: s
    },
    refs: l
  } = e, {
    enabled: c = !0,
    delay: u = 0,
    handleClose: d = null,
    mouseOnly: h = !1,
    restMs: p = 0,
    move: v = !0
  } = r, m = Ui(), y = mp(), b = Fr(d), g = Fr(u), w = T.useRef(), x = T.useRef(), C = T.useRef(), O = T.useRef(), E = T.useRef(!0), _ = T.useRef(!1), R = T.useRef(() => {
  }), H = T.useCallback(() => {
    var A;
    const W = (A = o.current.openEvent) == null ? void 0 : A.type;
    return (W == null ? void 0 : W.includes("mouse")) && W !== "mousedown";
  }, [o]);
  T.useEffect(() => {
    if (!c)
      return;
    function A() {
      clearTimeout(x.current), clearTimeout(O.current), E.current = !0;
    }
    return i.on("dismiss", A), () => {
      i.off("dismiss", A);
    };
  }, [c, i]), T.useEffect(() => {
    if (!c || !b.current || !t)
      return;
    function A(U) {
      H() && n(!1, U);
    }
    const W = st(s).documentElement;
    return W.addEventListener("mouseleave", A), () => {
      W.removeEventListener("mouseleave", A);
    };
  }, [s, t, n, c, b, o, H]);
  const $ = T.useCallback(function(A, W) {
    W === void 0 && (W = !0);
    const U = Pa(g.current, "close", w.current);
    U && !C.current ? (clearTimeout(x.current), x.current = setTimeout(() => n(!1, A), U)) : W && (clearTimeout(x.current), n(!1, A));
  }, [g, n]), Y = T.useCallback(() => {
    R.current(), C.current = void 0;
  }, []), j = T.useCallback(() => {
    if (_.current) {
      const A = st(l.floating.current).body;
      A.style.pointerEvents = "", A.removeAttribute(E1), _.current = !1;
    }
  }, [l]);
  return T.useEffect(() => {
    if (!c)
      return;
    function A() {
      return o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1;
    }
    function W(J) {
      if (clearTimeout(x.current), E.current = !1, h && !Ei(w.current) || p > 0 && Pa(g.current, "open") === 0)
        return;
      const le = Pa(g.current, "open", w.current);
      le ? x.current = setTimeout(() => {
        n(!0, J);
      }, le) : n(!0, J);
    }
    function U(J) {
      if (A())
        return;
      R.current();
      const le = st(s);
      if (clearTimeout(O.current), b.current) {
        t || clearTimeout(x.current), C.current = b.current({
          ...e,
          tree: m,
          x: J.clientX,
          y: J.clientY,
          onClose() {
            j(), Y(), $(J);
          }
        });
        const F = C.current;
        le.addEventListener("mousemove", F), R.current = () => {
          le.removeEventListener("mousemove", F);
        };
        return;
      }
      (w.current === "touch" ? !rt(s, J.relatedTarget) : !0) && $(J);
    }
    function Z(J) {
      A() || b.current == null || b.current({
        ...e,
        tree: m,
        x: J.clientX,
        y: J.clientY,
        onClose() {
          j(), Y(), $(J);
        }
      })(J);
    }
    if (dt(a)) {
      const J = a;
      return t && J.addEventListener("mouseleave", Z), s == null || s.addEventListener("mouseleave", Z), v && J.addEventListener("mousemove", W, {
        once: !0
      }), J.addEventListener("mouseenter", W), J.addEventListener("mouseleave", U), () => {
        t && J.removeEventListener("mouseleave", Z), s == null || s.removeEventListener("mouseleave", Z), v && J.removeEventListener("mousemove", W), J.removeEventListener("mouseenter", W), J.removeEventListener("mouseleave", U);
      };
    }
  }, [a, s, c, e, h, p, v, $, Y, j, n, t, m, g, b, o]), ft(() => {
    var A;
    if (c && t && (A = b.current) != null && A.__options.blockPointerEvents && H()) {
      const Z = st(s).body;
      if (Z.setAttribute(E1, ""), Z.style.pointerEvents = "none", _.current = !0, dt(a) && s) {
        var W, U;
        const J = a, le = m == null || (W = m.nodesRef.current.find((z) => z.id === y)) == null || (U = W.context) == null ? void 0 : U.elements.floating;
        return le && (le.style.pointerEvents = ""), J.style.pointerEvents = "auto", s.style.pointerEvents = "auto", () => {
          J.style.pointerEvents = "", s.style.pointerEvents = "";
        };
      }
    }
  }, [c, t, y, s, a, m, b, o, H]), ft(() => {
    t || (w.current = void 0, Y(), j());
  }, [t, Y, j]), T.useEffect(() => () => {
    Y(), clearTimeout(x.current), clearTimeout(O.current), j();
  }, [c, a, Y, j]), T.useMemo(() => {
    if (!c)
      return {};
    function A(W) {
      w.current = W.pointerType;
    }
    return {
      reference: {
        onPointerDown: A,
        onPointerEnter: A,
        onMouseMove(W) {
          t || p === 0 || (clearTimeout(O.current), O.current = setTimeout(() => {
            E.current || n(!0, W.nativeEvent);
          }, p));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(x.current);
        },
        onMouseLeave(W) {
          i.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: !1
            }
          }), $(W.nativeEvent, !1);
        }
      }
    };
  }, [i, c, p, t, n, $]);
}
let I1 = 0;
function Cn(e, r) {
  r === void 0 && (r = {});
  const {
    preventScroll: t = !1,
    cancelPrevious: n = !0,
    sync: o = !1
  } = r;
  n && cancelAnimationFrame(I1);
  const i = () => e == null ? void 0 : e.focus({
    preventScroll: t
  });
  o ? i() : I1 = requestAnimationFrame(i);
}
function K9(e, r) {
  var t;
  let n = [], o = (t = e.find((i) => i.id === r)) == null ? void 0 : t.parentId;
  for (; o; ) {
    const i = e.find((a) => a.id === o);
    o = i == null ? void 0 : i.parentId, i && (n = n.concat(i));
  }
  return n;
}
function Yr(e, r) {
  let t = e.filter((o) => {
    var i;
    return o.parentId === r && ((i = o.context) == null ? void 0 : i.open);
  }), n = t;
  for (; n.length; )
    n = e.filter((o) => {
      var i;
      return (i = n) == null ? void 0 : i.some((a) => {
        var s;
        return o.parentId === a.id && ((s = o.context) == null ? void 0 : s.open);
      });
    }), t = t.concat(n);
  return t;
}
const Kl = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function gp(e, r) {
  const t = zs(e, Kl());
  r === "prev" && t.reverse();
  const n = t.indexOf(_n(st(e)));
  return t.slice(n + 1)[0];
}
function yp() {
  return gp(document.body, "next");
}
function wp() {
  return gp(document.body, "prev");
}
function $r(e, r) {
  const t = r || e.currentTarget, n = e.relatedTarget;
  return !n || !rt(t, n);
}
function Q9(e) {
  zs(e, Kl()).forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  });
}
function q9(e) {
  e.querySelectorAll("[data-tabindex]").forEach((t) => {
    const n = t.dataset.tabindex;
    delete t.dataset.tabindex, n ? t.setAttribute("tabindex", n) : t.removeAttribute("tabindex");
  });
}
const Ql = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let G9;
function O1(e) {
  e.key === "Tab" && (e.target, clearTimeout(G9));
}
const Ii = /* @__PURE__ */ T.forwardRef(function(r, t) {
  const [n, o] = T.useState();
  ft(() => (j9() && o("button"), document.addEventListener("keydown", O1), () => {
    document.removeEventListener("keydown", O1);
  }), []);
  const i = {
    ref: t,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: n,
    "aria-hidden": n ? void 0 : !0,
    [Tn("focus-guard")]: "",
    style: Ql
  };
  return /* @__PURE__ */ T.createElement("span", io({}, r, i));
}), xp = /* @__PURE__ */ T.createContext(null);
function X9(e) {
  let {
    id: r,
    root: t
  } = e === void 0 ? {} : e;
  const [n, o] = T.useState(null), i = Bi(), a = bp(), s = T.useMemo(() => ({
    id: r,
    root: t,
    portalContext: a,
    uniqueId: i
  }), [r, t, a, i]), l = T.useRef();
  return ft(() => () => {
    n == null || n.remove();
  }, [n, s]), ft(() => {
    if (l.current === s)
      return;
    l.current = s;
    const {
      id: c,
      root: u,
      portalContext: d,
      uniqueId: h
    } = s, p = c ? document.getElementById(c) : null, v = Tn("portal");
    if (p) {
      const m = document.createElement("div");
      m.id = h, m.setAttribute(v, ""), p.appendChild(m), o(m);
    } else {
      let m = u || (d == null ? void 0 : d.portalNode);
      m && !dt(m) && (m = m.current), m = m || document.body;
      let y = null;
      c && (y = document.createElement("div"), y.id = c, m.appendChild(y));
      const b = document.createElement("div");
      b.id = h, b.setAttribute(v, ""), m = y || m, m.appendChild(b), o(b);
    }
  }, [s]), n;
}
function Cp(e) {
  let {
    children: r,
    id: t,
    root: n = null,
    preserveTabOrder: o = !0
  } = e;
  const i = X9({
    id: t,
    root: n
  }), [a, s] = T.useState(null), l = T.useRef(null), c = T.useRef(null), u = T.useRef(null), d = T.useRef(null), h = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && o && !!(n || i)
  );
  return T.useEffect(() => {
    if (!i || !o || a != null && a.modal)
      return;
    function p(v) {
      i && $r(v) && (v.type === "focusin" ? q9 : Q9)(i);
    }
    return i.addEventListener("focusin", p, !0), i.addEventListener("focusout", p, !0), () => {
      i.removeEventListener("focusin", p, !0), i.removeEventListener("focusout", p, !0);
    };
  }, [i, o, a == null ? void 0 : a.modal]), /* @__PURE__ */ T.createElement(xp.Provider, {
    value: T.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: u,
      afterInsideRef: d,
      portalNode: i,
      setFocusManagerState: s
    }), [o, i])
  }, h && i && /* @__PURE__ */ T.createElement(Ii, {
    "data-type": "outside",
    ref: l,
    onFocus: (p) => {
      if ($r(p, i)) {
        var v;
        (v = u.current) == null || v.focus();
      } else {
        const m = wp() || (a == null ? void 0 : a.refs.domReference.current);
        m == null || m.focus();
      }
    }
  }), h && i && /* @__PURE__ */ T.createElement("span", {
    "aria-owns": i.id,
    style: Ql
  }), i && /* @__PURE__ */ Kp(r, i), h && i && /* @__PURE__ */ T.createElement(Ii, {
    "data-type": "outside",
    ref: c,
    onFocus: (p) => {
      if ($r(p, i)) {
        var v;
        (v = d.current) == null || v.focus();
      } else {
        const m = yp() || (a == null ? void 0 : a.refs.domReference.current);
        m == null || m.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1, p.nativeEvent));
      }
    }
  }));
}
const bp = () => T.useContext(xp), J9 = /* @__PURE__ */ T.forwardRef(function(r, t) {
  return /* @__PURE__ */ T.createElement("button", io({}, r, {
    type: "button",
    ref: t,
    tabIndex: -1,
    style: Ql
  }));
});
function ey(e) {
  const {
    context: r,
    children: t,
    disabled: n = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: a = 0,
    returnFocus: s = !0,
    modal: l = !0,
    visuallyHiddenDismiss: c = !1,
    closeOnFocusOut: u = !0
  } = e, {
    open: d,
    refs: h,
    nodeId: p,
    onOpenChange: v,
    events: m,
    dataRef: y,
    elements: {
      domReference: b,
      floating: g
    }
  } = r, w = vp() ? i : !0, x = Fr(o), C = Fr(a), O = Fr(s), E = Ui(), _ = bp(), R = typeof a == "number" && a < 0, H = T.useRef(null), $ = T.useRef(null), Y = T.useRef(!1), j = T.useRef(null), A = T.useRef(!1), W = _ != null, U = b && b.getAttribute("role") === "combobox" && up(b), Z = T.useCallback(function(F) {
    return F === void 0 && (F = g), F ? zs(F, Kl()) : [];
  }, [g]), J = T.useCallback((F) => {
    const L = Z(F);
    return x.current.map((N) => b && N === "reference" ? b : g && N === "floating" ? g : L).filter(Boolean).flat();
  }, [b, g, x, Z]);
  T.useEffect(() => {
    if (n || !l)
      return;
    function F(N) {
      if (N.key === "Tab") {
        rt(g, _n(st(g))) && Z().length === 0 && !U && Sa(N);
        const I = J(), P = cp(N);
        x.current[0] === "reference" && P === b && (Sa(N), N.shiftKey ? Cn(I[I.length - 1]) : Cn(I[1])), x.current[1] === "floating" && P === g && N.shiftKey && (Sa(N), Cn(I[0]));
      }
    }
    const L = st(g);
    return L.addEventListener("keydown", F), () => {
      L.removeEventListener("keydown", F);
    };
  }, [n, b, g, l, x, h, U, Z, J]), T.useEffect(() => {
    if (n || !u)
      return;
    function F() {
      A.current = !0, setTimeout(() => {
        A.current = !1;
      });
    }
    function L(N) {
      const I = N.relatedTarget;
      queueMicrotask(() => {
        const P = !(rt(b, I) || rt(g, I) || rt(I, g) || rt(_ == null ? void 0 : _.portalNode, I) || I != null && I.hasAttribute(Tn("focus-guard")) || E && (Yr(E.nodesRef.current, p).find((B) => {
          var ee, te;
          return rt((ee = B.context) == null ? void 0 : ee.elements.floating, I) || rt((te = B.context) == null ? void 0 : te.elements.domReference, I);
        }) || K9(E.nodesRef.current, p).find((B) => {
          var ee, te;
          return ((ee = B.context) == null ? void 0 : ee.elements.floating) === I || ((te = B.context) == null ? void 0 : te.elements.domReference) === I;
        })));
        I && P && !A.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        I !== j.current && (Y.current = !0, v(!1, N));
      });
    }
    if (g && fr(b))
      return b.addEventListener("focusout", L), b.addEventListener("pointerdown", F), !l && g.addEventListener("focusout", L), () => {
        b.removeEventListener("focusout", L), b.removeEventListener("pointerdown", F), !l && g.removeEventListener("focusout", L);
      };
  }, [n, b, g, l, p, E, _, v, u]), T.useEffect(() => {
    var F;
    if (n)
      return;
    const L = Array.from((_ == null || (F = _.portalNode) == null ? void 0 : F.querySelectorAll("[" + Tn("portal") + "]")) || []);
    if (g && l) {
      const N = [g, ...L, H.current, $.current].filter((B) => B != null), P = (w ? hp : H9)(x.current.includes("reference") || U ? N.concat(b || []) : N, void 0, Tn("inert"));
      return () => {
        P();
      };
    }
  }, [n, b, g, l, x, _, U, w]), ft(() => {
    if (n || !g)
      return;
    const F = st(g), L = _n(F);
    queueMicrotask(() => {
      const N = J(g), I = C.current, P = (typeof I == "number" ? N[I] : I.current) || g, B = rt(g, L);
      !R && !B && d && Cn(P, {
        preventScroll: P === g
      });
    });
  }, [n, d, g, R, J, C]), ft(() => {
    if (n || !g)
      return;
    let F = !1;
    const L = st(g), N = _n(L), I = y.current;
    j.current = N;
    function P(B) {
      if (B.type === "escapeKey" && h.domReference.current && (j.current = h.domReference.current), ["referencePress", "escapeKey"].includes(B.type))
        return;
      const ee = B.data.returnFocus;
      typeof ee == "object" ? (Y.current = !1, F = ee.preventScroll) : Y.current = !ee;
    }
    return m.on("dismiss", P), () => {
      m.off("dismiss", P);
      const B = _n(L);
      (rt(g, B) || E && Yr(E.nodesRef.current, p).some((te) => {
        var ae;
        return rt((ae = te.context) == null ? void 0 : ae.elements.floating, B);
      }) || I.openEvent && ["click", "mousedown"].includes(I.openEvent.type)) && h.domReference.current && (j.current = h.domReference.current), // eslint-disable-next-line react-hooks/exhaustive-deps
      O.current && fr(j.current) && !Y.current && Cn(j.current, {
        // When dismissing nested floating elements, by the time the rAF has
        // executed, the menus will all have been unmounted. When they try
        // to get focused, the calls get ignored — leaving the root
        // reference focused as desired.
        cancelPrevious: !1,
        preventScroll: F
      });
    };
  }, [n, g, O, y, h, m, E, p]), ft(() => {
    if (!(n || !_))
      return _.setFocusManagerState({
        ...r,
        modal: l,
        closeOnFocusOut: u,
        open: d
      }), () => {
        _.setFocusManagerState(null);
      };
  }, [n, _, l, d, u, r]), ft(() => {
    if (!n && g && typeof MutationObserver == "function") {
      const F = () => {
        const N = g.getAttribute("tabindex");
        x.current.includes("floating") || _n(st(g)) !== h.domReference.current && Z().length === 0 ? N !== "0" && g.setAttribute("tabindex", "0") : N !== "-1" && g.setAttribute("tabindex", "-1");
      };
      F();
      const L = new MutationObserver(F);
      return L.observe(g, {
        childList: !0,
        subtree: !0,
        attributes: !0
      }), () => {
        L.disconnect();
      };
    }
  }, [n, g, h, x, Z]);
  function le(F) {
    return n || !c || !l ? null : /* @__PURE__ */ T.createElement(J9, {
      ref: F === "start" ? H : $,
      onClick: (L) => v(!1, L.nativeEvent)
    }, typeof c == "string" ? c : "Dismiss");
  }
  const z = !n && w && !U && (W || l);
  return /* @__PURE__ */ T.createElement(T.Fragment, null, z && /* @__PURE__ */ T.createElement(Ii, {
    "data-type": "inside",
    ref: _ == null ? void 0 : _.beforeInsideRef,
    onFocus: (F) => {
      if (l) {
        const N = J();
        Cn(o[0] === "reference" ? N[0] : N[N.length - 1]);
      } else if (_ != null && _.preserveTabOrder && _.portalNode)
        if (Y.current = !1, $r(F, _.portalNode)) {
          const N = yp() || b;
          N == null || N.focus();
        } else {
          var L;
          (L = _.beforeOutsideRef.current) == null || L.focus();
        }
    }
  }), !U && le("start"), t, le("end"), z && /* @__PURE__ */ T.createElement(Ii, {
    "data-type": "inside",
    ref: _ == null ? void 0 : _.afterInsideRef,
    onFocus: (F) => {
      if (l)
        Cn(J()[0]);
      else if (_ != null && _.preserveTabOrder && _.portalNode)
        if (u && (Y.current = !0), $r(F, _.portalNode)) {
          const N = wp() || b;
          N == null || N.focus();
        } else {
          var L;
          (L = _.afterOutsideRef.current) == null || L.focus();
        }
    }
  }));
}
function N1(e) {
  return fr(e.target) && e.target.tagName === "BUTTON";
}
function T1(e) {
  return up(e);
}
function ty(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: u = !0
  } = r, d = T.useRef(), h = T.useRef(!1);
  return T.useMemo(() => a ? {
    reference: {
      onPointerDown(p) {
        d.current = p.pointerType;
      },
      onMouseDown(p) {
        p.button === 0 && (Ei(d.current, !0) && c || s !== "click" && (t && l && (!o.current.openEvent || o.current.openEvent.type === "mousedown") ? n(!1, p.nativeEvent) : (p.preventDefault(), n(!0, p.nativeEvent))));
      },
      onClick(p) {
        if (s === "mousedown" && d.current) {
          d.current = void 0;
          return;
        }
        Ei(d.current, !0) && c || (t && l && (!o.current.openEvent || o.current.openEvent.type === "click") ? n(!1, p.nativeEvent) : n(!0, p.nativeEvent));
      },
      onKeyDown(p) {
        d.current = void 0, !(p.defaultPrevented || !u || N1(p)) && (p.key === " " && !T1(i) && (p.preventDefault(), h.current = !0), p.key === "Enter" && n(!(t && l), p.nativeEvent));
      },
      onKeyUp(p) {
        p.defaultPrevented || !u || N1(p) || T1(i) || p.key === " " && h.current && (h.current = !1, n(!(t && l), p.nativeEvent));
      }
    }
  } : {}, [a, o, s, c, u, i, l, t, n]);
}
const ny = T[/* @__PURE__ */ "useInsertionEffect".toString()], ry = ny || ((e) => e());
function Qo(e) {
  const r = T.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return ry(() => {
    r.current = e;
  }), T.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
const oy = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, iy = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, ay = (e) => {
  var r, t;
  return {
    escapeKeyBubbles: typeof e == "boolean" ? e : (r = e == null ? void 0 : e.escapeKey) != null ? r : !1,
    outsidePressBubbles: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.outsidePress) != null ? t : !0
  };
};
function Mp(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    events: o,
    nodeId: i,
    elements: {
      reference: a,
      domReference: s,
      floating: l
    },
    dataRef: c
  } = e, {
    enabled: u = !0,
    escapeKey: d = !0,
    outsidePress: h = !0,
    outsidePressEvent: p = "pointerdown",
    referencePress: v = !1,
    referencePressEvent: m = "pointerdown",
    ancestorScroll: y = !1,
    bubbles: b
  } = r, g = Ui(), w = mp() != null, x = Qo(typeof h == "function" ? h : () => !1), C = typeof h == "function" ? x : h, O = T.useRef(!1), {
    escapeKeyBubbles: E,
    outsidePressBubbles: _
  } = ay(b), R = Qo(($) => {
    if (!t || !u || !d || $.key !== "Escape")
      return;
    const Y = g ? Yr(g.nodesRef.current, i) : [];
    if (!E && ($.stopPropagation(), Y.length > 0)) {
      let j = !0;
      if (Y.forEach((A) => {
        var W;
        if ((W = A.context) != null && W.open && !A.context.dataRef.current.__escapeKeyBubbles) {
          j = !1;
          return;
        }
      }), !j)
        return;
    }
    o.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: !1
        }
      }
    }), n(!1, P9($) ? $.nativeEvent : $);
  }), H = Qo(($) => {
    const Y = O.current;
    if (O.current = !1, Y || typeof C == "function" && !C($))
      return;
    const j = cp($);
    if (fr(j) && l) {
      const U = j.clientWidth > 0 && j.scrollWidth > j.clientWidth, Z = j.clientHeight > 0 && j.scrollHeight > j.clientHeight;
      let J = Z && $.offsetX > j.clientWidth;
      if (Z && N9(j).direction === "rtl" && (J = $.offsetX <= j.offsetWidth - j.clientWidth), J || U && $.offsetY > j.clientHeight)
        return;
    }
    const A = g && Yr(g.nodesRef.current, i).some((U) => {
      var Z;
      return Ko($, (Z = U.context) == null ? void 0 : Z.elements.floating);
    });
    if (Ko($, l) || Ko($, s) || A)
      return;
    const W = g ? Yr(g.nodesRef.current, i) : [];
    if (W.length > 0) {
      let U = !0;
      if (W.forEach((Z) => {
        var J;
        if ((J = Z.context) != null && J.open && !Z.context.dataRef.current.__outsidePressBubbles) {
          U = !1;
          return;
        }
      }), !U)
        return;
    }
    o.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: w ? {
          preventScroll: !0
        } : S9($) || R9($)
      }
    }), n(!1, $);
  });
  return T.useEffect(() => {
    if (!t || !u)
      return;
    c.current.__escapeKeyBubbles = E, c.current.__outsidePressBubbles = _;
    function $(A) {
      n(!1, A);
    }
    const Y = st(l);
    d && Y.addEventListener("keydown", R), C && Y.addEventListener(p, H);
    let j = [];
    return y && (dt(s) && (j = un(s)), dt(l) && (j = j.concat(un(l))), !dt(a) && a && a.contextElement && (j = j.concat(un(a.contextElement)))), j = j.filter((A) => {
      var W;
      return A !== ((W = Y.defaultView) == null ? void 0 : W.visualViewport);
    }), j.forEach((A) => {
      A.addEventListener("scroll", $, {
        passive: !0
      });
    }), () => {
      d && Y.removeEventListener("keydown", R), C && Y.removeEventListener(p, H), j.forEach((A) => {
        A.removeEventListener("scroll", $);
      });
    };
  }, [c, l, s, a, d, C, p, t, n, y, u, E, _, R, H]), T.useEffect(() => {
    O.current = !1;
  }, [C, p]), T.useMemo(() => u ? {
    reference: {
      onKeyDown: R,
      [oy[m]]: ($) => {
        v && (o.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), n(!1, $.nativeEvent));
      }
    },
    floating: {
      onKeyDown: R,
      [iy[p]]: () => {
        O.current = !0;
      }
    }
  } : {}, [u, o, v, p, m, n, R]);
}
let Ms;
process.env.NODE_ENV !== "production" && (Ms = /* @__PURE__ */ new Set());
function Dp(e) {
  var r;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: n,
    nodeId: o
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var i;
    const E = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if (!((i = Ms) != null && i.has(E))) {
      var a, s;
      (a = Ms) == null || a.add(E), (s = e.elements) != null && s.reference && !dt(e.elements.reference) && console.error(E);
    }
  }
  const [l, c] = T.useState(null), u = ((r = e.elements) == null ? void 0 : r.reference) || l, d = md(e), h = Ui(), p = Qo((E, _) => {
    E && (m.current.openEvent = _), n == null || n(E, _);
  }), v = T.useRef(null), m = T.useRef({}), y = T.useState(() => Z9())[0], b = Bi(), g = T.useCallback((E) => {
    const _ = dt(E) ? {
      getBoundingClientRect: () => E.getBoundingClientRect(),
      contextElement: E
    } : E;
    d.refs.setReference(_);
  }, [d.refs]), w = T.useCallback((E) => {
    (dt(E) || E === null) && (v.current = E, c(E)), (dt(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    E !== null && !dt(E)) && d.refs.setReference(E);
  }, [d.refs]), x = T.useMemo(() => ({
    ...d.refs,
    setReference: w,
    setPositionReference: g,
    domReference: v
  }), [d.refs, w, g]), C = T.useMemo(() => ({
    ...d.elements,
    domReference: u
  }), [d.elements, u]), O = T.useMemo(() => ({
    ...d,
    refs: x,
    elements: C,
    dataRef: m,
    nodeId: o,
    floatingId: b,
    events: y,
    open: t,
    onOpenChange: p
  }), [d, o, b, y, t, p, x, C]);
  return ft(() => {
    const E = h == null ? void 0 : h.nodesRef.current.find((_) => _.id === o);
    E && (E.context = O);
  }), T.useMemo(() => ({
    ...d,
    context: O,
    refs: x,
    elements: C
  }), [d, x, C, O]);
}
function sy(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    onOpenChange: n,
    dataRef: o,
    events: i,
    refs: a,
    elements: {
      floating: s,
      domReference: l
    }
  } = e, {
    enabled: c = !0,
    keyboardOnly: u = !0
  } = r, d = T.useRef(""), h = T.useRef(!1), p = T.useRef();
  return T.useEffect(() => {
    if (!c)
      return;
    const m = st(s).defaultView || window;
    function y() {
      !t && fr(l) && l === _n(st(l)) && (h.current = !0);
    }
    return m.addEventListener("blur", y), () => {
      m.removeEventListener("blur", y);
    };
  }, [s, l, t, c]), T.useEffect(() => {
    if (!c)
      return;
    function v(m) {
      (m.type === "referencePress" || m.type === "escapeKey") && (h.current = !0);
    }
    return i.on("dismiss", v), () => {
      i.off("dismiss", v);
    };
  }, [i, c]), T.useEffect(() => () => {
    clearTimeout(p.current);
  }, []), T.useMemo(() => c ? {
    reference: {
      onPointerDown(v) {
        let {
          pointerType: m
        } = v;
        d.current = m, h.current = !!(m && u);
      },
      onMouseLeave() {
        h.current = !1;
      },
      onFocus(v) {
        var m;
        h.current || v.type === "focus" && ((m = o.current.openEvent) == null ? void 0 : m.type) === "mousedown" && Ko(o.current.openEvent, l) || n(!0, v.nativeEvent);
      },
      onBlur(v) {
        h.current = !1;
        const m = v.relatedTarget, y = dt(m) && m.hasAttribute(Tn("focus-guard")) && m.getAttribute("data-type") === "outside";
        p.current = setTimeout(() => {
          rt(a.floating.current, m) || rt(l, m) || y || n(!1, v.nativeEvent);
        });
      }
    }
  } : {}, [c, u, l, a, o, n]);
}
function Aa(e, r, t) {
  const n = /* @__PURE__ */ new Map();
  return {
    ...t === "floating" && {
      tabIndex: -1
    },
    ...e,
    ...r.map((o) => o ? o[t] : null).concat(e).reduce((o, i) => (i && Object.entries(i).forEach((a) => {
      let [s, l] = a;
      if (s.indexOf("on") === 0) {
        if (n.has(s) || n.set(s, []), typeof l == "function") {
          var c;
          (c = n.get(s)) == null || c.push(l), o[s] = function() {
            for (var u, d = arguments.length, h = new Array(d), p = 0; p < d; p++)
              h[p] = arguments[p];
            return (u = n.get(s)) == null ? void 0 : u.map((v) => v(...h)).find((v) => v !== void 0);
          };
        }
      } else
        o[s] = l;
    }), o), {})
  };
}
function _p(e) {
  e === void 0 && (e = []);
  const r = e, t = T.useCallback(
    (i) => Aa(i, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), n = T.useCallback(
    (i) => Aa(i, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = T.useCallback(
    (i) => Aa(i, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((i) => i == null ? void 0 : i.item)
  );
  return T.useMemo(() => ({
    getReferenceProps: t,
    getFloatingProps: n,
    getItemProps: o
  }), [t, n, o]);
}
function Ki(e) {
  return T.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    e.forEach((t) => {
      typeof t == "function" ? t(r) : t != null && (t.current = r);
    });
  }, e);
}
function Ep(e, r) {
  r === void 0 && (r = {});
  const {
    open: t,
    floatingId: n
  } = e, {
    enabled: o = !0,
    role: i = "dialog"
  } = r, a = Bi();
  return T.useMemo(() => {
    const s = {
      id: n,
      role: i
    };
    return o ? i === "tooltip" ? {
      reference: {
        "aria-describedby": t ? n : void 0
      },
      floating: s
    } : {
      reference: {
        "aria-expanded": t ? "true" : "false",
        "aria-haspopup": i === "alertdialog" ? "dialog" : i,
        "aria-controls": t ? n : void 0,
        ...i === "listbox" && {
          role: "combobox"
        },
        ...i === "menu" && {
          id: a
        }
      },
      floating: {
        ...s,
        ...i === "menu" && {
          "aria-labelledby": a
        }
      }
    } : {};
  }, [o, i, t, n, a]);
}
function ly({
  initialOpen: e = !1,
  placement: r = "bottom",
  open: t,
  onOpenChange: n
} = {}) {
  const [o, i] = $e(e), [a, s] = $e(), [l, c] = $e(), u = t ?? o, d = n ?? i, h = Dp({
    placement: r,
    open: u,
    onOpenChange: d,
    whileElementsMounted: Ys,
    middleware: [
      As(5),
      $s({
        crossAxis: r.includes("-"),
        fallbackAxisSideDirection: "end",
        padding: 5
      }),
      pd({ padding: 5 })
    ]
  }), p = h.context, v = ty(p, {
    enabled: t == null
  }), m = Mp(p), y = Ep(p), b = _p([v, m, y]);
  return it(
    () => ({
      open: u,
      setOpen: d,
      ...b,
      ...h,
      labelId: a,
      descriptionId: l,
      setLabelId: s,
      setDescriptionId: c
    }),
    [u, d, b, h, a, l]
  );
}
const Ip = Kt(null), Qi = () => {
  const e = ze(Ip);
  if (e == null)
    throw new Error("Popover components must be wrapped in <Popover />");
  return e;
}, cy = ({
  children: e,
  ...r
}) => {
  const t = ly({ ...r });
  return /* @__PURE__ */ f.jsx(Ip.Provider, { value: t, children: e });
}, uy = qe(function({ children: r, asChild: t = !1, className: n, ...o }, i) {
  const a = Qi(), s = r.ref, l = Ki([a.refs.setReference, i, s]);
  return t && Is(r) ? Oi(
    r,
    a.getReferenceProps({
      ref: l,
      ...o,
      ...r.props,
      "data-state": a.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ f.jsx(
    "button",
    {
      ref: l,
      type: "button",
      "data-state": a.open ? "open" : "closed",
      ...a.getReferenceProps(o),
      className: X("sp-popover__trigger", n),
      children: r
    }
  );
}), dy = qe(function({
  style: r,
  elevation: t = "level-1",
  radius: n = "m",
  padding: o = "small",
  className: i,
  ...a
}, s) {
  const { context: l, ...c } = Qi(), u = Ki([c.refs.setFloating, s]);
  return l.open ? /* @__PURE__ */ f.jsx(Cp, { children: /* @__PURE__ */ f.jsx(ey, { context: l, children: /* @__PURE__ */ f.jsx(
    vr,
    {
      ref: u,
      style: { ...c.floatingStyles, ...r },
      "aria-labelledby": c.labelId,
      "aria-describedby": c.descriptionId,
      ...c.getFloatingProps(a),
      elevation: t,
      radius: n,
      padding: o,
      className: i,
      children: a.children
    }
  ) }) }) : null;
}), fy = qe(function({ className: r, ...t }, n) {
  const { setOpen: o } = Qi();
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      type: "button",
      ref: n,
      ...t,
      onClick: (i) => {
        var a;
        (a = t.onClick) == null || a.call(t, i), o(!1);
      },
      className: X("sp-popover__close", r)
    }
  );
}), La = { Wrapper: cy, Close: fy, Content: dy, Trigger: uy }, py = ({
  className: e,
  options: r,
  onSelect: t,
  size: n = "s",
  showSelectedIndex: o = !1,
  selectedIndex: i,
  setSelectedIndex: a,
  ...s
}) => {
  const { open: l, setOpen: c } = Qi(), u = (d, h) => {
    o && a(h), c(!1), t(d);
  };
  return l ? /* @__PURE__ */ f.jsx(
    "div",
    {
      className: X("sp-single-select__content", e),
      ...s,
      children: r.map((d, h) => /* @__PURE__ */ f.jsxs(
        "div",
        {
          "aria-disabled": (d == null ? void 0 : d.disabled) ?? !1,
          className: X("sp-single-select__item", {
            "sp-single-select__item--disabled": d == null ? void 0 : d.disabled
          }),
          onClick: () => u(d.value, h),
          onKeyDownCapture: (p) => {
            p.key === "Enter" && (p.preventDefault(), u(d.value, h));
          },
          onKeyDown: (p) => {
            p.key === "Enter" && (p.preventDefault(), u(d.value, h));
          },
          children: [
            /* @__PURE__ */ f.jsx(
              pe,
              {
                size: n === "xs" ? "caption-m" : n,
                variant: "body-content",
                children: d.label
              }
            ),
            o && h === i && /* @__PURE__ */ f.jsx(
              Gl,
              {
                iconColor: "var(--text-link-default)",
                size: n === "s" ? "16" : "24"
              }
            )
          ]
        },
        d.value
      ))
    }
  ) : null;
}, Ds = ({
  children: e,
  options: r,
  placement: t = "bottom-start",
  open: n,
  onOpenChange: o,
  initialOpen: i,
  size: a,
  showSelectedIndex: s,
  className: l,
  elevation: c = "level-1",
  radius: u = "s",
  padding: d = "no",
  ...h
}) => {
  const [p, v] = $e();
  return /* @__PURE__ */ f.jsxs(
    La.Wrapper,
    {
      placement: t,
      onOpenChange: o,
      open: n,
      initialOpen: i,
      children: [
        /* @__PURE__ */ f.jsx(
          La.Trigger,
          {
            className: l,
            onClick: o ? () => o(!n) : void 0,
            children: e
          }
        ),
        /* @__PURE__ */ f.jsx(
          La.Content,
          {
            padding: d,
            radius: u,
            elevation: c,
            className: l,
            children: /* @__PURE__ */ f.jsx(
              py,
              {
                ...h,
                options: r,
                size: a,
                showSelectedIndex: s,
                selectedIndex: p,
                setSelectedIndex: v
              }
            )
          }
        )
      ]
    }
  );
};
const Op = ({ children: e, onClickOutside: r }) => {
  const t = (n) => {
    n.target.classList.contains("sp-overlay") && r && r();
  };
  return fe(() => {
    const n = (o) => {
      o.key === "Escape" && r && r();
    };
    return document.addEventListener("keyup", n), () => {
      document.removeEventListener("keyup", n);
    };
  }, []), /* @__PURE__ */ f.jsx("div", { className: "sp-overlay", onClick: t, children: e });
};
const tb = ({
  title: e,
  actions: r,
  description: t,
  thumbnail: n,
  tag: o
}) => /* @__PURE__ */ f.jsxs("div", { className: "sp-page-header", children: [
  /* @__PURE__ */ f.jsxs("div", { className: "sp-page-header__details", children: [
    (r == null ? void 0 : r.back) && /* @__PURE__ */ f.jsx(
      Xe,
      {
        variant: "tertiary",
        icon: Sp,
        className: "sp-page-header__details__back",
        onClick: r.back.action,
        children: /* @__PURE__ */ f.jsx(pe, { size: "caption-m", variant: "body-content", children: r.back.title })
      }
    ),
    /* @__PURE__ */ f.jsxs("header", { className: "sp-page-header__header", children: [
      n && /* @__PURE__ */ f.jsx(
        Np,
        {
          initial: n,
          shape: "circle",
          size: "l",
          variant: "blue"
        }
      ),
      /* @__PURE__ */ f.jsx(
        pe,
        {
          size: "m",
          variant: "headline-brand",
          tag: "h1",
          children: e
        }
      ),
      o && /* @__PURE__ */ f.jsx(An.Label, { ...o })
    ] }),
    t && /* @__PURE__ */ f.jsx(
      pe,
      {
        size: "s",
        variant: "body-content",
        tag: "p",
        className: "sp-page-header__description",
        children: t
      }
    )
  ] }),
  /* @__PURE__ */ f.jsxs("div", { className: "sp-page-header__buttons", children: [
    (r == null ? void 0 : r.tertiary) && /* @__PURE__ */ f.jsx(Xe, { size: "s", variant: "tertiary", onClick: r.tertiary.action, children: r.tertiary.title }),
    (r == null ? void 0 : r.secondary) && /* @__PURE__ */ f.jsx(
      Xe,
      {
        size: "s",
        variant: "secondary",
        onClick: r.secondary.action,
        children: r.secondary.title
      }
    ),
    (r == null ? void 0 : r.primary) && /* @__PURE__ */ f.jsx(Xe, { size: "s", variant: "primary", onClick: r.primary.action, children: r.primary.title }),
    (r == null ? void 0 : r.overflow) && /* @__PURE__ */ f.jsx(
      Xe,
      {
        size: "s",
        variant: "tertiary",
        onClick: r.overflow.action,
        icon: Ap,
        children: r.overflow.title
      }
    )
  ] })
] });
const pr = ({ variant: e, className: r, ...t }) => {
  let n;
  return e === "next" ? n = "Next" : n = "Previous", /* @__PURE__ */ f.jsx(
    "button",
    {
      title: n,
      "aria-label": n,
      className: X("sp-navigation", r),
      ...t,
      children: /* @__PURE__ */ f.jsx(
        Rp,
        {
          size: "24",
          className: X(
            "sp-navigation__icon",
            `sp-navigation__icon--${e}`
          )
        }
      )
    }
  );
};
const hy = ({
  className: e,
  number: r,
  isSelected: t,
  ...n
}) => /* @__PURE__ */ f.jsx(
  "button",
  {
    className: X([
      "sp-page-number",
      e,
      { "sp-page-number--selected": t }
    ]),
    ...n,
    children: /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", children: r })
  }
), vy = hy, Or = "...", Po = (e, r) => {
  const t = r - e + 1;
  return Array.from({ length: t }, (n, o) => o + e);
}, my = ({
  totalPageCount: e,
  siblingCount: r = 1,
  currentPage: t
}) => it(() => {
  if (r + 5 >= e)
    return Po(1, e);
  const i = Math.max(t - r, 1), a = Math.min(
    t + r,
    e
  ), s = i > 2, l = a < e - 2, c = 1, u = e;
  if (!s && l) {
    const d = 3 + 2 * r;
    return [...Po(1, d), Or, e];
  }
  if (s && !l) {
    const d = 3 + 2 * r, h = Po(
      e - d + 1,
      e
    );
    return [c, Or, ...h];
  }
  if (s && l) {
    const d = Po(i, a);
    return [c, Or, ...d, Or, u];
  }
}, [e, r, t]), gy = ({
  totalRecords: e,
  currentPage: r,
  className: t,
  onPageChange: n,
  pageSize: o,
  ...i
}) => {
  const a = e / o;
  return /* @__PURE__ */ f.jsxs("div", { className: X(t, "sp-pagination"), ...i, children: [
    /* @__PURE__ */ f.jsxs(pe, { size: "s", variant: "body-content", tag: "p", children: [
      "Page ",
      r,
      " of ",
      a
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "sp-pagination__navigation-buttons", children: [
      /* @__PURE__ */ f.jsx(
        pr,
        {
          variant: "previous",
          onClick: () => n(r - 1),
          disabled: r <= 1,
          className: "sp-pagination__navigation-buttons__left"
        }
      ),
      /* @__PURE__ */ f.jsx(
        pr,
        {
          variant: "next",
          onClick: () => n(r + 1),
          disabled: r >= a,
          className: "sp-pagination__navigation-buttons__right"
        }
      )
    ] })
  ] });
}, yy = ({
  totalRecords: e,
  currentPage: r,
  className: t,
  onPageChange: n,
  pageSize: o,
  ...i
}) => {
  const a = e / o;
  return /* @__PURE__ */ f.jsx("div", { className: X(t, "sp-pagination"), ...i, children: /* @__PURE__ */ f.jsxs("div", { className: "sp-pagination__navigation-buttons sp-pagination__navigation-buttons--center", children: [
    /* @__PURE__ */ f.jsx(
      pr,
      {
        variant: "previous",
        onClick: () => n(r - 1),
        disabled: r <= 1
      }
    ),
    /* @__PURE__ */ f.jsxs(pe, { size: "s", variant: "body-content", tag: "p", children: [
      "Page ",
      r,
      " of ",
      a
    ] }),
    /* @__PURE__ */ f.jsx(
      pr,
      {
        variant: "next",
        onClick: () => n(r + 1),
        disabled: r >= a
      }
    )
  ] }) });
}, wy = ({
  totalRecords: e,
  currentPage: r,
  className: t,
  onPageChange: n,
  pageSize: o,
  ...i
}) => {
  const a = e / o, s = my({
    currentPage: r,
    totalPageCount: a,
    siblingCount: 2
  }) ?? [];
  let l;
  const c = (u, d) => u === Or ? (l = "More Pages", d === 1 ? r - 5 : r + 5) : u;
  return /* @__PURE__ */ f.jsxs("div", { className: X(t, "sp-pagination"), ...i, children: [
    /* @__PURE__ */ f.jsx(
      pr,
      {
        variant: "previous",
        onClick: () => n(r - 1),
        disabled: r <= 1
      }
    ),
    s.map((u, d) => /* @__PURE__ */ f.jsx(
      vy,
      {
        number: u,
        title: l,
        isSelected: r === u,
        onClick: () => n(c(u, d))
      },
      u + `${d}`
    )),
    /* @__PURE__ */ f.jsx(
      pr,
      {
        variant: "next",
        onClick: () => n(r + 1),
        disabled: r >= a
      }
    )
  ] });
}, nb = { Left: gy, Center: yy, QuickJump: wy };
const xy = qe(
  ({
    size: e = "m",
    id: r,
    checked: t,
    children: n,
    required: o,
    disabled: i,
    value: a,
    onChange: s,
    ...l
  }, c) => {
    const [u, d] = $e(!!t), h = me(null);
    fe(() => {
      d(!!t);
    }, [t]);
    const p = () => {
      !i && h.current && h.current.click();
    }, v = (y) => {
      const b = y.target.value;
      d(!0), s && s(b, y);
    }, m = (y) => {
      (y.key === "Enter" || y.key === " ") && p();
    };
    return /* @__PURE__ */ f.jsxs(
      "label",
      {
        htmlFor: r,
        ref: c,
        className: X("sp-radio", {
          "sp-radio--small": e === "s"
        }),
        onClick: p,
        onKeyDown: m,
        children: [
          /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: h,
              className: "sp-radio__input",
              type: "radio",
              "data-state": u ? "checked" : "unchecked",
              disabled: i,
              checked: u,
              value: a,
              onChange: v,
              ...l
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "sp-radio__input-checkmark" }),
          n != null && /* @__PURE__ */ f.jsxs(
            pe,
            {
              size: e,
              variant: "body-content",
              className: "sp-radio__label",
              children: [
                n,
                o && /* @__PURE__ */ f.jsx("span", { className: "sp-radio__label__required", children: "*" })
              ]
            }
          )
        ]
      }
    );
  }
);
xy.displayName = "Radio";
const Cy = ({
  title: e,
  backActionButton: r,
  linkAction: t,
  actionButton: n,
  onClose: o,
  children: i
}) => {
  const a = n == null ? void 0 : n.icon;
  return /* @__PURE__ */ f.jsxs("div", { className: "sp-sidepanel-header", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "sp-sidepanel-header__section", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "sp-sidepanel-header__title-section", children: [
        r ? /* @__PURE__ */ f.jsx(
          "button",
          {
            className: "sp-sidepanel-header__title-section__back-button",
            "aria-label": "back-button Sidepanel",
            title: "backButton Sidepanel",
            onClick: o,
            children: /* @__PURE__ */ f.jsx(Sp, { size: "24", iconColor: "var(--icon-default)" })
          }
        ) : null,
        /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "headline-content", tag: "h1", children: e })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "sp-sidepanel-header__action-button-row", children: [
        t ? /* @__PURE__ */ f.jsx(
          "a",
          {
            href: "#",
            onClick: t.action,
            className: "sp-sidepanel-header__action-button-row__button sp-sidepanel-header__action-button-row__button--link-button",
            children: /* @__PURE__ */ f.jsx(pe, { size: "m", variant: "body-content", weight: 600, children: t.title })
          }
        ) : null,
        n ? /* @__PURE__ */ f.jsx(
          "button",
          {
            className: "sp-sidepanel-header__action-button-row__button sp-sidepanel-header__action-button-row__button--action-button",
            "aria-label": "edit Sidepanel",
            title: "Edit Sidepanel",
            onClick: n.action,
            children: /* @__PURE__ */ f.jsx(a, { size: "24", iconColor: "var(--icon-default)" })
          }
        ) : null,
        o ? /* @__PURE__ */ f.jsx(
          "button",
          {
            className: "sp-sidepanel-header__action-button-row__button sp-sidepanel-header__action-button-row__button--close-button",
            "aria-label": "Close Modal",
            title: "Close Modal",
            onClick: o,
            children: /* @__PURE__ */ f.jsx(yr, { size: "24", iconColor: "var(--icon-default)" })
          }
        ) : null
      ] })
    ] }),
    !!i && /* @__PURE__ */ f.jsx("div", { className: "sp-sidepanel-header__section", children: i })
  ] });
};
const by = ({
  primaryActionButton: e,
  secondaryActionButton: r,
  tertiaryActionButton: t,
  footerStacking: n,
  footerAlignment: o,
  additionalFooterItem: i
}) => {
  const a = (t == null ? void 0 : t.variant) ?? (n === "horizontal" ? "tertiary" : "danger"), s = (r == null ? void 0 : r.variant) ?? (n === "horizontal" ? "secondary" : "success");
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: X(
        "sp-sidepanel-footer",
        `sp-sidepanel-footer--${n}`,
        o ? `sp-sidepanel-footer--${o}` : void 0
      ),
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "sp-sidepanel-footer__action-secondary", children: [
          i,
          t ? /* @__PURE__ */ f.jsx(
            Xe,
            {
              variant: a,
              className: "sp-sidepanel-footer__action-secondary__success",
              onClick: t.action,
              disabled: t.disabled,
              loading: t.loading,
              icon: t.icon,
              children: t.title
            }
          ) : null,
          r ? /* @__PURE__ */ f.jsx(
            Xe,
            {
              variant: s,
              className: "sp-sidepanel-footer__action-secondary__danger",
              onClick: r.action,
              disabled: r.disabled,
              loading: r.loading,
              icon: r.icon,
              children: r.title
            }
          ) : null
        ] }),
        e ? /* @__PURE__ */ f.jsx("div", { className: "sp-sidepanel-footer__action-primary", children: /* @__PURE__ */ f.jsx(
          Xe,
          {
            variant: e.variant ?? "primary",
            className: "sp-sidepanel-footer__action-primary__primary",
            onClick: e.action,
            disabled: e.disabled,
            loading: e.loading,
            type: e.type ?? "button",
            icon: e.icon,
            children: e.title
          }
        ) }) : null
      ]
    }
  );
};
const My = 472, rb = ({
  primaryActionButton: e,
  showSidepanel: r,
  width: t,
  secondaryActionButton: n,
  tertiaryActionButton: o,
  title: i,
  linkAction: a,
  backActionButton: s,
  actionButton: l,
  onClose: c,
  children: u,
  position: d,
  transitionType: h = "rightToLeft",
  footerStacking: p,
  headerChildren: v,
  footerAlignment: m,
  additionalFooterItem: y
}) => {
  const b = e ?? n ?? o;
  let g = {
    animate: { x: 0 },
    initial: { x: "100%" },
    exit: { x: "100%" }
  };
  const w = ({
    axis: C,
    initial: O,
    animate: E,
    exit: _
  }) => ({
    animate: {
      opacity: 1,
      scale: 1,
      [C]: E
    },
    initial: { opacity: 0, scale: 1, [C]: O },
    exit: {
      [C]: _,
      opacity: 0,
      scale: 1
    }
  });
  switch (h) {
    case "rightToLeft":
      d = "right", g = w({
        axis: "x",
        initial: "100%",
        animate: "0",
        exit: "100%"
      });
      break;
    case "leftToRight":
      d = "left", g = w({
        axis: "x",
        initial: "-100%",
        animate: "0",
        exit: "-100%"
      });
      break;
    case "topToBottom":
      g = w({
        axis: "y",
        initial: "-100%",
        animate: "0",
        exit: "-100%"
      });
      break;
    case "bottomToTop":
      g = w({
        axis: "y",
        initial: "100%",
        animate: "0",
        exit: "100%"
      });
      break;
  }
  const x = {
    duration: 0.8,
    type: "spring",
    stiffness: 902,
    damping: 60,
    mass: 1
  };
  return /* @__PURE__ */ f.jsx(xf, { children: r && /* @__PURE__ */ f.jsx(Op, { onClickOutside: c, children: /* @__PURE__ */ f.jsxs(
    gr.div,
    {
      ...g,
      transition: x,
      className: X([
        "sp-sidepanel",
        `sp-sidepanel__${d}`
      ]),
      style: { width: t ?? My },
      "data-testid": "side-panel",
      children: [
        /* @__PURE__ */ f.jsx(
          Cy,
          {
            title: i,
            backActionButton: s,
            linkAction: a,
            actionButton: l,
            onClose: c,
            children: !!v && v
          }
        ),
        /* @__PURE__ */ f.jsx("div", { className: "sp-sidepanel__content", children: u }),
        b ? /* @__PURE__ */ f.jsx(
          by,
          {
            additionalFooterItem: y,
            primaryActionButton: e,
            secondaryActionButton: n,
            tertiaryActionButton: o,
            footerStacking: p,
            footerAlignment: m
          }
        ) : null
      ]
    }
  ) }) });
};
const Dy = ({
  alignment: e,
  status: r,
  title: t,
  label: n,
  className: o,
  ...i
}) => /* @__PURE__ */ f.jsxs(
  "article",
  {
    className: X(
      "sp-stepper-content",
      `sp-stepper-content--${e}`,
      o
    ),
    ...i,
    children: [
      /* @__PURE__ */ f.jsx(
        pe,
        {
          size: "s",
          variant: "body-content",
          className: X(
            "sp-stepper-content__title",
            `sp-stepper-content__title--${r}`
          ),
          tag: "p",
          weight: r === "in-progress" ? 600 : void 0,
          children: t
        }
      ),
      /* @__PURE__ */ f.jsx(
        pe,
        {
          size: "caption-m",
          variant: "body-content",
          tag: "p",
          className: X(
            "sp-stepper-content__label",
            `sp-stepper-content__label--${r}`
          ),
          children: n
        }
      )
    ]
  }
), _y = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "circle",
        {
          cx: "8",
          cy: "8",
          r: "7.5",
          fill: "var(--text-body-brand)",
          stroke: "var(--text-body-brand)"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7121 5.21582C11.3727 4.88664 10.8683 4.94001 10.5854 5.33503L7.70705 9.35488C7.42968 9.74225 7.27374 9.95672 7.14925 10.0885C7.14764 10.0902 7.14605 10.0919 7.1445 10.0935C7.14282 10.0921 7.14111 10.0906 7.13937 10.089C7.00513 9.97089 6.83316 9.77374 6.52679 9.41719L5.36568 8.06587C5.05326 7.70227 4.54673 7.70227 4.23431 8.06587C3.9219 8.42947 3.9219 9.01898 4.23431 9.38257L5.39542 10.7339C5.40632 10.7466 5.41721 10.7592 5.42808 10.7719C5.68927 11.076 5.94055 11.3686 6.17434 11.5743C6.43624 11.8048 6.77921 12.0215 7.21874 11.9983C7.65826 11.9751 7.98297 11.7231 8.22586 11.466C8.44268 11.2365 8.67016 10.9186 8.90663 10.5883C8.91647 10.5745 8.92633 10.5608 8.9362 10.547L11.8146 6.52712C12.0974 6.13209 12.0515 5.54501 11.7121 5.21582Z",
          fill: "white"
        }
      )
    ]
  }
), Ey = _y, Iy = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M0.86159 14.5L8 2.00778L15.1384 14.5H0.86159Z",
          fill: "#E41B1B",
          stroke: "#E41B1B"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.21136 5.52586C6.77371 5.81763 6.53286 6.32715 6.5852 6.85053L6.9101 10.0995C6.96122 10.6107 7.39139 11 7.90514 11H8.09516C8.60891 11 9.03908 10.6107 9.0902 10.0995L9.4151 6.85053C9.46743 6.32715 9.22659 5.81763 8.78894 5.52586C8.31129 5.20742 7.68901 5.20742 7.21136 5.52586ZM8.00015 12C7.44786 12 7.00015 12.4477 7.00015 13C7.00015 13.5523 7.44786 14 8.00015 14C8.55243 14 9.00015 13.5523 9.00015 13C9.00015 12.4477 8.55243 12 8.00015 12Z",
          fill: "white"
        }
      )
    ]
  }
), Oy = Iy, Ny = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "circle",
      {
        cx: "8",
        cy: "8",
        r: "7.5",
        fill: "white",
        stroke: "var(--text-body-brand)"
      }
    )
  }
), k1 = Ny, Ty = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "circle",
      {
        cx: "8",
        cy: "8",
        r: "7.5",
        fill: "white",
        stroke: "var(--text-body-brand)"
      }
    )
  }
), ky = Ty, Sy = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("circle", { cx: "8", cy: "8", r: "7.5", fill: "#FFFBEE", stroke: "#CFB146" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.2043 3.53054C6.76983 3.82019 6.52704 4.32303 6.5704 4.8434L6.9237 9.08305C6.96689 9.60134 7.40016 10 7.92025 10H8.07998C8.60007 10 9.03334 9.60134 9.07653 9.08305L9.42983 4.8434C9.4732 4.32303 9.23041 3.82019 8.79593 3.53054C8.31402 3.20927 7.68621 3.20927 7.2043 3.53054ZM8.00012 11C7.44783 11 7.00012 11.4477 7.00012 12C7.00012 12.5523 7.44783 13 8.00012 13C8.5524 13 9.00012 12.5523 9.00012 12C9.00012 11.4477 8.5524 11 8.00012 11Z",
          fill: "#CFB146"
        }
      )
    ]
  }
), Ry = Sy;
const ob = ({
  items: e,
  className: r,
  orientation: t,
  ...n
}) => /* @__PURE__ */ f.jsx(
  "ol",
  {
    ...n,
    className: X(
      "sp-stepper",
      `sp-stepper--${t}`,
      r
    ),
    children: e.map((o, i) => {
      let a;
      switch (o.status) {
        case "complete":
          a = Ey;
          break;
        case "danger":
          a = Oy;
          break;
        case "in-progress":
          a = ky;
          break;
        case "incomplete":
          a = k1;
          break;
        case "warning":
          a = Ry;
          break;
        default:
          a = k1;
          break;
      }
      return /* @__PURE__ */ f.jsxs("li", { className: "sp-stepper__step", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "sp-stepper__step__separator-block", children: [
          /* @__PURE__ */ f.jsx(a, {}),
          i < e.length - 1 ? /* @__PURE__ */ f.jsx(
            "hr",
            {
              className: X(
                "sp-stepper__step__separator-block__separator",
                `sp-stepper__step__separator-block__separator--${o.status}`
              )
            }
          ) : null
        ] }),
        /* @__PURE__ */ f.jsx(Dy, { ...o })
      ] }, i);
    })
  }
);
const jy = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-switch icon-switch--on",
    children: /* @__PURE__ */ f.jsx("rect", { x: "6.5", y: "3", width: "1", height: "8", fill: "white" })
  }
), Py = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-switch icon-switch--on",
    children: /* @__PURE__ */ f.jsx("rect", { x: "3.5", y: "1", width: "1", height: "6", fill: "white" })
  }
), Ay = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-switch icon-switch--off",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 3.11111C4.85223 3.11111 3.11111 4.85223 3.11111 7C3.11111 9.14777 4.85223 10.8889 7 10.8889C9.14777 10.8889 10.8889 9.14777 10.8889 7C10.8889 4.85223 9.14777 3.11111 7 3.11111ZM2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7Z",
        fill: "white"
      }
    )
  }
), Ly = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-switch icon-switch--off",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 1.85714C2.81653 1.85714 1.85714 2.81653 1.85714 4C1.85714 5.18347 2.81653 6.14286 4 6.14286C5.18347 6.14286 6.14286 5.18347 6.14286 4C6.14286 2.81653 5.18347 1.85714 4 1.85714ZM1 4C1 2.34315 2.34315 1 4 1C5.65685 1 7 2.34315 7 4C7 5.65685 5.65685 7 4 7C2.34315 7 1 5.65685 1 4Z",
        fill: "white"
      }
    )
  }
), ib = ({
  size: e,
  isActive: r,
  className: t,
  disabled: n,
  ...o
}) => {
  const i = e === "m" ? Ay : Ly, a = e === "m" ? jy : Py;
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": r ? "true" : "false",
      className: X("sp-switch", `sp-switch--${e}`, t),
      ...o,
      disabled: n,
      children: [
        /* @__PURE__ */ f.jsx(i, {}),
        /* @__PURE__ */ f.jsx(a, {}),
        /* @__PURE__ */ f.jsx(
          gr.span,
          {
            className: "sp-switch__handle",
            layout: !0,
            transition: { duration: 0.3, ease: [0.7, -0.4, 0.4, 1.4] }
          }
        )
      ]
    }
  );
};
var Vy = Object.defineProperty, Hy = (e, r, t) => r in e ? Vy(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ao = (e, r, t) => (Hy(e, typeof r != "symbol" ? r + "" : r, t), t), _s = /* @__PURE__ */ new Map(), Lo = /* @__PURE__ */ new WeakMap(), S1 = 0, Fy = void 0;
function Yy(e) {
  return e ? (Lo.has(e) || (S1 += 1, Lo.set(e, S1.toString())), Lo.get(e)) : "0";
}
function $y(e) {
  return Object.keys(e).sort().filter(
    (r) => e[r] !== void 0
  ).map((r) => `${r}_${r === "root" ? Yy(e.root) : e[r]}`).toString();
}
function zy(e) {
  let r = $y(e), t = _s.get(r);
  if (!t) {
    const n = /* @__PURE__ */ new Map();
    let o;
    const i = new IntersectionObserver((a) => {
      a.forEach((s) => {
        var l;
        const c = s.isIntersecting && o.some((u) => s.intersectionRatio >= u);
        e.trackVisibility && typeof s.isVisible > "u" && (s.isVisible = c), (l = n.get(s.target)) == null || l.forEach((u) => {
          u(c, s);
        });
      });
    }, e);
    o = i.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), t = {
      id: r,
      observer: i,
      elements: n
    }, _s.set(r, t);
  }
  return t;
}
function Zy(e, r, t = {}, n = Fy) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const l = e.getBoundingClientRect();
    return r(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof t.threshold == "number" ? t.threshold : 0,
      time: 0,
      boundingClientRect: l,
      intersectionRect: l,
      rootBounds: l
    }), () => {
    };
  }
  const { id: o, observer: i, elements: a } = zy(t);
  let s = a.get(e) || [];
  return a.has(e) || a.set(e, s), s.push(r), i.observe(e), function() {
    s.splice(s.indexOf(r), 1), s.length === 0 && (a.delete(e), i.unobserve(e)), a.size === 0 && (i.disconnect(), _s.delete(o));
  };
}
function Wy(e) {
  return typeof e.children != "function";
}
var By = class extends T.Component {
  constructor(e) {
    super(e), Ao(this, "node", null), Ao(this, "_unobserveCb", null), Ao(this, "handleNode", (r) => {
      this.node && (this.unobserve(), !r && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = r || null, this.observeNode();
    }), Ao(this, "handleChange", (r, t) => {
      r && this.props.triggerOnce && this.unobserve(), Wy(this.props) || this.setState({ inView: r, entry: t }), this.props.onChange && this.props.onChange(r, t);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold: e,
      root: r,
      rootMargin: t,
      trackVisibility: n,
      delay: o,
      fallbackInView: i
    } = this.props;
    this._unobserveCb = Zy(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: r,
        rootMargin: t,
        // @ts-ignore
        trackVisibility: n,
        // @ts-ignore
        delay: o
      },
      i
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: p, entry: v } = this.state;
      return e({ inView: p, entry: v, ref: this.handleNode });
    }
    const {
      as: r,
      triggerOnce: t,
      threshold: n,
      root: o,
      rootMargin: i,
      onChange: a,
      skip: s,
      trackVisibility: l,
      delay: c,
      initialInView: u,
      fallbackInView: d,
      ...h
    } = this.props;
    return T.createElement(
      r || "div",
      { ref: this.handleNode, ...h },
      e
    );
  }
};
const Uy = ({
  label: e,
  icon: r,
  badgeCount: t,
  active: n,
  size: o,
  position: i,
  orientation: a,
  id: s,
  inViewOnChange: l,
  ...c
}) => {
  const u = r, d = me(null);
  return fe(() => {
    n && d.current && d.current.scrollIntoView({
      behavior: "smooth",
      inline: "start"
    });
  }, [n]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: d,
      ...c,
      title: e,
      role: "tab",
      className: "sp-tab-item",
      children: /* @__PURE__ */ f.jsxs(
        By,
        {
          as: "button",
          onChange: (h) => l(h, s),
          threshold: 1,
          className: X(
            "sp-tab-item__content",
            {
              "sp-tab-item__content--active": n
            },
            `sp-tab-item__content--${a}`,
            `sp-tab-item__content--${a}--${i}`,
            `sp-tab-item__content--${o}`
          ),
          children: [
            n ? /* @__PURE__ */ f.jsx(
              gr.span,
              {
                className: "sp-tab-item__content__indicator",
                layoutId: `indicator${s}`
              }
            ) : null,
            u ? /* @__PURE__ */ f.jsx(
              u,
              {
                size: "16",
                iconColor: n ? "var(--text-body-brand)" : "var(--icon-subtle)"
              }
            ) : null,
            /* @__PURE__ */ f.jsx(
              pe,
              {
                size: o === "s" ? "caption-m" : "s",
                variant: "body-content",
                weight: n ? 600 : void 0,
                className: "sp-tab-item__content__label",
                children: e
              }
            ),
            t ? /* @__PURE__ */ f.jsx(An.Notification, { size: "l", label: t }) : null
          ]
        }
      )
    }
  );
};
const Ky = ({
  items: e,
  position: r,
  orientation: t,
  size: n,
  activeTab: o,
  setActiveTab: i,
  className: a,
  ...s
}) => {
  const [l, c] = $e(e), [u, d] = $e([]), h = (p, v) => {
    c((y) => {
      const b = y.find((g) => g.id === v);
      return b && (b.visible = p), [...y];
    });
    const m = l.filter((y) => !y.visible);
    d(
      m.map((y) => ({ label: y.label, value: y.id }))
    );
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: "tablist",
      className: X(
        "sp-tab-list",
        `sp-tab-list--${t}`,
        `sp-tab-list--${t}--${r}`,
        a
      ),
      ...s,
      children: [
        l.map((p) => {
          const { id: v, label: m, icon: y, badgeCount: b } = p;
          return /* @__PURE__ */ f.jsx(
            Uy,
            {
              active: o.id === v,
              position: r,
              label: m,
              orientation: t,
              onClick: () => i(p),
              size: n,
              icon: y,
              badgeCount: b,
              id: v,
              inViewOnChange: h
            },
            v
          );
        }),
        u != null && u.length && t === "horizontal" ? /* @__PURE__ */ f.jsx(
          Ds,
          {
            options: u,
            onSelect: (p) => {
              const v = l.find(
                (m) => m.id === p
              );
              i(v);
            },
            className: "sp-tab-list__single-select",
            children: /* @__PURE__ */ f.jsx("div", { className: "sp-tab-list__single-select__icon", children: /* @__PURE__ */ f.jsx(Ap, { iconColor: "var(--icon-default)", size: "16" }) })
          }
        ) : null
      ]
    }
  );
};
const ab = ({ position: e, orientation: r, size: t, items: n, id: o }) => {
  const [i, a] = $e(n[0]);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: X(
        "sp-tab",
        `sp-tab--${r}`,
        `sp-tab--${r}--${e}`
      ),
      children: [
        /* @__PURE__ */ f.jsx(
          Ky,
          {
            items: n,
            activeTab: i,
            position: e,
            orientation: r,
            setActiveTab: (s) => a(s),
            size: t,
            className: "sp-tab__list",
            id: o
          }
        ),
        /* @__PURE__ */ f.jsx("section", { className: "sp-tab__content", children: i.content })
      ]
    }
  );
};
const Qy = ({
  label: e,
  className: r,
  variant: t,
  hierarchy: n,
  dismissible: o,
  onDismiss: i,
  Icon: a,
  size: s = "l",
  ...l
}) => {
  let c = "currentColor";
  if (n === "default")
    switch (t) {
      case "danger":
        c = "var(--chart-red-default)";
        break;
      case "info":
        c = "var(--chart-blue-subtle)";
        break;
      case "neutral":
        c = "var(--icon-disabled)";
        break;
      case "success":
        c = "var(--green-030)";
        break;
      case "warning":
        c = "var(--yellow-060)";
        break;
    }
  return /* @__PURE__ */ f.jsxs(
    "article",
    {
      className: X([
        "sp-tags",
        "sp-tags--label",
        r,
        `sp-tags--label--${s}`,
        `sp-tags--${n}--${t}`,
        "sp__fonts sp__fonts__body-content sp__fonts__body-content--caption-m sp__fonts__body-content--caption-m--600"
      ]),
      ...l,
      children: [
        a ? /* @__PURE__ */ f.jsx(a, { size: "16", iconColor: "currentColor" }) : null,
        e,
        o ? /* @__PURE__ */ f.jsx("button", { className: "sp-tags__button", onClick: i, children: /* @__PURE__ */ f.jsx(
          yr,
          {
            iconColor: c,
            size: "16",
            className: "sp-tags__button__cross"
          }
        ) }) : null
      ]
    }
  );
}, qy = Qy, Gy = ({
  label: e,
  className: r,
  variant: t,
  hierarchy: n,
  ...o
}) => /* @__PURE__ */ f.jsx(
  "article",
  {
    className: X([
      "sp-tags",
      "sp-tags--progression",
      r,
      `sp-tags--${n}`,
      `sp-tags--${n}--${t}`,
      "sp__fonts sp__fonts__body-content sp__fonts__body-content--caption-m sp__fonts__body-content--caption-m--600"
    ]),
    ...o,
    children: e
  }
), Xy = Gy, Jy = ({ label: e, className: r, variant: t, ...n }) => /* @__PURE__ */ f.jsxs(
  "article",
  {
    className: X([
      "sp-tags",
      "sp-tags--tier",
      r,
      `sp-tags--${t}`,
      { "sp-tags--tier--no-text": !e },
      "sp__fonts sp__fonts__body-content sp__fonts__body-content--caption-m sp__fonts__body-content--caption-m--600"
    ]),
    ...n,
    children: [
      t === "premium" ? /* @__PURE__ */ f.jsx(Lp, { iconColor: "var(--icon-default-inverse)", size: "16" }) : null,
      e
    ]
  }
), ew = Jy, tw = ({
  size: e,
  className: r,
  label: t,
  ...n
}) => /* @__PURE__ */ f.jsx(
  "article",
  {
    className: X(
      "sp-tags",
      "sp-tags--notification",
      r,
      `sp-tags--notification--${e}`
    ),
    ...n,
    children: e === "l" && /* @__PURE__ */ f.jsx(pe, { size: "caption-m", variant: "body-content", weight: 600, children: t })
  }
), nw = tw, An = { Label: qy, Progression: Xy, Tier: ew, Notification: nw };
const rw = ({
  className: e,
  shape: r,
  size: t,
  variant: n,
  elevation: o,
  initial: i,
  ...a
}) => /* @__PURE__ */ f.jsx(
  "article",
  {
    className: X([
      "sp-thumbnail",
      e,
      `sp-thumbnail--${r}`,
      `sp-thumbnail--${t}`,
      `sp-thumbnail--${n}`,
      {
        "sp-thumbnail--elevation": o
      },
      "sp__fonts sp__fonts__body-content sp__fonts__body-content--m sp__fonts__body-content--m--600"
    ]),
    ...a,
    children: i
  }
), Np = rw, ow = 5e3, iw = 5;
var wo = /* @__PURE__ */ ((e) => (e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.REMOVE_TOAST = 1] = "REMOVE_TOAST", e[e.START_PAUSE = 2] = "START_PAUSE", e[e.END_PAUSE = 3] = "END_PAUSE", e))(wo || {});
const aw = (e, r) => {
  switch (r.type) {
    case 0:
      return {
        ...e,
        toasts: [r.toast, ...e.toasts].slice(0, iw)
      };
    case 1:
      return r.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((t) => t.id !== r.toastId)
      };
    case 2:
      return {
        ...e,
        pausedAt: r.time
      };
    case 3: {
      const t = r.time - (e.pausedAt ?? 0);
      return {
        ...e,
        pausedAt: void 0,
        toasts: e.toasts.map((n) => ({
          ...n,
          pauseDuration: n.pauseDuration + t
        }))
      };
    }
  }
}, qo = [];
let Go = { toasts: [], pausedAt: void 0 };
const qi = (e) => {
  Go = aw(Go, e), qo.forEach((r) => {
    r(Go);
  });
}, sw = {
  danger: 1 / 0,
  success: ow
}, lw = (e = {}) => {
  const [r, t] = $e(Go);
  fe(() => (qo.push(t), () => {
    const o = qo.indexOf(t);
    o > -1 && qo.splice(o, 1);
  }), [r]);
  const n = r.toasts.map((o) => {
    var i, a;
    return {
      ...e,
      ...e[o.variant],
      ...o,
      duration: o.duration ?? ((i = e[o.variant]) == null ? void 0 : i.duration) ?? (e == null ? void 0 : e.duration) ?? sw[o.variant],
      style: {
        ...e.style,
        ...(a = e[o.variant]) == null ? void 0 : a.style,
        ...o.style
      }
    };
  });
  return {
    ...r,
    toasts: n
  };
}, cw = () => {
  qi({
    type: wo.START_PAUSE,
    time: Date.now()
  });
}, uw = (e) => {
  const { toasts: r, pausedAt: t } = lw(e);
  fe(() => {
    if (t)
      return;
    const o = Date.now(), i = r.map((a) => {
      if (a.duration === 1 / 0)
        return;
      const s = (a.duration ?? 0) + a.pauseDuration - (o - a.createdAt);
      if (s < 0) {
        a.visible && hr.remove(a.id);
        return;
      }
      return setTimeout(() => hr.remove(a.id), s);
    });
    return () => {
      i.forEach((a) => a && clearTimeout(a));
    };
  }, [r, t]);
  const n = Oe(() => {
    t && qi({ type: wo.END_PAUSE, time: Date.now() });
  }, [t]);
  return {
    toasts: r,
    handlers: {
      startPause: cw,
      endPause: n
    }
  };
};
const dw = ({
  variant: e = "success",
  message: r,
  id: t,
  actionButton: n
}) => {
  let o, i;
  e === "danger" ? (o = Vp, i = "var(--fill-system-danger-strong)") : (o = Gl, i = "var(--fill-system-success-strong)");
  const a = {
    initial: {
      y: "100%",
      opacity: 0
    },
    open: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 30,
        stiffness: 400,
        mass: 1
      }
    },
    closed: {
      opacity: 0,
      transition: {
        type: "spring",
        damping: 30,
        stiffness: 400,
        mass: 1
      }
    }
  };
  return /* @__PURE__ */ f.jsxs(
    gr.div,
    {
      variants: a,
      animate: "open",
      initial: "initial",
      exit: "closed",
      className: X("sp-toast", `sp-toast--${e}`),
      role: "alert",
      layout: !0,
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "sp-toast__content", children: [
          /* @__PURE__ */ f.jsx(
            o,
            {
              iconColor: i,
              size: "24",
              className: "sp-toast__content__icon"
            }
          ),
          /* @__PURE__ */ f.jsx(pe, { variant: "body-content", size: "m", tag: "p", children: r })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "sp-toast__actions", children: [
          n,
          /* @__PURE__ */ f.jsx(
            "button",
            {
              title: "Close Toast",
              onClick: () => hr.remove(t),
              className: "sp-toast__actions__action",
              children: /* @__PURE__ */ f.jsx(yr, { iconColor: "currentColor", size: "24" })
            }
          )
        ] })
      ]
    }
  );
}, fw = dw;
const sb = ({ className: e, ...r }) => {
  const { toasts: t, handlers: n } = uw(), { startPause: o, endPause: i } = n, a = [...t].reverse();
  return /* @__PURE__ */ f.jsx(_8, { children: /* @__PURE__ */ f.jsx(
    gr.div,
    {
      onMouseEnter: o,
      onMouseLeave: i,
      className: X("sp-toast-container", e),
      ...r,
      layout: "position",
      transition: {
        layout: { type: "spring", damping: 30, stiffness: 400, mass: 1 }
      },
      "data-testid": "toast-container",
      children: /* @__PURE__ */ f.jsx(xf, { children: a.filter((s) => s.visible).map(({ message: s, variant: l, id: c, actionButton: u }) => /* @__PURE__ */ f.jsx(
        fw,
        {
          message: s,
          variant: l,
          id: c,
          actionButton: u
        },
        c
      )) })
    }
  ) });
}, pw = (e, r, t) => ({
  createdAt: Date.now(),
  visible: !0,
  variant: r,
  message: e,
  pauseDuration: 0,
  ...t,
  id: (t == null ? void 0 : t.id) ?? H4()
}), ql = (e) => (r, t) => {
  const n = pw(r, e, t);
  return qi({ type: wo.ADD_TOAST, toast: n }), n.id;
}, hr = (e, r) => ql("success")(e, r);
hr.danger = ql("danger");
hr.success = ql("success");
hr.remove = (e) => qi({ type: wo.REMOVE_TOAST, toastId: e });
const qn = 8, hw = 12, vw = 4, mw = ({
  initialOpen: e = !1,
  placement: r = "top",
  open: t,
  onOpenChange: n
} = {}) => {
  const [o, i] = $e(e), a = me(null), s = t ?? o, l = n ?? i;
  let c = 0;
  r.includes("-start") ? c = -1 * qn : r.includes("-end") && (c = 1 * qn);
  const u = Dp({
    placement: r,
    open: s,
    onOpenChange: l,
    whileElementsMounted: Ys,
    middleware: [
      As({
        mainAxis: qn,
        crossAxis: c
      }),
      $s({
        crossAxis: r.includes("-"),
        fallbackAxisSideDirection: "start",
        padding: qn
      }),
      pd({ padding: qn }),
      hd({
        element: a
      })
    ]
  }), { context: d } = u, h = U9(d, {
    move: !1,
    enabled: t == null
  }), p = sy(d, {
    enabled: t == null
  }), v = Mp(d), m = Ep(d, { role: "tooltip" }), y = _p([h, p, v, m]);
  return it(
    () => ({
      open: s,
      setOpen: l,
      ...y,
      ...u,
      arrowRef: a
    }),
    [s, l, y, u, a]
  );
}, Tp = Kt(null), kp = () => {
  const e = ze(Tp);
  if (e == null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return e;
};
const gw = ({ style: e, className: r, ...t }) => {
  const { floatingStyles: n, getFloatingProps: o, refs: i, open: a, arrowRef: s, context: l } = kp(), c = Ki([i.setFloating]);
  if (!a)
    return null;
  const { children: u } = o(t);
  return /* @__PURE__ */ f.jsx(Cp, { children: /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: c,
      style: {
        ...n,
        ...e
      },
      ...o(t),
      className: X("sp-tooltip__content", r),
      children: [
        /* @__PURE__ */ f.jsx(pe, { size: "s", variant: "body-content", children: u }),
        /* @__PURE__ */ f.jsx(
          z9,
          {
            ref: s,
            context: l,
            fill: "var(--text-body-default)",
            tipRadius: vw,
            height: qn,
            width: hw
          }
        )
      ]
    }
  ) });
};
const yw = qe(function({ children: r, asChild: t = !1, ...n }, o) {
  const { open: i, getReferenceProps: a, refs: s } = kp(), l = r.ref, c = Ki([s.setReference, o, l]);
  return t && Is(r) ? Oi(
    r,
    a({
      ref: c,
      ...n,
      ...r.props,
      "data-state": i ? "open" : "closed"
    })
  ) : /* @__PURE__ */ f.jsx(
    "button",
    {
      ref: c,
      "data-state": i ? "open" : "closed",
      ...a(n),
      className: "sp-tooltip__trigger",
      type: "button",
      children: r
    }
  );
}), lb = ({
  children: e,
  title: r,
  initialOpen: t,
  onOpenChange: n,
  open: o,
  placement: i,
  ...a
}) => {
  const s = mw({ initialOpen: t, onOpenChange: n, open: o, placement: i });
  return /* @__PURE__ */ f.jsxs(Tp.Provider, { value: s, children: [
    /* @__PURE__ */ f.jsx(yw, { children: e }),
    /* @__PURE__ */ f.jsx(gw, { ...a, children: r })
  ] });
}, ww = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.021 2h9.432a2.021 2.021 0 0 1 2.022 2.021v2.021a.674.674 0 0 1-1.348 0H2.347v4.043a.674.674 0 0 0 .674.673h3.207a.674.674 0 0 1 0 1.348H3.021A2.021 2.021 0 0 1 1 10.085V4.02A2.021 2.021 0 0 1 3.021 2Zm-.674 2.695h10.78V4.02a.673.673 0 0 0-.674-.674H3.021a.674.674 0 0 0-.674.674v.674ZM4.37 7.39h2.02a.674.674 0 1 1 0 1.347H4.37a.674.674 0 0 1 0-1.347Zm6.656 4.655a.53.53 0 0 1-.377-.155l-.714-.714a.533.533 0 1 1 .754-.754l.337.343L12.17 9.62a.525.525 0 0 1 .748 0 .534.534 0 0 1 0 .754l-1.61 1.59a.512.512 0 0 1-.283.081Zm-1.586 1.556a3.578 3.578 0 1 0 3.967-5.956A3.578 3.578 0 0 0 9.44 13.6Zm.633-5.002a2.44 2.44 0 1 1 2.7 4.063 2.44 2.44 0 0 1-2.7-4.063Z",
          style: { fill: e }
        }
      )
    }
  );
}, cb = ww, xw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.32875 1.33325C0.963069 1.33325 0.666626 1.63177 0.666626 2.00001V11.9999C0.666626 12.3681 0.963069 12.6666 1.32875 12.6666H5.96289C6.31402 12.6666 6.65077 12.8071 6.89905 13.0571C7.14734 13.3071 7.28682 13.6462 7.28682 13.9998C7.28682 14.3681 7.58327 14.6666 7.94895 14.6666C7.96611 14.6666 7.98312 14.6659 7.99996 14.6646C8.0168 14.6659 8.03381 14.6666 8.05097 14.6666C8.41665 14.6666 8.7131 14.3681 8.7131 13.9998C8.7131 13.6462 8.85258 13.3071 9.10087 13.0571C9.34916 12.8071 9.6859 12.6666 10.037 12.6666H14.6712C15.0369 12.6666 15.3333 12.3681 15.3333 11.9999V2.00001C15.3333 1.63177 15.0369 1.33325 14.6712 1.33325H10.6991C9.82113 1.33325 8.97917 1.68445 8.35838 2.30958C8.22636 2.44253 8.10664 2.58555 7.99996 2.73686C7.89328 2.58555 7.77356 2.44253 7.64154 2.30958C7.02075 1.68445 6.17879 1.33325 5.30087 1.33325H1.32875ZM7.28682 4.66664V11.6903C6.88771 11.4583 6.43171 11.3331 5.96289 11.3331H1.99088V2.66678H5.30087C5.82758 2.66678 6.33271 2.87748 6.70515 3.25252C7.07759 3.62757 7.28682 4.13624 7.28682 4.66664ZM10.037 11.3331C9.56821 11.3331 9.11221 11.4583 8.7131 11.6903V4.66664C8.7131 4.13624 8.92233 3.62757 9.29477 3.25252C9.66721 2.87748 10.1723 2.66678 10.6991 2.66678H14.009V11.3331H10.037Z",
          style: { fill: e }
        }
      )
    }
  );
}, ub = xw, Cw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.4167 2C12.6928 2 12.9167 2.27982 12.9167 2.625V4L14.375 4C14.7202 4 15 4.22386 15 4.5C15 4.77614 14.7202 5 14.375 5H12.9167V6.375C12.9167 6.72018 12.6928 7 12.4167 7C12.1405 7 11.9167 6.72018 11.9167 6.375V5H10.625C10.2798 5 10 4.77614 10 4.5C10 4.22386 10.2798 4 10.625 4L11.9167 4V2.625C11.9167 2.27982 12.1405 2 12.4167 2ZM9 4.5C9 3.9632 9.12085 3.45463 9.33682 3H2.1C1.49249 3 1 3.49249 1 4.1V5H9.03544C9.01209 4.8367 9 4.66976 9 4.5ZM12.5 8C11.1038 8 9.89855 7.18247 9.33682 6H1V11.9C1 12.5075 1.4925 13 2.1 13H13.9C14.5075 13 15 12.5075 15 11.9V6.94949C14.3647 7.59777 13.4793 8 12.5 8ZM7 8V9H3V8H7Z",
          style: { fill: e }
        }
      )
    }
  );
}, db = Cw, bw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.80001 2.58334H3.53334C3.00867 2.58334 2.58334 3.00867 2.58334 3.53334V5.80001C2.58334 6.32468 3.00867 6.75001 3.53334 6.75001H5.80001C6.32468 6.75001 6.75001 6.32468 6.75001 5.80001V3.53334C6.75001 3.00867 6.32468 2.58334 5.80001 2.58334Z",
            style: { stroke: e, fill: e },
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.80001 9.25H3.53334C3.00867 9.25 2.58334 9.67533 2.58334 10.2V12.4667C2.58334 12.9913 3.00867 13.4167 3.53334 13.4167H5.80001C6.32468 13.4167 6.75001 12.9913 6.75001 12.4667V10.2C6.75001 9.67533 6.32468 9.25 5.80001 9.25Z",
            style: { stroke: e, fill: e },
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M12.4667 9.25H10.2C9.67533 9.25 9.25 9.67533 9.25 10.2V12.4667C9.25 12.9913 9.67533 13.4167 10.2 13.4167H12.4667C12.9913 13.4167 13.4167 12.9913 13.4167 12.4667V10.2C13.4167 9.67533 12.9913 9.25 12.4667 9.25Z",
            style: { stroke: e, fill: e },
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4167 2C11.6928 2 11.9167 2.27982 11.9167 2.625L11.9167 6.375C11.9167 6.72018 11.6928 7 11.4167 7C11.1405 7 10.9167 6.72018 10.9167 6.375L10.9167 2.625C10.9167 2.27982 11.1405 2 11.4167 2Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14 4.5C14 4.77614 13.7202 5 13.375 5L9.625 5C9.27982 5 9 4.77614 9 4.5C9 4.22386 9.27982 4 9.625 4L13.375 4C13.7202 4 14 4.22386 14 4.5Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, fb = bw, Mw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 8.5a2.5 2.5 0 0 1-2.458-2.042 2.5 2.5 0 0 1 0-4.916c.013-.07.029-.14.048-.209H6.667c-1.886 0-2.829 0-3.415.586-.585.586-.585 1.529-.585 3.414v5.334c0 1.885 0 2.828.585 3.414.586.586 1.529.586 3.415.586h2.666c1.886 0 2.829 0 3.415-.586.585-.586.585-1.529.585-3.414V8.115A2.488 2.488 0 0 1 12 8.5Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M12 2v4M14 4h-4",
            style: { stroke: e },
            strokeWidth: 2,
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}, pb = Mw, Dw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.286 1.333h.047v1.334c-.961 0-1.615.001-2.105.067-.471.063-.69.175-.837.323-.149.149-.26.367-.324.837C4.001 4.384 4 5.038 4 6v4c0 .962.001 1.616.067 2.106.064.47.175.688.324.837.148.148.366.26.837.323.49.066 1.144.067 2.105.067h1.334c.961 0 1.616-.001 2.105-.067.471-.063.69-.175.838-.323.148-.149.26-.367.323-.837.066-.49.067-1.144.067-2.106V8.667h1.333v1.38c0 .903 0 1.647-.079 2.236-.083.619-.264 1.165-.702 1.603-.437.437-.983.618-1.602.702-.59.079-1.334.079-2.236.079H7.286c-.902 0-1.647 0-2.236-.08-.619-.083-1.165-.264-1.602-.701-.438-.438-.619-.984-.702-1.603-.08-.589-.08-1.333-.08-2.236V5.953c0-.903 0-1.647.08-2.236.083-.619.264-1.165.702-1.603.437-.437.983-.618 1.602-.701.59-.08 1.334-.08 2.236-.08Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 1.333c.368 0 .667.299.667.667v4a.667.667 0 0 1-1.334 0V2c0-.368.299-.667.667-.667Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.667 4a.667.667 0 0 1-.667.667h-4a.667.667 0 1 1 0-1.334h4c.368 0 .667.299.667.667Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, hb = Dw, _w = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.667 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0ZM8 12.704a1 1 0 0 1-1-1V9H4.296a1 1 0 1 1 0-2H7V4.296a1 1 0 1 1 2 0V7h2.704a1 1 0 1 1 0 2H9v2.704a1 1 0 0 1-1 1Z",
          style: { fill: e }
        }
      )
    }
  );
}, vb = _w, Ew = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8 2.667v10.666M13.333 8H2.667",
          style: { stroke: e },
          strokeWidth: 2,
          strokeLinecap: "round"
        }
      )
    }
  );
}, mb = Ew, Iw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M2.863 2.917v11.552l2.345-1.54L8.08 14.75l2.66-1.82 2.399 1.54V2.916c0-1.429-1.109-1.704-1.663-1.663h-6.95c-1.358 0-1.674 1.108-1.662 1.663Z",
            style: { fill: e, stroke: e },
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M8 6v3.333M9.667 7.667H6.333",
            stroke: "#fff",
            strokeWidth: 2,
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}, gb = Iw, Ow = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M2.863 2.917v11.552l2.345-1.54L8.08 14.75l2.66-1.82 2.399 1.54V2.916c0-1.429-1.109-1.704-1.663-1.663h-6.95c-1.358 0-1.674 1.108-1.662 1.663Z",
            style: { stroke: e },
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M8 6v3.333M9.667 7.667H6.333",
            style: { stroke: e },
            strokeWidth: 2,
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}, yb = Ow, Nw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.667 13.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333Zm0 1.334a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 4v.194a2 2 0 0 1 1.667 1.973v.282a4.634 4.634 0 0 0-1.345-.403.667.667 0 0 0-.655-.546h-8V10c0 .368.298.667.666.667H6c0 .463.068.91.193 1.333h-2.86a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2H9a2 2 0 0 1 2 2ZM2.667 4c0-.368.298-.667.666-.667H9c.368 0 .667.299.667.667v.167h-7V4Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M11.333 9.333a.667.667 0 1 0-1.333 0V10h-.667a.667.667 0 0 0 0 1.333H10V12a.667.667 0 0 0 1.333 0v-.667H12A.667.667 0 1 0 12 10h-.667v-.667Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.333 8.667C3.333 8.298 3.632 8 4 8h1.333a.667.667 0 0 1 0 1.333H4a.667.667 0 0 1-.667-.666Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, wb = Nw, Tw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "m1.79 8.616.912.234.69-1.08-1.302-.325a.616.616 0 0 0-.462.078.602.602 0 0 0-.28.364.616.616 0 0 0 .078.462.553.553 0 0 0 .365.267Zm11.857.182-2.967 2.668L7.179 8.76a.68.68 0 0 0-.221-.104l-.469-.117-.69 1.08.742.182 3.787 2.928a.71.71 0 0 0 .189.098.598.598 0 0 0 .404-.006.497.497 0 0 0 .188-.117l3.358-3.02a.554.554 0 0 0 .195-.41.572.572 0 0 0-.156-.436.591.591 0 0 0-.417-.195.606.606 0 0 0-.442.156Zm-6.52-2.941 3.253 2.082a.606.606 0 0 0 .45.085.538.538 0 0 0 .37-.254l3.358-4.815a.588.588 0 0 0 .098-.456.586.586 0 0 0-.254-.39.587.587 0 0 0-.456-.098.586.586 0 0 0-.39.254l-3.02 4.347L7.27 4.516a.697.697 0 0 0-.228-.09.563.563 0 0 0-.455.097.63.63 0 0 0-.163.176l-4.998 7.834a.623.623 0 0 0-.078.462c.035.16.126.285.274.371.043.035.093.061.15.078a.554.554 0 0 0 .455-.052.698.698 0 0 0 .227-.208l4.673-7.327Z",
          style: { fill: e }
        }
      )
    }
  );
}, xb = Tw, kw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M11.9 1H4.1A1.1 1.1 0 0 0 3 2.1v11.8A1.1 1.1 0 0 0 4.1 15h7.8a1.1 1.1 0 0 0 1.1-1.1V2.1A1.1 1.1 0 0 0 11.9 1Zm-1.47 6.818-2.88 4.534-1.68-2.058.775-.632.804.985 2.136-3.365.845.536ZM5.5 4C5 4 5 4 5 3.5s0-.5.5-.5h5c.5 0 .5 0 .5.5s0 .5-.5.5h-5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Cb = kw, Sw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M15 12.9V5.1A1.1 1.1 0 0 0 13.9 4H6.618l-.696-1.392A1.1 1.1 0 0 0 4.938 2H2.1A1.1 1.1 0 0 0 1 3.1v9.8A1.1 1.1 0 0 0 2.1 14h11.8a1.1 1.1 0 0 0 1.1-1.1ZM7.5 2H14v1H8.5l-1-1Zm.125 9.185 2.782-3.894-.814-.582-2.218 3.106-1.098-.731-.554.832 1.902 1.269Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, bb = Sw, Rw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M15 5.1v7.8a1.1 1.1 0 0 1-1.1 1.1H2.1A1.1 1.1 0 0 1 1 12.9V3.1A1.1 1.1 0 0 1 2.1 2h2.838a1.1 1.1 0 0 1 .984.608L6.618 4H13.9A1.1 1.1 0 0 1 15 5.1ZM2.1 3a.1.1 0 0 0-.1.1v9.8a.1.1 0 0 0 .1.1h11.8a.1.1 0 0 0 .1-.1V5.1a.1.1 0 0 0-.1-.1H6.062a.1.1 0 0 1-.09-.055l-.944-1.89A.1.1 0 0 0 4.938 3H2.1Zm8.307 4.29-2.782 3.895-1.902-1.269.554-.832 1.098.731L9.593 6.71l.814.582ZM13.5 2h-6l1 1H14v-.5a.5.5 0 0 0-.5-.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Mb = Rw, jw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M4.1 1h7.8A1.1 1.1 0 0 1 13 2.1v11.8a1.1 1.1 0 0 1-1.1 1.1H4.1A1.1 1.1 0 0 1 3 13.9V2.1A1.1 1.1 0 0 1 4.1 1Zm0 1a.1.1 0 0 0-.1.1v11.8a.1.1 0 0 0 .1.1h7.8a.1.1 0 0 0 .1-.1V2.1a.1.1 0 0 0-.1-.1H11v1.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 5 3.25V2h-.9ZM6 2h4v1H6V2Zm1.797 9.802 2.628-3.976-.835-.551-2.033 3.077-.993-.77-.612.792 1.845 1.428Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Db = jw, Pw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.293 4.293a1 1 0 1 1 1.414 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7A.997.997 0 0 1 4 12.003l.001-.002v-.003a.997.997 0 0 1 .286-.697l.008-.008m0 0 6.999-7Z",
          style: { fill: e }
        }
      )
    }
  );
}, Sp = Pw, Aw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.3562 7.32206C4.86739 4.87801 6.94202 2.68492 9.40942 3.03741C10.1832 3.14795 10.9003 3.50647 11.453 4.05917L15.3906 7.99679L18.3487 5.03864L19.4094 6.0993L16.4512 9.05745L15.3906 10.1181L14.3299 11.1788L13.2693 12.2394L12.2086 13.3001L11.1479 14.3608L10.163 15.3456L9.10237 16.4063L5.54607 19.9626L4.48541 18.9019L8.04171 15.3456L5.82851 13.1325L6.88917 12.0718L9.10237 14.285L10.0873 13.3001L6.50321 9.71603C5.95857 9.17139 5.58734 8.47773 5.43628 7.72245L5.3562 7.32206ZM11.1479 12.2394L12.2086 11.1788L8.96968 7.93986L10.0303 6.8792L13.2693 10.1181L14.3299 9.05745L10.3923 5.11983C10.0691 4.79663 9.64978 4.58697 9.19729 4.52233C7.75442 4.31621 6.54123 5.59867 6.82707 7.02788L6.90715 7.42828C7.00013 7.89317 7.22863 8.32013 7.56387 8.65537L11.1479 12.2394ZM16.4512 11.1788L17.5119 10.1181L19.6694 12.2756C20.9201 13.5263 21.4188 15.3437 20.9816 17.0576C20.505 18.9256 18.9992 20.3545 17.1088 20.7326L16.8726 20.7799C15.1042 21.1335 13.2761 20.58 12.0009 19.3048L10.163 17.467L11.2237 16.4063L13.0616 18.2442C13.9821 19.1647 15.3018 19.5643 16.5784 19.309L16.8146 19.2617C18.1391 18.9968 19.1942 17.9956 19.5281 16.6868C19.8345 15.486 19.485 14.2126 18.6087 13.3363L16.4512 11.1788ZM14.1718 17.3846L12.2086 15.4214L13.2693 14.3608L15.2324 16.3239C15.2795 16.371 15.3328 16.4117 15.3906 16.4448C16.0538 16.8237 16.7929 16.0846 16.4139 15.4215C16.3809 15.3636 16.3402 15.3104 16.2931 15.2633L14.3299 13.3001L15.3906 12.2394L17.3537 14.2026C17.4951 14.344 17.6171 14.5036 17.7163 14.6773C18.8531 16.6668 16.6359 18.884 14.6464 17.7471C14.4728 17.6479 14.3132 17.526 14.1718 17.3846Z",
          style: { fill: e }
        }
      )
    }
  );
}, _b = Aw, Lw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 4.33332C2 4.13147 2.12137 3.94942 2.30769 3.87178L7.23077 1.8205C7.72308 1.61537 8.27692 1.61537 8.76923 1.8205L13.6923 3.87178C13.8786 3.94942 14 4.13147 14 4.33332V5.99999H2V4.33332ZM2 13C2 12.4477 2.44772 12 3 12V6.99999H5V12H7V6.99999H9V12H11V6.99999H13V12C13.5523 12 14 12.4477 14 13V14H2V13Z",
          style: { fill: e }
        }
      )
    }
  );
}, Eb = Lw, Vw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.44721 2.84163L13 5.11802V5.99999H12H10H9H7H6H4H3V5.11802L7.55279 2.84163C7.83431 2.70086 8.16569 2.70086 8.44721 2.84163ZM3 6.99999H2V5.99999V4.49999L7.10557 1.9472C7.66863 1.66567 8.33137 1.66567 8.89443 1.9472L14 4.49999V5.99999V6.99999H13V11C13.5523 11 14 11.4477 14 12V13V14H13H3H2V13V12C2 11.4477 2.44772 11 3 11V6.99999ZM4 6.99999V11H6V6.99999H4ZM7 6.99999V11H9V6.99999H7ZM10 6.99999V11H12V6.99999H10ZM12 12H13V13H3V12H4H6H7H9H10H12Z",
          style: { fill: e }
        }
      )
    }
  );
}, Ib = Vw, Hw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M4.956 2.86 2 1.382V13.9A1.1 1.1 0 0 0 3.1 15H13V1.523l-3.35 1.34-2.088-1.566L4.956 2.86ZM7 6h1v1h1.5v1H7a.5.5 0 1 0 0 1h1a1.5 1.5 0 1 1 0 3v1H7v-1H5.5v-1H8a.5.5 0 1 0 0-1H7a1.5 1.5 0 1 1 0-3V6Zm8 1h-1v8h1V7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Ob = Hw, Fw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M3.512 1.993 2 1.093V13.9A1.1 1.1 0 0 0 3.1 15H13V1.06l-1.427.675-2.395 1.132-1.54-1.278-.643-.534-.64.539L4.9 2.82l-1.388-.827ZM7 2.358l2.03 1.685L11 3.112l1-.473V14H3.1a.1.1 0 0 1-.1-.1V2.853l1 .595 1 .595 2-1.685ZM15 7h-1v8h1V7ZM7 6h1v1h1.5v1H7a.5.5 0 0 0 0 1h1a1.5 1.5 0 1 1 0 3v1H7v-1H5.5v-1H8a.5.5 0 0 0 0-1H7a1.5 1.5 0 1 1 0-3V6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Nb = Fw, Yw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M14.0005 8.00232H12.0005V2.00232C12.001 1.88485 11.9704 1.76934 11.9119 1.66749C11.8533 1.56564 11.7689 1.48106 11.6672 1.42232C11.5659 1.36381 11.4509 1.33301 11.3339 1.33301C11.2168 1.33301 11.1019 1.36381 11.0005 1.42232L9.00053 2.56899L7.00053 1.42232C6.89919 1.36381 6.78423 1.33301 6.6672 1.33301C6.55018 1.33301 6.43521 1.36381 6.33387 1.42232L4.33387 2.56899L2.33387 1.42232C2.23252 1.36381 2.11756 1.33301 2.00053 1.33301C1.88351 1.33301 1.76855 1.36381 1.6672 1.42232C1.56546 1.48106 1.48106 1.56564 1.42252 1.66749C1.36398 1.76934 1.3334 1.88485 1.33387 2.00232V12.0023C1.33387 12.5328 1.54458 13.0415 1.91965 13.4165C2.29473 13.7916 2.80343 14.0023 3.33387 14.0023H12.6672C13.1976 14.0023 13.7063 14.4583 14.0814 14.0832C14.4565 13.7081 14.6672 13.1994 14.6672 12.669V8.66899C14.6672 8.49218 14.597 8.32261 14.4719 8.19759C14.3469 8.07256 14.1773 8.00232 14.0005 8.00232ZM3.33387 12.669C3.15706 12.669 2.98749 12.5988 2.86246 12.4737C2.73744 12.3487 2.6672 12.1791 2.6672 12.0023V3.15566L4.00053 3.91566C4.10343 3.9694 4.21779 3.99747 4.33387 3.99747C4.44995 3.99747 4.56431 3.9694 4.6672 3.91566L6.6672 2.76899L8.6672 3.91566C8.77009 3.9694 8.88445 3.99747 9.00053 3.99747C9.11662 3.99747 9.23098 3.9694 9.33387 3.91566L10.6672 3.15566V12.0023C10.669 12.2298 10.7096 12.4552 10.7872 12.669H3.33387ZM13.3339 12.669C13.3339 12.8458 13.2636 13.0154 13.1386 13.1404C13.0136 13.2654 12.844 13.3357 12.6672 13.3357C12.4904 13.3357 12.3208 13.2654 12.1958 13.1404C12.0708 13.0154 12.0005 12.8458 12.0005 12.669V9.33566H13.3339V12.669Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx("circle", { cx: "10.6667", cy: "10.6659", r: "2.66667", fill: "white" }),
        /* @__PURE__ */ f.jsx("rect", { x: "12", y: "6.66602", width: "2.66667", height: "8", fill: "white" }),
        /* @__PURE__ */ f.jsx("rect", { x: "10.6666", y: "13.9993", width: "2", height: "0.666667", fill: "white" }),
        /* @__PURE__ */ f.jsx("circle", { cx: "10.6667", cy: "10.6659", r: "4.66667", fill: "white" }),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M12 11.3327C12.3681 11.3327 12.6666 11.0342 12.6666 10.666C12.6666 10.2978 12.3681 9.99935 12 9.99935H11.3333V9.33268C11.3333 8.96449 11.0348 8.66602 10.6666 8.66602C10.2984 8.66602 9.99996 8.96449 9.99996 9.33268V10.666C9.99996 11.0342 10.2984 11.3327 10.6666 11.3327H12Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6666 10.666C14.6666 12.8752 12.8758 14.666 10.6666 14.666C8.45749 14.666 6.66663 12.8752 6.66663 10.666C6.66663 8.45688 8.45749 6.66602 10.6666 6.66602C12.8758 6.66602 14.6666 8.45688 14.6666 10.666ZM13.3333 10.666C13.3333 12.1388 12.1394 13.3327 10.6666 13.3327C9.19387 13.3327 7.99996 12.1388 7.99996 10.666C7.99996 9.19326 9.19387 7.99935 10.6666 7.99935C12.1394 7.99935 13.3333 9.19326 13.3333 10.666Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 5.99943C4 5.63124 4.29848 5.33276 4.66667 5.33276H6.66667C7.03486 5.33276 7.33333 5.63124 7.33333 5.99943C7.33333 6.36762 7.03486 6.6661 6.66667 6.6661H4.66667C4.29848 6.6661 4 6.36762 4 5.99943Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 7.99943C4 7.63124 4.29848 7.33276 4.66667 7.33276H5.33333C5.70152 7.33276 6 7.63124 6 7.99943C6 8.36762 5.70152 8.6661 5.33333 8.6661H4.66667C4.29848 8.6661 4 8.36762 4 7.99943Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, Tb = Yw, $w = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M6.4 12.8h3.2l-.324 1.297a.4.4 0 0 1-.388.303H7.112a.4.4 0 0 1-.388-.303L6.4 12.8ZM7.6 1.6h.8v1.6h-.8V1.6ZM4 2.8l.693-.4.8 1.386-.693.4L4 2.8ZM11.893 2.8l-.693-.4-.8 1.386.693.4.8-1.386Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.166 10.996c-.22.161-.366.403-.366.667V12H6.2v-.337c0-.264-.147-.506-.366-.667C4.842 10.267 4 9.032 4 7.81 4 5.706 5.79 4 8 4s4 1.706 4 3.81c0 1.222-.842 2.457-1.834 3.186ZM9.6 7.048c.442 0 .8-.341.8-.762s-.358-.762-.8-.762c-.442 0-.8.34-.8.762 0 .42.358.762.8.762Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, kb = $w, zw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 8h-4v2h3v12h2V9a1 1 0 0 0-1-1ZM4 2a1 1 0 0 0-1 1v19h2V4.2c0-.11.09-.2.2-.2h6.6c.11 0 .2.09.2.2V22h2V3a1 1 0 0 0-1-1H4Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M6 5.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2V5.2ZM6 8.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2V8.2ZM6 11.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-1.6ZM6 14.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-1.6ZM9 5.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2V5.2ZM9 8.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2V8.2ZM9 11.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-1.6ZM9 14.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-1.6ZM15 11.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.6ZM15 14.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.6Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, Sb = zw, Zw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.333 4.007h.007a.66.66 0 0 0 .66-.66V1.993a.66.66 0 0 0-.66-.66h-.007a.66.66 0 0 0-.66.66v1.354c0 .364.296.66.66.66Zm8.754-.767a1.914 1.914 0 0 0-1.42-.573h-.927v.666a1.072 1.072 0 1 1-2.14 0v-.666H6.407v.666a1.073 1.073 0 1 1-2.14 0v-.666h-.934a1.913 1.913 0 0 0-1.42.58 1.933 1.933 0 0 0-.58 1.42v8a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2v-8a1.935 1.935 0 0 0-.58-1.427Zm-.754 9.427a.605.605 0 0 1-.666.666H3.333a.605.605 0 0 1-.666-.666V8h10.666v4.667Zm-2.66-8.66h-.006a.66.66 0 0 1-.66-.66V1.993a.66.66 0 0 1 .66-.66h.006a.66.66 0 0 1 .66.66v1.354a.66.66 0 0 1-.66.66Z",
          style: { fill: e }
        }
      )
    }
  );
}, Rb = Zw, Ww = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.668 2.661h-1.342v-.656c0-.208-.06-.372-.18-.492a.643.643 0 0 0-.476-.18c-.208 0-.372.06-.492.18s-.18.284-.18.492v.656H6.002v-.656c0-.208-.06-.372-.18-.492s-.284-.18-.492-.18a.644.644 0 0 0-.476.18c-.12.12-.18.284-.18.492v.656H3.332a1.93 1.93 0 0 0-1.421.578c-.385.385-.578.859-.578 1.421v8.007c0 .563.193 1.036.578 1.422a1.93 1.93 0 0 0 1.42.578h9.337a1.93 1.93 0 0 0 1.421-.578c.385-.386.578-.86.578-1.422V4.66c0-.562-.193-1.036-.578-1.421a1.93 1.93 0 0 0-1.42-.578ZM3.332 4.004h1.342v.656c0 .209.06.373.18.492.12.12.278.18.476.18.208 0 .372-.06.492-.18s.18-.283.18-.492v-.656h3.996v.656c0 .209.06.373.18.492.12.12.284.18.492.18.198 0 .356-.06.476-.18s.18-.283.18-.492v-.656h1.342c.198 0 .357.06.476.18.12.12.18.278.18.476v2H2.676v-2c0-.198.06-.356.18-.476s.278-.18.476-.18Zm9.336 9.32H3.332a.643.643 0 0 1-.476-.18.644.644 0 0 1-.18-.477V8.003h10.648v4.664c0 .198-.06.357-.18.477a.643.643 0 0 1-.476.18Z",
          style: { fill: e }
        }
      )
    }
  );
}, jb = Ww, Bw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      viewBox: "0 0 16 16",
      fill: "none",
      width: n,
      height: o,
      ...t,
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 1H4V2H3.1C2.49248 2 2 2.49249 2 3.1V5H12V3.1C12 2.49249 11.5075 2 10.9 2H10V1H9V2H5V1ZM2 6H9.16783C7.647 6.76357 6.60329 8.33751 6.60329 10.1552C6.60329 11.2269 6.9661 12.2139 7.57559 13H3.1C2.49249 13 2 12.5075 2 11.9V6ZM11.25 12.5C12.2165 12.5 13 11.7165 13 10.75H12.9998C12.9998 9.75826 12.3026 9.01116 11.3779 9.00014V9.00039C11.3275 9.00039 11.2824 8.99993 11.2412 8.9995H11.2412H11.2411C11.1607 8.99868 11.0953 8.998 11.0349 9.00124L11.6859 10.1282L8.74141 9.72764L9.76938 6.81042L10.5068 8.08705C10.8207 7.9908 11.0864 7.99563 11.282 7.99919L11.2822 7.9992C11.3085 7.99967 11.3335 8.00013 11.3572 8.00031V8.00002C12.9075 8.00002 13.9998 9.26389 13.9998 10.75H14C14 12.2688 12.7688 13.5 11.25 13.5C10.5312 13.5 9.84855 13.2825 9.33666 12.8508C8.81657 12.4121 8.5 11.7734 8.5 11.0051H9.5C9.5 11.4794 9.68711 11.8382 9.98136 12.0863C10.2838 12.3414 10.7261 12.5 11.25 12.5Z",
          style: { fill: e }
        }
      )
    }
  );
}, Pb = Bw, Uw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 1H4V2H3.1C2.49248 2 2 2.49249 2 3.1V11.9C2 12.5075 2.49249 13 3.1 13H7.75777C7.55127 12.6915 7.3819 12.356 7.25606 12H3.1C3.04477 12 3 11.9552 3 11.9V6H11V6.02746C11.1642 6.00932 11.331 6 11.5 6C11.669 6 11.8358 6.00932 12 6.02746V6V5V3.1C12 2.49249 11.5075 2 10.9 2H10V1H9V2H5V1ZM11 5V3.1C11 3.04477 10.9552 3 10.9 3H10V4H9V3H5V4H4V3H3.1C3.04477 3 3 3.04477 3 3.1V5H11ZM10.5068 8.08703L9.76933 6.81039L8.74136 9.72762L11.6858 10.1282L11.0348 9.00121C11.0952 8.99797 11.1607 8.99864 11.2411 8.99947H11.2411H11.2412H11.2412H11.2412C11.2824 8.9999 11.3275 9.00036 11.3779 9.00036V9.00011C12.3027 9.01104 13 9.75818 13 10.75H13C13 11.7165 12.2165 12.5 11.25 12.5C10.7261 12.5 10.2838 12.3414 9.98135 12.0863C9.6871 11.8381 9.49999 11.4794 9.49999 11.0051H8.49999C8.49999 11.7734 8.81657 12.4121 9.33665 12.8507C9.84855 13.2825 10.5312 13.5 11.25 13.5C12.7688 13.5 14 12.2688 14 10.75H14C14 9.26386 12.9077 7.99999 11.3574 7.99999V8.00028C11.3336 8.0001 11.3084 7.99964 11.2821 7.99916L11.282 7.99916C11.0863 7.9956 10.8207 7.99077 10.5068 8.08703Z",
          style: { fill: e }
        }
      )
    }
  );
}, Ab = Uw, Kw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.44 4.153c.494.212.884.61 1.087 1.107.096.246.144.509.14.773v5.334a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2V6.033a2 2 0 0 1 2-2h.854l.213-.666A2 2 0 0 1 6.293 2h3.414A2 2 0 0 1 11.6 3.333l.213.667h.854c.265 0 .527.053.773.153Zm-4.42 6.314a2.713 2.713 0 0 0 1.2-.987v.02a2.667 2.667 0 0 0-3.7-3.7A2.713 2.713 0 0 0 5.533 7a2.667 2.667 0 0 0 3.487 3.467ZM7.26 9.109A1.333 1.333 0 1 0 8.74 6.89 1.333 1.333 0 0 0 7.26 9.11Z",
          style: { fill: e }
        }
      )
    }
  );
}, Lb = Kw, Qw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.667 4.333h-.854l-.213-.666a2 2 0 0 0-1.893-1.334H6.293A2 2 0 0 0 4.4 3.7l-.213.667h-.854a2 2 0 0 0-2 2V11.7a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V6.367a2.001 2.001 0 0 0-2-2.034Zm.666 7.334a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666V6.333a.667.667 0 0 1 .666-.666h1.334a.667.667 0 0 0 .666-.454l.36-1.093a.667.667 0 0 1 .634-.453H9.74a.667.667 0 0 1 .633.453l.36 1.093a.667.667 0 0 0 .6.454h1.334a.667.667 0 0 1 .666.666v5.334ZM8 5.667A2.667 2.667 0 1 0 8 11a2.667 2.667 0 0 0 0-5.333Zm0 4A1.333 1.333 0 1 1 8 7a1.333 1.333 0 0 1 0 2.667Z",
          style: { fill: e }
        }
      )
    }
  );
}, Vb = Qw, qw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M13.9 3H2.1A1.1 1.1 0 0 0 1 4.1V5h14v-.9A1.1 1.1 0 0 0 13.9 3ZM1 11.9V6h14v5.9a1.1 1.1 0 0 1-1.1 1.1H2.1A1.1 1.1 0 0 1 1 11.9ZM7 9V8H3v1h4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Hb = qw, Gw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M2.1 3h11.8A1.1 1.1 0 0 1 15 4.1v7.8a1.1 1.1 0 0 1-1.1 1.1H2.1A1.1 1.1 0 0 1 1 11.9V4.1A1.1 1.1 0 0 1 2.1 3Zm0 1a.1.1 0 0 0-.1.1V5h12v-.9a.1.1 0 0 0-.1-.1H2.1ZM2 11.9V6h12v5.9a.1.1 0 0 1-.1.1H2.1a.1.1 0 0 1-.1-.1ZM7 9V8H3v1h4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Fb = Gw, Xw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M0 2.2c0-.11.09-.2.2-.2h15.6c.11 0 .2.09.2.2v8.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V2.2ZM.2 14a.2.2 0 0 1-.2-.2V12h1v1h14v-1h1v1.8a.2.2 0 0 1-.2.2H.2ZM1 8h1v1H1V8Zm1 1h1v1H2V9Zm0-5v1H1V4h1Zm1 0H2V3h1v1Zm7 1H9V4H7v1H6v3h1v1h2V8h1V5ZM9 8H7V5h2v3Zm5-5h-1v1h1v1h1V4h-1V3Zm0 7h-1V9h1v1Zm0-1V8h1v1h-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Yb = Xw, Jw = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            style: { fill: e },
            fillRule: "evenodd",
            d: "M1 4V3h1v1H1Zm13 0h-1V3H3v1H2v1H1v3h1v1H1v1h1V9h1v1h10V9h1v1h1V9h-1V8h1V5h-1V4Zm0 0V3h1v1h-1ZM0 2.2c0-.11.09-.2.2-.2h15.6c.11 0 .2.09.2.2v8.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V2.2ZM9 4H7v1H6v3h1v1h2V8h1V5H9V4Zm0 1v3H7V5h2Zm-8 7H0v1.8c0 .11.09.2.2.2h15.6a.2.2 0 0 0 .2-.2V12h-1v1H1v-1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            style: { fill: e },
            d: "M1 9h1v1H1zm0-6h1v1H1zm13 6h1v1h-1zm0-6h1v1h-1z"
          }
        )
      ]
    }
  );
}, $b = Jw, ex = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M5.3 2.583H4.033c-.8 0-1.45.65-1.45 1.45V5.3c0 .8.65 1.45 1.45 1.45H5.3c.8 0 1.45-.65 1.45-1.45V4.033c0-.8-.65-1.45-1.45-1.45ZM5.3 9.25H4.033c-.8 0-1.45.65-1.45 1.45v1.267c0 .8.65 1.45 1.45 1.45H5.3c.8 0 1.45-.65 1.45-1.45V10.7c0-.8-.65-1.45-1.45-1.45ZM11.967 2.583H10.7c-.8 0-1.45.65-1.45 1.45V5.3c0 .8.65 1.45 1.45 1.45h1.267c.8 0 1.45-.65 1.45-1.45V4.033c0-.8-.65-1.45-1.45-1.45ZM11.967 9.25H10.7c-.8 0-1.45.65-1.45 1.45v1.267c0 .8.65 1.45 1.45 1.45h1.267c.8 0 1.45-.65 1.45-1.45V10.7c0-.8-.65-1.45-1.45-1.45Z",
          style: { fill: e, stroke: e },
          strokeWidth: 1.5
        }
      )
    }
  );
}, zb = ex, tx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M5.3 2.583H4.033c-.8 0-1.45.65-1.45 1.45V5.3c0 .8.65 1.45 1.45 1.45H5.3c.8 0 1.45-.65 1.45-1.45V4.033c0-.8-.65-1.45-1.45-1.45ZM5.3 9.25H4.033c-.8 0-1.45.65-1.45 1.45v1.267c0 .8.65 1.45 1.45 1.45H5.3c.8 0 1.45-.65 1.45-1.45V10.7c0-.8-.65-1.45-1.45-1.45ZM11.967 2.583H10.7c-.8 0-1.45.65-1.45 1.45V5.3c0 .8.65 1.45 1.45 1.45h1.267c.8 0 1.45-.65 1.45-1.45V4.033c0-.8-.65-1.45-1.45-1.45ZM11.967 9.25H10.7c-.8 0-1.45.65-1.45 1.45v1.267c0 .8.65 1.45 1.45 1.45h1.267c.8 0 1.45-.65 1.45-1.45V10.7c0-.8-.65-1.45-1.45-1.45Z",
          style: { stroke: e },
          strokeWidth: 1.5
        }
      )
    }
  );
}, Zb = tx, nx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M3.4 2h9.2A1.4 1.4 0 0 1 14 3.4v9.2a1.4 1.4 0 0 1-1.4 1.4H3.4A1.4 1.4 0 0 1 2 12.6V3.4A1.4 1.4 0 0 1 3.4 2Zm5.219 8.213 3.573-5.243-.827-.563-2.984 4.379-2.004-1.504-2.293 3.44.832.555 1.707-2.56 1.996 1.496Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Wb = nx, rx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M12.9 2H3.1A1.1 1.1 0 0 0 2 3.1v9.8A1.1 1.1 0 0 0 3.1 14h9.8a1.1 1.1 0 0 0 1.1-1.1V3.1A1.1 1.1 0 0 0 12.9 2ZM3 3.1a.1.1 0 0 1 .1-.1h9.8a.1.1 0 0 1 .1.1v9.8a.1.1 0 0 1-.1.1H3.1a.1.1 0 0 1-.1-.1V3.1Zm5.619 7.113 3.573-5.243-.827-.563-2.984 4.379-2.004-1.504-2.293 3.44.832.555 1.707-2.56 1.996 1.496Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Bb = rx, ox = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M7.012 2.081C7.333 2.028 7.663 2 8 2v12a6.036 6.036 0 0 1-1.21-.122A6.002 6.002 0 0 1 7 2.083m2.905 11.608a5.948 5.948 0 0 1-.905.226V8.1a.1.1 0 0 1 .1-.1H14a6.036 6.036 0 0 1-.098 1.088 6.01 6.01 0 0 1-3.997 4.603Zm.01-11.379A5.959 5.959 0 0 0 9 2.083V6.9a.1.1 0 0 0 .1.1h4.817a5.952 5.952 0 0 0-.268-1.026 6.017 6.017 0 0 0-3.734-3.662Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Ub = ox, ix = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M8 8v5A5 5 0 0 1 8 3v5Zm1 0v4.9A5.002 5.002 0 0 0 13 8H9Zm3.9-1A5.006 5.006 0 0 0 9 3.1V7h3.9ZM14 8A6 6 0 1 0 2 8a6 6 0 0 0 12 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, Kb = ix, ax = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm3.243-7.32a.75.75 0 1 0-1.152-.96L8.159 8.037c-.342.41-.55.657-.72.813a.734.734 0 0 1-.162.118.734.734 0 0 1-.17-.103c-.185-.14-.414-.366-.792-.744l-.451-.451a.75.75 0 0 0-1.061 1.06l.451.452.034.033c.333.333.636.636.914.847.305.23.676.426 1.143.405.468-.021.82-.25 1.102-.507.258-.235.533-.564.834-.926l.03-.036 1.932-2.318Z",
          style: { fill: e }
        }
      )
    }
  );
}, Gl = ax, sx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.065 1.62A6.667 6.667 0 1 1 8 14.667a.667.667 0 0 1 0-1.334 5.333 5.333 0 1 0-3.771-1.562.667.667 0 1 1-.943.943A6.666 6.666 0 0 1 6.065 1.62Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.094 6.155a.667.667 0 0 0-.94.085L7.757 9.118c-.231.278-.361.431-.465.526a.541.541 0 0 1-.004.003l-.004-.003c-.112-.085-.255-.226-.51-.481l-.968-.968a.667.667 0 1 0-.943.943l.968.968.027.027c.217.218.427.427.622.574.218.165.504.32.87.304.366-.017.637-.197.84-.381.18-.165.37-.392.567-.629l.024-.03 2.399-2.878a.667.667 0 0 0-.085-.938Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, Qb = sx, lx = ({ iconColor: e, ...r }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.53027 19.5303L7.46961 18.4697L14.0104 11.9289L7.46961 5.3882L8.53027 4.32754L16.1317 11.9289L8.53027 19.5303Z",
        style: { fill: e }
      }
    )
  }
), Rp = lx, cx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.529 5.529c.26-.26.682-.26.942 0L8 9.057l3.529-3.528a.667.667 0 1 1 .942.942l-4 4a.667.667 0 0 1-.942 0l-4-4a.667.667 0 0 1 0-.942Z",
          style: { fill: e }
        }
      )
    }
  );
}, Es = cx, ux = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.471 3.529c.26.26.26.682 0 .942L6.943 8l3.528 3.529a.667.667 0 1 1-.942.942l-4-4a.667.667 0 0 1 0-.942l4-4c.26-.26.682-.26.942 0Z",
          style: { fill: e }
        }
      )
    }
  );
}, jp = ux, dx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.529 12.471a.667.667 0 0 1 0-.942L9.057 8 5.53 4.471a.667.667 0 1 1 .942-.942l4 4c.26.26.26.682 0 .942l-4 4a.667.667 0 0 1-.942 0Z",
          style: { fill: e }
        }
      )
    }
  );
}, Pp = dx, fx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.471 10.471a.667.667 0 0 1-.942 0L8 6.943 4.471 10.47a.667.667 0 1 1-.942-.942l4-4c.26-.26.682-.26.942 0l4 4c.26.26.26.682 0 .942Z",
          style: { fill: e }
        }
      )
    }
  );
}, px = fx, hx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 7.333H8.667V4.667a.667.667 0 0 0-1.334 0V8A.667.667 0 0 0 8 8.667h2a.667.667 0 1 0 0-1.334Zm-2-6a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.334 5.334 0 1 1 8 2.666a5.334 5.334 0 0 1 0 10.667Z",
          style: { fill: e }
        }
      )
    }
  );
}, qb = hx, vx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.328 7.316A2.67 2.67 0 0 0 6.55 9.2l.02 5.53a.91.91 0 0 1-.91.9h-1A2.67 2.67 0 0 1 2 12.96v-8.3A2.66 2.66 0 0 1 4.66 2h8.3a2.66 2.66 0 0 1 2.67 2.63v1a.9.9 0 0 1-.9.9H9.21a2.67 2.67 0 0 0-1.882.786ZM11.02 8.37h8.29a2.67 2.67 0 0 1 2.67 2.67v8.29A2.67 2.67 0 0 1 19.31 22h-8.29a2.67 2.67 0 0 1-2.67-2.67v-8.29a2.67 2.67 0 0 1 2.67-2.67Z",
          style: { fill: e }
        }
      )
    }
  );
}, Gb = vx, mx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.847 5.579H7.39c-.512 0-.943.173-1.294.518-.35.346-.526.779-.526 1.3v5.452c0 .511.176.942.526 1.292.35.35.782.526 1.294.526h5.458c.521 0 .955-.175 1.3-.526.347-.35.52-.78.52-1.292V7.397c0-.521-.173-.954-.52-1.3-.345-.345-.779-.518-1.3-.518Zm.611 7.27c0 .18-.054.324-.163.433-.109.11-.258.163-.448.163H7.39a.586.586 0 0 1-.434-.163.585.585 0 0 1-.163-.433V7.397c0-.19.054-.339.163-.448a.586.586 0 0 1 .434-.163h5.458c.19 0 .339.054.448.163.109.11.163.258.163.448v5.452ZM3.75 9.214h-.597a.591.591 0 0 1-.448-.17.61.61 0 0 1-.163-.44V3.15a.61.61 0 0 1 .163-.44.591.591 0 0 1 .448-.17H8.61c.18 0 .325.056.434.17a.61.61 0 0 1 .163.44v.61c0 .18.057.325.17.434a.61.61 0 0 0 .441.163.61.61 0 0 0 .441-.163.572.572 0 0 0 .17-.434v-.61c0-.511-.175-.942-.525-1.292a1.76 1.76 0 0 0-1.294-.526H3.153c-.521 0-.955.175-1.3.526-.347.35-.52.78-.52 1.292v5.452c0 .512.173.942.52 1.293.345.35.779.525 1.3.525h.597c.19 0 .339-.054.448-.163.109-.11.163-.258.163-.448a.585.585 0 0 0-.163-.433c-.11-.109-.259-.163-.448-.163Z",
          style: { fill: e }
        }
      )
    }
  );
}, Xb = mx, gx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.667 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0ZM4.33 11.67a1 1 0 0 1 0-1.414L6.586 8 4.33 5.744A1 1 0 1 1 5.744 4.33L8 6.586l2.256-2.256a1 1 0 1 1 1.414 1.414L9.414 8l2.256 2.256a1 1 0 0 1-1.414 1.414L8 9.414 5.744 11.67a1 1 0 0 1-1.414 0Z",
          style: { fill: e }
        }
      )
    }
  );
}, Jb = gx, yx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.263 4.532a.897.897 0 0 1 1.269-1.27L8 6.732l3.468-3.468a.897.897 0 1 1 1.27 1.269L9.268 8l3.468 3.468a.897.897 0 0 1-1.269 1.27L8 9.268l-3.468 3.468a.897.897 0 1 1-1.27-1.269L6.732 8 3.263 4.532Z",
          style: { fill: e }
        }
      )
    }
  );
}, yr = yx, wx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.333c.326 0 .655.027.937.081.142.027.28.063.405.11.114.042.27.113.4.236a.667.667 0 0 1-.862 1.014l-.005-.001a1.224 1.224 0 0 0-.189-.05A3.796 3.796 0 0 0 8 2.668c-.26 0-.503.021-.686.057a1.224 1.224 0 0 0-.189.049l-.005.001a.667.667 0 0 1-.863-1.014c.132-.123.287-.194.4-.236.126-.047.264-.083.406-.11.282-.054.61-.08.937-.08ZM2 4h12v2c-.736 0-1.333.597-1.333 1.333V10c0 1.886 0 2.828-.586 3.414-.586.586-1.529.586-3.414.586H7.333c-1.885 0-2.828 0-3.414-.586-.586-.586-.586-1.528-.586-3.414V7.333C3.333 6.597 2.736 6 2 6V4Zm4.333 2.667c.369 0 .667.298.667.666v3.334a.667.667 0 1 1-1.333 0V7.333c0-.368.298-.666.666-.666Zm3.334 0c.368 0 .666.298.666.666v3.334a.667.667 0 0 1-1.333 0V7.333c0-.368.299-.666.667-.666Z",
          style: { fill: e }
        }
      )
    }
  );
}, eM = wx, xx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.333c.326 0 .655.027.937.081.142.027.28.063.405.11.114.042.27.113.4.236a.667.667 0 0 1-.862 1.014l-.005-.001a1.224 1.224 0 0 0-.189-.05A3.796 3.796 0 0 0 8 2.668c-.26 0-.503.021-.686.057a1.224 1.224 0 0 0-.189.049l-.005.001a.667.667 0 0 1-.863-1.014c.132-.123.287-.194.4-.236.126-.047.264-.083.406-.11.282-.054.61-.08.937-.08ZM2.684 5.344c-.158-.01-.364-.01-.684-.01V4h12v1.333c-.32 0-.526 0-.684.011a.773.773 0 0 0-.238.04.667.667 0 0 0-.36.36.774.774 0 0 0-.04.239c-.011.157-.011.364-.011.684v4.043c0 .591 0 1.1-.055 1.508-.059.438-.191.856-.531 1.196-.34.34-.759.473-1.196.531-.408.055-.917.055-1.508.055H6.623c-.591 0-1.1 0-1.508-.055-.437-.059-.856-.191-1.196-.53-.34-.34-.472-.76-.53-1.196-.056-.408-.056-.917-.056-1.508V6.667c0-.32 0-.527-.01-.684a.773.773 0 0 0-.04-.238.667.667 0 0 0-.361-.36.773.773 0 0 0-.238-.04Zm8.664.548c.012-.187.038-.374.1-.559H4.551c.063.185.089.372.101.559.015.209.015.46.015.753v4.022c0 .647.001 1.066.043 1.374.038.289.101.38.152.43.05.051.141.114.43.153.309.041.727.043 1.375.043h2.666c.648 0 1.066-.002 1.374-.043.29-.04.38-.102.431-.153.05-.05.114-.141.152-.43.042-.309.043-.727.043-1.374V6.645c0-.292 0-.544.015-.753ZM6 10a.667.667 0 1 0 1.333 0V8A.667.667 0 1 0 6 8v2Zm2.667 0A.667.667 0 1 0 10 10V8a.667.667 0 0 0-1.333 0v2Z",
          style: { fill: e }
        }
      )
    }
  );
}, tM = xx, Cx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.667 11.485v1.354c0 .375.303.678.677.678h9.485a.677.677 0 0 0 .677-.677v-1.355a.678.678 0 0 0-1.355 0v.678h-8.13v-.678a.678.678 0 0 0-1.354 0ZM7.41 8.14a.677.677 0 0 1-.001-.043v-5.42a.677.677 0 1 1 1.355 0v5.425l1.626-1.224a.678.678 0 0 1 .813 1.084l-2.71 2.032a.677.677 0 0 1-.407.136.677.677 0 0 1-.393-.122l-2.71-1.91a.677.677 0 1 1 .786-1.105L7.41 8.14Z",
          style: { fill: e }
        }
      )
    }
  );
}, nM = Cx, bx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.307 3.907c.06.061.107.134.14.213a.728.728 0 0 1 .046.293v.114a1.2 1.2 0 0 1-.04.146.607.607 0 0 1-.146.22l-1.734 1.694-3.386-3.334 1.733-1.726a.58.58 0 0 1 .213-.147.713.713 0 0 1 .514 0 .607.607 0 0 1 .22.147l2.44 2.38ZM1.527 10.78l6.5-6.487 3.373 3.38-6.393 6.547a.58.58 0 0 1-.227.147.667.667 0 0 1-.28.046H2.027a.667.667 0 0 1-.667-.666l-.027-2.494A.667.667 0 0 1 1.387 11a.766.766 0 0 1 .14-.22Z",
          style: { fill: e }
        }
      )
    }
  );
}, rM = bx, Mx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14.667 4.827a.666.666 0 0 0-.194-.474l-2.826-2.826a.667.667 0 0 0-.474-.194.667.667 0 0 0-.473.194L8.813 3.413 1.527 10.7a.667.667 0 0 0-.194.473V14a.667.667 0 0 0 .667.667h2.827a.666.666 0 0 0 .506-.194l7.247-7.286 1.893-1.854a.792.792 0 0 0 .147-.22.67.67 0 0 0 0-.16.47.47 0 0 0 0-.093l.047-.033ZM4.553 13.333H2.667v-1.886l6.62-6.62 1.886 1.886-6.62 6.62Zm7.56-7.56-1.886-1.886.946-.94 1.88 1.88-.94.946Z",
          style: { fill: e }
        }
      )
    }
  );
}, oM = Mx, Dx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.28033 1.71967C7.98744 1.42678 7.51256 1.42678 7.21967 1.71967C6.92678 2.01256 6.92678 2.48744 7.21967 2.78033L11.3055 6.86612C11.6538 7.21444 11.8605 7.42346 11.9895 7.5925C12.0486 7.66996 12.072 7.71497 12.0811 7.7367C12.0832 7.74174 12.0844 7.74522 12.085 7.74731L12.0858 7.75L12.085 7.75269C12.0844 7.75478 12.0832 7.75826 12.0811 7.7633C12.072 7.78503 12.0486 7.83004 11.9895 7.9075C11.8605 8.07654 11.6538 8.28556 11.3055 8.63388L7.21967 12.7197C6.92678 13.0126 6.92678 13.4874 7.21967 13.7803C7.51256 14.0732 7.98744 14.0732 8.28033 13.7803L12.3661 9.69454L12.3978 9.6629L12.3978 9.66288C12.7039 9.35688 12.9845 9.07632 13.1821 8.81737C13.3996 8.53222 13.5858 8.18703 13.5858 7.75C13.5858 7.31297 13.3996 6.96778 13.1821 6.68263C12.9845 6.42368 12.7038 6.14311 12.3978 5.8371L12.3978 5.83709L12.3661 5.80546L8.28033 1.71967ZM12.0858 7.75048L12.0858 7.75007L12.0858 7.75C12.0859 7.75024 12.0859 7.7504 12.0859 7.75045L12.0858 7.7502C12.0858 7.75046 12.0858 7.75057 12.0858 7.75048ZM12.0859 7.75045C12.0859 7.75047 12.0859 7.75047 12.0859 7.75045L12.0859 7.75045ZM3.28033 1.71967C2.98744 1.42678 2.51256 1.42678 2.21967 1.71967C1.92678 2.01256 1.92678 2.48744 2.21967 2.78033L6.30546 6.86612C6.65378 7.21444 6.86055 7.42346 6.98952 7.5925C7.04862 7.66996 7.072 7.71497 7.08107 7.7367C7.08197 7.73887 7.0827 7.74074 7.0833 7.74235C7.0841 7.74447 7.08465 7.74612 7.08502 7.74731L7.08579 7.75L7.08502 7.75269C7.08437 7.75478 7.08317 7.75826 7.08107 7.7633C7.072 7.78503 7.04862 7.83004 6.98952 7.9075C6.86055 8.07654 6.65378 8.28556 6.30546 8.63388L2.21967 12.7197C1.92678 13.0126 1.92678 13.4874 2.21967 13.7803C2.51256 14.0732 2.98744 14.0732 3.28033 13.7803L7.36612 9.69454L7.39777 9.6629L7.39778 9.66288C7.70386 9.35688 7.98448 9.07632 8.18205 8.81737C8.39962 8.53222 8.58579 8.18703 8.58579 7.75C8.58579 7.31297 8.39962 6.96778 8.18205 6.68263C7.98448 6.42368 7.70385 6.14311 7.39776 5.8371L7.39776 5.83709L7.36612 5.80546L3.28033 1.71967ZM7.08578 7.75048L7.08579 7.75007L7.08583 7.75C7.08587 7.75033 7.0859 7.75052 7.08589 7.75045L7.0858 7.7502C7.08578 7.75046 7.08578 7.75057 7.08578 7.75048Z",
          style: { fill: e }
        }
      )
    }
  );
}, iM = Dx, _x = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 4H7.692v1.243h2.186L7.182 7.94a.622.622 0 0 0 .88.879l2.695-2.695v2.185H12V4Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 5.244c-.473.156-.815.601-.815 1.126v3.26c0 .654.53 1.185 1.185 1.185h3.26c.525 0 .97-.342 1.126-.815h1.215a2.37 2.37 0 0 1-2.341 2H6.37A2.37 2.37 0 0 1 4 9.63V6.37A2.37 2.37 0 0 1 6 4.03v1.215Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, aM = _x, Ex = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.762 9c0-.378-.198-.602-.594-1.052C12.124 6.763 10.2 5 8 5S3.877 6.763 2.832 7.948c-.396.45-.594.674-.594 1.052s.198.602.594 1.052C3.877 11.237 5.8 13 8 13s4.123-1.763 5.168-2.948c.396-.45.594-.674.594-1.052ZM8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          style: { fill: e }
        }
      )
    }
  );
}, Ix = Ex, Ox = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.257 8.625C4.696 8.139 5.28 7.58 5.948 7.15c.672-.433 1.368-.7 2.052-.7.684 0 1.38.267 2.052.7.668.431 1.252.99 1.691 1.475.103.113.178.196.239.269.04.047.066.081.084.106a1.84 1.84 0 0 1-.084.106c-.061.073-.136.156-.239.27-.439.485-1.023 1.043-1.691 1.474-.672.433-1.368.7-2.052.7-.684 0-1.38-.267-2.052-.7-.668-.431-1.252-.99-1.691-1.475a11.004 11.004 0 0 1-.239-.269A1.822 1.822 0 0 1 3.934 9c.018-.025.044-.059.084-.106.061-.073.136-.156.239-.27ZM8 4.45c-1.2 0-2.273.462-3.136 1.018-.867.56-1.583 1.253-2.09 1.814l-.072.078c-.33.362-.785.858-.785 1.639s.454 1.277.785 1.639l.071.078c.508.561 1.224 1.255 2.091 1.814.863.556 1.936 1.018 3.136 1.018 1.2 0 2.273-.462 3.136-1.018.867-.56 1.583-1.253 2.09-1.814l.072-.078c.33-.362.784-.858.784-1.639s-.453-1.277-.784-1.639c-.025-.027-.049-.052-.071-.078-.508-.561-1.224-1.255-2.091-1.814C10.273 4.913 9.2 4.451 8 4.451ZM7.775 9a.225.225 0 1 1 .45 0 .225.225 0 0 1-.45 0Zm2 0a1.775 1.775 0 1 1-3.55 0 1.775 1.775 0 0 1 3.55 0Z",
          style: { fill: e }
        }
      )
    }
  );
}, sM = Ox, Nx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm1 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5ZM4 8.111a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm1 2.111a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5Z",
          style: { fill: e }
        }
      )
    }
  );
}, lM = Nx, Tx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.586 2H6.5A2.5 2.5 0 0 0 4 4.5v15A2.5 2.5 0 0 0 6.5 22h11a2.5 2.5 0 0 0 2.5-2.5V8.207a.5.5 0 0 0-.146-.353l-5.561-5.561A1 1 0 0 0 13.586 2ZM12 4v5.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5H12Zm2 1v3h3l-3-3Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M8 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1ZM8 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM8 16.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, cM = Tx, kx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.7761 3.22386 14 3.5 14H12.5C12.7761 14 13 13.7761 13 13.5V8V6.5V6H10H9V2H8.5H3.5ZM10 2V5L12.9661 5C12.9466 4.94988 12.919 4.90286 12.8841 4.86093L10.6499 2.17991C10.5549 2.06591 10.4142 2 10.2658 2H10ZM5 6H7V7H5V6ZM5 8H11V9H5V8ZM11 10H5V11H11V10Z",
          style: { fill: e }
        }
      )
    }
  );
}, uM = kx, Sx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 13V6H10H9V5V3H4V13H12ZM10.0316 3L11.6983 5H10V3H10.0316ZM3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.7761 3.22386 14 3.5 14H12.5C12.7761 14 13 13.7761 13 13.5V5.18103C13 5.06406 12.959 4.95079 12.8841 4.86093L10.6499 2.17991C10.5549 2.06591 10.4142 2 10.2658 2H3.5ZM5.1 6C5.04477 6 5 6.04477 5 6.1V6.9C5 6.95523 5.04477 7 5.1 7H6.9C6.95523 7 7 6.95523 7 6.9V6.1C7 6.04477 6.95523 6 6.9 6H5.1ZM5.1 8C5.04477 8 5 8.04477 5 8.1V8.9C5 8.95523 5.04477 9 5.1 9H10.9C10.9552 9 11 8.95523 11 8.9V8.1C11 8.04477 10.9552 8 10.9 8H5.1ZM5 10.1C5 10.0448 5.04477 10 5.1 10H10.9C10.9552 10 11 10.0448 11 10.1V10.9C11 10.9552 10.9552 11 10.9 11H5.1C5.04477 11 5 10.9552 5 10.9V10.1Z",
          style: { fill: e }
        }
      )
    }
  );
}, dM = Sx, Rx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H8.5H9V6H10H13V6.5V7.55366C12.641 7.21067 12.1544 7.00002 11.6187 7.00002L9.61854 7.00005C8.87828 7.00006 8.23197 7.40223 7.88615 8H5V9H7.61856V9.00003L7.61855 10H5V11H7.61854L7.61853 12.2372C7.61852 12.9997 8.04524 13.6626 8.67291 14H3.5C3.22386 14 3 13.7761 3 13.5V2.5ZM10 5V2H10.2658C10.4142 2 10.5549 2.06591 10.6499 2.17991L12.8841 4.86093C12.919 4.90286 12.9466 4.94988 12.9661 5L10 5ZM5 6H7V7H5V6ZM9.71581 8.5822L10.1188 11H11.1188L11.5217 8.5822C11.5725 8.27743 11.3375 8 11.0285 8H10.209C9.90003 8 9.66501 8.27743 9.71581 8.5822ZM10.1188 12V13H11.1188V12H10.1188Z",
          style: { fill: e }
        }
      )
    }
  );
}, fM = Rx, jx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 13H8.6506C8.82757 13.4285 9.14915 13.7821 9.55452 14H3.5C3.22386 14 3 13.7761 3 13.5V2.5C3 2.22386 3.22386 2 3.5 2H10.2658C10.4142 2 10.5549 2.06591 10.6499 2.17991L12.8841 4.86093C12.959 4.95079 13 5.06406 13 5.18103V7.06306C12.8402 7.02194 12.6727 7.00008 12.5001 7.00008L12 7.00007V6H10H9V5V3H4V13ZM5.1 11H8.49996V10H5.1C5.04477 10 5 10.0448 5 10.1V10.9C5 10.9552 5.04477 11 5.1 11ZM8.49996 9C8.49997 8.63571 8.59738 8.29417 8.76756 8H5.1C5.04477 8 5 8.04477 5 8.1V8.9C5 8.95523 5.04477 9 5.1 9H8.49996ZM10.0316 3L11.6983 5H10V3H10.0316ZM5.1 6C5.04477 6 5 6.04477 5 6.1V6.9C5 6.95523 5.04477 7 5.1 7H6.9C6.95523 7 7 6.95523 7 6.9V6.1C7 6.04477 6.95523 6 6.9 6H5.1ZM10.597 8.5822L11 11H12L12.403 8.5822C12.4538 8.27743 12.2187 8 11.9098 8H11.0902C10.7813 8 10.5462 8.27743 10.597 8.5822ZM11 12V13H12V12H11Z",
          style: { fill: e }
        }
      )
    }
  );
}, pM = jx, Px = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.667 5.333a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1-3c1.306 0 2.417.835 2.829 2h5.837a1 1 0 1 1 0 2H7.496a3.001 3.001 0 0 1-5.83-1 3 3 0 0 1 3-3Zm-2 7.334a1 1 0 0 0 0 2h5.837a3.001 3.001 0 1 0 0-2H2.667Zm8.666 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
          style: { fill: e }
        }
      )
    }
  );
}, hM = Px, Ax = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.32578 1L9 2L7.90857 7H11.6742L6.5 14.9741L8.32578 9H4.09143L9.32578 1Z",
          style: { fill: e }
        }
      )
    }
  );
}, vM = Ax, Lx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M7.89657 3.33333C5.36746 3.33333 3.33337 5.1769 3.33337 8C3.33337 8.36819 3.0349 8.66667 2.66671 8.66667C2.29852 8.66667 2.00004 8.36819 2.00004 8C2.00004 4.4231 4.64862 2 7.89657 2C9.80891 2 11.5004 2.75724 12.5621 4.06952L12.6866 3.57165C12.7759 3.21445 13.1379 2.99728 13.4951 3.08658C13.8523 3.17587 14.0694 3.53783 13.9801 3.89503L13.4496 6.01722C13.4444 6.03955 13.438 6.06157 13.4306 6.08318C13.3999 6.17288 13.3515 6.25237 13.2903 6.31862C13.2283 6.38595 13.1518 6.4413 13.0632 6.47922C12.9882 6.51154 12.9068 6.53026 12.823 6.53311C12.757 6.53542 12.6917 6.52777 12.6292 6.51115L10.505 5.9801C10.1478 5.8908 9.93064 5.52884 10.0199 5.17165C10.1092 4.81445 10.4712 4.59728 10.8284 4.68658L11.4734 4.84782C10.6812 3.90992 9.42048 3.33333 7.89657 3.33333Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M13.3334 7.33333C13.7016 7.33333 14 7.63181 14 8C14 11.5769 11.3515 14 8.10351 14C6.40678 14 4.88351 13.4036 3.81992 12.3522L3.0097 12.8383C2.77848 12.9771 2.48646 12.9629 2.26981 12.8023C2.05316 12.6418 1.95454 12.3666 2.01994 12.105L2.55071 9.98188C2.55524 9.96254 2.56063 9.94345 2.56684 9.92465C2.62825 9.73767 2.76638 9.59417 2.93684 9.52079C3.00945 9.48952 3.08793 9.47098 3.16884 9.46722C3.23797 9.46395 3.30628 9.47159 3.37157 9.48904L5.49506 10.0199C5.75665 10.0853 5.95308 10.3018 5.99277 10.5685C6.03246 10.8353 5.90758 11.0996 5.67636 11.2383L5.01467 11.6353C5.79582 12.2841 6.86252 12.6667 8.10351 12.6667C10.6326 12.6667 12.6667 10.8231 12.6667 8C12.6667 7.63181 12.9652 7.33333 13.3334 7.33333Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M7.7225 7.0303H9.11022C9.25744 7.0303 9.39863 6.97922 9.50273 6.88829C9.60683 6.79737 9.66531 6.67404 9.66531 6.54545C9.66531 6.41686 9.60683 6.29354 9.50273 6.20262C9.39863 6.11169 9.25744 6.06061 9.11022 6.06061H8.55513V5.81818C8.55513 5.68959 8.49665 5.56627 8.39255 5.47534C8.28845 5.38442 8.14726 5.33333 8.00004 5.33333C7.85282 5.33333 7.71163 5.38442 7.60753 5.47534C7.50343 5.56627 7.44495 5.68959 7.44495 5.81818V6.08485C7.10769 6.14467 6.80791 6.31181 6.6038 6.55382C6.39969 6.79584 6.30582 7.09547 6.3404 7.39455C6.37499 7.69362 6.53557 7.9708 6.79096 8.17227C7.04636 8.37375 7.37835 8.48515 7.7225 8.48485H8.27759C8.3512 8.48485 8.42179 8.51039 8.47384 8.55585C8.52589 8.60132 8.55513 8.66298 8.55513 8.72727C8.55513 8.79157 8.52589 8.85323 8.47384 8.89869C8.42179 8.94416 8.3512 8.9697 8.27759 8.9697H6.88986C6.74264 8.9697 6.60145 9.02078 6.49735 9.11171C6.39325 9.20263 6.33477 9.32596 6.33477 9.45455C6.33477 9.58314 6.39325 9.70646 6.49735 9.79739C6.60145 9.88831 6.74264 9.93939 6.88986 9.93939H7.44495V10.1818C7.44495 10.3104 7.50343 10.4337 7.60753 10.5247C7.71163 10.6156 7.85282 10.6667 8.00004 10.6667C8.14726 10.6667 8.28845 10.6156 8.39255 10.5247C8.49665 10.4337 8.55513 10.3104 8.55513 10.1818V9.91515C8.89239 9.85534 9.19217 9.68819 9.39628 9.44618C9.60039 9.20416 9.69426 8.90453 9.65968 8.60546C9.62509 8.30638 9.46451 8.0292 9.20912 7.82773C8.95372 7.62625 8.62173 7.51485 8.27759 7.51515H7.7225C7.64889 7.51515 7.57829 7.48961 7.52624 7.44415C7.47419 7.39868 7.44495 7.33702 7.44495 7.27273C7.44495 7.20843 7.47419 7.14677 7.52624 7.10131C7.57829 7.05584 7.64889 7.0303 7.7225 7.0303Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, mM = Lx, Vx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M6.623 2.21a1.622 1.622 0 0 1 2.754 0 1.62 1.62 0 0 0 1.743.723 1.622 1.622 0 0 1 1.947 1.947 1.621 1.621 0 0 0 .722 1.744c.128.079.24.171.335.274a1.623 1.623 0 0 1-.335 2.479 1.622 1.622 0 0 0-.722 1.744 1.622 1.622 0 0 1-1.947 1.946 1.622 1.622 0 0 0-1.743.722 1.622 1.622 0 0 1-2.754 0 1.622 1.622 0 0 0-1.743-.722 1.622 1.622 0 0 1-1.947-1.947 1.622 1.622 0 0 0-.722-1.743 1.622 1.622 0 0 1 0-2.754c.589-.366.88-1.067.722-1.743A1.622 1.622 0 0 1 4.88 2.933a1.622 1.622 0 0 0 1.743-.722ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, gM = Vx, Hx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M4.653 3.907a2.622 2.622 0 0 0 2.82-1.168.622.622 0 0 1 1.055 0 2.622 2.622 0 0 0 2.819 1.168.622.622 0 0 1 .746.746 2.622 2.622 0 0 0 1.168 2.82c.39.243.39.811 0 1.055a2.622 2.622 0 0 0-1.168 2.819.622.622 0 0 1-.746.746 2.622 2.622 0 0 0-2.82 1.168.622.622 0 0 1-1.055 0 2.622 2.622 0 0 0-2.819-1.168.622.622 0 0 1-.746-.746 2.622 2.622 0 0 0-1.168-2.82.622.622 0 0 1 0-1.055 2.622 2.622 0 0 0 1.168-2.819.622.622 0 0 1 .746-.746Zm1.97-1.696a1.622 1.622 0 0 1 2.754 0c.366.589 1.067.88 1.743.722a1.622 1.622 0 0 1 1.947 1.947 1.622 1.622 0 0 0 .722 1.743 1.622 1.622 0 0 1 0 2.754 1.622 1.622 0 0 0-.722 1.743 1.622 1.622 0 0 1-1.947 1.947 1.622 1.622 0 0 0-1.743.722 1.622 1.622 0 0 1-2.754 0 1.622 1.622 0 0 0-1.743-.722 1.622 1.622 0 0 1-1.947-1.947 1.622 1.622 0 0 0-.722-1.743 1.622 1.622 0 0 1 0-2.754c.589-.366.88-1.067.722-1.743A1.622 1.622 0 0 1 4.88 2.933a1.622 1.622 0 0 0 1.743-.722ZM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, yM = Hx, Fx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.5 7c0-.404.022-.693.068-.905.045-.206.107-.305.164-.363.058-.057.157-.119.363-.164.212-.046.501-.068.905-.068s.693.022.905.068c.206.045.305.107.363.164.057.058.119.157.164.363.046.212.068.501.068.905 0 .236-.023.341-.042.387l-.002.006c-.002.008-.003.01-.03.022-.064.027-.19.055-.444.07C8.735 7.5 8.42 7.5 8 7.5V8h-.5v2h1V8.499c.2-.002.381-.006.54-.015.277-.017.548-.051.778-.15.26-.11.454-.297.565-.565.097-.235.117-.505.117-.769 0-.425-.021-.8-.091-1.118-.071-.325-.199-.622-.434-.857s-.532-.363-.857-.434C8.8 4.521 8.425 4.5 8 4.5c-.425 0-.8.021-1.118.091-.325.071-.622.199-.857.434s-.363.532-.434.857C5.521 6.2 5.5 6.575 5.5 7h1Zm2 4v1h-1v-1h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, wM = Fx, Yx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM6.5 7c0-.404.022-.693.068-.905.045-.206.107-.305.164-.363.058-.057.157-.119.363-.164.212-.046.501-.068.905-.068s.693.022.905.068c.206.045.305.107.363.164.057.058.119.157.164.363.046.212.068.501.068.905 0 .236-.023.341-.042.387l-.002.006c-.002.008-.003.01-.03.022-.064.027-.19.055-.444.07C8.735 7.5 8.42 7.5 8 7.5V8h-.5v2h1V8.499c.2-.002.381-.006.54-.015.277-.017.548-.051.778-.15.26-.11.454-.297.565-.565.097-.235.117-.505.117-.769 0-.425-.021-.8-.091-1.118-.071-.325-.199-.622-.434-.857s-.532-.363-.857-.434C8.8 4.521 8.425 4.5 8 4.5c-.425 0-.8.021-1.118.091-.325.071-.622.199-.857.434s-.363.532-.434.857C5.521 6.2 5.5 6.575 5.5 7h1Zm2 5v-1h-1v1h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, xM = Yx, $x = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.887.96a1 1 0 1 0-1.414 1.414L13.14 13.04a1 1 0 0 0 1.414-1.414l-1.875-1.874c.244-.257.454-.499.627-.708.258-.314.388-.471.388-.71 0-.24-.13-.397-.389-.711-.946-1.15-3.034-3.29-5.458-3.29-.185 0-.369.013-.55.036L3.887.96Zm1.96 7.373c0-.167.02-.33.06-.486L4.023 5.965a12.639 12.639 0 0 0-1.636 1.658c-.259.314-.388.471-.388.71 0 .24.13.397.388.71.947 1.15 3.035 3.29 5.459 3.29.723 0 1.416-.19 2.057-.488l-1.571-1.571a2 2 0 0 1-2.486-1.94Z",
          style: { fill: e }
        }
      )
    }
  );
}, zx = $x, Zx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.887.96a1 1 0 1 0-1.414 1.414L13.14 13.04a1 1 0 0 0 1.414-1.414l-1.167-1.167c.136-.143.262-.282.378-.413l.07-.08h.002c.326-.366.772-.865.772-1.633 0-.767-.446-1.266-.772-1.632a13.17 13.17 0 0 1-.072-.08c-.555-.63-1.363-1.437-2.348-2.09-.98-.652-2.203-1.198-3.57-1.198-.486 0-.954.07-1.399.187L3.888.96Zm4.405 4.405.46.46c.745.268 1.335.859 1.604 1.603l1.616 1.616a12.252 12.252 0 0 0 .62-.71 1.919 1.919 0 0 0-.09-.116 11.76 11.76 0 0 0-.238-.275c-.489-.555-1.165-1.224-1.953-1.747-.651-.433-1.334-.737-2.019-.831Zm2.359 7.227-1.51-1.51c-.428.16-.862.251-1.294.251-.833 0-1.672-.336-2.464-.862-.788-.524-1.465-1.192-1.954-1.747a11.59 11.59 0 0 1-.238-.275 1.88 1.88 0 0 1-.09-.116 1.88 1.88 0 0 1 .09-.115c.062-.075.136-.16.238-.275.35-.396.793-.85 1.306-1.267l-1.42-1.42A13.387 13.387 0 0 0 1.856 6.7c-.326.366-.772.865-.772 1.632 0 .768.446 1.267.772 1.633l.072.08c.555.63 1.362 1.436 2.347 2.09.98.652 2.204 1.197 3.57 1.197 1.031 0 1.98-.31 2.805-.741ZM5.379 7.32a2.667 2.667 0 0 0 3.48 3.48L5.38 7.32Z",
          style: { fill: e }
        }
      )
    }
  );
}, CM = Zx, Wx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M8.287 2.087a.6.6 0 0 0-.574 0l-5.4 2.946A.6.6 0 0 0 2 5.559V13.4a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6v-3.3h4v3.3a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6V5.56a.6.6 0 0 0-.313-.527l-5.4-2.946Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, bM = Wx, Bx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M7.713 2.087a.6.6 0 0 1 .574 0l5.4 2.946a.6.6 0 0 1 .313.526V13.4a.6.6 0 0 1-.6.6H9.6a.6.6 0 0 1-.6-.6V10H7v3.4a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6V5.56a.6.6 0 0 1 .313-.527l5.4-2.946ZM8 3.07 3 5.797V13h3V9.6a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 .6.6V13h3V5.797L8 3.07Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, MM = Bx, Ux = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.667 1.333H3.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h9.334c.11-.002.219-.013.326-.034l.2-.046h.08l.247-.094.087-.046c.066-.04.14-.074.206-.12.09-.066.174-.137.254-.214l.046-.06c.066-.066.126-.137.18-.213l.06-.087c.047-.074.087-.152.12-.233a.669.669 0 0 0 .047-.1c.033-.08.053-.167.08-.253v-.1c.038-.13.06-.265.067-.4V3.333a2 2 0 0 0-2-2Zm-9.334 12a.667.667 0 0 1-.666-.666V9.793l2.193-2.2a.667.667 0 0 1 .947 0l5.733 5.74H3.333Zm10-.666a.667.667 0 0 1-.046.24.668.668 0 0 1-.054.093.623.623 0 0 1-.06.08L9.607 9.513l.586-.586a.667.667 0 0 1 .947 0l2.193 2.2v1.54Zm0-3.427L12.08 8a2.053 2.053 0 0 0-2.827 0l-.586.587-1.92-1.92a2.053 2.053 0 0 0-2.827 0l-1.253 1.24V3.333a.667.667 0 0 1 .666-.666h9.334a.667.667 0 0 1 .666.666V9.24ZM9 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
          style: { fill: e }
        }
      )
    }
  );
}, DM = Ux, Kx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx("rect", { x: 7, y: 7.5, width: 2, height: 4, rx: 0.5, fill: "#fff" }),
        /* @__PURE__ */ f.jsx("rect", { x: 7, y: 4, width: 2, height: 2, rx: 1, fill: "#fff" })
      ]
    }
  );
}, Qx = Kx, qx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 2.556a5.444 5.444 0 1 0 0 10.888A5.444 5.444 0 0 0 8 2.556ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            x: 7,
            y: 7.5,
            width: 2,
            height: 4,
            rx: 0.5,
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            x: 7,
            y: 4,
            width: 2,
            height: 2,
            rx: 1,
            style: { fill: e }
          }
        )
      ]
    }
  );
}, _M = qx, Gx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M12.6 3H9v3h1.6c.22 0 .4.18.4.4v3.2a.4.4 0 0 1-.4.4H9v3h3.6a.4.4 0 0 0 .4-.4V3.4a.4.4 0 0 0-.4-.4ZM3.707 7.328 3 8.036l.707.707 2.829 2.828.707-.707L4.879 8.5H9.8a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2H4.95l2.293-2.293-.707-.707-2.829 2.828Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, EM = Gx, Xx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M12 3H8v1h4v8H8v1h4.6a.4.4 0 0 0 .4-.4V3.4a.4.4 0 0 0-.4-.4H12ZM3 8.036l.707-.708L6.536 4.5l.707.707L4.95 7.5H9.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.879l2.364 2.364-.707.707-2.829-2.828L3 8.036Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, IM = Xx, Jx = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 2.2C0 2.08954 0.0895431 2 0.2 2H15.8C15.9105 2 16 2.08954 16 2.2V10.8C16 10.9105 15.9105 11 15.8 11H11.4264C11.3941 10.9593 11.3599 10.9201 11.3239 10.8825C11.165 10.7167 10.9737 10.5856 10.7619 10.4972C10.5501 10.4087 10.3223 10.365 10.0928 10.3686C9.97587 10.3705 9.85979 10.3846 9.74641 10.4106V6.66851C9.74641 6.226 9.57062 5.80161 9.25771 5.4887C8.94481 5.17579 8.52042 5.00001 8.0779 5.00001C7.63539 5.00001 7.211 5.17579 6.89809 5.4887C6.58518 5.8016 6.40939 6.226 6.40939 6.66851V10.3731C6.29878 10.3502 6.18587 10.3387 6.07238 10.3387C5.85212 10.3387 5.63403 10.3823 5.43071 10.467C5.22865 10.5512 5.04514 10.6743 4.89063 10.8293C4.83689 10.8829 4.78699 10.9399 4.74121 11H0.2C0.0895429 11 0 10.9105 0 10.8V2.2ZM8.55061 6.19581C8.67598 6.32118 8.74641 6.49121 8.74641 6.66851V11V12.4389L9.62216 11.5899C9.68365 11.5215 9.7586 11.4666 9.8423 11.4285C9.92601 11.3904 10.0167 11.3699 10.1086 11.3685C10.2006 11.367 10.2919 11.3846 10.3767 11.42C10.4616 11.4554 10.5382 11.508 10.6019 11.5744C10.6655 11.6408 10.7148 11.7196 10.7465 11.8059C10.7783 11.8922 10.792 11.9841 10.7866 12.0759C10.7812 12.1677 10.757 12.2575 10.7153 12.3395C10.6737 12.4215 10.6156 12.494 10.5447 12.5525L8.53917 14.4912C8.41421 14.6137 8.2462 14.6823 8.07122 14.6823C7.89623 14.6823 7.72822 14.6137 7.60326 14.4912L5.59774 12.4857C5.53508 12.4235 5.48535 12.3496 5.45141 12.2681C5.41747 12.1867 5.39999 12.0993 5.39999 12.0111C5.39999 11.9228 5.41747 11.8354 5.45141 11.754C5.48535 11.6725 5.53508 11.5986 5.59774 11.5364C5.65988 11.4738 5.73382 11.424 5.81529 11.3901C5.89675 11.3561 5.98413 11.3387 6.07238 11.3387C6.16063 11.3387 6.24801 11.3561 6.32947 11.3901C6.41093 11.424 6.48487 11.4738 6.54702 11.5364L7.40939 12.4055V11V6.66851C7.40939 6.49121 7.47983 6.32118 7.6052 6.19581C7.73057 6.07044 7.9006 6.00001 8.0779 6.00001C8.2552 6.00001 8.42524 6.07044 8.55061 6.19581ZM1 8H2V9H1V8ZM2 9H3V10H2V9ZM2 4V5H1V4H2ZM2 4V3H3V4H2ZM14 3H13V4H14V5H15V4H14V3ZM14 10H13V9H14V10ZM14 9V8H15V9H14Z",
          style: { fill: e }
        }
      )
    }
  );
}, OM = Jx, eC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.07122 2C7.89623 2 7.72822 2.06861 7.60326 2.1911L5.59774 4.19662C5.53508 4.25877 5.48535 4.3327 5.45141 4.41417C5.41747 4.49563 5.39999 4.58301 5.39999 4.67126C5.39999 4.75951 5.41747 4.84689 5.45141 4.92835C5.46166 4.95296 5.47335 4.97688 5.48641 5C5.48686 5.0008 5.48731 5.00159 5.48777 5.00239C5.51769 5.05488 5.55466 5.10318 5.59774 5.1459C5.65988 5.20856 5.73382 5.25829 5.81529 5.29223C5.89675 5.32617 5.98413 5.34364 6.07238 5.34364C6.16063 5.34364 6.24801 5.32617 6.32947 5.29223C6.35703 5.28075 6.38372 5.26746 6.40939 5.25248C6.41218 5.25085 6.41496 5.24921 6.41772 5.24754C6.46473 5.21918 6.50818 5.18506 6.54702 5.1459L6.6918 5L7.40939 4.27684V5V10.0138C7.40939 10.1911 7.47983 10.3611 7.6052 10.4865C7.73057 10.6119 7.9006 10.6823 8.0779 10.6823C8.2552 10.6823 8.42524 10.6119 8.55061 10.4865C8.67598 10.3611 8.74641 10.1911 8.74641 10.0138V5V4.24342L9.52682 5L9.62216 5.09242C9.65907 5.13346 9.70082 5.16967 9.74641 5.2003C9.74829 5.20157 9.75018 5.20282 9.75208 5.20407C9.78076 5.22291 9.81091 5.23957 9.8423 5.25386C9.92601 5.29195 10.0167 5.31237 10.1086 5.31382C10.2006 5.31528 10.2919 5.29775 10.3767 5.26232C10.4616 5.2269 10.5382 5.17434 10.6019 5.10794C10.6336 5.07484 10.6617 5.03866 10.6859 5C10.7103 4.96111 10.7306 4.91971 10.7465 4.87643C10.7783 4.79013 10.792 4.6982 10.7866 4.60639C10.7812 4.51458 10.757 4.42486 10.7153 4.34285C10.6737 4.26084 10.6156 4.1883 10.5447 4.12977L8.53917 2.1911C8.41421 2.06861 8.2462 2 8.07122 2ZM4.52831 5.31293C4.48617 5.21176 4.45419 5.10693 4.4327 5H0.2C0.0895431 5 0 5.08954 0 5.2V13.8C0 13.9105 0.0895429 14 0.2 14H15.8C15.9105 14 16 13.9105 16 13.8V5.2C16 5.08954 15.9105 5 15.8 5H11.7496C11.7332 5.07524 11.7117 5.14943 11.6849 5.22202C11.6056 5.43741 11.4827 5.63412 11.3239 5.79985C11.165 5.96557 10.9737 6.09674 10.7619 6.18516C10.5501 6.27357 10.3223 6.31733 10.0928 6.3137C9.97587 6.31184 9.85979 6.29771 9.74641 6.27172V10.0138C9.74641 10.4563 9.57062 10.8807 9.25771 11.1936C8.94481 11.5065 8.52042 11.6823 8.0779 11.6823C7.63539 11.6823 7.211 11.5065 6.89809 11.1936C6.58518 10.8807 6.40939 10.4563 6.40939 10.0138V6.30925C6.29878 6.33207 6.18587 6.34365 6.07238 6.34365C5.85212 6.34365 5.63403 6.30003 5.43071 6.21533C5.22865 6.13114 5.04514 6.00803 4.89063 5.85301C4.73561 5.6985 4.6125 5.51499 4.52831 5.31293ZM1 11H2V12H1V11ZM2 12H3V13H2V12ZM2 7V8H1V7H2ZM2 7V6H3V7H2ZM14 6H13V7H14V8H15V7H14V6ZM14 13H13V12H14V13ZM14 12V11H15V12H14Z",
          style: { fill: e }
        }
      )
    }
  );
}, NM = eC, tC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.333 1.333h-6a2 2 0 0 0-2 2v3.22A.667.667 0 0 0 4 7.22h3.233v-.707a.773.773 0 0 1 1.26-.606l1.86 1.486a.774.774 0 0 1 0 1.214l-1.86 1.486a.773.773 0 0 1-1.26-.606v-.714H4a.667.667 0 0 0-.667.667v3.227a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2Z",
          style: { fill: e }
        }
      )
    }
  );
}, TM = tC, nC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.667 8a.667.667 0 0 1 .666-.667H8a.667.667 0 0 1 0 1.334H3.333A.667.667 0 0 1 2.667 8Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "m7.747 6.2 1.586 1.28a.667.667 0 0 1 0 1.04l-1.6 1.28a.667.667 0 0 1-1.066-.52V6.72a.667.667 0 0 1 1.08-.52Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.333 1.333h-6a2 2 0 0 0-2 2v2a.667.667 0 0 0 1.334 0v-2a.667.667 0 0 1 .666-.666h6a.667.667 0 0 1 .667.666v9.334a.667.667 0 0 1-.667.666h-6a.667.667 0 0 1-.666-.666v-2a.667.667 0 1 0-1.334 0v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, kM = nC, rC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.333A3.683 3.683 0 0 0 4.335 4.65l-.191 1.91a5.805 5.805 0 0 1-.946 2.643l-.574.862c-.219.327-.328.49-.37.617a1 1 0 0 0 .687 1.283c.128.035.325.035.718.035h8.681c.394 0 .591 0 .72-.035a1 1 0 0 0 .686-1.283c-.042-.126-.151-.29-.37-.617l-.574-.862a5.805 5.805 0 0 1-.946-2.642l-.191-1.91A3.683 3.683 0 0 0 8 1.332ZM8 15c.342 0 .693-.028 1-.087.154-.03.311-.07.459-.125.13-.048.333-.138.511-.304a1 1 0 0 0-1.244-1.559l-.01.003a1.321 1.321 0 0 1-.093.021c-.158.03-.378.051-.623.051s-.465-.02-.623-.051a1.32 1.32 0 0 1-.092-.02l-.011-.004a1 1 0 0 0-1.244 1.56c.178.165.38.255.51.303.149.056.306.096.46.125.307.06.658.087 1 .087Z",
          style: { fill: e }
        }
      )
    }
  );
}, SM = rC, oC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1a4.724 4.724 0 0 0-4.695 4.203l-.168 1.51A4.423 4.423 0 0 1 2.534 8.5l-.386.643-.02.032c-.062.104-.134.223-.182.329a2 2 0 0 0 1.595 2.817c.116.013.255.013.376.012h1.25c.164.636.45 1.231.86 1.703C6.524 14.606 7.21 15 8 15s1.477-.393 1.972-.964c.41-.472.697-1.067.861-1.703h1.25c.121 0 .26 0 .376-.012a2 2 0 0 0 1.595-2.817 3.513 3.513 0 0 0-.183-.329l-.02-.032-.385-.643a4.422 4.422 0 0 1-.603-1.787l-.168-1.51A4.724 4.724 0 0 0 8 1Zm.715 11.333h-1.43c.076.156.162.288.252.391.203.234.373.276.463.276.09 0 .26-.042.463-.276.09-.103.176-.235.252-.39Zm-3.423-6.91a2.724 2.724 0 0 1 5.416 0l.167 1.511c.102.918.401 1.803.876 2.595l.386.643.089.15.006.01h-.013l-.174.001H3.768l.006-.012.09-.15.385-.642a6.423 6.423 0 0 0 .876-2.595l.167-1.51Z",
          style: { fill: e }
        }
      )
    }
  );
}, RM = oC, iC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1.333A3.683 3.683 0 0 0 4.335 4.65l-.191 1.91a5.805 5.805 0 0 1-.946 2.643l-.574.862c-.219.327-.328.49-.37.617a1 1 0 0 0 .687 1.283c.128.035.325.035.718.035h8.681c.394 0 .591 0 .72-.035a1 1 0 0 0 .686-1.283c-.042-.126-.151-.29-.37-.617l-.574-.862a5.805 5.805 0 0 1-.946-2.642l-.191-1.91A3.683 3.683 0 0 0 8 1.332ZM8 15c.342 0 .693-.028 1-.087.154-.03.311-.07.459-.125.13-.048.333-.138.511-.304a1 1 0 0 0-1.244-1.559l-.01.003a1.321 1.321 0 0 1-.093.021c-.158.03-.378.051-.623.051s-.465-.02-.623-.051a1.32 1.32 0 0 1-.092-.02l-.011-.004a1 1 0 0 0-1.244 1.56c.178.165.38.255.51.303.149.056.306.096.46.125.307.06.658.087 1 .087Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx("circle", { cx: 12, cy: 4, r: 2.5, fill: e, stroke: "#fff" })
      ]
    }
  );
}, jM = iC, aC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1a4.724 4.724 0 0 0-4.695 4.203l-.168 1.51A4.423 4.423 0 0 1 2.534 8.5l-.386.643-.02.032c-.062.104-.134.223-.182.329a2 2 0 0 0 1.595 2.817c.116.013.255.013.376.012h1.25c.164.636.45 1.231.86 1.703C6.524 14.606 7.21 15 8 15s1.477-.393 1.972-.964c.41-.472.697-1.067.861-1.703h1.25c.121 0 .26 0 .376-.012a2 2 0 0 0 1.595-2.817 3.513 3.513 0 0 0-.183-.329l-.02-.032-.385-.643a4.422 4.422 0 0 1-.603-1.787l-.168-1.51A4.724 4.724 0 0 0 8 1Zm.715 11.333h-1.43c.076.156.162.288.252.391.203.234.373.276.463.276.09 0 .26-.042.463-.276.09-.103.176-.235.252-.39Zm-3.423-6.91a2.724 2.724 0 0 1 5.416 0l.167 1.511c.102.918.401 1.803.876 2.595l.386.643.089.15.006.01h-.013l-.174.001H3.768l.006-.012.09-.15.385-.642a6.423 6.423 0 0 0 .876-2.595l.167-1.51Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx("circle", { cx: 12, cy: 4, r: 2.5, fill: e, stroke: "#fff" })
      ]
    }
  );
}, PM = aC, sC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.465 12.136h3.34V7.348c0-.588.332-1.064.92-1.064H10.388v-.947c0-.249-.086-.49-.245-.68L8.711 2.942a1.065 1.065 0 0 0-.82-.383H3.465A1.066 1.066 0 0 0 2.4 3.624v7.448a1.064 1.064 0 0 0 1.065 1.064Zm4.26-8.512h.166L9.22 5.22h-.963a.533.533 0 0 1-.533-.532V3.624ZM4.53 5.22h1.065a.533.533 0 1 1 0 1.064H4.53a.533.533 0 1 1 0-1.064Zm.533 4.256H4.53a.533.533 0 1 1 0-1.064h.533a.533.533 0 1 1 0 1.064ZM4.53 7.88a.533.533 0 1 1 0-1.064h1.065a.533.533 0 1 1 0 1.064H4.53Zm3.614 1.623a.509.509 0 0 1-.15-.36V8.125a.509.509 0 0 1 .51-.51h1.02a.51.51 0 1 1 0 1.019h-.51v.51a.509.509 0 0 1-.87.359Zm3.918-1.887a.514.514 0 0 0-.512.509.507.507 0 0 0 .512.509h.513v.51a.507.507 0 0 0 .513.508.514.514 0 0 0 .512-.509V8.125a.507.507 0 0 0-.512-.51h-1.026Zm-2.539 5.6a.51.51 0 0 0 0-1.018h-.51v-.51a.509.509 0 0 0-1.019 0v1.019a.509.509 0 0 0 .51.509h1.02ZM13.6 11.68a.513.513 0 0 0-.51-.512.509.509 0 0 0-.51.512v.512h-.509a.508.508 0 0 0-.51.512.513.513 0 0 0 .51.512h1.02a.508.508 0 0 0 .509-.512V11.68Z",
          style: { fill: e }
        }
      )
    }
  );
}, AM = sC, lC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M11.333 8A1.333 1.333 0 1 0 14 8a1.333 1.333 0 0 0-2.667 0ZM4.667 8A1.333 1.333 0 1 0 2 8a1.333 1.333 0 0 0 2.667 0Zm4.666 0a1.333 1.333 0 1 0-2.666 0 1.333 1.333 0 0 0 2.666 0Z",
          style: { fill: e }
        }
      )
    }
  );
}, LM = lC, cC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8 4.667A1.333 1.333 0 1 0 8 2a1.333 1.333 0 0 0 0 2.667Zm0 6.666A1.333 1.333 0 1 0 8 14a1.333 1.333 0 0 0 0-2.667Zm0-4.666a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666Z",
          style: { fill: e }
        }
      )
    }
  );
}, Ap = cC, uC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.99991 8.00003C1.99991 4.68632 4.6862 2.00003 7.99991 2.00003C11.3136 2.00003 13.9999 4.68632 13.9999 8.00003C13.9999 11.3137 11.3136 14 7.99991 14C4.6862 14 1.99991 11.3137 1.99991 8.00003ZM5.5 5.2C5.5 5.08954 5.58954 5 5.7 5H6.8C6.91046 5 7 5.08954 7 5.2V10.8C7 10.9105 6.91046 11 6.8 11H5.7C5.58954 11 5.5 10.9105 5.5 10.8V5.2ZM9.2 5C9.08954 5 9 5.08954 9 5.2V10.8C9 10.9105 9.08954 11 9.2 11H10.3C10.4105 11 10.5 10.9105 10.5 10.8V5.2C10.5 5.08954 10.4105 5 10.3 5H9.2Z",
          style: { fill: e }
        }
      )
    }
  );
}, VM = uC, dC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 1a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM1.6 8a.6.6 0 0 0-.6.6V13h8V8.6a.6.6 0 0 0-.6-.6H1.6Zm12.8 1H10v4h5V9.6a.6.6 0 0 0-.6-.6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, HM = dC, fC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 9v4H1V8.6a.6.6 0 0 1 .6-.6h6.8a.6.6 0 0 1 .6.6V13H8V9H2Zm11-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1 3V9h4.4a.6.6 0 0 1 .6.6V13h-1v-3h-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, FM = fC, pC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2 0A5 5 0 1 1 7 7a5 5 0 0 1 10 0ZM7 13a3 3 0 0 0-3 3v4a1 1 0 1 0 2 0v-4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4a1 1 0 1 0 2 0v-4a3 3 0 0 0-3-3H7Z",
          style: { fill: e }
        }
      )
    }
  );
}, YM = pC, hC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Zm0-1.334A5.333 5.333 0 1 0 8 2.667a5.333 5.333 0 0 0 0 10.666Z",
          style: { fill: e }
        }
      )
    }
  );
}, $M = hC, vC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM6.25 4.41613V11.5839C6.25 11.7516 6.44399 11.8448 6.57494 11.7401L11.0548 8.15618C11.1549 8.07612 11.1549 7.9239 11.0548 7.84384L6.57494 4.25996C6.44399 4.1552 6.25 4.24843 6.25 4.41613Z",
          style: { fill: e }
        }
      )
    }
  );
}, zM = vC, mC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.783 3H4.769L2 5h2.36l1.423-2ZM2 6l5.994 7.975L3.874 6H2Zm6.022 7.975-.02.025L5.64 6h4.72l-2.338 7.975Zm-.02.025L14 6h-1.873l-4.124 8ZM14 5l-2.77-2h-1.013l1.424 2H14ZM9.013 3l1.347 2H5.64l1.347-2h2.026Z",
          style: { fill: e }
        }
      )
    }
  );
}, Lp = mC, gC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M2.863 2.917v11.552l2.345-1.54L8.08 14.75l2.66-1.82 2.399 1.54V2.916c0-1.429-1.109-1.704-1.663-1.663h-6.95c-1.358 0-1.674 1.108-1.662 1.663Z",
            style: { fill: e, stroke: e },
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "m6.085 8.17 1.163 1.163 2.667-2.666",
            stroke: "#fff",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}, ZM = gC, yC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M2.863 2.917v11.552l2.345-1.54L8.08 14.75l2.66-1.82 2.399 1.54V2.916c0-1.429-1.109-1.704-1.663-1.663h-6.95c-1.358 0-1.674 1.108-1.662 1.663Z",
            style: { stroke: e },
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "m6.085 8.17 1.163 1.163 2.667-2.666",
            style: { stroke: e },
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}, WM = yC, wC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.11109 8C4.11109 5.64741 5.80614 4.11111 7.9137 4.11111C9.1836 4.11111 10.2342 4.5916 10.8943 5.37318L10.3568 5.23881C10.0592 5.1644 9.75756 5.34538 9.68314 5.64304C9.60873 5.9407 9.7897 6.24233 10.0874 6.31675L11.8575 6.75929C11.9096 6.77315 11.964 6.77951 12.019 6.77759C12.0888 6.77522 12.1566 6.75962 12.2192 6.73268C12.2929 6.70108 12.3568 6.65495 12.4084 6.59885C12.4594 6.54364 12.4997 6.4774 12.5253 6.40265C12.5315 6.38464 12.5368 6.36629 12.5411 6.34768L12.9832 4.57919C13.0577 4.28153 12.8767 3.9799 12.579 3.90548C12.2814 3.83106 11.9797 4.01204 11.9053 4.30971L11.8016 4.7246C10.9168 3.63103 9.50728 3 7.9137 3C5.20711 3 3 5.01925 3 8C3 8.30683 3.24873 8.55556 3.55555 8.55556C3.86237 8.55556 4.11109 8.30683 4.11109 8ZM11.8889 8.55554C11.8889 10.9081 10.1938 12.4444 8.08627 12.4444C6.81637 12.4444 5.7658 11.9639 5.10567 11.1824L5.64313 11.3167C5.94079 11.3911 6.24241 11.2102 6.31683 10.9125C6.39124 10.6148 6.21027 10.3132 5.91261 10.2388L4.14247 9.79625C4.0904 9.7824 4.03602 9.77603 3.98096 9.77795C3.91112 9.78032 3.84334 9.79593 3.78079 9.82286C3.70702 9.85446 3.6432 9.90059 3.59157 9.95669C3.54059 10.0119 3.50022 10.0781 3.47465 10.1529C3.46845 10.1709 3.46317 10.1892 3.45884 10.2079L3.01672 11.9764C2.94231 12.274 3.12328 12.5756 3.42094 12.6501C3.7186 12.7245 4.02023 12.5435 4.09464 12.2458L4.19836 11.8309C5.08315 12.9245 6.49269 13.5555 8.08627 13.5555C10.7929 13.5555 13 11.5363 13 8.55554C13 8.24872 12.7512 7.99999 12.4444 7.99999C12.1376 7.99999 11.8889 8.24872 11.8889 8.55554Z",
          style: { fill: e }
        }
      )
    }
  );
}, BM = wC, xC = ({
  iconColor: e,
  size: r,
  ...t
}) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.47 7.39a4.747 4.747 0 0 0-1.39 3.357c0 .919.27 1.818.773 2.586H2.667A1.333 1.333 0 0 1 1.333 12V2.667a1.333 1.333 0 0 1 1.334-1.334h5.54a1.333 1.333 0 0 1 1.026.48l1.794 2.147c.198.24.307.542.306.853V6a4.222 4.222 0 0 0-.506 0c-1.26 0-2.467.5-3.357 1.39Zm.737-4.723H8V4a.667.667 0 0 0 .667.667h1.206l-1.666-2Zm-2.874 2H4A.667.667 0 0 0 4 6h1.333a.667.667 0 0 0 0-1.333ZM4 10h.667a.667.667 0 1 0 0-1.333H4A.667.667 0 0 0 4 10Zm-.471-2.195A.667.667 0 0 0 4 8h2a.667.667 0 1 0 0-1.333H4a.667.667 0 0 0-.471 1.138Zm11.138 2.862a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.334 0a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0ZM12 11.333A.667.667 0 1 0 12 10h-.667v-.667a.667.667 0 1 0-1.333 0v1.334a.666.666 0 0 0 .667.666H12Z",
          style: { fill: e }
        }
      )
    }
  );
}, UM = xC, CC = ({
  iconColor: e,
  size: r,
  ...t
}) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.667 12V2.667h4V4a2 2 0 0 0 2 2h2.666V4.813c0-.311-.108-.613-.306-.853L9.233 1.813a1.333 1.333 0 0 0-1.026-.48h-5.54a1.333 1.333 0 0 0-1.334 1.334V12a1.333 1.333 0 0 0 1.334 1.333H6.86A4.566 4.566 0 0 1 6.193 12H2.667Zm7.206-7.333-1.666-2H8V4a.667.667 0 0 0 .667.667h1.206Zm-6.344.195A.667.667 0 0 0 4 6h1.333a.667.667 0 1 0 0-1.333H4a.667.667 0 0 0-.471.195Zm-.196 2.471A.667.667 0 0 1 4 6.667h2A.667.667 0 0 1 6 8H4a.667.667 0 0 1-.667-.667Zm.196 1.529A.667.667 0 0 0 4 10h.667a.667.667 0 1 0 0-1.333H4a.667.667 0 0 0-.471.195ZM12 11.333A.667.667 0 1 0 12 10h-.667v-.667a.667.667 0 1 0-1.333 0v1.334a.666.666 0 0 0 .667.666H12Zm1.992 1.556a4 4 0 1 0-6.65-4.445 4 4 0 0 0 6.65 4.445Zm-1.108-.74a2.667 2.667 0 1 0-4.435-2.964 2.667 2.667 0 0 0 4.435 2.963Z",
          style: { fill: e }
        }
      )
    }
  );
}, KM = CC, bC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_739_16539)", children: /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.66671 12.0019V2.66854H6.66671V4.00187C6.66671 4.53231 6.87742 5.04101 7.25249 5.41609C7.62757 5.79116 8.13627 6.00187 8.66671 6.00187H11.3334V4.81521C11.334 4.50367 11.2255 4.20176 11.0267 3.96187L9.23337 1.81521C9.10801 1.6647 8.95102 1.54366 8.77358 1.4607C8.59613 1.37773 8.40259 1.33489 8.20671 1.33521H2.66671C2.31309 1.33521 1.97395 1.47568 1.7239 1.72573C1.47385 1.97578 1.33337 2.31492 1.33337 2.66854V12.0019C1.33337 12.3555 1.47385 12.6946 1.7239 12.9447C1.97395 13.1947 2.31309 13.3352 2.66671 13.3352H6.86004C6.56629 12.9303 6.34107 12.4798 6.19337 12.0019H2.66671ZM9.87337 4.66854L8.20671 2.66854H8.00004V4.00187C8.00004 4.17868 8.07028 4.34825 8.1953 4.47328C8.32033 4.5983 8.4899 4.66854 8.66671 4.66854H9.87337ZM3.52863 4.86382C3.40361 4.98884 3.33337 5.15841 3.33337 5.33522C3.33337 5.51204 3.40361 5.6816 3.52863 5.80663C3.65366 5.93165 3.82323 6.00189 4.00004 6.00189H5.33337C5.51018 6.00189 5.67975 5.93165 5.80478 5.80663C5.9298 5.6816 6.00004 5.51204 6.00004 5.33522C6.00004 5.15841 5.9298 4.98884 5.80478 4.86382C5.67975 4.7388 5.51018 4.66856 5.33337 4.66856H4.00004C3.82323 4.66856 3.65366 4.7388 3.52863 4.86382ZM3.33337 7.33523C3.33337 7.15841 3.40361 6.98884 3.52863 6.86382C3.65366 6.7388 3.82323 6.66856 4.00004 6.66856H6.00004C6.17685 6.66856 6.34642 6.7388 6.47144 6.86382C6.59647 6.98884 6.66671 7.15841 6.66671 7.33523C6.66671 7.51204 6.59647 7.6816 6.47144 7.80663C6.34642 7.93165 6.17685 8.00189 6.00004 8.00189H4.00004C3.82323 8.00189 3.65366 7.93165 3.52863 7.80663C3.40361 7.6816 3.33337 7.51204 3.33337 7.33523ZM3.52863 8.86382C3.40361 8.98884 3.33337 9.15841 3.33337 9.33522C3.33337 9.51204 3.40361 9.6816 3.52863 9.80663C3.65366 9.93165 3.82323 10.0019 4.00004 10.0019H4.66671C4.84352 10.0019 5.01309 9.93165 5.13811 9.80663C5.26313 9.6816 5.33337 9.51204 5.33337 9.33522C5.33337 9.15841 5.26313 8.98884 5.13811 8.86382C5.01309 8.7388 4.84352 8.66856 4.66671 8.66856H4.00004C3.82323 8.66856 3.65366 8.7388 3.52863 8.86382ZM12 11.3352C12.1768 11.3352 12.3464 11.265 12.4714 11.14C12.5965 11.0149 12.6667 10.8454 12.6667 10.6686C12.6667 10.4917 12.5965 10.3222 12.4714 10.1972C12.3464 10.0721 12.1768 10.0019 12 10.0019H11.3334V9.33522C11.3334 9.15841 11.2631 8.98884 11.1381 8.86382C11.0131 8.7388 10.8435 8.66856 10.6667 8.66856C10.4899 8.66856 10.3203 8.7388 10.1953 8.86382C10.0703 8.98884 10 9.15841 10 9.33522V10.6686C10 10.8454 10.0703 11.0149 10.1953 11.14C10.3203 11.265 10.4899 11.3352 10.6667 11.3352H12ZM13.9926 12.8908C14.4321 12.233 14.6667 11.4597 14.6667 10.6686C14.6667 9.60769 14.2453 8.59028 13.4951 7.84013C12.745 7.08999 11.7276 6.66856 10.6667 6.66856C9.87558 6.66856 9.10222 6.90315 8.44443 7.34268C7.78663 7.78221 7.27394 8.40692 6.97119 9.13782C6.66844 9.86873 6.58922 10.673 6.74357 11.4489C6.89791 12.2248 7.27887 12.9376 7.83828 13.497C8.39769 14.0564 9.11042 14.4374 9.88635 14.5917C10.6623 14.746 11.4665 14.6668 12.1974 14.3641C12.9283 14.0613 13.5531 13.5486 13.9926 12.8908ZM12.884 12.1501C13.177 11.7115 13.3334 11.196 13.3334 10.6686C13.3334 9.96131 13.0524 9.28304 12.5523 8.78294C12.0522 8.28284 11.374 8.00189 10.6667 8.00189C10.1393 8.00189 9.62372 8.15829 9.18519 8.45131C8.74666 8.74432 8.40486 9.1608 8.20303 9.64807C8.00119 10.1353 7.94839 10.6715 8.05128 11.1888C8.15417 11.7061 8.40815 12.1812 8.78109 12.5542C9.15403 12.9271 9.62918 13.1811 10.1465 13.284C10.6637 13.3869 11.1999 13.3341 11.6872 13.1322C12.1745 12.9304 12.5909 12.5886 12.884 12.1501Z",
            style: { fill: e }
          }
        ) }),
        /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_739_16539", children: /* @__PURE__ */ f.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
}, QM = bC, MC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "m14.398 12.982-2.173-2.174a6 6 0 1 0-1.394 1.4l2.167 2.167a.986.986 0 0 0 1.4 0 .98.98 0 0 0 0-1.393Zm-7.053-1.647a4 4 0 0 1-3.687-2.467 4 4 0 0 1-.227-2.307 4 4 0 0 1 3.134-3.133 4 4 0 0 1 2.306.227 4 4 0 0 1-1.526 7.68Z",
          style: { fill: e }
        }
      )
    }
  );
}, qM = MC, DC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "m14.487 13.54-2.473-2.453a6 6 0 1 0-.927.927l2.454 2.453a.667.667 0 0 0 .946 0 .667.667 0 0 0 0-.926Zm-7.14-1.526a4.667 4.667 0 1 1 0-9.335 4.667 4.667 0 0 1 0 9.335Z",
          style: { fill: e }
        }
      )
    }
  );
}, GM = DC, _C = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.333 4.667a1 1 0 0 1 1-1h9.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1Zm0 3.333a1 1 0 0 1 1-1H10a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1Zm1 2.333a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z",
          style: { fill: e }
        }
      )
    }
  );
}, XM = _C, EC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.667 2.683c.528-.059 1.062.04 1.533.287a2.56 2.56 0 0 1 1.333 1.527A2.666 2.666 0 0 1 9.267 7.91a.333.333 0 0 1-.214-.433 4 4 0 0 0 .614-2.127 3.953 3.953 0 0 0-.4-1.82.573.573 0 0 1 .4-.847ZM8.333 5.35A2.667 2.667 0 1 1 3 5.35a2.667 2.667 0 0 1 5.333 0ZM3.667 8.683a2 2 0 0 0-2 2v2a.667.667 0 0 0 .666.667H9a.667.667 0 0 0 .667-.667v-2a2 2 0 0 0-2-2h-4Zm8 0h.666a2 2 0 0 1 2 2v2a.667.667 0 0 1-.666.667h-2a.667.667 0 0 1-.667-.667V9.35a.666.666 0 0 1 .667-.667Z",
          style: { fill: e }
        }
      )
    }
  );
}, JM = EC, IC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.333 10.667a2 2 0 0 1 2-2h5.334a2 2 0 0 1 2 2v2a.667.667 0 0 1-1.334 0v-2A.667.667 0 0 0 8.667 10H3.333a.667.667 0 0 0-.666.667v2a.667.667 0 0 1-1.334 0v-2ZM11.333 9.333c0-.368.299-.666.667-.666h.667a2 2 0 0 1 2 2v2a.667.667 0 0 1-1.334 0v-2a.667.667 0 0 0-.666-.667H12a.667.667 0 0 1-.667-.667ZM6 6.667A1.333 1.333 0 1 0 6 4a1.333 1.333 0 0 0 0 2.667ZM6 8a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 6 8ZM9.333 2.667c0-.369.299-.667.667-.667a2.667 2.667 0 1 1 0 5.333A.667.667 0 1 1 10 6a1.333 1.333 0 1 0 0-2.667.667.667 0 0 1-.667-.666Z",
          style: { fill: e }
        }
      )
    }
  );
}, eD = IC, OC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M8.003 3.944A.75.75 0 0 1 9.14 3.3l4.463 2.677c.479.287.275 1.022-.283 1.022H2.5a.5.5 0 1 1 0-1H8l.003-2.056ZM8 12.056a.75.75 0 0 1-1.136.642l-4.596-2.676C1.79 9.735 1.993 9 2.551 9h10.82a.5.5 0 0 1 0 1H8.002L8 12.056Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, tD = OC, NC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          style: { fill: e },
          fillRule: "evenodd",
          d: "M8.761 3.075a.5.5 0 1 0-.514.857L11.694 6H2.5a.5.5 0 1 0 0 1h10.82c.557 0 .76-.735.282-1.022l-4.84-2.903ZM7.24 12.928a.5.5 0 0 0 .514-.857l-3.447-2.068H13.5a.5.5 0 0 0 0-1H2.68c-.557 0-.76.735-.282 1.022l4.84 2.903Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}, nD = NC, TC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.50472 10.3852C5.29481 10.548 5.02931 10.6201 4.76661 10.5857C4.67914 10.5872 4.59205 10.5737 4.50907 10.5458L2.76577 10.0768C2.6363 10.0464 2.51423 9.99003 2.40683 9.9111C2.29942 9.83218 2.20889 9.73228 2.14062 9.61735C2.07234 9.50243 2.02773 9.37484 2.00943 9.24218C1.99113 9.10952 1.99952 8.9745 2.03411 8.84518C2.06869 8.71585 2.12876 8.59486 2.21073 8.48942C2.2927 8.38398 2.3949 8.29624 2.51123 8.23143C2.62757 8.16663 2.75566 8.12607 2.88788 8.1122C3.0201 8.09832 3.15374 8.1114 3.28083 8.15065L5.02414 8.58976C5.28684 8.62417 5.52522 8.76232 5.68682 8.9738C5.84843 9.18529 5.92004 9.4528 5.88589 9.71748C5.85174 9.98216 5.71463 10.2223 5.50472 10.3852ZM8.9574 5.55034C8.77754 5.41624 8.64804 5.22473 8.58999 5.00701L8.15417 3.29049C8.1152 3.16243 8.10222 3.02779 8.116 2.89457C8.12977 2.76136 8.17002 2.6323 8.23434 2.51508C8.29867 2.39787 8.38575 2.2949 8.4904 2.21231C8.59506 2.12973 8.71514 2.06921 8.8435 2.03436C8.97185 1.99952 9.10586 1.99106 9.23753 2.0095C9.3692 2.02794 9.49583 2.07289 9.6099 2.14168C9.72396 2.21046 9.82311 2.30168 9.90145 2.40989C9.97978 2.5181 10.0357 2.64109 10.0659 2.77154L10.5314 4.52798C10.5982 4.78202 10.5629 5.05237 10.4331 5.28033C10.3033 5.50829 10.0894 5.67545 9.83804 5.74552C9.75274 5.75932 9.66581 5.75932 9.58051 5.74552C9.35689 5.75324 9.13726 5.68444 8.9574 5.55034ZM13.4931 16.3216L12.0536 14.882C12.0125 14.9138 11.9738 14.9488 11.9379 14.9868L8.47113 18.5396C8.06352 18.9336 7.52051 19.1536 6.95564 19.1536C6.39077 19.1536 5.84777 18.9336 5.44016 18.5396C5.2395 18.34 5.08019 18.1023 4.97145 17.8402C4.86271 17.5781 4.80672 17.2968 4.80672 17.0127C4.80672 16.7286 4.86271 16.4474 4.97145 16.1853C5.08019 15.9231 5.2395 15.6854 5.44016 15.4858L8.96639 11.9929C9.00185 11.9623 9.03502 11.9293 9.06571 11.8941L7.6622 10.4906C7.6294 10.5201 7.59851 10.5519 7.56976 10.5857L4.01381 14.0687C3.62879 14.4566 3.32337 14.9171 3.11499 15.424C2.90662 15.9308 2.79937 16.4741 2.79937 17.0227C2.79937 17.5713 2.90662 18.1146 3.11499 18.6214C3.32337 19.1283 3.62879 19.5888 4.01381 19.9767C4.39884 20.3646 4.85593 20.6724 5.35899 20.8823C5.86205 21.0923 6.40123 21.2003 6.94574 21.2003C7.49025 21.2003 8.02942 21.0923 8.53248 20.8823C9.03554 20.6724 9.49264 20.3646 9.87766 19.9767L13.3742 16.4539C13.4178 16.4133 13.4576 16.369 13.4931 16.3216ZM10.4485 7.62012C10.4655 7.60004 10.4832 7.5806 10.5017 7.56184L13.9982 4.00903C14.5769 3.41829 15.3181 3.01589 16.126 2.85377C16.934 2.69165 17.7716 2.77726 18.5308 3.09955C19.29 3.42184 19.9359 3.96601 20.385 4.66181C20.8342 5.35761 21.0661 6.17309 21.0507 7.00297C21.0467 8.09333 20.6202 9.139 19.8621 9.91708L16.3061 13.4C16.2931 13.413 16.2798 13.4256 16.2662 13.4378L14.8671 12.0386C14.8807 12.023 14.8948 12.0077 14.9095 11.9929L18.4357 8.49995C18.6364 8.30036 18.7957 8.06261 18.9044 7.8005C19.0132 7.53838 19.0691 7.25712 19.0691 6.97303C19.0691 6.68895 19.0132 6.40769 18.9044 6.14557C18.7957 5.88346 18.6364 5.64571 18.4357 5.44612C18.0281 5.05211 17.4851 4.83211 16.9202 4.83211C16.3554 4.83211 15.8123 5.05211 15.4047 5.44612L11.9379 8.99894C11.9196 9.01755 11.9006 9.03541 11.8809 9.05249L10.4485 7.62012ZM5.87598 6.88322C5.61613 6.88211 5.36712 6.77817 5.18262 6.5938L3.90486 5.30641C3.74259 5.11549 3.65779 4.86991 3.66742 4.61875C3.67705 4.36758 3.78039 4.12932 3.9568 3.95159C4.1332 3.77385 4.36968 3.66973 4.61897 3.66003C4.86825 3.65033 5.112 3.73576 5.30148 3.89926L6.57925 5.18665C6.76373 5.37363 6.86728 5.62657 6.86728 5.89023C6.86728 6.15388 6.76373 6.40682 6.57925 6.5938C6.48669 6.6863 6.37693 6.75947 6.25625 6.80914C6.13557 6.8588 6.00634 6.88398 5.87598 6.88322ZM19.3668 13.4399L21.1101 13.909C21.3728 13.9434 21.631 14.0117 21.7926 14.2232C21.9542 14.4347 22.0258 14.7022 21.9917 14.9669C21.9575 15.2315 21.8204 15.4717 21.6105 15.6345C21.4006 15.7974 21.1351 15.8695 20.8724 15.8351H20.6148L18.8715 15.3661C18.7369 15.3422 18.6087 15.2905 18.4948 15.2143C18.381 15.138 18.2841 15.0389 18.2101 14.923C18.1362 14.8072 18.0868 14.6772 18.0652 14.5412C18.0436 14.4052 18.0501 14.2662 18.0844 14.1329C18.1186 13.9996 18.1799 13.8748 18.2644 13.7666C18.3488 13.6583 18.4546 13.5688 18.5751 13.5037C18.6955 13.4386 18.8281 13.3993 18.9643 13.3884C19.1006 13.3774 19.2376 13.395 19.3668 13.4399ZM15.1128 18.6302C15.1927 18.7338 15.2515 18.8522 15.2859 18.9787L15.791 20.7651C15.8254 20.8923 15.8345 21.025 15.8177 21.1557C15.8009 21.2864 15.7586 21.4124 15.6932 21.5265C15.6279 21.6406 15.5407 21.7406 15.4368 21.8206C15.3329 21.9006 15.2142 21.9591 15.0878 21.9926C15.0022 22.0025 14.9158 22.0025 14.8302 21.9926C14.6066 22.0004 14.387 21.9316 14.2071 21.7975C14.0273 21.6634 13.8978 21.4719 13.8397 21.2541L13.3742 19.4977C13.3074 19.2437 13.3427 18.9733 13.4725 18.7453C13.6023 18.5174 13.8161 18.3502 14.0675 18.2802C14.1931 18.2453 14.3242 18.2358 14.4534 18.252C14.5826 18.2683 14.7073 18.3101 14.8205 18.375C14.9336 18.4398 15.033 18.5266 15.1128 18.6302ZM18.0107 17.1727C18.26 17.163 18.5038 17.2484 18.6932 17.4119L19.971 18.6993C20.1555 18.8863 20.259 19.1392 20.259 19.4029C20.259 19.6665 20.1555 19.9195 19.971 20.1065C19.7854 20.2923 19.5344 20.3967 19.2727 20.3967C19.011 20.3967 18.76 20.2923 18.5744 20.1065L17.2966 18.8191C17.1343 18.6281 17.0496 18.3826 17.0592 18.1314C17.0688 17.8802 17.1722 17.642 17.3486 17.4642C17.525 17.2865 17.7614 17.1824 18.0107 17.1727Z",
          style: { fill: e }
        }
      )
    }
  );
}, rD = TC, kC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.556 9.768a2.667 2.667 0 0 0-1.09-5.101.096.096 0 0 1-.09-.069 3.668 3.668 0 0 0-7.013-.016.12.12 0 0 1-.113.085h-.07a.047.047 0 0 0-.047.047c0 .022-.014.04-.035.046a2.668 2.668 0 0 0-.566 4.92L6.94 6.273a1.5 1.5 0 0 1 2.122 0l3.495 3.495Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M8.444 7.508a.611.611 0 0 0-.855 0L5.755 9.28a.611.611 0 1 0 .844.88l.8-.776v3.447a.611.611 0 1 0 1.223 0V9.415l.788.794a.61.61 0 0 0 .868 0 .61.61 0 0 0 0-.868L8.444 7.508Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, oD = kC, SC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M8.578 6.841a.611.611 0 0 0-.856 0L5.89 8.614a.611.611 0 1 0 .843.88l.8-.777v3.447a.611.611 0 1 0 1.223 0V8.748l.788.794a.611.611 0 0 0 1.002-.198.612.612 0 0 0-.134-.67L8.578 6.842Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M11.58 4.467a3.666 3.666 0 0 0-6.93 0 3.056 3.056 0 0 0-1.882 5.054.611.611 0 1 0 .916-.776A1.833 1.833 0 0 1 5.06 5.69h.061a.611.611 0 0 0 .612-.49 2.444 2.444 0 0 1 4.79 0 .612.612 0 0 0 .612.49h.037a1.834 1.834 0 0 1 1.375 3.055.61.61 0 0 0 .055.868.611.611 0 0 0 .861-.055 3.056 3.056 0 0 0-1.882-5.09Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, iD = SC, RC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M17.37 8.701a5.5 5.5 0 0 0-10.395 0 4.583 4.583 0 0 0-2.823 7.58.917.917 0 1 0 1.375-1.163 2.75 2.75 0 0 1 2.062-4.584h.092a.916.916 0 0 0 .916-.733 3.667 3.667 0 0 1 7.187 0 .916.916 0 0 0 .917.733h.055a2.75 2.75 0 0 1 2.062 4.584.917.917 0 0 0 .083 1.301.916.916 0 0 0 1.292-.082A4.582 4.582 0 0 0 17.37 8.7Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.712 12.185a.8.8 0 0 0-1.127.103l-2.878 3.454c-.277.333-.433.517-.558.63l-.004.005-.006-.004c-.134-.102-.306-.271-.612-.578l-1.161-1.16a.8.8 0 0 0-1.132 1.13l1.161 1.162.033.032c.261.262.513.513.746.69.262.198.605.384 1.045.364.44-.02.764-.236 1.007-.457.217-.197.444-.47.68-.754l.03-.036 2.879-3.454a.8.8 0 0 0-.103-1.127Z",
            style: { fill: e }
          }
        )
      ]
    }
  );
}, aD = RC, jC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      ...t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4.75C10.2051 4.75 8.75 6.20507 8.75 8V10.5H17C18.3807 10.5 19.5 11.6193 19.5 13V19C19.5 20.3807 18.3807 21.5 17 21.5H7C5.61929 21.5 4.5 20.3807 4.5 19V13C4.5 11.6193 5.61929 10.5 7 10.5H7.25V8C7.25 5.37665 9.37665 3.25 12 3.25C14.6234 3.25 16.75 5.37665 16.75 8H15.25C15.25 6.20507 13.7949 4.75 12 4.75ZM7 12H7.25H8.75H17C17.5523 12 18 12.4477 18 13V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V13C6 12.4477 6.44772 12 7 12ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
          style: { fill: e }
        }
      )
    }
  );
}, sD = jC, PC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsxs(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.036 2.333h9.503a2.036 2.036 0 0 1 2.037 2.037v2.715a.679.679 0 0 1-1.358 0v-.679H2.358v4.073a.679.679 0 0 0 .678.679h2.716a.679.679 0 1 1 0 1.357H3.036A2.036 2.036 0 0 1 1 10.48v-6.11a2.036 2.036 0 0 1 2.036-2.036Zm-.678 2.715h10.86V4.37a.679.679 0 0 0-.679-.68H3.036a.679.679 0 0 0-.678.68v.678Zm2.036 2.716H6.43a.679.679 0 1 1 0 1.357H4.394a.679.679 0 1 1 0-1.357Z",
            style: { fill: e }
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M13.668 9.448a2.475 2.475 0 0 0-1.122-1.126 2.838 2.838 0 0 0-1.642-.278 2.717 2.717 0 0 0-1.493.683 2.3 2.3 0 0 0-.732 1.366 1.505 1.505 0 0 0-.877.544c-.21.273-.301.607-.258.937.043.331.218.636.492.856.274.221.628.343.994.342h4.108c.448-.001.88-.149 1.219-.416.338-.267.56-.635.624-1.038a1.574 1.574 0 0 0-.274-1.157 1.86 1.86 0 0 0-1.039-.713Zm-.53 2.645H9.03a.786.786 0 0 1-.528-.2.65.65 0 0 1-.219-.48.65.65 0 0 1 .22-.48.786.786 0 0 1 .527-.198.394.394 0 0 0 .264-.1c.07-.063.11-.15.11-.24 0-.401.158-.79.444-1.096a1.92 1.92 0 0 1 1.118-.575c.436-.066.883.011 1.262.217.38.206.666.528.81.908.021.057.06.109.11.148.052.04.114.066.18.076.274.045.52.182.688.384.169.201.25.452.225.704a.986.986 0 0 1-.354.66c-.204.172-.47.269-.749.272Z",
            style: { fill: e, stroke: e },
            strokeWidth: 0.75
          }
        )
      ]
    }
  );
}, lD = PC, AC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.807 4.1c0-.346.28-.626.627-.626H10.4c.705 0 1.28.556 1.312 1.253h-8.28a.627.627 0 0 1-.626-.627Zm2.474-2.126h5.12a2.814 2.814 0 0 1 2.813 2.814v.054a2.48 2.48 0 0 1 1.73 2.364v3.46a2.921 2.921 0 0 1-2.922 2.921H5.676a4.369 4.369 0 0 1-4.369-4.369V3.83c0-.136.036-.263.1-.373a2.128 2.128 0 0 1 2.027-1.483H5.28ZM3.434 6.227h9.03c.541 0 .98.438.98.979v3.46c0 .785-.637 1.421-1.422 1.421H5.676a2.869 2.869 0 0 1-2.869-2.869V6.133c.198.061.409.094.627.094ZM10 9.25a.75.75 0 0 0 0 1.5h1.785a.75.75 0 0 0 0-1.5H10Z",
          style: { fill: e }
        }
      )
    }
  );
}, cD = AC, LC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.278 9.997 9.767 3.582a2.14 2.14 0 0 0-3.51 0L1.742 9.997A2.147 2.147 0 0 0 3.5 13.405h9.026a2.148 2.148 0 0 0 1.752-3.408ZM8.014 11.55a.68.68 0 1 1 0-1.362.68.68 0 0 1 0 1.362Zm.682-2.68a.682.682 0 1 1-1.364 0V6.146a.682.682 0 0 1 1.364 0v2.727Z",
          style: { fill: e }
        }
      )
    }
  );
}, Vp = LC, VC = ({ iconColor: e, size: r, ...t }) => {
  const { width: n, height: o } = V(r);
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      width: n,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.853 3.667a1.08 1.08 0 0 1 .9.466l4.414 6.274a1.106 1.106 0 0 1-.9 1.74H3.44a1.093 1.093 0 0 1-.98-.594 1.08 1.08 0 0 1 .08-1.146l4.413-6.294a1.073 1.073 0 0 1 .9-.466v.02Zm0-1.02a2.073 2.073 0 0 0-1.72.893L1.72 9.833a2.1 2.1 0 0 0 1.72 3.334h8.827a2.108 2.108 0 0 0 1.72-3.334L9.573 3.56a2.087 2.087 0 0 0-1.72-.893v-.02Zm.667 3.42a.667.667 0 0 0-1.333 0v2.666a.667.667 0 1 0 1.333 0V6.067Zm-.667 3.953a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333Z",
          style: { fill: e }
        }
      )
    }
  );
}, uD = VC, HC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx("rect", { x: "31", y: "29", width: "50", height: "65", rx: "2", fill: "#F8F8F8" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M75 100.5V35C75 33.8954 74.1046 33 73 33H38C36.3431 33 35 31.6569 35 30V19C35 17.8954 35.8954 17 37 17L94 17C94.5523 17 95 17.4477 95 18V84.5C95 85.0523 94.5523 85.5 94 85.5H82C80.8954 85.5 80 86.3954 80 87.5V89.5C80 90.6046 80.8954 91.5 82 91.5H84C85.1046 91.5 86 90.6046 86 89.5V23.5H25V100.5H75Z",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M41 71.5002L50.0624 75.7961L59.5 59.5001",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), dD = HC, FC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx("rect", { x: "24", y: "15", width: "53.3333", height: "70", rx: "2", fill: "#F8F8F8" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M63.769 102.066H41.1655C38.9564 102.066 37.1655 100.275 37.1655 98.0663V95.3254C37.1655 93.1163 38.9564 91.3254 41.1655 91.3254H43.7346C45.9437 91.3254 47.7346 93.1163 47.7346 95.3254V104.917C47.7346 106.022 46.8392 106.917 45.7346 106.917H30.1062C29.0017 106.917 28.1062 106.022 28.1062 104.917V21.916C28.1062 20.8114 29.0017 19.916 30.1062 19.916H86.8787C87.9832 19.916 88.8787 20.8114 88.8787 21.916V98.3116C88.8787 99.4162 87.9832 100.312 86.8787 100.312H84.6667C83.5621 100.312 82.6667 99.4162 82.6667 98.3116V97C82.6667 95.8954 83.5621 95 84.6667 95H94C95.1046 95 96 94.1046 96 93V71.5",
          stroke: "#C8D0D8",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M39.604 39.1638H55.2077",
          stroke: "#C8D0D8",
          strokeWidth: "2",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M39.6731 53.8667H69.06",
          stroke: "#C8D0D8",
          strokeWidth: "2",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M39.6731 59.3765H63.1826",
          stroke: "#C8D0D8",
          strokeWidth: "2",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M34.7752 19.5851V15C34.7752 13.8954 35.6706 13 36.7752 13H93.9978C95.1024 13 95.9978 13.8954 95.9978 15V71.7737",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), fD = FC, YC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M62.0046 105.95C86.8752 104.713 101.641 80.637 102.911 65.9892C103.006 64.8888 102.105 64 101 64L62 64C60.8954 64 60 64.8954 60 66L60 104C60 105.105 60.9014 106.005 62.0046 105.95Z",
          fill: "#F8F8F8"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M103 53C103 28.2683 78.3 14 65 14V53H103Z",
          fill: "#F8F8F8",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M57.7266 19V65.7872C57.7266 66.8918 56.8312 67.7872 55.7266 67.7872H51.7656C50.661 67.7872 49.7656 66.8918 49.7656 65.7872V62.2815C49.7656 61.1769 50.661 60.2815 51.7656 60.2815H98C98 78.5767 84.8879 101 58.4759 101C32.0638 101 16.9847 81.8604 16.0483 62.1579C15.1119 42.4554 27.7557 19 57.7266 19Z",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), pD = YC, $C = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "31.6751",
          y: "37.8374",
          width: "76.9431",
          height: "16.9106",
          fill: "#F8F8F8"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { d: "M19.8374 75.0407H67.187", stroke: "#C8D0D8", strokeWidth: "2" }),
      /* @__PURE__ */ f.jsx("path", { d: "M19.8374 80.9594H40.9756", stroke: "#C8D0D8", strokeWidth: "2" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.4311 80.9594H60.423", stroke: "#C8D0D8", strokeWidth: "2" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.00014 42.8204H26.6568C28.866 42.8204 30.6568 44.6113 30.6568 46.8204V50.9707C30.6568 53.1799 28.866 54.9707 26.6568 54.9707H21.9373C19.7281 54.9707 17.9373 53.1799 17.9373 50.9707V35.6097C17.9373 34.5051 18.8327 33.6097 19.9373 33.6097H102.39C103.495 33.6097 104.39 34.5051 104.39 35.6097V92.4878C104.39 93.5923 103.495 94.4878 102.39 94.4878H11.9876C10.883 94.4878 9.98756 93.5923 9.98756 92.4878V65.1613",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M25.7563 33.3805V28C25.7563 26.8954 26.6517 26 27.7563 26H110C111.105 26 112 26.8954 112 28V80.6504C112 81.755 111.105 82.6504 110 82.6504H105.181",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), hD = $C, zC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.2988 63.5166L38.4137 37.4484C38.7782 36.8588 39.4219 36.5 40.1149 36.5H80.8498C81.5619 36.5 82.2203 36.8787 82.5785 37.4942L97.7287 63.5337C97.9064 63.8391 98 64.1861 98 64.5395V82C98 83.1046 97.1046 84 96 84H24C22.8954 84 22 83.1046 22 82V64.5683C22 64.1968 22.1035 63.8326 22.2988 63.5166Z",
          fill: "#F8F8F8"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16 64.5V86.5C16 87.6046 16.8954 88.5 18 88.5H102C103.105 88.5 104 87.6046 104 86.5V58C104 56.8954 103.105 56 102 56H80.8736C80.0461 56 79.304 56.5097 79.0069 57.282L77.4931 61.218C77.196 61.9903 76.4539 62.5 75.6264 62.5H43.6946C42.9588 62.5 42.2825 62.096 41.9336 61.4482L39.5664 57.0518C39.2175 56.404 38.5412 56 37.8054 56H20.2264C18.5382 56 17.6094 54.0373 18.6799 52.7318L35.8999 31.7318C36.2798 31.2686 36.8473 31 37.4464 31H83.0603C83.6556 31 84.2199 31.2651 84.5998 31.7233L101 51.5",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), ZC = zC, WC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx("rect", { x: "18", y: "28", width: "91", height: "44", fill: "#F8F8F8" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8 34.7423V86C8 87.1046 8.89543 88 10 88H102.894C103.999 88 104.894 87.1046 104.894 86V78.2577M104.894 78.2577V34.1443C104.894 33.0398 103.999 32.1443 102.894 32.1443H14.3975C13.2929 32.1443 12.3975 33.0398 12.3975 34.1443V39.9381C12.3975 41.0427 13.2929 41.9381 14.3975 41.9381H20.2112C21.3157 41.9381 22.2112 41.0427 22.2112 39.9381V27C22.2112 25.8954 23.1066 25 24.2112 25H110C111.105 25 112 25.8954 112 27V76.2577C112 77.3623 111.105 78.2577 110 78.2577H104.894Z",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { d: "M12 95H98", stroke: "#C8D0D8", strokeWidth: "2" }),
      /* @__PURE__ */ f.jsx("circle", { cx: "57", cy: "60", r: "11", stroke: "#C8D0D8", strokeWidth: "2" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M11 76H18C19.1046 76 20 76.8954 20 78V85",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M93 85L93 78C93 76.8954 93.8954 76 95 76L102 76",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M102 44L95 44C93.8954 44 93 43.1046 93 42L93 35",
          stroke: "#C8D0D8",
          strokeWidth: "2"
        }
      )
    ]
  }
), vD = WC, BC = ({ size: e, ...r }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    preserveAspectRatio: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M28.2917 21.1725C28.2917 18.7861 30.2188 16.8516 32.596 16.8516H97.6958C100.073 16.8516 102 18.7861 102 21.1725V98.7529C102 101.139 100.073 103.074 97.6958 103.074H32.596C30.2188 103.074 28.2917 101.139 28.2917 98.7529V21.1725Z",
          fill: "url(#paint0_linear_904_234560)"
        }
      ),
      /* @__PURE__ */ f.jsxs("g", { filter: "url(#filter0_d_904_234560)", children: [
        /* @__PURE__ */ f.jsx("rect", { x: "18", y: "12", width: "73", height: "97", rx: "6.15152", fill: "white" }),
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            x: "18.6042",
            y: "12.6042",
            width: "71.7917",
            height: "95.7917",
            rx: "5.54735",
            stroke: "#DBE4EB",
            strokeWidth: "1.20833"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M32 37H75",
          stroke: "#DBE4EB",
          strokeWidth: "4",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M32 29H75",
          stroke: "#DBE4EB",
          strokeWidth: "4",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ f.jsx("g", { style: { mixBlendMode: "multiply" }, children: /* @__PURE__ */ f.jsx("rect", { x: "11", y: "50", width: "55", height: "13", rx: "6.5", fill: "#4FB77E" }) }),
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "8",
          y: "47",
          width: "56.8364",
          height: "13.6909",
          rx: "6.84545",
          fill: "#E4F8ED"
        }
      ),
      /* @__PURE__ */ f.jsx("circle", { cx: "14.7273", cy: "53.8455", r: "1.34545", fill: "#266C46" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M25.7654 57.3438L25.2407 55.818H23.0691L22.5525 57.3438H21.4546L23.5696 51.5556H24.7483L26.8633 57.3438H25.7654ZM24.4738 53.4446C24.4523 53.3693 24.42 53.267 24.3769 53.1379C24.3339 53.0087 24.2908 52.8768 24.2478 52.7423C24.2101 52.6024 24.1805 52.4867 24.159 52.3952C24.132 52.5028 24.0971 52.6266 24.054 52.7665C24.0163 52.9064 23.9787 53.0383 23.941 53.1621C23.9087 53.2859 23.8818 53.38 23.8603 53.4446L23.3517 54.93H24.9743L24.4738 53.4446ZM29.8252 52.8876C30.3365 52.8876 30.7482 53.0787 31.0603 53.4608C31.3725 53.8375 31.5285 54.3999 31.5285 55.148C31.5285 55.6431 31.4559 56.0602 31.3106 56.3992C31.1653 56.7383 30.9634 56.9939 30.7051 57.1661C30.4468 57.3384 30.1454 57.4245 29.801 57.4245C29.5911 57.4245 29.4054 57.3976 29.244 57.3438C29.0825 57.2845 28.9453 57.2119 28.8322 57.1258C28.7192 57.0343 28.6224 56.9374 28.5416 56.8352H28.477C28.4986 56.932 28.5147 57.0424 28.5255 57.1661C28.5362 57.2845 28.5416 57.3976 28.5416 57.5052V59.2812H27.5245V52.9683H28.3479L28.4932 53.5496H28.5416C28.6224 53.4258 28.7192 53.3155 28.8322 53.2186C28.9506 53.1163 29.0906 53.0356 29.252 52.9764C29.4189 52.9172 29.6099 52.8876 29.8252 52.8876ZM29.5346 53.711C29.2978 53.711 29.1067 53.7595 28.9614 53.8563C28.8161 53.9478 28.7112 54.0904 28.6466 54.2842C28.582 54.4779 28.547 54.7201 28.5416 55.0107V55.1399C28.5416 55.452 28.5712 55.7157 28.6304 55.931C28.695 56.1463 28.8 56.3104 28.9453 56.4235C29.096 56.5365 29.2978 56.593 29.5507 56.593C29.766 56.593 29.9409 56.5338 30.0754 56.4154C30.2154 56.297 30.3176 56.1301 30.3822 55.9149C30.4522 55.6942 30.4872 55.4332 30.4872 55.1318C30.4872 54.6797 30.4091 54.3299 30.253 54.0824C30.1024 53.8348 29.8629 53.711 29.5346 53.711ZM34.8785 52.8876C35.3898 52.8876 35.8015 53.0787 36.1137 53.4608C36.4258 53.8375 36.5819 54.3999 36.5819 55.148C36.5819 55.6431 36.5092 56.0602 36.3639 56.3992C36.2186 56.7383 36.0168 56.9939 35.7585 57.1661C35.5001 57.3384 35.1987 57.4245 34.8543 57.4245C34.6444 57.4245 34.4587 57.3976 34.2973 57.3438C34.1358 57.2845 33.9986 57.2119 33.8856 57.1258C33.7726 57.0343 33.6757 56.9374 33.595 56.8352H33.5304C33.5519 56.932 33.5681 57.0424 33.5788 57.1661C33.5896 57.2845 33.595 57.3976 33.595 57.5052V59.2812H32.5778V52.9683H33.4012L33.5465 53.5496H33.595C33.6757 53.4258 33.7726 53.3155 33.8856 53.2186C34.004 53.1163 34.1439 53.0356 34.3054 52.9764C34.4722 52.9172 34.6633 52.8876 34.8785 52.8876ZM34.5879 53.711C34.3511 53.711 34.1601 53.7595 34.0147 53.8563C33.8694 53.9478 33.7645 54.0904 33.6999 54.2842C33.6353 54.4779 33.6003 54.7201 33.595 55.0107V55.1399C33.595 55.452 33.6246 55.7157 33.6838 55.931C33.7483 56.1463 33.8533 56.3104 33.9986 56.4235C34.1493 56.5365 34.3511 56.593 34.6041 56.593C34.8193 56.593 34.9942 56.5338 35.1288 56.4154C35.2687 56.297 35.371 56.1301 35.4355 55.9149C35.5055 55.6942 35.5405 55.4332 35.5405 55.1318C35.5405 54.6797 35.4625 54.3299 35.3064 54.0824C35.1557 53.8348 34.9162 53.711 34.5879 53.711ZM39.9238 52.8876C39.9884 52.8876 40.0637 52.8903 40.1498 52.8957C40.2359 52.9011 40.3086 52.9118 40.3678 52.928L40.279 53.8725C40.2306 53.8617 40.166 53.8536 40.0852 53.8483C40.0099 53.8375 39.9426 53.8321 39.8834 53.8321C39.722 53.8321 39.5659 53.859 39.4152 53.9128C39.2699 53.9613 39.138 54.0366 39.0196 54.1389C38.9066 54.2357 38.8151 54.3622 38.7452 54.5183C38.6806 54.6744 38.6483 54.86 38.6483 55.0753V57.3438H37.6311V52.9683H38.4142L38.5595 53.7272H38.6079C38.694 53.5711 38.8017 53.4312 38.9308 53.3074C39.06 53.1782 39.208 53.076 39.3748 53.0006C39.5471 52.9253 39.73 52.8876 39.9238 52.8876ZM44.9283 55.148C44.9283 55.5139 44.8798 55.8368 44.7829 56.1167C44.6861 56.3965 44.5461 56.636 44.3632 56.8352C44.1856 57.0289 43.9649 57.1769 43.7012 57.2792C43.4429 57.376 43.1549 57.4245 42.8374 57.4245C42.536 57.4245 42.2589 57.376 42.0059 57.2792C41.753 57.1769 41.5323 57.0289 41.344 56.8352C41.161 56.636 41.0184 56.3965 40.9161 56.1167C40.8139 55.8368 40.7627 55.5139 40.7627 55.148C40.7627 54.6636 40.8461 54.2546 41.013 53.9209C41.1798 53.5819 41.4193 53.3262 41.7315 53.154C42.049 52.9764 42.423 52.8876 42.8536 52.8876C43.2626 52.8876 43.6205 52.9764 43.9272 53.154C44.2394 53.3262 44.4843 53.5819 44.6619 53.9209C44.8395 54.2546 44.9283 54.6636 44.9283 55.148ZM41.8041 55.148C41.8041 55.4547 41.8391 55.7184 41.9091 55.9391C41.9844 56.1544 42.0974 56.3185 42.2481 56.4315C42.4042 56.5445 42.6033 56.6011 42.8455 56.6011C43.0931 56.6011 43.2922 56.5445 43.4429 56.4315C43.5989 56.3185 43.712 56.1544 43.7819 55.9391C43.8519 55.7184 43.8869 55.4547 43.8869 55.148C43.8869 54.8358 43.8492 54.5748 43.7739 54.3649C43.7039 54.1496 43.5909 53.9882 43.4348 53.8805C43.2841 53.7675 43.0877 53.711 42.8455 53.711C42.4795 53.711 42.2131 53.8348 42.0463 54.0824C41.8848 54.3299 41.8041 54.6851 41.8041 55.148ZM46.8312 57.3438L45.1682 52.9683H46.2419L47.1138 55.4951C47.1514 55.5973 47.1864 55.7104 47.2187 55.8341C47.251 55.9525 47.2779 56.0709 47.2994 56.1893C47.3263 56.3024 47.3425 56.4019 47.3479 56.488H47.3802C47.3909 56.3965 47.4098 56.2943 47.4367 56.1813C47.4636 56.0629 47.4932 55.9445 47.5255 55.8261C47.5631 55.7077 47.5981 55.5973 47.6304 55.4951L48.5023 52.9683H49.5759L47.913 57.3438H46.8312ZM51.9889 52.8876C52.3817 52.8876 52.7181 52.9683 52.998 53.1298C53.2832 53.2859 53.5038 53.5119 53.6599 53.8079C53.816 54.0985 53.894 54.4537 53.894 54.8735V55.3901H51.004C51.0148 55.7884 51.1251 56.0979 51.335 56.3185C51.5449 56.5338 51.8355 56.6414 52.2068 56.6414C52.4921 56.6414 52.745 56.6145 52.9657 56.5607C53.1917 56.5015 53.4231 56.4181 53.6599 56.3104V57.1258C53.4446 57.228 53.2213 57.3034 52.9899 57.3518C52.7585 57.4003 52.4813 57.4245 52.1584 57.4245C51.7332 57.4245 51.3538 57.3438 51.0201 57.1823C50.6918 57.0155 50.4335 56.7652 50.2452 56.4315C50.0622 56.0979 49.9707 55.6835 49.9707 55.1883C49.9707 54.6878 50.0541 54.268 50.2209 53.929C50.3932 53.5845 50.63 53.3262 50.9313 53.154C51.2327 52.9764 51.5852 52.8876 51.9889 52.8876ZM51.9889 53.6384C51.7198 53.6384 51.4991 53.7272 51.3269 53.9048C51.1601 54.077 51.0605 54.3353 51.0282 54.6797H52.9092C52.9092 54.4752 52.8742 54.2949 52.8042 54.1389C52.7396 53.9828 52.6401 53.8617 52.5055 53.7756C52.371 53.6841 52.1988 53.6384 51.9889 53.6384ZM56.3647 57.4245C55.8588 57.4245 55.4471 57.2361 55.1296 56.8594C54.8174 56.4773 54.6614 55.9122 54.6614 55.1641C54.6614 54.416 54.8201 53.8509 55.1377 53.4688C55.4552 53.0813 55.8723 52.8876 56.3889 52.8876C56.6042 52.8876 56.7926 52.9172 56.954 52.9764C57.1209 53.0302 57.2635 53.1056 57.3819 53.2024C57.5003 53.2993 57.5998 53.4069 57.6806 53.5253H57.729C57.7129 53.45 57.6967 53.3343 57.6806 53.1782C57.6644 53.0221 57.6564 52.8768 57.6564 52.7423V51.2085H58.6735V57.3438H57.8824L57.6967 56.7706H57.6564C57.5756 56.889 57.4761 56.9993 57.3577 57.1016C57.2393 57.1984 57.0993 57.2765 56.9379 57.3357C56.7764 57.3949 56.5854 57.4245 56.3647 57.4245ZM56.6715 56.6011C57.0482 56.6011 57.3146 56.4934 57.4707 56.2782C57.6268 56.0629 57.7048 55.7373 57.7048 55.3013V55.1722C57.7048 54.6986 57.6294 54.338 57.4788 54.0904C57.3334 53.8429 57.059 53.7191 56.6553 53.7191C56.3486 53.7191 56.1118 53.8483 55.9449 54.1066C55.7781 54.3595 55.6947 54.7174 55.6947 55.1803C55.6947 55.6431 55.7781 55.9956 55.9449 56.2378C56.1118 56.48 56.354 56.6011 56.6715 56.6011Z",
          fill: "#266C46"
        }
      ),
      /* @__PURE__ */ f.jsx("g", { style: { mixBlendMode: "multiply" }, children: /* @__PURE__ */ f.jsx("rect", { x: "52", y: "87", width: "52", height: "19", rx: "9.5", fill: "#4FB77E" }) }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M45.9824 65.0274C48.2597 65.2186 57.0499 64.8681 58.2539 70.9567C59.7589 78.5675 61.587 79.5322 61.903 79.7146M61.903 79.7146L63.5023 74.9706M61.903 79.7146L55.6995 77.5252",
          stroke: "#69798C",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "48",
          y: "82",
          width: "54.2545",
          height: "21.0364",
          rx: "10.5182",
          fill: "#E4F8ED"
        }
      ),
      /* @__PURE__ */ f.jsx("circle", { cx: "58.0909", cy: "92.5182", r: "2.01818", fill: "#266C46" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M71.8873 88.3736C73.0094 88.3736 73.8247 88.6077 74.3333 89.076C74.85 89.5442 75.1083 90.19 75.1083 91.0134C75.1083 91.3848 75.0518 91.74 74.9388 92.079C74.8257 92.41 74.636 92.7087 74.3696 92.9751C74.1032 93.2415 73.7521 93.4514 73.3161 93.6048C72.8883 93.7581 72.3555 93.8348 71.7177 93.8348H70.858V97.0195H69.308V88.3736H71.8873ZM71.7904 89.6572H70.858V92.5513H71.5603C71.9801 92.5513 72.3353 92.5028 72.6259 92.406C72.9246 92.301 73.1506 92.1396 73.304 91.9216C73.4574 91.7036 73.5341 91.4211 73.5341 91.074C73.5341 90.5977 73.3928 90.2425 73.1103 90.0084C72.8277 89.7743 72.3878 89.6572 71.7904 89.6572ZM79.2755 90.3353C80.1232 90.3353 80.7649 90.521 81.2009 90.8923C81.6449 91.2556 81.8669 91.8288 81.8669 92.6118V97.0195H80.7892L80.4864 96.1113H80.438C80.2523 96.3455 80.0586 96.5432 79.8568 96.7047C79.663 96.8581 79.437 96.9671 79.1786 97.0316C78.9284 97.1043 78.6216 97.1406 78.2584 97.1406C77.8709 97.1406 77.5197 97.068 77.2049 96.9227C76.8981 96.7773 76.6559 96.5553 76.4783 96.2567C76.3007 95.9499 76.2119 95.5664 76.2119 95.1063C76.2119 94.4282 76.4581 93.9196 76.9506 93.5805C77.4511 93.2334 78.2059 93.0437 79.215 93.0114L80.3532 92.9751V92.6481C80.3532 92.2284 80.2523 91.9297 80.0505 91.7521C79.8487 91.5745 79.5661 91.4857 79.2029 91.4857C78.8719 91.4857 78.553 91.5341 78.2462 91.631C77.9395 91.7279 77.6408 91.8409 77.3502 91.97L76.8658 90.9044C77.1887 90.7349 77.556 90.5977 77.9677 90.4927C78.3875 90.3878 78.8234 90.3353 79.2755 90.3353ZM79.554 93.9438C78.884 93.968 78.4198 94.0851 78.1615 94.295C77.9032 94.4968 77.774 94.7713 77.774 95.1184C77.774 95.4252 77.8668 95.6472 78.0525 95.7844C78.2382 95.9216 78.4763 95.9903 78.7669 95.9903C79.2109 95.9903 79.5863 95.8651 79.8931 95.6149C80.1998 95.3565 80.3532 94.9771 80.3532 94.4766V93.9196L79.554 93.9438ZM85.3045 90.4564V97.0195H83.7788V90.4564H85.3045ZM84.5416 87.9256C84.7677 87.9256 84.9655 87.9861 85.135 88.1072C85.3045 88.2203 85.3893 88.4261 85.3893 88.7248C85.3893 89.0154 85.3045 89.2253 85.135 89.3545C84.9655 89.4756 84.7677 89.5361 84.5416 89.5361C84.3075 89.5361 84.1057 89.4756 83.9362 89.3545C83.7747 89.2253 83.694 89.0154 83.694 88.7248C83.694 88.4261 83.7747 88.2203 83.9362 88.1072C84.1057 87.9861 84.3075 87.9256 84.5416 87.9256ZM89.4229 97.1406C88.6641 97.1406 88.0465 96.8581 87.5702 96.293C87.102 95.7198 86.8679 94.8722 86.8679 93.7501C86.8679 92.628 87.1061 91.7803 87.5824 91.2072C88.0586 90.6259 88.6843 90.3353 89.4593 90.3353C89.7822 90.3353 90.0647 90.3797 90.3069 90.4685C90.5572 90.5492 90.7711 90.6623 90.9487 90.8076C91.1263 90.9529 91.2756 91.1143 91.3967 91.2919H91.4694C91.4452 91.1789 91.4209 91.0053 91.3967 90.7712C91.3725 90.5371 91.3604 90.3192 91.3604 90.1173V87.8166H92.8861V97.0195H91.6994L91.4209 96.1598H91.3604C91.2393 96.3374 91.09 96.5029 90.9124 96.6563C90.7348 96.8016 90.5249 96.9186 90.2827 97.0074C90.0405 97.0962 89.7539 97.1406 89.4229 97.1406ZM89.8831 95.9055C90.4482 95.9055 90.8478 95.744 91.0819 95.4211C91.316 95.0982 91.433 94.6098 91.433 93.9559V93.7622C91.433 93.0518 91.32 92.5109 91.094 92.1396C90.876 91.7682 90.4643 91.5825 89.8589 91.5825C89.3987 91.5825 89.0435 91.7763 88.7933 92.1638C88.543 92.5432 88.4179 93.08 88.4179 93.7743C88.4179 94.4685 88.543 94.9973 88.7933 95.3606C89.0435 95.7239 89.4068 95.9055 89.8831 95.9055Z",
          fill: "#266C46"
        }
      ),
      /* @__PURE__ */ f.jsxs("defs", { children: [
        /* @__PURE__ */ f.jsxs(
          "filter",
          {
            id: "filter0_d_904_234560",
            x: "18",
            y: "10.7917",
            width: "77.8333",
            height: "99.4167",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ f.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ f.jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ f.jsx(
                "feMorphology",
                {
                  radius: "1.20833",
                  operator: "erode",
                  in: "SourceAlpha",
                  result: "effect1_dropShadow_904_234560"
                }
              ),
              /* @__PURE__ */ f.jsx("feOffset", { dx: "3.625" }),
              /* @__PURE__ */ f.jsx("feGaussianBlur", { stdDeviation: "1.20833" }),
              /* @__PURE__ */ f.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ f.jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
                }
              ),
              /* @__PURE__ */ f.jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_904_234560"
                }
              ),
              /* @__PURE__ */ f.jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_904_234560",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_904_234560",
            x1: "153.906",
            y1: "67.1703",
            x2: "-10.3587",
            y2: "67.1703",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { stopColor: "#F4F8FB" }),
              /* @__PURE__ */ f.jsx("stop", { offset: "1", stopColor: "#D9DFE7" })
            ]
          }
        )
      ] })
    ]
  }
), mD = BC;
export {
  Xp as Accordion,
  ub as AccountingOutline,
  L1 as ActionChip,
  qC as ActionChipGroup,
  cb as ActivateCard,
  db as AddCard,
  fb as AddCategories,
  pb as AddDocumentFilled,
  hb as AddDocumentOutline,
  vb as AddFilled,
  mb as AddOutline,
  gb as AddReceiptFilled,
  yb as AddReceiptOutline,
  wb as AddWallet,
  xb as Analytics,
  Cb as ApprovalFilled,
  bb as ApprovalFolderFilled,
  Mb as ApprovalFolderOutline,
  Db as ApprovalOutline,
  Sp as ArrowLeft,
  _b as AttachmentCrossedOutline,
  Eb as BankFilled,
  Ib as BankOutline,
  GC as Banner,
  Ob as BillFilled,
  Nb as BillOutline,
  Tb as BillsApprovalOutline,
  kb as BulbFilled,
  Sb as Business,
  Xe as Button,
  Rb as CalendarFilled,
  jb as CalendarOutline,
  Pb as CalendarReloadFilled,
  Ab as CalendarReloadOutline,
  Lb as CameraFilled,
  Vb as CameraOutline,
  vr as Card,
  Hb as CardFilled,
  Fb as CardOutline,
  Yb as CashFilled,
  $b as CashOutline,
  zb as CategoriesFilled,
  Zb as CategoriesOutline,
  Wb as ChartLineFilled,
  Bb as ChartLineOutline,
  Ub as ChartPieFilled,
  Kb as ChartPieOutline,
  Gl as CheckFilled,
  Qb as CheckOutline,
  V1 as Checkbox,
  Rp as Chevron24,
  Es as ChevronDown,
  jp as ChevronLeft,
  Pp as ChevronRight,
  px as ChevronUp,
  qb as ClockOutline,
  Gb as CopyFilled,
  Xb as CopyOutline,
  Jb as CrossFilled,
  yr as CrossOutline,
  S4 as DatePicker,
  eM as DeleteFilled,
  tM as DeleteOutline,
  nM as DownloadOutline,
  rM as EditFilled,
  oM as EditOutline,
  R4 as EmptyState,
  iM as Expand,
  aM as ExternalOutline,
  Ix as EyeFilled,
  sM as EyeOutline,
  lM as FaqFilled,
  cM as File,
  uM as FileFilled,
  dM as FileOutline,
  fM as FileWarningFilled,
  pM as FileWarningOutline,
  hM as Filter,
  vM as Flash,
  Yd as Footer,
  mM as FundTransferOutline,
  gM as GearFilled,
  yM as GearOutline,
  j4 as Grid,
  wM as HelpFilled,
  xM as HelpOutline,
  zx as HideFilled,
  CM as HideOutline,
  bM as HomeFilled,
  MM as HomeOutline,
  dD as IllApprovals,
  mD as IllApprovedToPaid,
  fD as IllBills,
  pD as IllBudgets,
  hD as IllCards,
  ZC as IllEmpty,
  vD as IllReimbursements,
  DM as Image,
  Qx as InfoFilled,
  _M as InfoOutline,
  V4 as Input,
  Z4 as Loader,
  EM as LogOutFilled,
  IM as LogOutOutline,
  XC as Modal,
  OM as MoneyIn,
  NM as MoneyOut,
  JC as MultiSelect,
  eb as Navigation,
  TM as NewTransactionFilled,
  kM as NewTransactionOutline,
  SM as NotificationOffFilled,
  RM as NotificationOffOutline,
  jM as NotificationOnFilled,
  PM as NotificationOnOutline,
  AM as OcrSupportFilled,
  LM as OverflowHorizontal,
  Ap as OverflowVertical,
  Op as Overlay,
  tb as PageHeader,
  nb as Pagination,
  VM as Pause,
  HM as PeopleFilled,
  FM as PeopleOutline,
  YM as Person,
  $M as Placeholder,
  zM as Play,
  La as Popover,
  Lp as PremiumFilled,
  xy as Radio,
  ZM as ReceiptAddedFilled,
  WM as ReceiptAddedOutline,
  BM as Refresh,
  QM as ReimbursementOutline,
  UM as RequestReimbursementFilled,
  KM as RequestReimbursementOutline,
  qM as SearchFilled,
  GM as SearchOutline,
  rb as Sidepanel,
  Ds as SingleSelect,
  XM as Sort,
  ob as Stepper,
  ib as Switch,
  ab as Tab,
  An as Tags,
  JM as TeamFilled,
  eD as TeamOutline,
  Np as Thumbnail,
  sb as Toast,
  lb as Tooltip,
  tD as TransactionFilled,
  nD as TransactionOutline,
  pe as Typography,
  rD as Unlink,
  sD as UnlockedOutline,
  oD as UploadFilled,
  iD as UploadOutline,
  aD as UploadSuccess,
  lD as VirtualCard,
  cD as Wallet,
  Vp as WarningFilled,
  uD as WarningOutline,
  hr as toast
};
